var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var _a, _b, _c, _d;
import { action, makeObservable, observable, computed, runInAction, toJS, reaction } from "mobx";
import { MobXProviderContext, observer, Provider, useLocalObservable } from "mobx-react";
import * as React from "react";
import React__default, { createContext, useContext, useState, useEffect } from "react";
import validator from "validator";
import unique from "array-unique";
import { differenceInYears, intervalToDuration, endOfDay, addYears } from "date-fns";
import axios from "axios";
import { stringify } from "qs";
import { saveAs } from "file-saver";
import SsoClient from "@teliaee/telia-sso-client";
import { LabelProvider, Text, Separator, Heading as Heading$1, AnalyticsTrigger, Button, ChoiceGroup, Grid, GridColumn, Modal, ModalContent, ModalFooter, Overlay, Signature, Spinner, Select, TextField, SuggestionField, Icon, Selector, Notice, Table as Table$2, TableRow, TableCell, Check, Card, CardContent, ArrowList, ArrowListItem, Container, Logo, Image, ThemeProvider, AnalyticsProvider, CardHeader, List, ListItem, CardFooter, Anchor, Toggle, Progress, ProgressItem, useCurrentBreakPoint, scrollToElement, Skeleton, SkeletonItem, ModalTrigger, ModalProvider, EqualHeight, Tooltip, TooltipToggle, Accordion, AccordionItem, AccordionHeader, AccordionTitle, AccordionContent, PassField, PageHeading, EqualHeightProvider, Search as Search$1, Tabs, TabsItem } from "telia-front-react";
import { debounce } from "throttle-debounce";
import { BrowserRouter, useLocation as useLocation$1, useNavigate, matchRoutes, useRoutes } from "react-router-dom";
import { useParams as useParams$1, useLocation } from "react-router";
class LocationUtils {
  static changePath(newPath) {
    window.location.pathname = newPath;
  }
  static redirectToUrl(url) {
    window.location.assign(url);
  }
  static getDomain() {
    return "".concat(window.location.protocol, "//").concat(location.host);
  }
}
var Language = /* @__PURE__ */ ((Language2) => {
  Language2["ET"] = "et";
  Language2["RU"] = "ru";
  Language2["EN"] = "en";
  return Language2;
})(Language || {});
var ContactInfoType = /* @__PURE__ */ ((ContactInfoType2) => {
  ContactInfoType2["EMAIL"] = "EMAIL";
  ContactInfoType2["PHONE"] = "PHONE";
  return ContactInfoType2;
})(ContactInfoType || {});
const isEmailValid = (value) => {
  return validator.isEmail(value, { host_blacklist: ["eesti.ee"] });
};
const isPhoneValid = (phone) => {
  const regex = /^[+]?[0-9]{7,15}$/;
  return regex.test(phone);
};
const isContactInfoChanged = (newValue, oldValue) => {
  return newValue !== oldValue;
};
const getCommunicationLanguageProps = (isDisabled, translateStore) => {
  const { translate } = translateStore;
  return [
    {
      id: "ET",
      label: translate("registration.contactInfo.communicationLanguage.ET"),
      name: "eesti",
      value: "et".toUpperCase(),
      disabled: isDisabled
    },
    {
      id: "EN",
      label: translate("registration.contactInfo.communicationLanguage.EN"),
      name: "inglise",
      value: "en".toUpperCase(),
      disabled: isDisabled
    },
    {
      id: "RU",
      label: translate("registration.contactInfo.communicationLanguage.RU"),
      name: "vene",
      value: "ru".toUpperCase(),
      disabled: isDisabled
    }
  ];
};
const getTranslatedCommunicationLanguage = (communicationLanguage, translate) => {
  switch (communicationLanguage) {
    case "ET":
      return translate("registration.contactInfo.communicationLanguage.ET");
    case "RU":
      return translate("registration.contactInfo.communicationLanguage.RU");
    case "EN":
      return translate("registration.contactInfo.communicationLanguage.EN");
    default:
      return "";
  }
};
const getFirstContactInfoPreferringPrime = (contactInfoList) => {
  if (!contactInfoList || contactInfoList.length === 0) {
    return null;
  }
  const primeContactInfo = contactInfoList.find((ci) => ci.prime === true);
  const primeOrFirstContactInfo = !!primeContactInfo ? primeContactInfo : contactInfoList[0];
  return primeOrFirstContactInfo;
};
const countryAliases = [
  { value: "CO", label: { et: "Kolumbia", ru: "", en: "" } },
  { value: "GB", label: { et: "Inglismaa", ru: "", en: "" } },
  { value: "GB", label: { et: "Ühendkuningriik", ru: "", en: "" } },
  { value: "GB", label: { et: "Briti", ru: "", en: "" } },
  { value: "GE", label: { et: "Georgia", ru: "", en: "" } },
  { value: "US", label: { et: "USA", ru: "", en: "" } }
];
const iso3166CountryMap = [
  { value: "AF", label: { et: "Afganistan", ru: "Афганистан", en: "Afghanistan" } },
  { value: "AX", label: { et: "Ahvenamaa", ru: "Аландские острова", en: "Åland" } },
  { value: "AL", label: { et: "Albaania", ru: "Албания", en: "Albania" } },
  { value: "DZ", label: { et: "Alžeeria", ru: "Алжир", en: "Algeria" } },
  { value: "AS", label: { et: "Ameerika Samoa", ru: "Американское Самоа", en: "American Samoa" } },
  { value: "US", label: { et: "Ameerika Ühendriigid", ru: "США", en: "United States of America" } },
  { value: "AD", label: { et: "Andorra", ru: "Андорра", en: "Andorra" } },
  { value: "AO", label: { et: "Angola", ru: "Ангола", en: "Angola" } },
  { value: "AI", label: { et: "Anguilla", ru: "Ангилья", en: "Anguilla" } },
  { value: "AQ", label: { et: "Antarktis", ru: "Антарктида", en: "Antarctica" } },
  { value: "AG", label: { et: "Antigua ja Barbuda", ru: "Антигуа и Барбуда", en: "Antigua and Barbuda" } },
  { value: "MO", label: { et: "Aomen - Hiina erihalduspiirkond", ru: "Макао", en: "Macau" } },
  { value: "AE", label: { et: "Araabia Ühendemiraadid", ru: "ОАЭ", en: "United Arab Emirates" } },
  { value: "AR", label: { et: "Argentina", ru: "Аргентина", en: "Argentina" } },
  { value: "AM", label: { et: "Armeenia", ru: "Армения", en: "Armenia" } },
  { value: "AW", label: { et: "Aruba", ru: "Аруба", en: "Aruba" } },
  { value: "AZ", label: { et: "Aserbaidžaan", ru: "Азербайджан", en: "Azerbaijan" } },
  { value: "AU", label: { et: "Austraalia", ru: "Австралия", en: "Australia" } },
  { value: "AT", label: { et: "Austria", ru: "Австрия", en: "Austria" } },
  { value: "BS", label: { et: "Bahama", ru: "Багамы", en: "Bahama" } },
  { value: "BH", label: { et: "Bahrein", ru: "Бахрейн", en: "Bahrain" } },
  { value: "BD", label: { et: "Bangladesh", ru: "Бангладеш", en: "Bangladesh" } },
  { value: "BB", label: { et: "Barbados", ru: "Барбадос", en: "Barbados" } },
  { value: "PW", label: { et: "Belau", ru: "Палау", en: "Palau" } },
  { value: "BE", label: { et: "Belgia", ru: "Бельгия", en: "Belgium" } },
  { value: "BZ", label: { et: "Belize", ru: "Белиз", en: "Belize" } },
  { value: "BJ", label: { et: "Benin", ru: "Бенин", en: "Benin" } },
  { value: "BM", label: { et: "Bermuda", ru: "Бермуды", en: "Bermuda" } },
  { value: "BT", label: { et: "Bhutan", ru: "Бутан", en: "Bhutan" } },
  { value: "BO", label: { et: "Boliivia", ru: "Боливия", en: "Bolivia" } },
  { value: "BA", label: { et: "Bosnia ja Hertsegoviina", ru: "Босния и Герцеговина", en: "Bosnia and Herzegovina" } },
  { value: "BW", label: { et: "Botswana", ru: "Ботсвана", en: "Botswana" } },
  { value: "BV", label: { et: "Bouvet’i saar", ru: "Остров Буве", en: "Bouvet Island" } },
  { value: "BR", label: { et: "Brasiilia", ru: "Бразилия", en: "Brazil" } },
  { value: "BQ", label: { et: "Bonaire, Sint Eustatius ja Saba", ru: "Бонэйр, Синт-Эстатиус и Саба", en: "Bonaire, Sint Eustatius and Saba" } },
  { value: "IO", label: { et: "Briti India ookeani ala", ru: "Британская территория в Индийском океане", en: "British Indian Ocean Territory" } },
  { value: "VG", label: { et: "Briti Neitsisaared", ru: "Британские Виргинские острова", en: "British Virgin Islands" } },
  { value: "BN", label: { et: "Brunei", ru: "Бруней", en: "Brunei" } },
  { value: "BG", label: { et: "Bulgaaria", ru: "Болгария", en: "Bulgaria" } },
  { value: "BF", label: { et: "Burkina Faso", ru: "Буркина-Фасо", en: "Burkina Faso" } },
  { value: "BI", label: { et: "Burundi", ru: "Бурунди", en: "Burundi" } },
  { value: "CO", label: { et: "Colombia", ru: "Колумбия", en: "Colombia" } },
  { value: "CK", label: { et: "Cooki saared", ru: "Острова Кука", en: "Cook Islands" } },
  { value: "CR", label: { et: "Costa Rica", ru: "Коста-Рика", en: "Costa Rica" } },
  { value: "CI", label: { et: "Côte d`Ivoire", ru: "Кот-д’Ивуар", en: "Ivory Coast" } },
  { value: "CW", label: { et: "Curaçao", ru: "Кюрасао", en: "Curaçao" } },
  { value: "DJ", label: { et: "Djibouti", ru: "Джибути", en: "Djibouti" } },
  { value: "DM", label: { et: "Dominica", ru: "Доминика", en: "Dominica" } },
  { value: "DO", label: { et: "Dominikaani Vabariik", ru: "Доминиканская Республика", en: "Dominican Republic" } },
  { value: "EC", label: { et: "Ecuador", ru: "Эквадор", en: "Ecuador" } },
  { value: "EE", label: { et: "Eesti", ru: "Эстония", en: "Estonian" } },
  { value: "EG", label: { et: "Egiptus", ru: "Египет", en: "Egypt" } },
  { value: "GQ", label: { et: "Ekvatoriaal-Guinea", ru: "Экваториальная Гвинея", en: "Equatorial Guinea" } },
  { value: "SV", label: { et: "El Salvador", ru: "Сальвадор", en: "El Salvador" } },
  { value: "ER", label: { et: "Eritrea", ru: "Эритрея", en: "Eritrea" } },
  { value: "ET", label: { et: "Etioopia", ru: "Эфиопия", en: "Ethiopia" } },
  { value: "FK", label: { et: "Falklandi saared", ru: "Фолклендские острова", en: "Falkland Islands" } },
  { value: "FJ", label: { et: "Fidži", ru: "Фиджи", en: "Fiji" } },
  { value: "PH", label: { et: "Filipiinid", ru: "Филиппины", en: "Philippines" } },
  { value: "FO", label: { et: "Fääri saared", ru: "Фареры", en: "Faroe Islands" } },
  { value: "GA", label: { et: "Gabon", ru: "Габон", en: "Gabon" } },
  { value: "GM", label: { et: "Gambia", ru: "Гамбия", en: "Gambia" } },
  { value: "GH", label: { et: "Ghana", ru: "Гана", en: "Ghana" } },
  { value: "GI", label: { et: "Gibraltar", ru: "Гибралтар", en: "Gibraltar" } },
  { value: "GD", label: { et: "Grenada", ru: "Гренада", en: "Grenada" } },
  { value: "GE", label: { et: "Gruusia", ru: "Грузия", en: "Georgia" } },
  { value: "GL", label: { et: "Gröönimaa", ru: "Гренландия", en: "Greenland" } },
  { value: "GP", label: { et: "Guadeloupe", ru: "Гваделупа", en: "Guadeloupe" } },
  { value: "GU", label: { et: "Guam", ru: "Гуам", en: "Guam" } },
  { value: "GT", label: { et: "Guatemala", ru: "Гватемала", en: "Guatemala" } },
  { value: "GG", label: { et: "Guernsey", ru: "Гернси", en: "Guernsey" } },
  { value: "GN", label: { et: "Guinea", ru: "Гвинея", en: "Guinea" } },
  { value: "GW", label: { et: "Guinea-Bissau", ru: "Гвинея-Бисау", en: "Guinea-Bissau" } },
  { value: "GY", label: { et: "Guyana", ru: "Гайана", en: "Guyana" } },
  { value: "HT", label: { et: "Haiti", ru: "Гаити", en: "Haiti" } },
  { value: "HM", label: { et: "Heard ja McDonald saared", ru: "Херд и Макдональд", en: "Heard Island and McDonald Islands" } },
  { value: "CN", label: { et: "Hiina", ru: "КНР (Китайская Народная Республика)", en: "China" } },
  { value: "ES", label: { et: "Hispaania", ru: "Испания", en: "Spain" } },
  { value: "NL", label: { et: "Holland", ru: "Нидерланды", en: "Holland" } },
  { value: "HN", label: { et: "Honduras", ru: "Гондурас", en: "Honduras" } },
  { value: "HK", label: { et: "Hongkong - Hiina erihalduspiirkond", ru: "Гонконг", en: "Hong Kong" } },
  { value: "HR", label: { et: "Horvaatia", ru: "Хорватия", en: "Croatia" } },
  { value: "TL", label: { et: "Ida-Timor", ru: "Восточный Тимор", en: "East Timor" } },
  { value: "IE", label: { et: "Iirimaa", ru: "Ирландия", en: "Ireland" } },
  { value: "IL", label: { et: "Iisrael", ru: "Израиль", en: "Israel" } },
  { value: "IN", label: { et: "India", ru: "Индия", en: "India" } },
  { value: "ID", label: { et: "Indoneesia", ru: "Индонезия", en: "Indonesia" } },
  { value: "IQ", label: { et: "Iraak", ru: "Ирак", en: "Iraq" } },
  { value: "IR", label: { et: "Iraan", ru: "Иран", en: "Iran" } },
  { value: "IS", label: { et: "Island", ru: "Исландия", en: "Iceland" } },
  { value: "IT", label: { et: "Itaalia", ru: "Италия", en: "Italy" } },
  { value: "JP", label: { et: "Jaapan", ru: "Япония", en: "Japan" } },
  { value: "JM", label: { et: "Jamaica", ru: "Ямайка", en: "Jamaica" } },
  { value: "YE", label: { et: "Jeemen", ru: "Йемен", en: "Yemen" } },
  { value: "JE", label: { et: "Jersey", ru: "Джерси", en: "Jersey" } },
  { value: "JO", label: { et: "Jordaania", ru: "Иордания", en: "Jordan" } },
  { value: "CX", label: { et: "Jõulusaar", ru: "Остров Рождества", en: "Christmas Island" } },
  { value: "KY", label: { et: "Kaimanisaared", ru: "Острова Кайман", en: "Cayman Islands" } },
  { value: "KH", label: { et: "Kambodža", ru: "Камбоджа", en: "Cambodia" } },
  { value: "CM", label: { et: "Kamerun", ru: "Камерун", en: "Cameroon" } },
  { value: "CA", label: { et: "Kanada", ru: "Канада", en: "Canada" } },
  { value: "KZ", label: { et: "Kasahstan", ru: "Казахстан", en: "Kazakhstan" } },
  { value: "QA", label: { et: "Katar", ru: "Катар", en: "Qatar" } },
  { value: "KE", label: { et: "Keenia", ru: "Кения", en: "Kenya" } },
  { value: "CF", label: { et: "Kesk-Aafrika Vabariik", ru: "ЦАР", en: "Central African Republic" } },
  { value: "KI", label: { et: "Kiribati", ru: "Кирибати", en: "Kiribati" } },
  { value: "KM", label: { et: "Komoorid", ru: "Коморы", en: "Comoros" } },
  { value: "CD", label: { et: "Kongo DV", ru: "Демократическая Республика Конго", en: "Democratic Republic of the Congo" } },
  { value: "CG", label: { et: "Kongo-Brazzaville", ru: "Республика Конго", en: "Republic of the Congo" } },
  { value: "CC", label: { et: "Kookossaared", ru: "Кокосовые острова", en: "Republic of the Congo" } },
  { value: "GR", label: { et: "Kreeka", ru: "Греция", en: "Greece" } },
  { value: "CU", label: { et: "Kuuba", ru: "Куба", en: "Cuba" } },
  { value: "KW", label: { et: "Kuveit", ru: "Кувейт", en: "Kuwait" } },
  { value: "KG", label: { et: "Kõrgõzstan", ru: "Киргизия", en: "Kyrgyzstan" } },
  { value: "CY", label: { et: "Küpros", ru: "Кипр", en: "Cyprus" } },
  { value: "LA", label: { et: "Laos", ru: "Лаос", en: "Laos" } },
  { value: "LT", label: { et: "Leedu", ru: "Литва", en: "Lithuania" } },
  { value: "LS", label: { et: "Lesotho", ru: "Лесото", en: "Lesotho" } },
  { value: "LR", label: { et: "Libeeria", ru: "Либерия", en: "Liberia" } },
  { value: "LI", label: { et: "Liechtenstein", ru: "Лихтенштейн", en: "Liechtenstein" } },
  { value: "LB", label: { et: "Liibanon", ru: "Ливан", en: "Lebanon" } },
  { value: "LY", label: { et: "Liibüa", ru: "Ливия", en: "Libya" } },
  { value: "LU", label: { et: "Luksemburg", ru: "Люксембург", en: "Luxembourg" } },
  { value: "ZA", label: { et: "Lõuna-Aafrika Vabariik", ru: "ЮАР", en: "Republic of South Africa" } },
  {
    value: "GS",
    label: { et: "Lõuna-Georgia ja Lõuna-Sandwichi saared", ru: "Южная Георгия и Южные Сандвичевы Острова", en: "South Georgia and the South Sandwich Islands" }
  },
  { value: "KR", label: { et: "Lõuna-Korea", ru: "Республика Корея", en: "South Korea" } },
  { value: "LV", label: { et: "Läti", ru: "Латвия", en: "Latvia" } },
  { value: "EH", label: { et: "Lääne-Sahara", ru: "САДР", en: "Western Sahara" } },
  { value: "MG", label: { et: "Madagaskar", ru: "Мадагаскар", en: "Madagascar" } },
  { value: "MK", label: { et: "Makedoonia", ru: "Македония", en: "Macedonia" } },
  { value: "MY", label: { et: "Malaisia", ru: "Малайзия", en: "Malaysia" } },
  { value: "MW", label: { et: "Malawi", ru: "Малави", en: "Malawi" } },
  { value: "MV", label: { et: "Maldiivid", ru: "Мальдивы", en: "Maldives" } },
  { value: "ML", label: { et: "Mali", ru: "Мали", en: "Mali" } },
  { value: "MT", label: { et: "Malta", ru: "Мальта", en: "Malta" } },
  { value: "IM", label: { et: "Mani saar", ru: "Остров Мэн", en: "Isle of Man" } },
  { value: "MA", label: { et: "Maroko", ru: "Марокко", en: "Morocco" } },
  { value: "MH", label: { et: "Marshalli saared", ru: "Маршалловы Остров", en: "Marshall Islands" } },
  { value: "MQ", label: { et: "Martinique", ru: "Мартиника", en: "Martinique" } },
  { value: "MR", label: { et: "Mauritaania", ru: "Мавритания", en: "Mauritania" } },
  { value: "MU", label: { et: "Mauritius", ru: "Маврикий", en: "Mauritius" } },
  { value: "YT", label: { et: "Mayotte", ru: "Майотта", en: "Mayotte" } },
  { value: "MX", label: { et: "Mehhiko", ru: "Мексика", en: "Mexico" } },
  { value: "FM", label: { et: "Mikroneesia Liiduriigid", ru: "Микронезия", en: "Federated States of Micronesia" } },
  { value: "MD", label: { et: "Moldova", ru: "Молдавия", en: "Moldova" } },
  { value: "MC", label: { et: "Monaco", ru: "Монако", en: "Monaco" } },
  { value: "MN", label: { et: "Mongoolia", ru: "Монголия", en: "Mongolia" } },
  { value: "ME", label: { et: "Montenegro", ru: "Черногория", en: "Montenegro" } },
  { value: "MS", label: { et: "Montserrat", ru: "Монтсеррат", en: "Montserrat" } },
  { value: "MZ", label: { et: "Mosambiik", ru: "Мозамбик", en: "Mozambique" } },
  { value: "MM", label: { et: "Myanmar", ru: "Мьянма", en: "Myanmar" } },
  { value: "NA", label: { et: "Namiibia", ru: "Намибия", en: "Namibia" } },
  { value: "NR", label: { et: "Nauru", ru: "Науру", en: "Nauru" } },
  { value: "NP", label: { et: "Nepal", ru: "Непал", en: "Nepal" } },
  { value: "NI", label: { et: "Nicaragua", ru: "Никарагуа", en: "Nicaragua" } },
  { value: "NG", label: { et: "Nigeeria", ru: "Нигерия", en: "Nigeria" } },
  { value: "NE", label: { et: "Niger", ru: "Нигер", en: "Niger" } },
  { value: "NU", label: { et: "Niue", ru: "Ниуэ", en: "Niue" } },
  { value: "NF", label: { et: "Norfolk", ru: "Остров Норфолк", en: "Norfolk" } },
  { value: "NO", label: { et: "Norra", ru: "Норвегия", en: "Norway" } },
  { value: "OM", label: { et: "Omaan", ru: "Оман", en: "Oman" } },
  { value: "PG", label: { et: "Paapua Uus-Guinea", ru: "Папуа - Новая Гвинея", en: "Papua New Guinea" } },
  { value: "PK", label: { et: "Pakistan", ru: "Пакистан", en: "Pakistan" } },
  { value: "PS", label: { et: "Palestiina ala", ru: "Государство Палестина", en: "Palestine" } },
  { value: "PA", label: { et: "Panama", ru: "Панама", en: "Panama" } },
  { value: "PY", label: { et: "Paraguay", ru: "Парагвай", en: "Paraguay" } },
  { value: "PE", label: { et: "Peruu", ru: "Перу", en: "Peru" } },
  { value: "PN", label: { et: "Pitcairn", ru: "Острова Питкэрн", en: "Pitcairn" } },
  { value: "PL", label: { et: "Poola", ru: "Польша", en: "Poland" } },
  { value: "PT", label: { et: "Portugal", ru: "Португалия", en: "Portugal" } },
  { value: "GF", label: { et: "Prantsuse Guajaana", ru: "Гвиана", en: "French Guiana" } },
  { value: "TF", label: { et: "Prantsuse Lõunaalad", ru: "Французские Южные и Антарктические Территории", en: "French Southern Territories" } },
  { value: "PF", label: { et: "Prantsuse Polüneesia", ru: "Французская Полинезия", en: "French Polynesia" } },
  { value: "FR", label: { et: "Prantsusmaa", ru: "Франция", en: "France" } },
  { value: "PR", label: { et: "Puerto Rico", ru: "Пуэрто-Рико", en: "Puerto Rico" } },
  { value: "KP", label: { et: "Põhja-Korea", ru: "КНДР (Корейская Народно-Демократическая Республика)", en: "North Korea" } },
  { value: "MP", label: { et: "Põhja-Mariaanid", ru: "Северные Марианские Острова", en: "Northern Mariana Islands" } },
  { value: "RE", label: { et: "Réunion", ru: "Реюньон", en: "Réunion" } },
  { value: "CV", label: { et: "Roheneemesaared", ru: "Кабо-Верде", en: "Cape Verde" } },
  { value: "SE", label: { et: "Rootsi", ru: "Швеция", en: "Sweden" } },
  { value: "SX", label: { et: "Sint Maarten", ru: "Синт-Мартен", en: "Sint Maarten" } },
  { value: "RO", label: { et: "Rumeenia", ru: "Румыния", en: "Romania" } },
  { value: "RW", label: { et: "Rwanda", ru: "Руанда", en: "Rwanda" } },
  { value: "SB", label: { et: "Saalomoni Saared", ru: "Соломоновы Острова", en: "Solomon Islands" } },
  { value: "BL", label: { et: "Saint Barthélemy", ru: "Сен-Бартелеми", en: "Saint-Barthélemy" } },
  { value: "SH", label: { et: "Saint Helena", ru: "Острова Святой Елены, Вознесения и Тристан-да-Кунья", en: "Saint Helena" } },
  { value: "KN", label: { et: "Saint Kitts ja Nevis", ru: "Сент-Китс и Невис", en: "Saint Kitts and Nevis" } },
  { value: "LC", label: { et: "Saint Lucia", ru: "Сент-Люсия", en: "Saint Lucia" } },
  { value: "MF", label: { et: "Saint Martin", ru: "Сен-Мартен", en: "Saint Martin" } },
  { value: "PM", label: { et: "Saint Pierre ja Miquelon", ru: "Сен-Пьер и Микелон", en: "Saint Pierre and Miquelon" } },
  { value: "VC", label: { et: "Saint Vincent ja Grenadiinid", ru: "Сент-Винсент и Гренадины", en: "Saint Vincent and the Grenadines" } },
  { value: "DE", label: { et: "Saksamaa", ru: "Германия", en: "Germany" } },
  { value: "ZM", label: { et: "Sambia", ru: "Замбия", en: "Zambia" } },
  { value: "WS", label: { et: "Samoa", ru: "Самоа", en: "Samoa" } },
  { value: "SM", label: { et: "San Marino", ru: "Сан-Марино", en: "San Marino" } },
  { value: "ST", label: { et: "São Tomé ja Príncipe", ru: "Сан-Томе и Принсипи", en: "São Tomé and Príncipe" } },
  { value: "SA", label: { et: "Saudi Araabia", ru: "Аравия", en: "Saudi Arabia" } },
  { value: "SC", label: { et: "Seišellid", ru: "Сейшельские Острова", en: "Seychelles" } },
  { value: "SN", label: { et: "Senegal", ru: "Сенегал", en: "Senegal" } },
  { value: "RS", label: { et: "Serbia", ru: "Сербия", en: "Serbia" } },
  { value: "SL", label: { et: "Sierra Leone", ru: "Сьерра-Леоне", en: "Sierra Leone" } },
  { value: "SG", label: { et: "Singapur", ru: "Сингапур", en: "Singapore" } },
  { value: "SK", label: { et: "Slovakkia", ru: "Словакия", en: "Slovakia" } },
  { value: "SI", label: { et: "Sloveenia", ru: "Словения", en: "Slovenia" } },
  { value: "SO", label: { et: "Somaalia", ru: "Сомали", en: "Somalia" } },
  { value: "FI", label: { et: "Soome", ru: "Финляндия", en: "Finland" } },
  { value: "LK", label: { et: "Sri Lanka", ru: "Шри-Ланка", en: "Sri Lanka" } },
  { value: "SD", label: { et: "Sudaan", ru: "Судан", en: "Sudan" } },
  { value: "SS", label: { et: "Lõuna-Sudaan", ru: "Южный Судан", en: "South Sudan" } },
  { value: "SR", label: { et: "Suriname", ru: "Суринам", en: "Suriname" } },
  { value: "GB", label: { et: "Suurbritannia", ru: "Великобритания", en: "Great Britain" } },
  { value: "SZ", label: { et: "Svaasimaa", ru: "Свазиленд", en: "Swaziland" } },
  { value: "SJ", label: { et: "Svalbard ja Jan Mayen", ru: "Шпицберген и Ян-Майен", en: "Svalbard and Jan Mayen" } },
  { value: "SY", label: { et: "Süüria", ru: "Сирия", en: "Syria" } },
  { value: "CH", label: { et: "Šveits", ru: "Швейцария", en: "Switzerland" } },
  { value: "ZW", label: { et: "Zimbabwe", ru: "Зимбабве", en: "Zimbabwe" } },
  { value: "DK", label: { et: "Taani", ru: "Дания", en: "Denmark" } },
  { value: "TJ", label: { et: "Tadžikistan", ru: "Таджикистан", en: "Tajikistan" } },
  { value: "TH", label: { et: "Tai", ru: "Таиланд", en: "Thailand" } },
  { value: "TW", label: { et: "Taiwan", ru: "Китайская Республика", en: "Taiwan" } },
  { value: "TZ", label: { et: "Tansaania", ru: "Танзания", en: "Tanzania" } },
  { value: "TG", label: { et: "Togo", ru: "Того", en: "Togo" } },
  { value: "TK", label: { et: "Tokelau", ru: "Токелау", en: "Tokelau" } },
  { value: "TO", label: { et: "Tonga", ru: "Тонга", en: "Tonga" } },
  { value: "TT", label: { et: "Trinidad ja Tobago", ru: "Тринидад и Тобаго", en: "Trinidad and Tobago" } },
  { value: "TD", label: { et: "Tšaad", ru: "Чад", en: "Chad" } },
  { value: "CZ", label: { et: "Tšehhi", ru: "Чехия", en: "Czech Republic" } },
  { value: "CL", label: { et: "Tšiili", ru: "Чили", en: "Chile" } },
  { value: "TN", label: { et: "Tuneesia", ru: "Тунис", en: "Tunisia" } },
  { value: "TC", label: { et: "Turks ja Caicos", ru: "Тёркс и Кайкос", en: "Turks and Caicos" } },
  { value: "TV", label: { et: "Tuvalu", ru: "Тувалу", en: "Tuvalu" } },
  { value: "TR", label: { et: "Türgi", ru: "Турция", en: "Turkey" } },
  { value: "TM", label: { et: "Türkmenistan", ru: "Туркмения", en: "Turkmenistan" } },
  { value: "UG", label: { et: "Uganda", ru: "Уганда", en: "Uganda" } },
  { value: "UA", label: { et: "Ukraina", ru: "Украина", en: "Ukraine" } },
  { value: "HU", label: { et: "Ungari", ru: "Венгрия", en: "Hungary" } },
  { value: "UY", label: { et: "Uruguay", ru: "Уругвай", en: "Uruguay" } },
  { value: "VI", label: { et: "USA Neitsisaared", ru: "Виргинские Острова (США)", en: "United States Virgin Islands" } },
  { value: "UZ", label: { et: "Usbekistan", ru: "Узбекистан", en: "Uzbekistan" } },
  { value: "NC", label: { et: "Uus-Kaledoonia", ru: "Новая Каледония", en: "New Caledonia" } },
  { value: "NZ", label: { et: "Uus-Meremaa", ru: "Новая Зеландия", en: "New Zealand" } },
  { value: "BY", label: { et: "Valgevene", ru: "Белоруссия", en: "Belarus" } },
  { value: "WF", label: { et: "Wallis ja Futuna", ru: "Уоллис и Футуна", en: "Wallis and Futuna" } },
  { value: "VU", label: { et: "Vanuatu", ru: "Вануату", en: "Vanuatu" } },
  { value: "VA", label: { et: "Vatikan", ru: "Ватикан", en: "Vatican" } },
  { value: "RU", label: { et: "Venemaa", ru: "Россия", en: "Russia" } },
  { value: "VE", label: { et: "Venezuela", ru: "Венесуэла", en: "Venezuela" } },
  { value: "VN", label: { et: "Vietnam", ru: "Вьетнам", en: "Vietnam" } },
  { value: "UM", label: { et: "Ühendriikide hajasaared", ru: "Внешние малые острова (США)", en: "United States Minor Outlying Islands" } },
  { value: "OTHER", label: { et: "Muu", ru: "Другая страна", en: "Other" } }
];
class CountryUtil {
  static countriesForView(searchTerm, currentLanguage) {
    currentLanguage = currentLanguage.toLowerCase();
    return this.findSuggestedCountries(searchTerm, currentLanguage).map((country) => ({ label: country.label[currentLanguage], value: country.value }));
  }
  static getCountryNameByCountryCode(countryCode, currentLanguage) {
    return countryCode ? this.getByCountryCode(countryCode).label[currentLanguage.toLowerCase()] : null;
  }
  static getByCountryCode(value) {
    if (!value) {
      return null;
    }
    return iso3166CountryMap.find((country) => country.value === value) || null;
  }
  static findSuggestedCountries(searchTerm, currentLanguage) {
    const foundCountries = this.getCountriesContainingSearchTerm(searchTerm, currentLanguage);
    const aliasCountries = this.findByAlias(searchTerm, currentLanguage);
    currentLanguage = currentLanguage.toLowerCase();
    return unique(
      foundCountries.concat(aliasCountries).sort((country1, country2) => country1.label[currentLanguage].localeCompare(country2.label[currentLanguage]))
    );
  }
  static findByAlias(searchTerm, currentLanguage) {
    return countryAliases.filter((country) => this.countryMatchesSearchTerm(country, searchTerm, currentLanguage)).map((alias) => this.getByCountryCode(alias.value));
  }
  static countryMatchesSearchTerm(country, searchTerm, currentLanguage) {
    const name = country.label[currentLanguage.toLowerCase()].toLowerCase();
    const nameFragments = name.replace("-", " ").split(" ");
    const nameFragmentsMatchTerm = () => nameFragments.some((nameFragment) => this.startsWith(nameFragment, searchTerm));
    return this.startsWith(name, searchTerm) || nameFragmentsMatchTerm();
  }
  static getCountriesContainingSearchTerm(searchTerm, currentLanguage) {
    return iso3166CountryMap.filter((country) => this.countryMatchesSearchTerm(country, searchTerm, currentLanguage));
  }
  static startsWith(name, searchTerm) {
    return name.startsWith(searchTerm.trim().toLowerCase());
  }
  static isEstonia(countryCode) {
    return countryCode === "EE";
  }
  static mapCountriesForSuggestionField(searchTerm, language) {
    return this.findSuggestedCountries(searchTerm, language).map((country) => ({ label: country.label[language], url: "" }));
  }
  static getSelectedCountry(searchTerm, language) {
    const countries = this.findSuggestedCountries(searchTerm, language);
    if (countries.length === 0) {
      return null;
    }
    return countries.length === 1 ? countries[0] : countries.find((country) => country.label[language].toLocaleLowerCase() === searchTerm.toLocaleLowerCase()) || null;
  }
}
const RADIX = 10;
const LEGAL_AGE = 18;
const LAST_CENTURY = 1900;
const CURRENT_CENTURY = 2e3;
const CENTURY_START = 0;
const CENTURY_END = 1;
const YEAR_START = 1;
const YEAR_END = 3;
const MONTH_START = 3;
const MONTH_END = 5;
const DAY_START = 5;
const DAY_END = 7;
const isUnderage = (personalCode) => {
  const year = getBirthYear(personalCode);
  const month = parseInt(personalCode.slice(MONTH_START, MONTH_END), RADIX) - 1;
  const day = parseInt(personalCode.slice(DAY_START, DAY_END), RADIX);
  return differenceInYears(/* @__PURE__ */ new Date(), new Date(year, month, day)) < LEGAL_AGE;
};
const getBirthYear = (personalCode) => {
  const century = parseInt(personalCode.slice(CENTURY_START, CENTURY_END), RADIX);
  let year = parseInt(personalCode.slice(YEAR_START, YEAR_END), RADIX);
  century < 5 ? year += LAST_CENTURY : year += CURRENT_CENTURY;
  return year;
};
const API_CONF = {
  timeout: 5e4,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
  paramsSerializer: (params) => stringify(params, { arrayFormat: "repeat" })
};
const API = axios.create(API_CONF);
function getUrl(url, paramsMap) {
  if (!paramsMap) {
    return url;
  }
  const queryParams = Object.entries(paramsMap).filter(([_, v]) => v !== null).map(([k, v]) => "".concat(k, "=").concat(encodeURIComponent(v))).join("&");
  return queryParams.length ? "".concat(url, "?").concat(queryParams) : url;
}
var FetchStatus = /* @__PURE__ */ ((FetchStatus2) => {
  FetchStatus2["FETCHING"] = "FETCHING";
  FetchStatus2["ERROR"] = "ERROR";
  FetchStatus2["FETCHED"] = "FETCHED";
  FetchStatus2["UNINITIALIZED"] = "UNINITIALIZED";
  return FetchStatus2;
})(FetchStatus || {});
var __defProp$G = Object.defineProperty;
var __getOwnPropDesc$J = Object.getOwnPropertyDescriptor;
var __decorateClass$L = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$J(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$G(target, key, result);
  return result;
};
class ComponentContactAddressStore {
  constructor(componentRootStore) {
    __publicField(this, "countrySelected", null);
    __publicField(this, "contactAddress", null);
    __publicField(this, "isLoaded", false);
    __publicField(this, "customerId");
    __publicField(this, "status", "UNINITIALIZED");
    __publicField(this, "isErrorDuringSave", false);
    __publicField(this, "componentRootStore");
    __publicField(this, "ssoStore");
    __publicField(this, "componentCreditInfoStore");
    __publicField(this, "PERSON_ENDPOINT", "/person/contact-address");
    __publicField(this, "LEGAL_ENTITY_ENDPOINT", "/legal-entity/contact-address");
    __publicField(this, "onSuccess", (response) => {
      const addresses = response.data;
      if (!addresses.length) {
        this.status = "FETCHED";
        return;
      }
      this.contactAddress = addresses[0];
      this.setInitialCountrySelected();
      this.status = "FETCHED";
    });
    __publicField(this, "onError", () => {
      this.contactAddress = null;
      this.status = "ERROR";
    });
    makeObservable(this);
    this.componentRootStore = componentRootStore;
    this.ssoStore = componentRootStore.componentSsoStore;
    this.componentCreditInfoStore = componentRootStore.componentCreditInfoStore;
  }
  async init() {
    this.isLoaded = false;
    this.contactAddress = null;
    if (this.status !== "FETCHING") {
      this.status = "FETCHING";
      await this.loadAddress();
    }
    if (!this.hasAddress) {
      this.componentRootStore.componentForeignAddressEditStore.reset();
      this.componentRootStore.componentRegistryAddressEditStore.reset();
      this.onLoaded();
      return;
    }
    if (this.isEstonianAddress) {
      this.componentRootStore.componentForeignAddressEditStore.reset();
      await this.componentRootStore.componentRegistryAddressEditStore.init();
    } else {
      this.componentRootStore.componentRegistryAddressEditStore.reset();
      await this.componentRootStore.componentForeignAddressEditStore.init();
    }
    this.onLoaded();
  }
  async saveAddress() {
    const { componentRegistryAddressEditStore, componentForeignAddressEditStore } = this.componentRootStore;
    this.isErrorDuringSave = false;
    if (this.isRegistryAddressSelected && (this.isAddressDirty || !componentRegistryAddressEditStore.addressValidated)) {
      await componentRegistryAddressEditStore.saveAddress().then(action((success) => this.isErrorDuringSave = !success));
    } else if (!this.isRegistryAddressSelected && this.isAddressDirty) {
      await componentForeignAddressEditStore.saveAddress().then(action((success) => this.isErrorDuringSave = !success));
    }
  }
  async reloadAddress() {
    await this.fetchAddress();
  }
  get addressId() {
    return this.contactAddress && this.contactAddress.id;
  }
  get isAddressDirty() {
    const { componentRegistryAddressEditStore, componentForeignAddressEditStore } = this.componentRootStore;
    return this.isRegistryAddressSelected ? componentRegistryAddressEditStore.isAddressDirty : componentForeignAddressEditStore.isAddressDirty;
  }
  get isRegistryAddressSelected() {
    return this.countrySelected && CountryUtil.isEstonia(this.countrySelected.value) || !this.countrySelected;
  }
  get hasCountrySelected() {
    return this.countrySelected !== null;
  }
  get hasAddress() {
    return this.contactAddress && this.contactAddress.prime;
  }
  setIsAddressDirtyFalse() {
    const { componentRegistryAddressEditStore, componentForeignAddressEditStore } = this.componentRootStore;
    this.isRegistryAddressSelected ? componentRegistryAddressEditStore.setIsAddressDirtyFalse() : componentForeignAddressEditStore.setIsAddressDirtyFalse();
  }
  setIsAddressDirtyTrue() {
    const { componentRegistryAddressEditStore, componentForeignAddressEditStore } = this.componentRootStore;
    this.isRegistryAddressSelected ? componentRegistryAddressEditStore.setIsAddressDirtyTrue() : componentForeignAddressEditStore.setIsAddressDirtyTrue();
  }
  hasAddressChanged() {
    const { componentRegistryAddressEditStore, componentForeignAddressEditStore } = this.componentRootStore;
    return this.isRegistryAddressSelected ? componentRegistryAddressEditStore.isAddressDirty : componentForeignAddressEditStore.isAddressDirty;
  }
  getAddress() {
    const { componentRegistryAddressEditStore, componentForeignAddressEditStore } = this.componentRootStore;
    return this.isRegistryAddressSelected ? componentRegistryAddressEditStore.getAddress() : componentForeignAddressEditStore.getAddress();
  }
  isAddressValid() {
    const { componentRegistryAddressEditStore, componentForeignAddressEditStore } = this.componentRootStore;
    return this.isRegistryAddressSelected ? !componentRegistryAddressEditStore.addressError : !componentForeignAddressEditStore.addressError;
  }
  getCountryCode() {
    if (!this.hasAddress) {
      return "EE";
    }
    return this.getContactAddress.countryCode;
  }
  onLoaded() {
    this.isLoaded = true;
  }
  async loadAddress() {
    const { customer } = this.ssoStore;
    const { entityToRegister } = this.componentCreditInfoStore;
    if (!customer || entityToRegister && (entityToRegister.registrationNumber !== customer.registrationNumber || entityToRegister.registrationNumberCountryCode !== customer.registrationNumberCountryCode)) {
      this.status = "FETCHED";
      return Promise.resolve();
    }
    this.customerId = this.ssoStore.customerId;
    return this.fetchAddress();
  }
  setInitialCountrySelected() {
    const country = CountryUtil.getByCountryCode(this.getCountryCode());
    this.countrySelected = {
      value: country.value,
      label: this.isEstonianAddress ? country.label.et : country.label.ru
    };
  }
  async fetchAddress() {
    this.status = "FETCHING";
    const baseUrl = this.componentRootStore.urlDataStore.componentsAPIURL;
    const isPerson = this.componentRootStore.componentSsoStore.isPrivate;
    const fullUrl = baseUrl.concat("".concat(isPerson ? this.PERSON_ENDPOINT : this.LEGAL_ENTITY_ENDPOINT)).concat("?include-unvalidated=true");
    return API.get(fullUrl).then(this.onSuccess).catch(this.onError);
  }
  get getContactAddress() {
    return this.contactAddress && this.contactAddress.address;
  }
  get isEstonianAddress() {
    return CountryUtil.isEstonia(this.getContactAddress.countryCode);
  }
  setAddressChanged() {
    const { componentRegistryAddressEditStore, componentForeignAddressEditStore } = this.componentRootStore;
    this.isRegistryAddressSelected ? componentRegistryAddressEditStore.setAddressChanged() : componentForeignAddressEditStore.setAddressChanged();
  }
}
__decorateClass$L([
  observable
], ComponentContactAddressStore.prototype, "countrySelected", 2);
__decorateClass$L([
  observable
], ComponentContactAddressStore.prototype, "contactAddress", 2);
__decorateClass$L([
  observable
], ComponentContactAddressStore.prototype, "isLoaded", 2);
__decorateClass$L([
  observable
], ComponentContactAddressStore.prototype, "customerId", 2);
__decorateClass$L([
  observable
], ComponentContactAddressStore.prototype, "status", 2);
__decorateClass$L([
  observable
], ComponentContactAddressStore.prototype, "isErrorDuringSave", 2);
__decorateClass$L([
  action.bound
], ComponentContactAddressStore.prototype, "init", 1);
__decorateClass$L([
  action.bound
], ComponentContactAddressStore.prototype, "saveAddress", 1);
__decorateClass$L([
  action.bound
], ComponentContactAddressStore.prototype, "reloadAddress", 1);
__decorateClass$L([
  computed
], ComponentContactAddressStore.prototype, "addressId", 1);
__decorateClass$L([
  computed
], ComponentContactAddressStore.prototype, "isAddressDirty", 1);
__decorateClass$L([
  computed
], ComponentContactAddressStore.prototype, "isRegistryAddressSelected", 1);
__decorateClass$L([
  computed
], ComponentContactAddressStore.prototype, "hasCountrySelected", 1);
__decorateClass$L([
  computed
], ComponentContactAddressStore.prototype, "hasAddress", 1);
__decorateClass$L([
  action.bound
], ComponentContactAddressStore.prototype, "onLoaded", 1);
__decorateClass$L([
  action.bound
], ComponentContactAddressStore.prototype, "loadAddress", 1);
__decorateClass$L([
  action.bound
], ComponentContactAddressStore.prototype, "setInitialCountrySelected", 1);
__decorateClass$L([
  action.bound
], ComponentContactAddressStore.prototype, "fetchAddress", 1);
__decorateClass$L([
  action.bound
], ComponentContactAddressStore.prototype, "onSuccess", 2);
__decorateClass$L([
  action.bound
], ComponentContactAddressStore.prototype, "onError", 2);
__decorateClass$L([
  computed
], ComponentContactAddressStore.prototype, "getContactAddress", 1);
__decorateClass$L([
  computed
], ComponentContactAddressStore.prototype, "isEstonianAddress", 1);
const _Config = class _Config {
  static init(componentURLDataStore) {
    _Config.apiUrl = componentURLDataStore.componentsAPIURL;
  }
};
__publicField(_Config, "apiUrl");
let Config = _Config;
class ContactInfoAPI {
  constructor(componentsApiBaseUrl) {
    __publicField(this, "PERSON_CONTACT_INFO_BASE_URL", "/person");
    __publicField(this, "GET_PERSON_PATH", "/person");
    __publicField(this, "PUT_PERSON_COMMUNICATION_LANGUAGE_PATH", "/person/contact-info/communication-language");
    __publicField(this, "PUT_PERSON_CONTACT_INFO_CONFIRMED_TS_PATH", "/person/contact-info-confirmed-ts");
    __publicField(this, "GET_PUT_POST_DELETE_PERSON_CONTACT_INFO_PATH", "/contact-info");
    __publicField(this, "POST_PRIVATE_CUSTOMERS_PATH", "/private-customers");
    __publicField(this, "POST_LEGAL_ENTITY_CUSTOMERS_PATH", "/legal-entity-customers");
    __publicField(this, "componentsApiBaseUrl");
    __publicField(this, "CUSTOMER_PERSON_CONTACT_INFO_BASE_URL", "/customer-person");
    this.componentsApiBaseUrl = componentsApiBaseUrl;
  }
  static getPersonContactInfos() {
    return API.get("".concat(Config.apiUrl, "/person/contact-info"));
  }
  static putPersonContactInfo(contactInfo) {
    return API.put("".concat(Config.apiUrl, "/person/contact-info"), contactInfo);
  }
  static postPersonContactInfo(contactInfo) {
    return API.post("".concat(Config.apiUrl, "/person/contact-info"), contactInfo);
  }
  static deletePersonContactInfo(contactInfoId) {
    return API.delete("".concat(Config.apiUrl, "/person/contact-info/").concat(contactInfoId));
  }
  // todo: convert all methods to be static and clean up - separate non-contact-info related calls
  getPerson() {
    return API.get(this.componentsApiBaseUrl.concat(this.GET_PERSON_PATH));
  }
  postPrivateCustomer(privateCustomerResource) {
    return API.post(this.componentsApiBaseUrl.concat(this.POST_PRIVATE_CUSTOMERS_PATH), privateCustomerResource);
  }
  postLegalEntityCustomer(legalEntityCustomerResource) {
    return API.post(this.componentsApiBaseUrl.concat(this.POST_LEGAL_ENTITY_CUSTOMERS_PATH), legalEntityCustomerResource);
  }
  getContactInfo(isPrivate, customerPersonId) {
    const baseUrl = this.componentsApiBaseUrl.concat(this.getContactInfoBaseUrl(isPrivate).concat(this.GET_PUT_POST_DELETE_PERSON_CONTACT_INFO_PATH));
    const url = customerPersonId ? "".concat(baseUrl, "/").concat(customerPersonId) : baseUrl;
    return API.get(url);
  }
  putContactInfo(isPrivate, contactInfo) {
    return API.put(this.componentsApiBaseUrl + this.getContactInfoBaseUrl(isPrivate) + this.GET_PUT_POST_DELETE_PERSON_CONTACT_INFO_PATH, contactInfo);
  }
  postContactInfo(isPrivate, contactInfo, customerPersonId) {
    const baseUrl = this.componentsApiBaseUrl.concat(this.getContactInfoBaseUrl(isPrivate).concat(this.GET_PUT_POST_DELETE_PERSON_CONTACT_INFO_PATH));
    const url = customerPersonId ? "".concat(baseUrl, "/").concat(customerPersonId) : baseUrl;
    return API.post(url, contactInfo);
  }
  deleteContactInfo(contactInfoId) {
    return API.delete(
      this.componentsApiBaseUrl.concat("".concat(this.PERSON_CONTACT_INFO_BASE_URL).concat(this.GET_PUT_POST_DELETE_PERSON_CONTACT_INFO_PATH, "/").concat(contactInfoId))
    );
  }
  putPersonContactInfoConfirmedTs() {
    return API.put(this.componentsApiBaseUrl.concat(this.PUT_PERSON_CONTACT_INFO_CONFIRMED_TS_PATH));
  }
  putPersonCommunicationLanguage(value) {
    return API.put(this.componentsApiBaseUrl.concat(this.PUT_PERSON_COMMUNICATION_LANGUAGE_PATH), value, { headers: { "Content-Type": "text/plain" } });
  }
  getContactInfoBaseUrl(isPrivate) {
    return isPrivate ? this.PERSON_CONTACT_INFO_BASE_URL : this.CUSTOMER_PERSON_CONTACT_INFO_BASE_URL;
  }
}
const GET_PERSON_MANDATES_PATH = "/mandate/person-mandates";
const GET_CUSTOMER_MANDATES_PATH = "/mandate/customer-mandates";
class MandateAPI {
  constructor(apiBaseUrl) {
    __publicField(this, "componentsApiBaseUrl");
    __publicField(this, "getPersonMandates", () => {
      return API.get(this.componentsApiBaseUrl.concat(GET_PERSON_MANDATES_PATH));
    });
    __publicField(this, "getCustomerMandates", (registrationNumber) => {
      const paramsMap = {};
      if (registrationNumber) {
        paramsMap.registrationNumber = registrationNumber;
      }
      return API.get(this.componentsApiBaseUrl.concat(getUrl(GET_CUSTOMER_MANDATES_PATH, paramsMap)));
    });
    this.componentsApiBaseUrl = apiBaseUrl;
  }
}
var __defProp$F = Object.defineProperty;
var __getOwnPropDesc$I = Object.getOwnPropertyDescriptor;
var __decorateClass$K = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$I(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$F(target, key, result);
  return result;
};
class ContactInfo {
  constructor(contactInfoType) {
    __publicField(this, "contactInfoId");
    __publicField(this, "prime", true);
    __publicField(this, "validated");
    __publicField(this, "type");
    __publicField(this, "value", "");
    __publicField(this, "oldValue", "");
    __publicField(this, "isUserInputError");
    __publicField(this, "isSavingError");
    __publicField(this, "isValidatedSuccessfully");
    makeObservable(this);
    this.type = contactInfoType;
  }
  onChange(value, isDealer) {
    this.value = value;
    this.checkValueValidity(isDealer);
    this.isSavingError && (this.isSavingError = false);
  }
  checkValueValidity(isDealer) {
    const isValueValid = (this.type === "EMAIL" ? isEmailValid(this.value) : isPhoneValid(this.value)) || isDealer && this.value === "";
    this.isUserInputError = this.hasValueChanged ? !isValueValid : false;
  }
  get isInputValid() {
    return !this.isUserInputError;
  }
  get hasValue() {
    return this.value !== "";
  }
  get isValidatedAndUnchanged() {
    return this.validated !== false && !this.hasValueChanged;
  }
  setSavingError(isError) {
    this.isSavingError = isError;
  }
  set(contactInfo) {
    this.contactInfoId = contactInfo.contactInfoId;
    this.prime = contactInfo.prime;
    this.type = contactInfo.type;
    this.value = contactInfo.value;
    this.isUserInputError = contactInfo.isUserInputError;
    this.oldValue = contactInfo.value;
    this.validated = contactInfo.validated;
    this.checkValueValidity();
  }
  initializeValidation() {
    this.validated = false;
    this.isValidatedSuccessfully = false;
  }
  get hasValueChanged() {
    return this.oldValue !== this.value;
  }
  get isEstonianMobilePhoneNumber() {
    if (this.type !== ContactInfoType.PHONE) {
      return false;
    }
    let phoneNumber = this.value;
    if (phoneNumber.startsWith("+372")) {
      phoneNumber = phoneNumber.substring(4);
    }
    if (phoneNumber.startsWith("372")) {
      phoneNumber = phoneNumber.substring(3);
    }
    if (phoneNumber.startsWith("00372")) {
      phoneNumber = phoneNumber.substring(5);
    }
    return phoneNumber.startsWith("5") && (phoneNumber.length === 7 || phoneNumber.length === 8);
  }
  getContactInfoResource() {
    return {
      prime: this.prime,
      type: this.type,
      contactInfoId: this.contactInfoId,
      value: this.value
    };
  }
}
__decorateClass$K([
  observable
], ContactInfo.prototype, "contactInfoId", 2);
__decorateClass$K([
  observable
], ContactInfo.prototype, "prime", 2);
__decorateClass$K([
  observable
], ContactInfo.prototype, "validated", 2);
__decorateClass$K([
  observable
], ContactInfo.prototype, "type", 2);
__decorateClass$K([
  observable
], ContactInfo.prototype, "value", 2);
__decorateClass$K([
  observable
], ContactInfo.prototype, "oldValue", 2);
__decorateClass$K([
  observable
], ContactInfo.prototype, "isUserInputError", 2);
__decorateClass$K([
  observable
], ContactInfo.prototype, "isSavingError", 2);
__decorateClass$K([
  observable
], ContactInfo.prototype, "isValidatedSuccessfully", 2);
__decorateClass$K([
  action.bound
], ContactInfo.prototype, "onChange", 1);
__decorateClass$K([
  action.bound
], ContactInfo.prototype, "checkValueValidity", 1);
__decorateClass$K([
  computed
], ContactInfo.prototype, "isInputValid", 1);
__decorateClass$K([
  computed
], ContactInfo.prototype, "hasValue", 1);
__decorateClass$K([
  computed
], ContactInfo.prototype, "isValidatedAndUnchanged", 1);
__decorateClass$K([
  action.bound
], ContactInfo.prototype, "setSavingError", 1);
__decorateClass$K([
  action.bound
], ContactInfo.prototype, "set", 1);
__decorateClass$K([
  action.bound
], ContactInfo.prototype, "initializeValidation", 1);
__decorateClass$K([
  computed
], ContactInfo.prototype, "hasValueChanged", 1);
__decorateClass$K([
  computed
], ContactInfo.prototype, "isEstonianMobilePhoneNumber", 1);
const getContactAddress = (address) => {
  let contactAddress;
  if (address.addressRegistryId) {
    contactAddress = {
      addressRegistryAddressIdentifier: {
        addressRegistryId: address.addressRegistryId,
        roomRegistryId: address.roomRegistryId,
        buildingRegistryId: address.buildingRegistryId,
        room: address.roomRegistryId ? null : address.room,
        privatePostalCode: address.privatePostalCode
      }
    };
  } else if (address.countryCode) {
    contactAddress = {
      foreignAddressIdentifier: {
        countryCode: address.countryCode,
        region: address.region,
        city: address.city,
        municipality: address.municipality,
        street: address.street,
        building: address.building,
        room: address.room,
        postalCode: address.postalCode
      }
    };
  }
  return contactAddress;
};
const getLegalEntityCreation = (person, email, phone, communicationLanguage, address, legalEntity) => {
  const legalEntityCreation = {
    legalEntity: {
      name: legalEntity.name,
      registrationNumber: legalEntity.registrationNumber,
      registrationNumberCountryCode: legalEntity.registrationNumberCountryCode,
      contactAddress: getContactAddress(address),
      segment: legalEntity.segment
    },
    legalCustomerPerson: {
      person: {
        firstName: person.firstName,
        lastName: person.lastName,
        personalCode: person.personalCode,
        personalCodeCountryCode: person.personalCodeCountryCode,
        communicationLanguageCode: communicationLanguage
      },
      mandate: {
        source: "STANDARD"
      },
      contactInfos: []
    }
  };
  if (email.hasValue) {
    legalEntityCreation.legalCustomerPerson.contactInfos.push({
      type: email.type,
      value: email.value
    });
  }
  if (phone.hasValue) {
    legalEntityCreation.legalCustomerPerson.contactInfos.push({
      type: phone.type,
      value: phone.value
    });
  }
  return legalEntityCreation;
};
const getPrivateCustomerResource = (person, email, phone, communicationLanguage, address) => {
  const privateCustomer = {
    person: {
      firstName: person.firstName,
      lastName: person.lastName,
      personalCode: person.personalCode,
      personalCodeCountryCode: person.personalCodeCountryCode,
      communicationLanguageCode: communicationLanguage,
      contactInfos: [],
      contactAddress: getContactAddress(address)
    }
  };
  if (email.hasValue) {
    privateCustomer.person.contactInfos.push({
      type: email.type,
      value: email.value
    });
  }
  if (phone.hasValue) {
    privateCustomer.person.contactInfos.push({
      type: phone.type,
      value: phone.value
    });
  }
  return privateCustomer;
};
class PersonApi {
  static getPerson() {
    return API.get("".concat(Config.apiUrl, "/person"));
  }
  static getCustomerOwnerPerson() {
    return API.get("".concat(Config.apiUrl, "/customer/person"));
  }
  static createPerson(personCreation) {
    return API.post("".concat(Config.apiUrl, "/person"), personCreation);
  }
  static updateCommunicationLanguage(value) {
    return API.put("".concat(Config.apiUrl, "/person/contact-info/communication-language"), value, { headers: { "Content-Type": "text/plain" } });
  }
}
__publicField(PersonApi, "getCustomerServicePassword", () => {
  return API.get("".concat(Config.apiUrl, "/person/customer-service-password"));
});
__publicField(PersonApi, "setCustomerServicePassword", (password, passwordHint) => {
  return API.put("".concat(Config.apiUrl, "/person/customer-service-password"), { password, passwordHint });
});
var __defProp$E = Object.defineProperty;
var __getOwnPropDesc$H = Object.getOwnPropertyDescriptor;
var __decorateClass$J = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$H(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$E(target, key, result);
  return result;
};
class ComponentCustomerContactInfoStore {
  constructor(rootStore) {
    __publicField(this, "contactInfoAPI");
    __publicField(this, "mandateAPI");
    __publicField(this, "componentSsoStore");
    __publicField(this, "contractStore");
    __publicField(this, "componentCreditInfoStore");
    __publicField(this, "initialCustomerId", null);
    __publicField(this, "isLoaded", false);
    __publicField(this, "isError", false);
    __publicField(this, "ciCheckBoxValue", []);
    __publicField(this, "ciCheckBoxCheckedTimes", 0);
    __publicField(this, "contactInfoUpdated", false);
    __publicField(this, "newCustomerId", null);
    __publicField(this, "customerPersonId", null);
    __publicField(this, "hasRepresentationStipulationForCustomer", false);
    __publicField(this, "email", new ContactInfo(ContactInfoType.EMAIL));
    __publicField(this, "phone", new ContactInfo(ContactInfoType.PHONE));
    __publicField(this, "oldEmail");
    __publicField(this, "oldPhone");
    __publicField(this, "communicationLanguage", { oldValue: "", value: "" });
    __publicField(this, "contactInfoConfirmedTs", null);
    __publicField(this, "status", "UNINITIALIZED");
    __publicField(this, "componentsApiBaseUrl");
    __publicField(this, "isLoading", () => {
      return this.status === "LOADING";
    });
    makeObservable(this);
    this.componentsApiBaseUrl = rootStore.urlDataStore.componentsAPIURL;
    this.componentSsoStore = rootStore.componentSsoStore;
    this.contractStore = rootStore.componentContractStore;
    this.componentCreditInfoStore = rootStore.componentCreditInfoStore;
    this.mandateAPI = new MandateAPI(rootStore.urlDataStore.componentsAPIURL);
  }
  async init() {
    if (!this.isLoaded || this.initialCustomerId !== this.componentSsoStore.customerId) {
      this.setInitialCustomerId();
      if (!this.isLoading()) {
        this.setIsLoading();
        this.resetStates();
        await this.getPerson();
        if (this.componentSsoStore.isPrivate) {
          this.getContactInfo().then(() => this.onLoaded());
        }
        if (this.componentSsoStore.isBusiness) {
          this.getCustomerPersonContactInfo().then(() => this.onLoaded());
        }
      }
    }
  }
  resetStates() {
    this.isLoaded = false;
    this.customerPersonId = null;
    this.email = new ContactInfo(ContactInfoType.EMAIL);
    this.phone = new ContactInfo(ContactInfoType.PHONE);
    this.communicationLanguage = { oldValue: "", value: "" };
    this.contactInfoAPI = new ContactInfoAPI(this.componentsApiBaseUrl);
  }
  setInitialCustomerId() {
    this.initialCustomerId = this.componentSsoStore.customerId;
  }
  async updateSingleContactInfo(contactInfo, updateConfirmedTs = true) {
    this.isError = false;
    if (!this.email.hasValue && !this.phone.hasValue) {
      throw new Error("Missing contact info.");
    }
    await this.updateContactInfoIfChanged(contactInfo).catch(() => this.onError(contactInfo));
    if (this.componentSsoStore.isPrivate && !this.isError && updateConfirmedTs) {
      await this.updateContactInfoConfirmedTs();
    }
  }
  async updateContactInfo(updateConfirmedTs = true) {
    this.isError = false;
    if (!this.email.hasValue && !this.phone.hasValue) {
      throw new Error("Missing contact info.");
    }
    await Promise.allSettled([
      this.updateContactInfoIfChanged(this.email).catch(() => this.onError(this.email)),
      this.updateContactInfoIfChanged(this.phone).catch(() => this.onError(this.phone))
    ]);
    await this.getContactInfo(this.customerPersonId);
    if (isContactInfoChanged(this.communicationLanguage.value, this.communicationLanguage.oldValue)) {
      await this.updateCommunicationLanguage(this.communicationLanguage.value);
      if (!this.isError) {
        runInAction(() => this.communicationLanguage.oldValue = this.communicationLanguage.value);
      }
    }
    if (this.componentSsoStore.isPrivate && !this.isError && updateConfirmedTs) {
      await this.updateContactInfoConfirmedTs();
    }
  }
  async updateContactInfoIfChanged(contactInfo) {
    if (contactInfo.hasValueChanged) {
      contactInfo.hasValue ? await this.updateOrCreateContactInfo(contactInfo) : await this.deleteContactInfo(contactInfo);
    }
  }
  async updateOrCreateContactInfo(contactInfo) {
    if (contactInfo.validated === false && contactInfo.value || isContactInfoChanged(contactInfo.value, contactInfo.oldValue)) {
      !contactInfo.contactInfoId ? await this.createEmailOrPhone(contactInfo) : await this.updateEmailOrPhone(contactInfo);
      contactInfo.oldValue = contactInfo.value;
    }
  }
  async deleteContactInfo(contactInfo) {
    if (!this.componentSsoStore.dealer) {
      this.isError = true;
      throw new Error("Only dealer can delete contact info.");
    }
    this.contactInfoAPI.deleteContactInfo(contactInfo.contactInfoId);
  }
  async getContactInfo(customerPersonId) {
    await this.contactInfoAPI.getContactInfo(this.componentSsoStore.isPrivate, customerPersonId).then((response) => {
      this.populateContactInfo(response.data);
    }).catch(() => {
      this.onError();
    });
  }
  populateContactInfo(contactInfos) {
    contactInfos.forEach((contactInfo) => {
      if (contactInfo.type === "EMAIL" && !this.email.isSavingError) {
        this.setEmailContactInfo(contactInfo);
      } else if (contactInfo.type === "PHONE" && !this.phone.isSavingError) {
        this.setPhoneContactInfo(contactInfo);
      }
    });
  }
  setEmailContactInfo(contactInfo) {
    this.email.set(contactInfo);
    const oldEmail = new ContactInfo(ContactInfoType.EMAIL);
    oldEmail.set(contactInfo);
    this.oldEmail = oldEmail;
  }
  setPhoneContactInfo(contactInfo) {
    this.phone.set(contactInfo);
    const oldPhone = new ContactInfo(ContactInfoType.PHONE);
    oldPhone.set(contactInfo);
    this.oldPhone = oldPhone;
  }
  async getPerson() {
    const apiCall = this.componentSsoStore.isPrivate ? PersonApi.getCustomerOwnerPerson() : PersonApi.getPerson();
    return apiCall.then(async (response) => this.onGetPersonSuccess(response)).catch(this.onError);
  }
  async updateContactInfoConfirmedTs() {
    await this.contactInfoAPI.putPersonContactInfoConfirmedTs().catch(() => this.onError());
    await this.getPerson();
  }
  async updateEmailOrPhone(contactInfo) {
    const contactInfoResource = contactInfo.getContactInfoResource();
    await this.contactInfoAPI.putContactInfo(this.componentSsoStore.isPrivate, contactInfoResource).catch(() => this.onError());
  }
  async updateCommunicationLanguage(newValue) {
    await this.contactInfoAPI.putPersonCommunicationLanguage(newValue).catch(() => this.onError());
  }
  async createEmailOrPhone(contactInfo) {
    const contactInfoResource = contactInfo.getContactInfoResource();
    await this.contactInfoAPI.postContactInfo(this.componentSsoStore.isPrivate, contactInfoResource, this.customerPersonId).then(
      action(({ data }) => {
        if (this.componentSsoStore.isPrivate) {
          contactInfo.contactInfoId = data;
        }
      })
    ).catch(() => this.onError());
  }
  async createNewCustomer(person, address) {
    const privateCustomer = getPrivateCustomerResource(person, this.email, this.phone, this.communicationLanguage.value, address);
    await this.contactInfoAPI.postPrivateCustomer(privateCustomer).catch(() => this.onError());
    await this.getCustomerAndUpdateSession(person.personalCode, person.personalCodeCountryCode);
  }
  async createNewB2bCustomer(address) {
    const customer = this.getLegalEntity();
    const legalEntityCustomer = getLegalEntityCreation(
      this.componentSsoStore.person,
      this.email,
      this.phone,
      this.communicationLanguage.value,
      address,
      customer
    );
    await this.contactInfoAPI.postLegalEntityCustomer(legalEntityCustomer).catch(() => this.onError());
    await this.getCustomerAndUpdateSession(customer.registrationNumber, customer.registrationNumberCountryCode);
  }
  async getCustomerAndUpdateSession(registrationNumber, registrationNumberCountryCode) {
    await this.getCustomerId(registrationNumber, registrationNumberCountryCode);
    if (this.newCustomerId) {
      this.componentSsoStore.updateSessionByCustomerId(this.newCustomerId);
    }
  }
  async getCustomerId(registrationNumber, registrationNumberCountryCode) {
    try {
      const response = await this.mandateAPI.getPersonMandates();
      const mandate = response.data.find(
        (entity) => entity.registrationNumber === registrationNumber && entity.registrationNumberCountryCode === registrationNumberCountryCode
      );
      this.newCustomerId = mandate.customerId;
      this.customerPersonId = mandate.customerPersonId;
    } catch (e) {
      this.onError();
    }
  }
  onGetPersonSuccess(response) {
    if (response.data !== null) {
      this.onCommunicationLanguageChange(response.data.communicationLanguageCode);
      this.communicationLanguage.oldValue = this.communicationLanguage.value;
      this.contactInfoConfirmedTs = response.data.contactInfoConfirmedTs;
    }
  }
  onCommunicationLanguageChange(value) {
    this.communicationLanguage.value = value;
  }
  setContactInfoUpdated() {
    this.contactInfoUpdated = true;
  }
  setContactInfoNotUpdated() {
    this.contactInfoUpdated = false;
  }
  onLoaded() {
    this.isLoaded = true;
    this.status = "LOADED";
  }
  onError(contactInfo) {
    this.isError = true;
    contactInfo == null ? void 0 : contactInfo.setSavingError(true);
  }
  setIsLoading() {
    this.status = "LOADING";
  }
  setCiConfirmationChecked() {
    this.ciCheckBoxCheckedTimes = this.ciCheckBoxCheckedTimes + 1;
    this.ciCheckBoxValue.push("checked");
  }
  setCiConfirmationUnChecked() {
    this.ciCheckBoxValue.pop();
    this.setContactInfoNotUpdated();
    this.contractStore.setAgreementUnChecked();
    this.contractStore.setContractCheckboxUnChecked();
  }
  get isCiConfirmationChecked() {
    return this.ciCheckBoxValue.length > 0;
  }
  shouldUpdateContactInfo() {
    return this.areMandatoryValuesValid() && this.isCiConfirmationChecked;
  }
  async getCustomerPersonContactInfo() {
    if (this.componentSsoStore.customerId) {
      await this.mandateAPI.getCustomerMandates(this.componentSsoStore.person.personalCode).then(
        action((response) => {
          var _a2;
          const customerMandates = (_a2 = response.data) == null ? void 0 : _a2.customerMandates;
          if (customerMandates && customerMandates.length) {
            this.customerPersonId = customerMandates[0].customerPersonId;
            this.hasRepresentationStipulationForCustomer = customerMandates[0].mandates[0].representationStipulation !== null;
          } else {
            this.onError();
          }
        })
      ).catch(() => this.onError());
    }
    if (this.customerPersonId) {
      await this.getContactInfo(this.customerPersonId);
    }
  }
  getLegalEntity() {
    const { entityToRegister } = this.componentCreditInfoStore;
    const { customer } = this.componentSsoStore;
    return {
      name: !!(entityToRegister == null ? void 0 : entityToRegister.name) ? entityToRegister.name : customer.displayName,
      segment: !!(customer == null ? void 0 : customer.segment) ? customer.segment : "SOHO",
      registrationNumber: !!(entityToRegister == null ? void 0 : entityToRegister.registrationNumber) ? entityToRegister.registrationNumber : customer.registrationNumber,
      registrationNumberCountryCode: !!(entityToRegister == null ? void 0 : entityToRegister.registrationNumberCountryCode) ? entityToRegister.registrationNumberCountryCode : customer.registrationNumberCountryCode
    };
  }
  get isEmailValid() {
    if (!this.email.isInputValid) {
      return false;
    }
    if (!!this.componentSsoStore.dealer) {
      return this.phone.hasValue || this.email.hasValue;
    } else {
      return this.email.hasValue;
    }
  }
  get isPhoneValid() {
    if (!this.phone.isInputValid) {
      return false;
    }
    if (!!this.componentSsoStore.dealer) {
      return this.email.hasValue || this.phone.hasValue;
    } else {
      return this.phone.hasValue;
    }
  }
  areMandatoryValuesValid() {
    return !!this.communicationLanguage.value && this.isPhoneValid && this.isEmailValid;
  }
}
__decorateClass$J([
  observable
], ComponentCustomerContactInfoStore.prototype, "isLoaded", 2);
__decorateClass$J([
  observable
], ComponentCustomerContactInfoStore.prototype, "isError", 2);
__decorateClass$J([
  observable
], ComponentCustomerContactInfoStore.prototype, "ciCheckBoxValue", 2);
__decorateClass$J([
  observable
], ComponentCustomerContactInfoStore.prototype, "ciCheckBoxCheckedTimes", 2);
__decorateClass$J([
  observable
], ComponentCustomerContactInfoStore.prototype, "contactInfoUpdated", 2);
__decorateClass$J([
  observable
], ComponentCustomerContactInfoStore.prototype, "newCustomerId", 2);
__decorateClass$J([
  observable
], ComponentCustomerContactInfoStore.prototype, "customerPersonId", 2);
__decorateClass$J([
  observable
], ComponentCustomerContactInfoStore.prototype, "hasRepresentationStipulationForCustomer", 2);
__decorateClass$J([
  observable
], ComponentCustomerContactInfoStore.prototype, "email", 2);
__decorateClass$J([
  observable
], ComponentCustomerContactInfoStore.prototype, "phone", 2);
__decorateClass$J([
  observable
], ComponentCustomerContactInfoStore.prototype, "oldEmail", 2);
__decorateClass$J([
  observable
], ComponentCustomerContactInfoStore.prototype, "oldPhone", 2);
__decorateClass$J([
  observable
], ComponentCustomerContactInfoStore.prototype, "communicationLanguage", 2);
__decorateClass$J([
  observable
], ComponentCustomerContactInfoStore.prototype, "contactInfoConfirmedTs", 2);
__decorateClass$J([
  observable
], ComponentCustomerContactInfoStore.prototype, "status", 2);
__decorateClass$J([
  action.bound
], ComponentCustomerContactInfoStore.prototype, "init", 1);
__decorateClass$J([
  action.bound
], ComponentCustomerContactInfoStore.prototype, "resetStates", 1);
__decorateClass$J([
  action.bound
], ComponentCustomerContactInfoStore.prototype, "updateSingleContactInfo", 1);
__decorateClass$J([
  action.bound
], ComponentCustomerContactInfoStore.prototype, "updateContactInfo", 1);
__decorateClass$J([
  action.bound
], ComponentCustomerContactInfoStore.prototype, "populateContactInfo", 1);
__decorateClass$J([
  action.bound
], ComponentCustomerContactInfoStore.prototype, "setEmailContactInfo", 1);
__decorateClass$J([
  action.bound
], ComponentCustomerContactInfoStore.prototype, "setPhoneContactInfo", 1);
__decorateClass$J([
  action.bound
], ComponentCustomerContactInfoStore.prototype, "onGetPersonSuccess", 1);
__decorateClass$J([
  action.bound
], ComponentCustomerContactInfoStore.prototype, "onCommunicationLanguageChange", 1);
__decorateClass$J([
  action.bound
], ComponentCustomerContactInfoStore.prototype, "setContactInfoUpdated", 1);
__decorateClass$J([
  action.bound
], ComponentCustomerContactInfoStore.prototype, "setContactInfoNotUpdated", 1);
__decorateClass$J([
  action.bound
], ComponentCustomerContactInfoStore.prototype, "onLoaded", 1);
__decorateClass$J([
  action.bound
], ComponentCustomerContactInfoStore.prototype, "onError", 1);
__decorateClass$J([
  action.bound
], ComponentCustomerContactInfoStore.prototype, "setIsLoading", 1);
__decorateClass$J([
  action.bound
], ComponentCustomerContactInfoStore.prototype, "setCiConfirmationChecked", 1);
__decorateClass$J([
  action.bound
], ComponentCustomerContactInfoStore.prototype, "setCiConfirmationUnChecked", 1);
__decorateClass$J([
  computed
], ComponentCustomerContactInfoStore.prototype, "isCiConfirmationChecked", 1);
__decorateClass$J([
  computed
], ComponentCustomerContactInfoStore.prototype, "isEmailValid", 1);
__decorateClass$J([
  computed
], ComponentCustomerContactInfoStore.prototype, "isPhoneValid", 1);
class ComponentRegistrationStore {
  constructor(rootStore) {
    __publicField(this, "componentCreditInfoStore");
    __publicField(this, "componentContractStore");
    __publicField(this, "componentSsoStore");
    __publicField(this, "componentMandatesStore");
    this.componentCreditInfoStore = rootStore.componentCreditInfoStore;
    this.componentContractStore = rootStore.componentContractStore;
    this.componentSsoStore = rootStore.componentSsoStore;
    this.componentMandatesStore = rootStore.componentMandateStore;
  }
  isEntityToRegisterChosen() {
    return this.componentCreditInfoStore.entityToRegister !== null;
  }
  hasRepresentationStipulationForCustomer() {
    return !!this.componentMandatesStore.stipulationForSsoPerson;
  }
  get hasRepresentationStipulationForEntityToRegister() {
    return !!this.componentCreditInfoStore.getSsoPersonRepresentationStipulationForEntityToRegister;
  }
  get hasRepresentationStipulation() {
    return this.hasRepresentationStipulationForEntityToRegister || this.hasRepresentationStipulationForCustomer();
  }
  get getRepresentationStipulation() {
    if (this.hasRepresentationStipulationForEntityToRegister) {
      return this.componentCreditInfoStore.getSsoPersonRepresentationStipulationForEntityToRegister;
    } else if (this.hasRepresentationStipulationForCustomer()) {
      return this.componentMandatesStore.stipulationForSsoPerson;
    }
    return null;
  }
  get hasSignedContract() {
    return this.componentContractStore.isLoaded && this.componentContractStore.hasSignedContract;
  }
  get hasRegistrableLegalEntities() {
    return this.componentCreditInfoStore.isInitialized && this.componentCreditInfoStore.hasRegistrableEntities;
  }
}
const GET_CREDITINFO_LEGAL_ENTITIES_PATH = "/creditinfo-legal-entities";
class CreditInfoLegalEntitiesAPI {
  constructor(apiBaseUrl) {
    __publicField(this, "componentsApiBaseUrl");
    __publicField(this, "getCreditInfoLegalEntities", () => {
      return API.get(this.componentsApiBaseUrl.concat(GET_CREDITINFO_LEGAL_ENTITIES_PATH));
    });
    __publicField(this, "getCreditInfoLegalEntity", (registrationNumber) => {
      return API.get("".concat(this.componentsApiBaseUrl.concat(GET_CREDITINFO_LEGAL_ENTITIES_PATH), "/").concat(registrationNumber));
    });
    this.componentsApiBaseUrl = apiBaseUrl;
  }
}
var __defProp$D = Object.defineProperty;
var __getOwnPropDesc$G = Object.getOwnPropertyDescriptor;
var __decorateClass$I = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$G(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$D(target, key, result);
  return result;
};
class ComponentCreditInfoStore {
  constructor(rootStore) {
    __publicField(this, "creditInfoLegalEntities", []);
    __publicField(this, "creditInfoLegalEntitiesAPI");
    __publicField(this, "status", "UNINITIALIZED");
    __publicField(this, "isInitialized", false);
    __publicField(this, "entityToRegister", null);
    __publicField(this, "componentSsoStore");
    makeObservable(this);
    this.creditInfoLegalEntitiesAPI = new CreditInfoLegalEntitiesAPI(rootStore.urlDataStore.componentsAPIURL);
    this.componentSsoStore = rootStore.componentSsoStore;
  }
  async init() {
    if (this.isInitialized || this.isLoading) {
      return;
    }
    this.entityToRegister = null;
    await this.getCreditInfoLegalEntities();
  }
  async getCreditInfoLegalEntities() {
    if (!this.isLoading) {
      this.status = "LOADING";
      const response = await this.creditInfoLegalEntitiesAPI.getCreditInfoLegalEntities();
      this.creditInfoLegalEntities = response.data.creditInfoLegalEntities;
    }
    runInAction(() => {
      this.status = "LOADED";
      this.isInitialized = true;
    });
  }
  async getAndSetEntityToRegister(registrationNumber) {
    if (!this.isLoading) {
      this.status = "LOADING";
      const response = await this.creditInfoLegalEntitiesAPI.getCreditInfoLegalEntity(registrationNumber);
      if (response.data.name && response.data.registrationNumber) {
        runInAction(() => {
          this.entityToRegister = { ...response.data, registrationNumberCountryCode: "EE" };
        });
      }
    }
    runInAction(() => {
      this.status = "LOADED";
      this.isInitialized = true;
    });
  }
  get isLoading() {
    return this.status === "LOADING";
  }
  get hasRegistrableEntities() {
    return this.creditInfoLegalEntities.length > 0;
  }
  get getSsoPersonRepresentationStipulationForEntityToRegister() {
    return this.entityToRegister && this.entityToRegister.personRelations && this.entityToRegister.personRelations.find((pr) => this.componentSsoStore.isSamePerson(pr.person.personalCode)).representationStipulation;
  }
}
__decorateClass$I([
  observable
], ComponentCreditInfoStore.prototype, "status", 2);
__decorateClass$I([
  observable
], ComponentCreditInfoStore.prototype, "isInitialized", 2);
__decorateClass$I([
  observable
], ComponentCreditInfoStore.prototype, "entityToRegister", 2);
__decorateClass$I([
  action.bound
], ComponentCreditInfoStore.prototype, "init", 1);
__decorateClass$I([
  action.bound
], ComponentCreditInfoStore.prototype, "getCreditInfoLegalEntities", 1);
__decorateClass$I([
  action.bound
], ComponentCreditInfoStore.prototype, "getAndSetEntityToRegister", 1);
__decorateClass$I([
  computed
], ComponentCreditInfoStore.prototype, "isLoading", 1);
class ContractAPI {
  constructor(apiBaseUrl) {
    __publicField(this, "CUSTOMER_CONTRACT_BASE_PATH", "/customer/contract");
    __publicField(this, "GET_CONTRACT_DOCUMENT_PATH", "/customer/contract/document");
    __publicField(this, "GET_SIGNED_CUSTOMER_CONTRACT_PATH", "/customer/contract/is-signed");
    __publicField(this, "GET_PREPARED_CLICK_ACCEPT_CONTRACT_PATH", "/customer/contract/has-prepared-click-accept");
    __publicField(this, "GET_PREPARED_ON_SCREEN_CONTRACT_PATH", "/customer/contract/has-prepared-on-screen");
    __publicField(this, "GET_PREPARED_PAPER_CONTRACT_PATH", "/customer/contract/has-prepared-paper");
    __publicField(this, "POST_DATA_REFRESH_PATH", "/customer/contract/data-refresh");
    __publicField(this, "POST_SIGN_CONTRACT_PATH", "/customer/contract/sign");
    __publicField(this, "PUT_CUSTOMER_SIGNER_PATH", "/customer/contract/customer-signers");
    __publicField(this, "crmApiBaseUrl");
    this.crmApiBaseUrl = apiBaseUrl;
  }
  getSignedCustomerContract() {
    return API.get(this.crmApiBaseUrl.concat(this.GET_SIGNED_CUSTOMER_CONTRACT_PATH));
  }
  getPreparedClickAcceptContract() {
    return API.get(this.crmApiBaseUrl.concat(this.GET_PREPARED_CLICK_ACCEPT_CONTRACT_PATH));
  }
  getPreparedOnScreenContract() {
    return API.get(this.crmApiBaseUrl.concat(this.GET_PREPARED_ON_SCREEN_CONTRACT_PATH));
  }
  getPreparedPaperContract() {
    return API.get(this.crmApiBaseUrl.concat(this.GET_PREPARED_PAPER_CONTRACT_PATH));
  }
  postContractDataRefresh(contractId) {
    return API.post(this.crmApiBaseUrl.concat(this.POST_DATA_REFRESH_PATH), contractId);
  }
  postNewContract(templateCode) {
    return API.post(this.crmApiBaseUrl.concat(this.CUSTOMER_CONTRACT_BASE_PATH), templateCode, { headers: { "Content-Type": "text/plain" } });
  }
  postSignContract(contractId) {
    return API.post(this.crmApiBaseUrl.concat(this.POST_SIGN_CONTRACT_PATH), contractId);
  }
  postSignDealerContract(contractId) {
    return API.post(this.crmApiBaseUrl.concat("".concat(this.CUSTOMER_CONTRACT_BASE_PATH, "/").concat(contractId, "/signing")));
  }
  postOnScreenSignatures(contractId, data) {
    return API.post(this.crmApiBaseUrl.concat("".concat(this.CUSTOMER_CONTRACT_BASE_PATH, "/").concat(contractId, "/on-screen-signatures")), data);
  }
  getContractDocument(contractId) {
    const queryParams = { ...API_CONF, responseType: "blob", timeout: 1e4 };
    return API.get(this.crmApiBaseUrl.concat("".concat(this.GET_CONTRACT_DOCUMENT_PATH, "/").concat(contractId)), queryParams);
  }
  updateContractSigners(contractId, customerSigners) {
    return API.put(this.crmApiBaseUrl.concat("".concat(this.PUT_CUSTOMER_SIGNER_PATH, "/").concat(contractId)), { customerSigners });
  }
  putEmployeeSigner(contractId, employeeADUsername) {
    return API.put(this.crmApiBaseUrl.concat("".concat(this.CUSTOMER_CONTRACT_BASE_PATH, "/").concat(contractId, "/employee-signer")), { employeeSigner: employeeADUsername });
  }
}
var __defProp$C = Object.defineProperty;
var __getOwnPropDesc$F = Object.getOwnPropertyDescriptor;
var __decorateClass$H = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$F(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$C(target, key, result);
  return result;
};
var ContractType = /* @__PURE__ */ ((ContractType2) => {
  ContractType2["CLICK_ACCEPT"] = "CLICK_ACCEPT";
  ContractType2["PAPER"] = "PAPER";
  ContractType2["ON_SCREEN"] = "ON_SCREEN";
  return ContractType2;
})(ContractType || {});
class ComponentContractStore {
  constructor(rootStore) {
    __publicField(this, "isLoaded", false);
    __publicField(this, "hasAgreedToTerms", false);
    __publicField(this, "isLoading", false);
    __publicField(this, "hasSignedContract", false);
    __publicField(this, "isError", false);
    __publicField(this, "contractCheckboxValue", []);
    __publicField(this, "status", "UNINITIALIZED");
    __publicField(this, "preparedContracts", {});
    __publicField(this, "contractAPI");
    __publicField(this, "urlData");
    __publicField(this, "ssoStore");
    __publicField(this, "componentSignerStore");
    __publicField(this, "apiUrl");
    __publicField(this, "contractType");
    __publicField(this, "updateContractSigners", async () => {
      const selectedSigners = this.componentSignerStore.getSelectedSigners();
      await this.contractAPI.updateContractSigners(this.preparedContract.contractId, selectedSigners);
    });
    makeObservable(this);
    this.urlData = rootStore.urlDataStore;
    this.apiUrl = rootStore.urlDataStore.componentsAPIURL;
    this.contractAPI = new ContractAPI(this.apiUrl);
    this.ssoStore = rootStore.componentSsoStore;
    this.componentSignerStore = rootStore.componentSignerStore;
  }
  async init() {
    this.isLoaded = false;
    this.isError = false;
    this.hasSignedContract = false;
    this.contractType = this.ssoStore.dealer ? "PAPER" : "CLICK_ACCEPT";
    if (this.ssoStore.customerId) {
      this.status = "LOADING";
      await this.fetchExistingSignedContract();
      if (!this.hasSignedContract) {
        await this.fetchExistingPreparedContract();
      }
    }
    if (!this.componentSignerStore.signers || this.componentSignerStore.signers.length === 0) {
      await this.componentSignerStore.initSigners();
    }
    this.onLoaded();
  }
  setContractType(contractType) {
    this.contractType = contractType;
  }
  async fetchExistingPreparedContract() {
    this.setIsLoading(true);
    let apiRequest;
    switch (this.contractType) {
      case "CLICK_ACCEPT":
        apiRequest = this.contractAPI.getPreparedClickAcceptContract();
        break;
      case "PAPER":
        apiRequest = this.contractAPI.getPreparedPaperContract();
        break;
      case "ON_SCREEN":
        apiRequest = this.contractAPI.getPreparedOnScreenContract();
        break;
      default:
        this.onError();
        break;
    }
    await apiRequest.then((response) => {
      this.preparedContracts[this.contractType] = response.data;
      if (this.ssoStore.dealer && this.preparedContract.contractId) {
        this.contractAPI.putEmployeeSigner(this.preparedContract.contractId, this.ssoStore.dealer.userName);
      }
      this.setIsLoading(false);
    }).catch(() => {
      this.onError();
    });
  }
  async refreshContractData() {
    this.setIsLoading(true);
    if (this.preparedContract && !!this.preparedContract.contractId) {
      await this.contractAPI.postContractDataRefresh(this.preparedContract.contractId).catch(() => this.onError());
    } else {
      console.warn("Missing contractId");
    }
    this.setIsLoading(false);
  }
  async createNewContract() {
    this.setIsLoading(true);
    await this.contractAPI.postNewContract(this.contractType).then(() => {
      this.setIsLoading(false);
    }).catch(() => this.onError());
  }
  async signContractAndRedirect(goToUrl) {
    this.setIsLoading(true);
    let apiRequest;
    switch (this.contractType) {
      case "CLICK_ACCEPT":
        apiRequest = this.contractAPI.postSignContract(this.preparedContract.contractId);
        break;
      case "PAPER":
      case "ON_SCREEN":
        apiRequest = this.contractAPI.postSignDealerContract(this.preparedContract.contractId);
        break;
      default:
        this.onError();
        break;
    }
    await apiRequest.then(async () => {
      this.redirectToGivenUrl(goToUrl);
    }).catch(() => {
      this.onError();
    }).finally(() => {
      this.setIsLoading(false);
    });
  }
  async ensurePreparedContractExists() {
    if (!this.preparedContract) {
      await this.fetchExistingPreparedContract();
    }
    if (!this.preparedContract.hasContract) {
      await this.createNewContract();
      await this.fetchExistingPreparedContract();
    }
    if (this.preparedContract.contractId) {
      await this.updateContractSigners();
    }
  }
  redirectToGivenUrl(goToUrl) {
    goToUrl ? LocationUtils.redirectToUrl(goToUrl) : LocationUtils.redirectToUrl(LocationUtils.getDomain());
  }
  setAgreementChecked() {
    this.hasAgreedToTerms = true;
  }
  setAgreementUnChecked() {
    this.hasAgreedToTerms = false;
  }
  setIsLoading(isLoading) {
    this.isLoading = isLoading;
  }
  onLoaded() {
    this.isLoaded = true;
    this.status = "LOADED";
  }
  onExistingContractCheck(response) {
    this.hasSignedContract = response.data;
  }
  onError() {
    this.isLoading = false;
    this.isError = true;
  }
  setContractCheckboxChecked() {
    this.contractCheckboxValue.push("checked");
  }
  setContractCheckboxUnChecked() {
    this.contractCheckboxValue.pop();
  }
  async getContractDocument() {
    const contractDocBytes = await this.contractAPI.getContractDocument(this.preparedContract.contractId);
    return saveAs(contractDocBytes.data, "contract.pdf");
  }
  get generalTermsLink() {
    return this.urlData.generalTermsUrl;
  }
  get preparedContract() {
    return this.preparedContracts[this.contractType];
  }
  async fetchExistingSignedContract() {
    this.setIsLoading(true);
    await this.contractAPI.getSignedCustomerContract().then((response) => {
      this.setIsLoading(false);
      this.onExistingContractCheck(response);
    }).catch(() => {
      this.onError();
    });
  }
}
__decorateClass$H([
  observable
], ComponentContractStore.prototype, "isLoaded", 2);
__decorateClass$H([
  observable
], ComponentContractStore.prototype, "hasAgreedToTerms", 2);
__decorateClass$H([
  observable
], ComponentContractStore.prototype, "isLoading", 2);
__decorateClass$H([
  observable
], ComponentContractStore.prototype, "hasSignedContract", 2);
__decorateClass$H([
  observable
], ComponentContractStore.prototype, "isError", 2);
__decorateClass$H([
  observable
], ComponentContractStore.prototype, "contractCheckboxValue", 2);
__decorateClass$H([
  observable
], ComponentContractStore.prototype, "status", 2);
__decorateClass$H([
  action.bound
], ComponentContractStore.prototype, "init", 1);
__decorateClass$H([
  action.bound
], ComponentContractStore.prototype, "setAgreementChecked", 1);
__decorateClass$H([
  action.bound
], ComponentContractStore.prototype, "setAgreementUnChecked", 1);
__decorateClass$H([
  action.bound
], ComponentContractStore.prototype, "setIsLoading", 1);
__decorateClass$H([
  action.bound
], ComponentContractStore.prototype, "onLoaded", 1);
__decorateClass$H([
  action.bound
], ComponentContractStore.prototype, "onExistingContractCheck", 1);
__decorateClass$H([
  action.bound
], ComponentContractStore.prototype, "onError", 1);
__decorateClass$H([
  action.bound
], ComponentContractStore.prototype, "setContractCheckboxChecked", 1);
__decorateClass$H([
  action.bound
], ComponentContractStore.prototype, "setContractCheckboxUnChecked", 1);
var __defProp$B = Object.defineProperty;
var __getOwnPropDesc$E = Object.getOwnPropertyDescriptor;
var __decorateClass$G = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$E(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$B(target, key, result);
  return result;
};
const _ComponentMandateStore = (_a = class {
  constructor(componentRootStore) {
    __publicField(this, "customerMandates");
    __publicField(this, "componentRootStore");
    __publicField(this, "componentSsoStore");
    __publicField(this, "mandateAPI");
    makeObservable(this);
    this.componentRootStore = componentRootStore;
    this.componentSsoStore = componentRootStore.componentSsoStore;
    this.mandateAPI = new MandateAPI(componentRootStore.urlDataStore.componentsAPIURL);
  }
  async hasCustomerMandate(mandates) {
    const { urlDataStore } = this.componentRootStore;
    const response = await API.get(urlDataStore.componentsAPIURL.concat(_a.CUSTOMER_MANDATES), {
      params: { mandates, stipulationAllowed: true }
    });
    return response.data;
  }
  async initCustomerMandates() {
    if (!!this.componentSsoStore.customerId) {
      await this.mandateAPI.getCustomerMandates().then(
        action((response) => {
          this.customerMandates = response.data.customerMandates;
        })
      ).catch((error) => {
        console.error(error);
      });
    }
  }
  get stipulationForSsoPerson() {
    return !!this.customerMandates && this.customerMandates.find((cm) => this.componentSsoStore.isSamePerson(cm.person.personalCode)).mandates[0].representationStipulation;
  }
}, __publicField(_a, "CUSTOMER_MANDATES", "/mandate/has-any-mandate"), _a);
__decorateClass$G([
  observable
], _ComponentMandateStore.prototype, "customerMandates", 2);
__decorateClass$G([
  computed
], _ComponentMandateStore.prototype, "stipulationForSsoPerson", 1);
let ComponentMandateStore = _ComponentMandateStore;
var __defProp$A = Object.defineProperty;
var __getOwnPropDesc$D = Object.getOwnPropertyDescriptor;
var __decorateClass$F = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$D(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$A(target, key, result);
  return result;
};
class InformationUpdateNoticeStore {
  constructor(rootStore) {
    __publicField(this, "showCustomerServicePasswordSubmitSuccess", false);
    __publicField(this, "componentCustomerContactInfoStore");
    __publicField(this, "setShowCustomerServicePasswordSubmitSuccess", (value) => {
      this.showCustomerServicePasswordSubmitSuccess = value;
    });
    makeObservable(this);
    this.componentCustomerContactInfoStore = rootStore.componentCustomerContactInfoStore;
  }
  get phoneHasError() {
    const { phone } = this.componentCustomerContactInfoStore;
    return !phone.hasValue || this.isPhoneUnvalidated || (phone.validated === false || phone.validated === null) && phone.isEstonianMobilePhoneNumber;
  }
  get isPhoneUnvalidated() {
    const { phone } = this.componentCustomerContactInfoStore;
    return phone.isEstonianMobilePhoneNumber && (phone.validated === false || phone.validated == null && phone.oldValue !== "");
  }
  get emailHasError() {
    return !this.componentCustomerContactInfoStore.email.hasValue || this.isEmailUnvalidated;
  }
  get isEmailUnvalidated() {
    const { email } = this.componentCustomerContactInfoStore;
    return email.validated === false || email.validated == null && email.oldValue !== "";
  }
}
__decorateClass$F([
  observable
], InformationUpdateNoticeStore.prototype, "showCustomerServicePasswordSubmitSuccess", 2);
__decorateClass$F([
  computed
], InformationUpdateNoticeStore.prototype, "phoneHasError", 1);
__decorateClass$F([
  computed
], InformationUpdateNoticeStore.prototype, "isPhoneUnvalidated", 1);
__decorateClass$F([
  computed
], InformationUpdateNoticeStore.prototype, "emailHasError", 1);
__decorateClass$F([
  computed
], InformationUpdateNoticeStore.prototype, "isEmailUnvalidated", 1);
__decorateClass$F([
  action
], InformationUpdateNoticeStore.prototype, "setShowCustomerServicePasswordSubmitSuccess", 2);
class ComponentAddressSuggestionStore {
  constructor(componentRootStore) {
    __publicField(this, "componentRootStore");
    __publicField(this, "urlDataStore");
    this.componentRootStore = componentRootStore;
    this.urlDataStore = componentRootStore.urlDataStore;
  }
  static resolveAddressType(address) {
    if (address.addressRegistryId) {
      return "ADDRESS";
    } else if (address.buildingRegistryId) {
      return "BUILDING";
    }
    return "ROOM";
  }
  fetchAddressResult(queryString) {
    if (!queryString) {
      return Promise.resolve([]);
    }
    return API.get(this.urlDataStore.componentsAPIURL.concat("/address/suggest"), {
      params: { term: queryString },
      timeout: API_CONF.timeout
    }).then((response) => response.data).catch(() => {
      return [];
    });
  }
  getAddressById(addressId) {
    return API.get(this.urlDataStore.componentsAPIURL.concat("/address/".concat(addressId)), { timeout: API_CONF.timeout }).then((result) => result.data).catch(() => {
      return null;
    });
  }
  getAddressFromContactAddress(address) {
    const addressId = address.addressRegistryId || address.buildingRegistryId || address.roomRegistryId;
    const type = ComponentAddressSuggestionStore.resolveAddressType(address);
    return API.get(this.urlDataStore.componentsAPIURL.concat("/address/".concat(addressId)), {
      params: { type },
      timeout: API_CONF.timeout
    }).then((result) => result.data).catch(() => {
      return null;
    });
  }
}
var __defProp$z = Object.defineProperty;
var __getOwnPropDesc$C = Object.getOwnPropertyDescriptor;
var __decorateClass$E = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$C(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$z(target, key, result);
  return result;
};
class ComponentForeignAddressEditStore {
  constructor(componentRootStore) {
    __publicField(this, "initialForeignAddress", {
      id: null,
      countryCode: void 0,
      region: void 0,
      city: void 0,
      building: void 0,
      street: void 0,
      room: void 0,
      postalCode: void 0
    });
    __publicField(this, "newForeignAddress", { ...this.initialForeignAddress });
    __publicField(this, "status", "UNINITIALIZED");
    __publicField(this, "isAddressDirty", false);
    __publicField(this, "hasChanged", false);
    __publicField(this, "componentRootStore");
    __publicField(this, "componentContactAddressStore");
    __publicField(this, "componentSsoStore");
    __publicField(this, "PERSON_ENDPOINT", "/person/contact-address/foreign-address");
    __publicField(this, "LEGAL_ENTITY_ENDPOINT", "/legal-entity/contact-address/foreign-address");
    __publicField(this, "handleError", () => {
      this.status = "ERROR";
    });
    __publicField(this, "handleSuccess", () => {
      this.status = "FETCHED";
      this.componentContactAddressStore.reloadAddress();
    });
    makeObservable(this);
    this.componentRootStore = componentRootStore;
    this.componentContactAddressStore = componentRootStore.componentContactAddressStore;
    this.componentSsoStore = componentRootStore.componentSsoStore;
  }
  setIsAddressDirtyFalse() {
    this.isAddressDirty = false;
  }
  setIsAddressDirtyTrue() {
    this.isAddressDirty = true;
  }
  get addressError() {
    if (!this.isStreetValid || !this.isPostalCodeValid || !this.isCityValid) {
      return true;
    }
    return this.status === "ERROR";
  }
  get isCityValid() {
    return !!this.newForeignAddress.city && this.newForeignAddress.city.length > 0;
  }
  get isStreetValid() {
    return !!this.newForeignAddress.street && this.newForeignAddress.street.length > 0;
  }
  get isPostalCodeValid() {
    return !!this.newForeignAddress.postalCode && this.newForeignAddress.postalCode.length < 11;
  }
  get hasAddressChanged() {
    return this.initialForeignAddress.id !== this.newForeignAddress.id || this.initialForeignAddress.countryCode !== this.newForeignAddress.countryCode || this.initialForeignAddress.region !== this.newForeignAddress.region || this.initialForeignAddress.city !== this.newForeignAddress.city || this.initialForeignAddress.building !== this.newForeignAddress.building || this.initialForeignAddress.street !== this.newForeignAddress.street || this.initialForeignAddress.room !== this.newForeignAddress.room || this.initialForeignAddress.postalCode !== this.newForeignAddress.postalCode || this.hasChanged;
  }
  reset() {
    this.resetForeignAddress();
    this.status = "UNINITIALIZED";
  }
  resetForeignAddress() {
    this.initialForeignAddress = {
      id: null,
      countryCode: void 0,
      region: void 0,
      city: void 0,
      building: void 0,
      street: void 0,
      room: void 0,
      postalCode: void 0
    };
    this.newForeignAddress = { ...this.initialForeignAddress };
  }
  init() {
    const address = this.componentContactAddressStore.contactAddress.address;
    this.initialForeignAddress.countryCode = address.countryCode ? address.countryCode : void 0;
    this.initialForeignAddress.region = address.region ? address.region : void 0;
    this.initialForeignAddress.city = address.city ? address.city : void 0;
    this.initialForeignAddress.street = address.street ? address.street : void 0;
    this.initialForeignAddress.building = address.building ? address.building : void 0;
    this.initialForeignAddress.room = address.room ? address.room : void 0;
    this.initialForeignAddress.postalCode = address.postalCode ? address.postalCode : void 0;
    this.newForeignAddress = { ...this.initialForeignAddress };
  }
  getAddress() {
    this.newForeignAddress.countryCode = this.componentContactAddressStore.countrySelected.value;
    const newContactAddress = this.newForeignAddress;
    const addressId = this.componentContactAddressStore.addressId;
    if (addressId) {
      newContactAddress.id = addressId;
    }
    return newContactAddress;
  }
  async saveAddress() {
    this.newForeignAddress.countryCode = this.componentContactAddressStore.countrySelected.value;
    this.status = "UNINITIALIZED";
    if (!this.hasAddressChanged || this.addressError) {
      return Promise.resolve(false);
    }
    const newAddress = this.getAddress();
    const baseUrl = this.componentRootStore.urlDataStore.componentsAPIURL;
    const isPerson = this.componentSsoStore.isPrivate;
    const fullUrl = baseUrl.concat("".concat(isPerson ? this.PERSON_ENDPOINT : this.LEGAL_ENTITY_ENDPOINT));
    const updateAddress = !!newAddress.id;
    this.status = "FETCHING";
    if (updateAddress) {
      await API.put(fullUrl, newAddress).then(this.handleSuccess).catch(this.handleError);
    } else {
      await API.post(fullUrl, newAddress).then(this.handleSuccess).catch(this.handleError);
    }
    return this.status !== "ERROR";
  }
  setAddressChanged() {
    this.hasChanged = true;
  }
  getAsContactAddress() {
    const { street, room, region, postalCode, countryCode, city, building } = this.newForeignAddress;
    return {
      countryCode,
      region,
      city,
      municipality: city,
      street,
      building,
      room,
      postalCode
    };
  }
}
__decorateClass$E([
  observable
], ComponentForeignAddressEditStore.prototype, "initialForeignAddress", 2);
__decorateClass$E([
  observable
], ComponentForeignAddressEditStore.prototype, "newForeignAddress", 2);
__decorateClass$E([
  observable
], ComponentForeignAddressEditStore.prototype, "status", 2);
__decorateClass$E([
  observable
], ComponentForeignAddressEditStore.prototype, "isAddressDirty", 2);
__decorateClass$E([
  observable
], ComponentForeignAddressEditStore.prototype, "hasChanged", 2);
__decorateClass$E([
  action.bound
], ComponentForeignAddressEditStore.prototype, "setIsAddressDirtyFalse", 1);
__decorateClass$E([
  action.bound
], ComponentForeignAddressEditStore.prototype, "setIsAddressDirtyTrue", 1);
__decorateClass$E([
  computed
], ComponentForeignAddressEditStore.prototype, "addressError", 1);
__decorateClass$E([
  computed
], ComponentForeignAddressEditStore.prototype, "isCityValid", 1);
__decorateClass$E([
  computed
], ComponentForeignAddressEditStore.prototype, "isStreetValid", 1);
__decorateClass$E([
  computed
], ComponentForeignAddressEditStore.prototype, "isPostalCodeValid", 1);
__decorateClass$E([
  computed
], ComponentForeignAddressEditStore.prototype, "hasAddressChanged", 1);
__decorateClass$E([
  action.bound
], ComponentForeignAddressEditStore.prototype, "reset", 1);
__decorateClass$E([
  action.bound
], ComponentForeignAddressEditStore.prototype, "resetForeignAddress", 1);
__decorateClass$E([
  action.bound
], ComponentForeignAddressEditStore.prototype, "init", 1);
__decorateClass$E([
  action.bound
], ComponentForeignAddressEditStore.prototype, "getAddress", 1);
__decorateClass$E([
  action.bound
], ComponentForeignAddressEditStore.prototype, "saveAddress", 1);
__decorateClass$E([
  action.bound
], ComponentForeignAddressEditStore.prototype, "handleError", 2);
__decorateClass$E([
  action.bound
], ComponentForeignAddressEditStore.prototype, "handleSuccess", 2);
__decorateClass$E([
  action.bound
], ComponentForeignAddressEditStore.prototype, "setAddressChanged", 1);
const capitalizeString = (word) => {
  return word && word[0].toUpperCase() + word.slice(1).toLowerCase();
};
const valueOrDash = (value) => {
  return !!value ? value : "-";
};
const formatInvoiceAddress = (address) => {
  const houseName = [address.streetName, address.houseNumber].join(" ") + (address.apartmentNumber ? "-".concat(address.apartmentNumber) : "");
  return [capitalizeString(houseName), [capitalizeString(address.city), address.zipCode].join(" "), capitalizeString(address.county)].join(", ");
};
const formatShortAddress = (address) => {
  const street = address.street || "";
  const building = address.building ? " ".concat(address.building) : "";
  const room = address.room ? "-".concat(address.room) : "";
  const city = address.city ? ", ".concat(address.city) : ", ".concat(address.municipality) || "";
  const postalCode = address.postalCode ? " ".concat(address.postalCode) : "";
  return street + building + room + city + postalCode;
};
const buildingTypes = /* @__PURE__ */ new Map([
  ["korrusmaja", "building.type.apartment.building"],
  ["kaubandusk", "building.type.shopping.mall"],
  ["muunimet", "building.type.other"],
  ["vare", "building.type.ruins"],
  ["kirik", "building.type.church"],
  ["elamu", "building.type.residential"],
  ["ridamaja", "building.type.terraced.house"],
  ["eramu", "building.type.private.house"],
  ["teadmata", "building.type.unknown"],
  ["ärihoone", "building.type.commercial.building"],
  ["üh./t.h.", "building.type.communal.production.building"],
  ["abihoone", "building.type.auxiliary.building"],
  ["paarismaja", "building.type.semi.detached.house"],
  ["tootmish.", "building.type.production.building"]
]);
var __defProp$y = Object.defineProperty;
var __getOwnPropDesc$B = Object.getOwnPropertyDescriptor;
var __decorateClass$D = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$B(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$y(target, key, result);
  return result;
};
class ComponentRegistryAddressEditStore {
  constructor(componentRootStore) {
    __publicField(this, "selectedAddress", null);
    __publicField(this, "newAddress", null);
    __publicField(this, "newRoom", null);
    __publicField(this, "addressText", "");
    __publicField(this, "roomText", "");
    __publicField(this, "addressAutocompleteItems", []);
    __publicField(this, "roomOptions", []);
    __publicField(this, "status", "UNINITIALIZED");
    __publicField(this, "hasAddressChanged", false);
    __publicField(this, "isAddressDirty", false);
    __publicField(this, "isInitializing", false);
    __publicField(this, "componentRootStore");
    __publicField(this, "componentContactAddressStore");
    __publicField(this, "componentAddressSuggestionStore");
    __publicField(this, "componentSsoStore");
    __publicField(this, "translateStore");
    __publicField(this, "PERSON_ENDPOINT", "/person/contact-address/registry-address");
    __publicField(this, "LEGAL_ENTITY_ENDPOINT", "/legal-entity/contact-address/registry-address");
    __publicField(this, "initSelectedAddress", (address) => {
      this.selectedAddress = address;
      this.addressText = this.selectedAddress ? this.selectedAddress.label2 : "";
    });
    __publicField(this, "fetchAddressSuggestions", () => {
      return this.componentAddressSuggestionStore.fetchAddressResult(this.addressText).then(this.onFetchAddressSuccess).catch(console.error);
    });
    __publicField(this, "submitChange", () => {
      this.onAddressChange(this.selectedAddress, findRoom(this.roomOptions, this.roomText));
    });
    __publicField(this, "initRooms", (roomText) => {
      if (roomText === null) {
        roomText = "";
      }
      this.roomText = roomText;
      this.roomOptions = [];
      if (this.selectedAddress && this.selectedAddress.rooms) {
        this.roomOptions = sortAndMapRoomsToSuggestionItems(this.selectedAddress.rooms.filter((r) => r.roomAddressId === this.selectedAddress.id));
      }
    });
    __publicField(this, "onAddressChange", (address, room) => {
      if (!this.isInitializing) {
        this.hasAddressChanged = true;
      }
      this.newAddress = address;
      this.newRoom = room;
    });
    __publicField(this, "onFetchAddressSuccess", (addresses) => {
      this.addressAutocompleteItems = mapAddressesToAutocompleteItems(addresses, this.addressText, this.translateStore);
      this.submitChange();
    });
    __publicField(this, "handleError", () => {
      this.status = "ERROR";
    });
    __publicField(this, "handleSuccess", () => {
      this.status = "FETCHED";
      this.componentContactAddressStore.reloadAddress();
    });
    __publicField(this, "getAsContactAddress", () => {
      const { id, buildingId, house, municipality, postalCode, region, street, cityCounty } = this.newAddress;
      return {
        countryCode: "EE",
        addressRegistryId: id,
        buildingRegistryId: buildingId,
        roomRegistryId: this.newRoom && this.newRoom.roomId,
        postalCode,
        region,
        city: cityCounty,
        municipality,
        street,
        room: this.newRoom && this.newRoom.roomName,
        building: house
      };
    });
    makeObservable(this);
    this.componentRootStore = componentRootStore;
    this.componentContactAddressStore = componentRootStore.componentContactAddressStore;
    this.componentAddressSuggestionStore = componentRootStore.componentAddressSuggestionStore;
    this.componentSsoStore = componentRootStore.componentSsoStore;
    this.translateStore = componentRootStore.componentTranslateStore;
  }
  setIsAddressDirtyFalse() {
    this.isAddressDirty = false;
  }
  setIsAddressDirtyTrue() {
    this.isAddressDirty = true;
  }
  get addressError() {
    return !this.newAddress || this.hasRoomsButNoneSelected();
  }
  reset() {
    this.selectedAddress = null;
    this.newAddress = null;
    this.newRoom = null;
    this.addressText = "";
    this.roomText = "";
    this.addressAutocompleteItems = [];
    this.roomOptions = [];
    this.status = "UNINITIALIZED";
    this.hasAddressChanged = false;
    this.isInitializing = false;
  }
  async init() {
    const address = this.componentContactAddressStore.contactAddress.address;
    this.isInitializing = true;
    await this.getAddressSuggestionIfAddressIdExists(address);
    await this.fetchAddressSuggestions();
    this.initRooms(address.room);
    this.submitChange();
    this.isInitializing = false;
  }
  async getAddressSuggestionIfAddressIdExists(address) {
    if (address.addressRegistryId || address.buildingRegistryId || address.roomRegistryId) {
      await this.componentAddressSuggestionStore.getAddressFromContactAddress(address).then(this.initSelectedAddress);
    }
  }
  async saveAddress() {
    this.status = "UNINITIALIZED";
    if (this.addressValidated && !this.hasAddressChanged || this.addressError) {
      return Promise.resolve(false);
    }
    const newAddress = this.getAddress();
    const baseUrl = this.componentRootStore.urlDataStore.componentsAPIURL;
    const isPerson = this.componentSsoStore.isPrivate;
    const fullUrl = baseUrl.concat("".concat(isPerson ? this.PERSON_ENDPOINT : this.LEGAL_ENTITY_ENDPOINT));
    const updateAddress = !!newAddress.id;
    this.status = "FETCHING";
    if (updateAddress) {
      await API.put(fullUrl, newAddress).then(this.handleSuccess).catch(this.handleError);
    } else {
      await API.post(fullUrl, newAddress).then(this.handleSuccess).catch(this.handleError);
    }
    return this.status !== "ERROR";
  }
  hasRoomsButNoneSelected() {
    var _a2;
    if (!this.newAddress) {
      return false;
    }
    return !!((_a2 = this.roomOptions) == null ? void 0 : _a2.length) && !this.newRoom;
  }
  getAddress() {
    const newContactAddress = addressToRegistryAddress(this.newAddress, this.newRoom);
    const addressId = this.componentContactAddressStore.addressId;
    if (addressId) {
      newContactAddress.id = addressId;
    }
    return newContactAddress;
  }
  setAddressChanged() {
    this.hasAddressChanged = true;
  }
  get addressValidatedOrChanged() {
    var _a2, _b2, _c2, _d2, _e;
    const { contactAddress } = this.componentContactAddressStore;
    return contactAddress === null || contactAddress.validated !== false || ((_b2 = (_a2 = contactAddress == null ? void 0 : contactAddress.address) == null ? void 0 : _a2.addressRegistryId) == null ? void 0 : _b2.toString()) !== ((_c2 = this.newAddress) == null ? void 0 : _c2.id) || ((_d2 = contactAddress == null ? void 0 : contactAddress.address) == null ? void 0 : _d2.room) !== ((_e = this.newRoom) == null ? void 0 : _e.roomName);
  }
  get addressValidated() {
    const { contactAddress } = this.componentContactAddressStore;
    return (contactAddress == null ? void 0 : contactAddress.validated) !== false;
  }
}
__decorateClass$D([
  observable
], ComponentRegistryAddressEditStore.prototype, "selectedAddress", 2);
__decorateClass$D([
  observable
], ComponentRegistryAddressEditStore.prototype, "newAddress", 2);
__decorateClass$D([
  observable
], ComponentRegistryAddressEditStore.prototype, "newRoom", 2);
__decorateClass$D([
  observable
], ComponentRegistryAddressEditStore.prototype, "addressText", 2);
__decorateClass$D([
  observable
], ComponentRegistryAddressEditStore.prototype, "roomText", 2);
__decorateClass$D([
  observable
], ComponentRegistryAddressEditStore.prototype, "addressAutocompleteItems", 2);
__decorateClass$D([
  observable
], ComponentRegistryAddressEditStore.prototype, "roomOptions", 2);
__decorateClass$D([
  observable
], ComponentRegistryAddressEditStore.prototype, "status", 2);
__decorateClass$D([
  observable
], ComponentRegistryAddressEditStore.prototype, "hasAddressChanged", 2);
__decorateClass$D([
  observable
], ComponentRegistryAddressEditStore.prototype, "isAddressDirty", 2);
__decorateClass$D([
  observable
], ComponentRegistryAddressEditStore.prototype, "isInitializing", 2);
__decorateClass$D([
  action.bound
], ComponentRegistryAddressEditStore.prototype, "setIsAddressDirtyFalse", 1);
__decorateClass$D([
  action.bound
], ComponentRegistryAddressEditStore.prototype, "setIsAddressDirtyTrue", 1);
__decorateClass$D([
  computed
], ComponentRegistryAddressEditStore.prototype, "addressError", 1);
__decorateClass$D([
  action.bound
], ComponentRegistryAddressEditStore.prototype, "reset", 1);
__decorateClass$D([
  action.bound
], ComponentRegistryAddressEditStore.prototype, "init", 1);
__decorateClass$D([
  action.bound
], ComponentRegistryAddressEditStore.prototype, "initSelectedAddress", 2);
__decorateClass$D([
  action.bound
], ComponentRegistryAddressEditStore.prototype, "initRooms", 2);
__decorateClass$D([
  action.bound
], ComponentRegistryAddressEditStore.prototype, "saveAddress", 1);
__decorateClass$D([
  action.bound
], ComponentRegistryAddressEditStore.prototype, "onAddressChange", 2);
__decorateClass$D([
  action.bound
], ComponentRegistryAddressEditStore.prototype, "onFetchAddressSuccess", 2);
__decorateClass$D([
  action.bound
], ComponentRegistryAddressEditStore.prototype, "handleError", 2);
__decorateClass$D([
  action.bound
], ComponentRegistryAddressEditStore.prototype, "handleSuccess", 2);
__decorateClass$D([
  action.bound
], ComponentRegistryAddressEditStore.prototype, "setAddressChanged", 1);
__decorateClass$D([
  computed
], ComponentRegistryAddressEditStore.prototype, "addressValidatedOrChanged", 1);
__decorateClass$D([
  computed
], ComponentRegistryAddressEditStore.prototype, "addressValidated", 1);
const parseIntWithNanToNull = (value) => {
  const valueAsNumber = Number.parseInt(value, 10);
  return isNaN(valueAsNumber) ? null : valueAsNumber;
};
const addressToRegistryAddress = (address, room) => {
  if (!address) {
    return null;
  }
  return {
    addressRegistryId: parseIntWithNanToNull(address.id),
    buildingRegistryId: parseIntWithNanToNull(address.buildingId),
    roomRegistryId: room ? parseIntWithNanToNull(room.roomId) : null,
    privatePostalCode: address.postalCode,
    room: room && !room.roomId ? room.roomName : null
  };
};
const findSuggestionItemByLabel$1 = (suggestions, label) => {
  return suggestions.find((item) => item.label === label);
};
const mapAddressesToAutocompleteItems = (addressList, addressText, translateStore) => {
  return addressList.map((address) => ({
    id: address.id,
    url: "#",
    label: address.label2,
    isActive: address.label2 === addressText,
    subLabel: translateStore.translate(buildingTypes.get(address.buildingType))
  }));
};
const sortAndMapRoomsToSuggestionItems = (rooms) => {
  return rooms.map((room) => ({ label: room.roomName, id: room.roomId, url: "#" })).sort((a, b) => {
    const aAsInt = Number.parseInt(a.label, 10);
    const bAsInt = Number.parseInt(b.label, 10);
    if ((isNaN(a.label) || isNaN(b.label)) && aAsInt === bAsInt) {
      return a.label.localeCompare(b.label);
    } else {
      return aAsInt - bAsInt;
    }
  });
};
const findRoom = (roomOptions, roomText) => {
  const roomOption = findSuggestionItemByLabel$1(roomOptions, roomText);
  return roomOption ? { roomId: roomOption.id, roomName: roomOption.label } : null;
};
var __defProp$x = Object.defineProperty;
var __getOwnPropDesc$A = Object.getOwnPropertyDescriptor;
var __decorateClass$C = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$A(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$x(target, key, result);
  return result;
};
const _ComponentContractValidatorStore = (_b = class {
  constructor(componentRootStore) {
    __publicField(this, "componentSsoStore");
    __publicField(this, "componentMandateStore");
    __publicField(this, "componentURLDataStore");
    __publicField(this, "signedCustomerContractExists", null);
    __publicField(this, "customerHasLegalMandate", null);
    __publicField(this, "currentCustomer");
    __publicField(this, "error");
    __publicField(this, "customerInitialized", false);
    __publicField(this, "handleError", (e) => {
      this.error = e;
    });
    makeObservable(this);
    this.componentSsoStore = componentRootStore.componentSsoStore;
    this.componentMandateStore = componentRootStore.componentMandateStore;
    this.componentURLDataStore = componentRootStore.urlDataStore;
  }
  set customer(newCustomer) {
    const doSetCustomer = () => {
      this.currentCustomer = newCustomer;
      runInAction(() => {
        this.signedCustomerContractExists = null;
        this.customerHasLegalMandate = null;
        this.customerInitialized = true;
      });
      if (this.currentCustomer) {
        this.getSignedCustomerContractData();
        if (this.currentCustomer.type === "B2B" && !!this.componentSsoStore.customerId) {
          this.getCustomerHasLegalMandate();
        }
      }
    };
    if (!this.currentCustomer || !newCustomer) {
      doSetCustomer();
      return;
    }
    const customerIdDifferent = this.currentCustomer.customerId !== newCustomer.customerId;
    const registrationNumberDifferent = this.currentCustomer.registrationNumber !== newCustomer.registrationNumber;
    const registrationNumberCountryCodeDifferent = this.currentCustomer.registrationNumberCountryCode !== newCustomer.registrationNumberCountryCode;
    if (customerIdDifferent || registrationNumberDifferent || registrationNumberCountryCodeDifferent) {
      doSetCustomer();
    }
  }
  get isLoading() {
    return !this.customerInitialized || !!this.currentCustomer && this.signedCustomerContractExists === null && this.customerHasLegalMandate === null;
  }
  get shouldRedirect() {
    if (this.error) {
      throw new Error(this.error);
    }
    if (this.componentSsoStore.dealer) {
      return false;
    }
    if (!this.currentCustomer) {
      return false;
    }
    if (!this.currentCustomer.customerId) {
      return true;
    }
    if (this.signedCustomerContractExists === null) {
      return false;
    }
    if (this.currentCustomer.type === "B2B") {
      if (this.customerHasLegalMandate === null) {
        return false;
      }
      return !this.signedCustomerContractExists && this.customerHasLegalMandate;
    }
    if (this.componentSsoStore.isRepresentingSelf) {
      return !this.signedCustomerContractExists;
    }
    return false;
  }
  getSignedCustomerContractData() {
    API.get(this.componentURLDataStore.componentsAPIURL.concat(_b.IS_SIGNED_CUSTOMER_CONTRACT_URL)).then(action((response) => this.signedCustomerContractExists = !!response.data)).catch(this.handleError);
  }
  getCustomerHasLegalMandate() {
    this.componentMandateStore.hasCustomerMandate(["LEGAL"]).then(action((response) => this.customerHasLegalMandate = response)).catch(this.handleError);
  }
}, __publicField(_b, "IS_SIGNED_CUSTOMER_CONTRACT_URL", "/customer/contract/is-signed"), _b);
__decorateClass$C([
  observable
], _ComponentContractValidatorStore.prototype, "signedCustomerContractExists", 2);
__decorateClass$C([
  observable
], _ComponentContractValidatorStore.prototype, "customerHasLegalMandate", 2);
__decorateClass$C([
  observable
], _ComponentContractValidatorStore.prototype, "currentCustomer", 2);
__decorateClass$C([
  observable
], _ComponentContractValidatorStore.prototype, "error", 2);
__decorateClass$C([
  observable
], _ComponentContractValidatorStore.prototype, "customerInitialized", 2);
__decorateClass$C([
  computed
], _ComponentContractValidatorStore.prototype, "isLoading", 1);
__decorateClass$C([
  computed
], _ComponentContractValidatorStore.prototype, "shouldRedirect", 1);
__decorateClass$C([
  action.bound
], _ComponentContractValidatorStore.prototype, "handleError", 2);
let ComponentContractValidatorStore = _ComponentContractValidatorStore;
const GET_POST_DELETE_EMPLOYEE_SIGNATURE_PATH = "/employees/signature";
class EmployeeSignatureAPI {
  constructor(componentsApiBaseUrl) {
    __publicField(this, "componentsApiBaseUrl");
    __publicField(this, "getSignature", () => {
      return API.get(this.componentsApiBaseUrl.concat(GET_POST_DELETE_EMPLOYEE_SIGNATURE_PATH));
    });
    __publicField(this, "saveSignature", (employeeSignature) => {
      return API.post(this.componentsApiBaseUrl.concat(GET_POST_DELETE_EMPLOYEE_SIGNATURE_PATH), employeeSignature);
    });
    __publicField(this, "deleteSignature", () => {
      return API.delete(this.componentsApiBaseUrl.concat(GET_POST_DELETE_EMPLOYEE_SIGNATURE_PATH));
    });
    this.componentsApiBaseUrl = componentsApiBaseUrl;
  }
}
class EmployeeSignatureResource {
  constructor(signature) {
    __publicField(this, "signatureImage");
    this.signatureImage = signature;
  }
}
class ComponentEmployeeSignatureStore {
  constructor(componentRootStore) {
    __publicField(this, "employeeSignature");
    __publicField(this, "employeeSignatureApi");
    this.employeeSignatureApi = new EmployeeSignatureAPI(componentRootStore.urlDataStore.componentsAPIURL);
  }
  async initSignature() {
    var _a2;
    const response = (_a2 = await this.employeeSignatureApi.getSignature()) == null ? void 0 : _a2.data;
    this.employeeSignature = !!response ? response.signatureImage : "";
  }
  get signature() {
    return this.employeeSignature;
  }
  async saveSignature(signature) {
    return this.employeeSignatureApi.saveSignature(new EmployeeSignatureResource(signature));
  }
  deleteSignature() {
    this.employeeSignatureApi.deleteSignature();
  }
}
var __defProp$w = Object.defineProperty;
var __getOwnPropDesc$z = Object.getOwnPropertyDescriptor;
var __decorateClass$B = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$z(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$w(target, key, result);
  return result;
};
class ComponentInformationCheckStore {
  constructor(rootStore) {
    __publicField(this, "informationCheckAccepted", false);
    __publicField(this, "isLoading", true);
    __publicField(this, "componentCustomerContactInfoStore");
    __publicField(this, "componentContactAddressStore");
    __publicField(this, "componentInvoiceSettingsStore");
    __publicField(this, "componentSsoStore");
    __publicField(this, "hasEmailInvoices", () => {
      return this.componentInvoiceSettingsStore.customerInvoiceSettings.invoiceSettings.some((invoice) => invoice.invoiceDeliveries.includes("EMAIL"));
    });
    __publicField(this, "hasPostInvoices", () => {
      return this.componentInvoiceSettingsStore.customerInvoiceSettings.invoiceSettings.some((invoice) => invoice.invoiceDeliveries.includes("POST"));
    });
    makeObservable(this);
    this.componentContactAddressStore = rootStore.componentContactAddressStore;
    this.componentCustomerContactInfoStore = rootStore.componentCustomerContactInfoStore;
    this.componentInvoiceSettingsStore = rootStore.componentInvoiceSettingsStore;
    this.componentSsoStore = rootStore.componentSsoStore;
  }
  async init() {
    if (this.componentSsoStore.customerId && this.isLoading) {
      await this.componentCustomerContactInfoStore.init();
      await this.componentContactAddressStore.init();
      await this.componentInvoiceSettingsStore.init();
      runInAction(() => this.isLoading = false);
    }
  }
  get shouldShowValidationCheck() {
    return this.hasAllContactInfo && (!this.customerAddressValidated || !this.customerEmailValidated || !this.customerPhoneValidated);
  }
  get addressExists() {
    return this.componentContactAddressStore.contactAddress && !!this.componentContactAddressStore.contactAddress.address;
  }
  get customerCommunicationLanguage() {
    return this.componentCustomerContactInfoStore.communicationLanguage.value;
  }
  get customerPhoneValue() {
    return this.componentCustomerContactInfoStore.isLoaded && this.componentCustomerContactInfoStore.phone && this.componentCustomerContactInfoStore.phone.value;
  }
  get customerPhoneValidated() {
    return this.componentCustomerContactInfoStore.isLoaded && this.componentCustomerContactInfoStore.phone && this.componentCustomerContactInfoStore.phone.validated !== false;
  }
  get customerEmailValue() {
    return this.componentCustomerContactInfoStore.isLoaded && this.componentCustomerContactInfoStore.email && this.componentCustomerContactInfoStore.email.value;
  }
  get customerEmailValidated() {
    return this.componentCustomerContactInfoStore.isLoaded && this.componentCustomerContactInfoStore.email && this.componentCustomerContactInfoStore.email.validated !== false;
  }
  get customerAddressFormatted() {
    return this.componentContactAddressStore.isLoaded && this.componentContactAddressStore.contactAddress && this.formatAddress(this.componentContactAddressStore.contactAddress.address);
  }
  get customerAddressValidated() {
    return this.componentContactAddressStore.isLoaded && this.componentContactAddressStore.contactAddress && this.componentContactAddressStore.contactAddress.validated !== false;
  }
  get amountOfInvoices() {
    return this.componentInvoiceSettingsStore.customerInvoiceSettings && this.componentInvoiceSettingsStore.customerInvoiceSettings.invoiceSettings && this.componentInvoiceSettingsStore.customerInvoiceSettings.invoiceSettings.length;
  }
  get contactAddressIsMatchingOnInvoicesAndContactInfo() {
    if (!this.componentInvoiceSettingsStore.customerInvoiceSettings || !this.addressExists) {
      return false;
    }
    let emailAddressExistsOnInvoices, addressExistsOnInvoices;
    const emailAddress = this.componentCustomerContactInfoStore.email.value;
    const contactAddress = this.componentContactAddressStore.contactAddress.address;
    if (emailAddress) {
      emailAddressExistsOnInvoices = this.hasEmailInvoices() ? this.componentInvoiceSettingsStore.customerInvoiceSettings.invoiceSettings.filter((invoice) => invoice.invoiceDeliveries.includes("EMAIL")).every((invoice) => invoice.emailAddresses.includes(emailAddress)) : true;
    } else {
      emailAddressExistsOnInvoices = true;
    }
    if (contactAddress) {
      addressExistsOnInvoices = this.hasPostInvoices() ? this.componentInvoiceSettingsStore.customerInvoiceSettings.invoiceSettings.filter((invoice) => invoice.invoiceDeliveries.includes("POST")).every((invoice) => this.validateInvoiceAndContactAddressAreEqual(invoice.address, contactAddress)) : true;
    } else {
      addressExistsOnInvoices = true;
    }
    return emailAddressExistsOnInvoices && !!addressExistsOnInvoices;
  }
  get isContactInfoOutdated() {
    if (!this.componentCustomerContactInfoStore.isLoaded) {
      return false;
    }
    const { contactInfoConfirmedTs } = this.componentCustomerContactInfoStore;
    const date = /* @__PURE__ */ new Date();
    date.setFullYear(date.getFullYear() - 1);
    return !contactInfoConfirmedTs || new Date(contactInfoConfirmedTs) < date;
  }
  get hasAllContactInfo() {
    return !!this.customerPhoneValue && !!this.customerEmailValue && !!this.customerAddressFormatted;
  }
  formatAddress(address) {
    const houseName = [address.street, address.building].join(" ") + (address.room ? "-".concat(address.room) : "");
    return [
      capitalizeString(houseName),
      [address.city ? capitalizeString(address.city) : capitalizeString(address.municipality), address.postalCode].join(" "),
      capitalizeString(address.region)
    ].join(", ");
  }
  validateInvoiceAndContactAddressAreEqual(invoiceAddress, contactAddress) {
    var _a2, _b2, _c2, _d2, _e, _f, _g, _h;
    if (!invoiceAddress) {
      return false;
    }
    return ((_a2 = contactAddress.city) == null ? void 0 : _a2.toUpperCase()) === ((_b2 = invoiceAddress.city) == null ? void 0 : _b2.toUpperCase()) && ((_c2 = contactAddress.municipality) == null ? void 0 : _c2.toUpperCase()) === ((_d2 = invoiceAddress.municipality) == null ? void 0 : _d2.toUpperCase()) && ((_e = contactAddress.region) == null ? void 0 : _e.toUpperCase()) === ((_f = invoiceAddress.county) == null ? void 0 : _f.toUpperCase()) && contactAddress.postalCode === invoiceAddress.zipCode && ((_g = contactAddress.street) == null ? void 0 : _g.toUpperCase()) === ((_h = invoiceAddress.streetName) == null ? void 0 : _h.toUpperCase()) && contactAddress.building === invoiceAddress.houseNumber && contactAddress.room === invoiceAddress.apartmentNumber;
  }
}
__decorateClass$B([
  observable
], ComponentInformationCheckStore.prototype, "informationCheckAccepted", 2);
__decorateClass$B([
  observable
], ComponentInformationCheckStore.prototype, "isLoading", 2);
__decorateClass$B([
  computed
], ComponentInformationCheckStore.prototype, "shouldShowValidationCheck", 1);
__decorateClass$B([
  computed
], ComponentInformationCheckStore.prototype, "addressExists", 1);
__decorateClass$B([
  computed
], ComponentInformationCheckStore.prototype, "customerCommunicationLanguage", 1);
__decorateClass$B([
  computed
], ComponentInformationCheckStore.prototype, "customerPhoneValue", 1);
__decorateClass$B([
  computed
], ComponentInformationCheckStore.prototype, "customerPhoneValidated", 1);
__decorateClass$B([
  computed
], ComponentInformationCheckStore.prototype, "customerEmailValue", 1);
__decorateClass$B([
  computed
], ComponentInformationCheckStore.prototype, "customerEmailValidated", 1);
__decorateClass$B([
  computed
], ComponentInformationCheckStore.prototype, "customerAddressFormatted", 1);
__decorateClass$B([
  computed
], ComponentInformationCheckStore.prototype, "customerAddressValidated", 1);
__decorateClass$B([
  computed
], ComponentInformationCheckStore.prototype, "amountOfInvoices", 1);
__decorateClass$B([
  computed
], ComponentInformationCheckStore.prototype, "contactAddressIsMatchingOnInvoicesAndContactInfo", 1);
__decorateClass$B([
  computed
], ComponentInformationCheckStore.prototype, "isContactInfoOutdated", 1);
__decorateClass$B([
  computed
], ComponentInformationCheckStore.prototype, "hasAllContactInfo", 1);
var ContentType = /* @__PURE__ */ ((ContentType2) => {
  ContentType2["PERIODIC_INVOICES"] = "PERIODIC_INVOICES";
  ContentType2["MOBILE"] = "MOBILE";
  ContentType2["BROADBAND"] = "BROADBAND";
  ContentType2["STATE_FEES"] = "STATE_FEES";
  ContentType2["FINANCE"] = "FINANCE";
  ContentType2["GOODS"] = "GOODS";
  ContentType2["DEBT"] = "DEBT";
  ContentType2["TELESERVICES"] = "TELESERVICES";
  ContentType2["PENALTY"] = "PENALTY";
  ContentType2["DAX_REF_NUMBER"] = "DAX_REF_NUMBER";
  ContentType2["MASTER_REF_NUMBER"] = "MASTER_REF_NUMBER";
  return ContentType2;
})(ContentType || {});
class ComponentInvoiceNameStore {
  constructor(rootStore) {
    __publicField(this, "ssoStore");
    __publicField(this, "translateStore");
    this.ssoStore = rootStore.componentSsoStore;
    this.translateStore = rootStore.componentTranslateStore;
  }
  getRefNumberName(contentType, assignedName, source) {
    const alwaysShowDefaultName = source === "TBCIS" && contentType === "MOBILE" && this.ssoStore.isPrivate;
    if (alwaysShowDefaultName) {
      return this.getDefaultInvoiceName(contentType);
    }
    if (assignedName) {
      return assignedName;
    }
    return this.getDefaultInvoiceName(contentType);
  }
  getDefaultInvoiceName(contentType) {
    const translate = this.translateStore.translate;
    switch (contentType) {
      case ContentType.MOBILE:
        return translate("dataconfirm.invoices.invoiceName.mobileService");
      case ContentType.BROADBAND:
        if (this.ssoStore.isPrivate) {
          return translate("dataconfirm.invoices.invoiceName.homeService");
        } else {
          return translate("dataconfirm.invoices.invoiceName.businessService");
        }
      case ContentType.GOODS:
        return translate("dataconfirm.invoices.invoiceName.product");
      case ContentType.PERIODIC_INVOICES:
        return translate("dataconfirm.invoices.invoiceName.unified");
      case ContentType.STATE_FEES:
        return translate("dataconfirm.invoices.invoiceName.stateFees");
      case ContentType.FINANCE:
        if (this.ssoStore.isPrivate) {
          return translate("dataconfirm.invoices.invoiceName.financeHome");
        } else {
          return translate("dataconfirm.invoices.invoiceName.financeBusiness");
        }
      case ContentType.DEBT:
        return translate("dataconfirm.invoices.invoiceName.debt");
      case ContentType.TELESERVICES:
        return translate("dataconfirm.invoices.invoiceName.teleServices");
      case ContentType.PENALTY:
        return translate("dataconfirm.invoices.invoiceName.penalty");
      case ContentType.DAX_REF_NUMBER:
        return translate("dataconfirm.invoices.invoiceName.daxRefNumber");
      case ContentType.MASTER_REF_NUMBER:
        return translate("dataconfirm.invoices.invoiceName.masterRefNumber");
      default:
        return translate("dataconfirm.invoices.invoiceName.other");
    }
  }
}
class InvoiceSettingsAPI {
  constructor(apiBaseUrl) {
    __publicField(this, "componentsApiBaseUrl");
    __publicField(this, "getCustomerInvoiceSettings", (customerId, brand) => {
      return API.get(this.componentsApiBaseUrl.concat("/customers/".concat(customerId, "/invoice-settings/brand/").concat(brand)));
    });
    __publicField(this, "getCustomerEInvoiceBankSuppliers", () => {
      return API.get(this.componentsApiBaseUrl.concat("/customers/invoice-settings/einvoice-suppliers"));
    });
    __publicField(this, "putCustomerInvoiceSettings", (customerId, referenceNumber, brand, invoiceSetting) => {
      return API.put(this.componentsApiBaseUrl.concat("/customers/".concat(customerId, "/invoice-settings/").concat(referenceNumber, "/brand/").concat(brand)), invoiceSetting);
    });
    this.componentsApiBaseUrl = apiBaseUrl;
  }
}
class InvoiceMobileNumberValidationAPI {
  constructor(apiBaseUrl) {
    __publicField(this, "componentsApiBaseUrl");
    __publicField(this, "validateMobileNumber", (mobileNumber) => {
      return API.get(this.componentsApiBaseUrl.concat("/mobile/".concat(mobileNumber, "/validate")));
    });
    this.componentsApiBaseUrl = apiBaseUrl;
  }
}
var __defProp$v = Object.defineProperty;
var __getOwnPropDesc$y = Object.getOwnPropertyDescriptor;
var __decorateClass$A = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$y(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$v(target, key, result);
  return result;
};
const _ComponentInvoiceSettingsStore = class _ComponentInvoiceSettingsStore2 {
  constructor(componentRootStore) {
    __publicField(this, "isLoaded", false);
    __publicField(this, "customerInvoiceSettings");
    __publicField(this, "invoiceSaved", false);
    __publicField(this, "saveError", false);
    __publicField(this, "saving", false);
    __publicField(this, "showSaveResultNotice", false);
    __publicField(this, "emailChangeAllVisibility", true);
    __publicField(this, "addressChangeAllVisibility", true);
    __publicField(this, "mobileNumberChangeAllVisibility", true);
    __publicField(this, "oldEmailValue");
    __publicField(this, "oldPhoneValue");
    __publicField(this, "customSuccessText");
    __publicField(this, "eInvoiceSuppliers");
    __publicField(this, "selectedInvoice");
    __publicField(this, "invoiceSettingsAPI");
    __publicField(this, "invoiceMobileNumberValidationAPI");
    __publicField(this, "componentSsoStore");
    __publicField(this, "componentRegistryAddressEditStore");
    __publicField(this, "componentContactAddressStore");
    __publicField(this, "componentCustomerContactInfoStore");
    __publicField(this, "translateStore");
    __publicField(this, "brand");
    __publicField(this, "setInvoice", (invoice) => {
      const invoiceIndex = this.customerInvoiceSettings.invoiceSettings.findIndex((it) => it.refNumber === invoice.refNumber);
      this.customerInvoiceSettings.invoiceSettings[invoiceIndex] = invoice;
    });
    __publicField(this, "setLoaded", (loaded) => {
      this.isLoaded = loaded;
    });
    __publicField(this, "updateAllOldMobileNumbers", async () => {
      const { phone } = this.componentCustomerContactInfoStore;
      const { translate } = this.translateStore;
      const invoicesToUpdate = [];
      this.mobileNumberChangeAllVisibility = false;
      for (const invoice of this.customerInvoiceSettings.invoiceSettings.filter(
        (it) => it.invoiceDeliveries.includes("MOBILE") && it.mobileNumber === this.oldPhoneValue
      )) {
        const invoiceToUpdate = { ...invoice };
        this.updateMobileNumber(invoiceToUpdate, phone.value);
        invoicesToUpdate.push(invoiceToUpdate);
      }
      await this.saveInvoices(invoicesToUpdate);
      runInAction(() => {
        this.customSuccessText = translate("dataconfirm.invoices.invoiceDataChange.updateAllMobileNumbers", { mobileNumber: phone.value });
      });
    });
    __publicField(this, "updateAllAddresses", async () => {
      const { selectedAddress, newRoom } = this.componentRegistryAddressEditStore;
      const { translate } = this.translateStore;
      const invoicesToUpdate = [];
      this.closeAddressChangeAllVisibility();
      for (const invoice of this.customerInvoiceSettings.invoiceSettings.filter((it) => it.invoiceDeliveries.includes("POST"))) {
        if (invoice.invoiceDeliveries.includes("POST")) {
          const invoiceToUpdate = { ...invoice };
          this.updateAddress(invoiceToUpdate, { ...selectedAddress, countryCode: "EE", selectedRoom: newRoom });
          invoicesToUpdate.push(invoiceToUpdate);
        }
      }
      await this.saveInvoices(invoicesToUpdate);
      runInAction(() => {
        this.customSuccessText = translate("dataconfirm.invoices.invoiceDataChange.updateAllAddresses", {
          address: formatInvoiceAddress(_ComponentInvoiceSettingsStore2.convertToInvoiceAddress({ ...selectedAddress, countryCode: "EE", selectedRoom: newRoom }))
        });
      });
    });
    __publicField(this, "updateAllEmails", async () => {
      const { translate } = this.translateStore;
      const { email } = this.componentCustomerContactInfoStore;
      const invoicesWithEmail = this.customerInvoiceSettings.invoiceSettings.filter((it) => it.invoiceDeliveries.includes("EMAIL"));
      const invoicesToUpdate = [];
      this.closeEmailChangeAllVisibility();
      for (const invoice of invoicesWithEmail) {
        const emails = [...invoice.emailAddresses];
        const index = emails.indexOf(this.oldEmailValue);
        if (index !== -1) {
          emails[index] = email.value;
          const invoiceToUpdate = { ...invoice };
          this.updateEmails(invoiceToUpdate, emails);
          invoicesToUpdate.push(invoiceToUpdate);
        }
      }
      await this.saveInvoices(invoicesToUpdate);
      runInAction(() => {
        this.customSuccessText = translate("dataconfirm.invoices.invoiceDataChange.updateAllEmails", { email: email.value });
      });
    });
    __publicField(this, "closeAddressChangeAllVisibility", () => {
      this.addressChangeAllVisibility = false;
    });
    __publicField(this, "closeEmailChangeAllVisibility", () => {
      this.emailChangeAllVisibility = false;
    });
    __publicField(this, "closeMobileNumberChangeAllVisibility", () => {
      this.mobileNumberChangeAllVisibility = false;
    });
    __publicField(this, "closeModal", () => {
      this.selectedInvoice = null;
    });
    __publicField(this, "toDeliveryChannels", (invoiceSettings) => {
      var _a2;
      const translate = this.translateStore.translate;
      const deliveryChannels = [];
      if (invoiceSettings.invoiceDeliveries.includes("INVOICE_CENTRAL")) {
        deliveryChannels.push({
          title: translate("dataconfirm.invoices.invoice.delivery.INVOICE_CENTRAL"),
          description: invoiceSettings.invoiceCentralSupplier
        });
      }
      if (invoiceSettings.invoiceDeliveries.includes("BANK")) {
        const description = ((_a2 = this.eInvoiceSuppliers) == null ? void 0 : _a2.filter((eInvoiceSupplier) => eInvoiceSupplier.type === "INTERNET_BANK").find((bank) => bank.channelCode === invoiceSettings.bankCode).name) || invoiceSettings.ibanOrUserCode;
        deliveryChannels.push({
          title: translate("dataconfirm.invoices.invoice.delivery.BANK"),
          description
        });
      }
      if (invoiceSettings.invoiceDeliveries.includes("MOBILE")) {
        deliveryChannels.push({
          title: translate("dataconfirm.invoices.invoice.delivery.MOBILE"),
          description: invoiceSettings.mobileNumber
        });
      }
      if (invoiceSettings.invoiceDeliveries.includes("EMAIL")) {
        for (const emailAddress of invoiceSettings.emailAddresses) {
          deliveryChannels.push({
            title: translate("dataconfirm.invoices.invoice.delivery.EMAIL"),
            description: emailAddress
          });
        }
      }
      if (invoiceSettings.invoiceDeliveries.includes("POST")) {
        deliveryChannels.push({
          title: translate("dataconfirm.invoices.invoice.delivery.POST"),
          description: invoiceSettings.address.addressLabel
        });
      }
      return deliveryChannels;
    });
    __publicField(this, "selectedRegistryAddressToInvoiceAddress", () => {
      const { selectedAddress, newRoom } = this.componentRegistryAddressEditStore;
      return _ComponentInvoiceSettingsStore2.convertToInvoiceAddress({ ...selectedAddress, countryCode: "EE", selectedRoom: newRoom });
    });
    makeObservable(this);
    this.brand = componentRootStore.brand;
    this.componentSsoStore = componentRootStore.componentSsoStore;
    this.componentRegistryAddressEditStore = componentRootStore.componentRegistryAddressEditStore;
    this.componentContactAddressStore = componentRootStore.componentContactAddressStore;
    this.componentCustomerContactInfoStore = componentRootStore.componentCustomerContactInfoStore;
    this.translateStore = componentRootStore.componentTranslateStore;
    this.invoiceSettingsAPI = new InvoiceSettingsAPI(componentRootStore.urlDataStore.componentsAPIURL);
    this.invoiceMobileNumberValidationAPI = new InvoiceMobileNumberValidationAPI(componentRootStore.urlDataStore.componentsAPIURL);
  }
  init() {
    this.setLoaded(false);
    if (this.componentSsoStore.customerId && this.componentSsoStore.hasAnyTeliaMandate) {
      this.invoiceSettingsAPI.getCustomerEInvoiceBankSuppliers().then((response) => this.eInvoiceSuppliers = response.data);
      return this.invoiceSettingsAPI.getCustomerInvoiceSettings(this.componentSsoStore.customerId, this.brand).then((response) => {
        this.customerInvoiceSettings = response.data;
        this.customerInvoiceSettings.failedToUpdateInvoiceSettings = [];
      }).then(() => {
        this.customerInvoiceSettings.invoiceSettings.forEach((invoice) => {
          invoice.isChanged = false;
          if (invoice.invoiceDeliveries.includes("POST")) {
            invoice.address.addressLabel = formatInvoiceAddress(invoice.address);
          }
        });
        this.setLoaded(true);
      });
    }
    return Promise.resolve();
  }
  updateAddress(invoice, address) {
    invoice.address = _ComponentInvoiceSettingsStore2.convertToInvoiceAddress(address);
    invoice.address.addressLabel = formatInvoiceAddress(invoice.address);
    invoice.isChanged = true;
  }
  async updateEmails(invoice, emails) {
    invoice.emailAddresses = emails;
    invoice.isChanged = true;
  }
  updateMobileNumber(invoice, mobileNumber) {
    invoice.mobileNumber = mobileNumber;
    invoice.isChanged = true;
  }
  openModal(invoice) {
    this.selectedInvoice = invoice;
  }
  setCustomSuccessText(text) {
    this.customSuccessText = text;
  }
  async saveInvoices(invoicesToSave) {
    runInAction(() => {
      this.showSaveResultNotice = false;
      this.saveError = false;
      this.saving = true;
    });
    const invoicesToUpdate = invoicesToSave ? invoicesToSave : this.customerInvoiceSettings.invoiceSettings.filter((invoice) => invoice.isChanged);
    await Promise.all(
      invoicesToUpdate.map((invoice) => {
        return this.invoiceSettingsAPI.putCustomerInvoiceSettings(this.componentSsoStore.customerId, invoice.refNumber, this.brand, invoice).catch(
          action(() => {
            this.saveError = true;
            !this.customerInvoiceSettings.failedToUpdateInvoiceSettings.includes(invoice) && this.customerInvoiceSettings.failedToUpdateInvoiceSettings.push(invoice);
          })
        ).then(
          action(() => {
            if (!this.saveError) {
              this.setInvoice(invoice);
            }
          })
        );
      })
    );
    runInAction(() => {
      this.showSaveResultNotice = true;
      this.saving = false;
    });
  }
  isMobileNumberValidForInvoice(mobileNumber) {
    return this.invoiceMobileNumberValidationAPI.validateMobileNumber(mobileNumber).then((response) => response.data);
  }
  get showChangeAllInvoiceMobileNumbersNotice() {
    var _a2, _b2;
    const { phone } = this.componentCustomerContactInfoStore;
    const { dealer } = this.componentSsoStore;
    return !this.saveError && !this.saving && phone.hasValue && (dealer && this.isMobileNumberValidForInvoice(phone.value) && this.hasPhoneValueChanged(phone) || !dealer && !phone.hasValueChanged && phone.isValidatedSuccessfully) && !!((_a2 = this.customerInvoiceSettings) == null ? void 0 : _a2.invoiceSettings.some((it) => it.invoiceDeliveries.includes("MOBILE"))) && !!((_b2 = this.customerInvoiceSettings) == null ? void 0 : _b2.invoiceSettings.some((it) => it.mobileNumber === this.oldPhoneValue));
  }
  get showChangeAllPostInvoiceEmailNotice() {
    var _a2, _b2;
    const { email, isEmailValid: isEmailValid2 } = this.componentCustomerContactInfoStore;
    const { dealer } = this.componentSsoStore;
    return !this.saveError && !this.saving && email.hasValue && (dealer && isEmailValid2 && this.hasEmailValueChanged(email) || !dealer && !email.hasValueChanged && email.isValidatedSuccessfully) && !!((_a2 = this.customerInvoiceSettings) == null ? void 0 : _a2.invoiceSettings.some((it) => it.invoiceDeliveries.includes("EMAIL"))) && !!((_b2 = this.customerInvoiceSettings) == null ? void 0 : _b2.invoiceSettings.some((it) => it.emailAddresses.includes(this.oldEmailValue)));
  }
  hasEmailValueChanged(email) {
    return email.hasValueChanged || this.oldEmailValue !== email.oldValue;
  }
  hasPhoneValueChanged(phone) {
    return phone.hasValueChanged || this.oldPhoneValue !== phone.oldValue;
  }
  get showChangeAllPostInvoiceAddressesNotice() {
    var _a2, _b2;
    const { isRegistryAddressSelected } = this.componentContactAddressStore;
    const { hasAddressChanged, selectedAddress } = this.componentRegistryAddressEditStore;
    return !this.saveError && !this.saving && isRegistryAddressSelected && this.componentContactAddressStore.isAddressValid() && hasAddressChanged && selectedAddress !== null && ((_a2 = this.customerInvoiceSettings) == null ? void 0 : _a2.invoiceSettings.some((it) => it.invoiceDeliveries.includes("POST"))) && ((_b2 = this.customerInvoiceSettings) == null ? void 0 : _b2.invoiceSettings.filter((it) => it.invoiceDeliveries.includes("POST")).every((invoice) => this.isInvoiceAddressNotMatchingSelectedAddress(invoice.address)));
  }
  isInvoiceAddressNotMatchingSelectedAddress(invoiceAddress) {
    return invoiceAddress.addressLabel !== formatInvoiceAddress(this.selectedRegistryAddressToInvoiceAddress());
  }
  get hasInvoices() {
    return this.customerInvoiceSettings && this.customerInvoiceSettings.invoiceSettings && this.customerInvoiceSettings.invoiceSettings.length > 0;
  }
  static convertToRegistryAddress(address) {
    return {
      fallbackLabel: address.addressLabel,
      addressRegistryId: address.addressRegisterId && address.addressRegisterId.toString(),
      buildingRegistryId: address.buildingRegistryId && address.buildingRegistryId.toString(),
      roomRegistryId: address.roomRegistryId && address.roomRegistryId.toString(),
      postalCode: address.zipCode,
      room: address.apartmentNumber
    };
  }
  static convertToInvoiceAddress(address) {
    var _a2;
    return {
      addressId: address.id ? Number.parseInt(address.id, 10) : null,
      addressRegisterId: address.id && Number.parseInt(address.id, 10),
      buildingRegistryId: address.buildingId && Number.parseInt(address.buildingId, 10),
      country: CountryUtil.getByCountryCode(address.countryCode).label.et.toUpperCase(),
      county: address.region,
      city: address.city ? address.city : address.cityCounty,
      municipality: address.municipality ? address.municipality : address.city ? address.city : address.cityCounty,
      streetName: address.street,
      houseNumber: address.house,
      apartmentNumber: (_a2 = address.selectedRoom) == null ? void 0 : _a2.roomName,
      zipCode: address.postalCode,
      roomRegistryId: address.selectedRoom && Number.parseInt(address.selectedRoom.roomId, 10),
      selected: true,
      type: address.addressType,
      addressLabel: address.label2
    };
  }
};
__decorateClass$A([
  observable
], _ComponentInvoiceSettingsStore.prototype, "isLoaded", 2);
__decorateClass$A([
  observable
], _ComponentInvoiceSettingsStore.prototype, "customerInvoiceSettings", 2);
__decorateClass$A([
  observable
], _ComponentInvoiceSettingsStore.prototype, "invoiceSaved", 2);
__decorateClass$A([
  observable
], _ComponentInvoiceSettingsStore.prototype, "saveError", 2);
__decorateClass$A([
  observable
], _ComponentInvoiceSettingsStore.prototype, "saving", 2);
__decorateClass$A([
  observable
], _ComponentInvoiceSettingsStore.prototype, "showSaveResultNotice", 2);
__decorateClass$A([
  observable
], _ComponentInvoiceSettingsStore.prototype, "emailChangeAllVisibility", 2);
__decorateClass$A([
  observable
], _ComponentInvoiceSettingsStore.prototype, "addressChangeAllVisibility", 2);
__decorateClass$A([
  observable
], _ComponentInvoiceSettingsStore.prototype, "mobileNumberChangeAllVisibility", 2);
__decorateClass$A([
  observable
], _ComponentInvoiceSettingsStore.prototype, "oldEmailValue", 2);
__decorateClass$A([
  observable
], _ComponentInvoiceSettingsStore.prototype, "oldPhoneValue", 2);
__decorateClass$A([
  observable
], _ComponentInvoiceSettingsStore.prototype, "customSuccessText", 2);
__decorateClass$A([
  observable
], _ComponentInvoiceSettingsStore.prototype, "eInvoiceSuppliers", 2);
__decorateClass$A([
  observable
], _ComponentInvoiceSettingsStore.prototype, "selectedInvoice", 2);
__decorateClass$A([
  action.bound
], _ComponentInvoiceSettingsStore.prototype, "setInvoice", 2);
__decorateClass$A([
  action.bound
], _ComponentInvoiceSettingsStore.prototype, "setLoaded", 2);
__decorateClass$A([
  action.bound
], _ComponentInvoiceSettingsStore.prototype, "updateAddress", 1);
__decorateClass$A([
  action.bound
], _ComponentInvoiceSettingsStore.prototype, "updateEmails", 1);
__decorateClass$A([
  action.bound
], _ComponentInvoiceSettingsStore.prototype, "updateMobileNumber", 1);
__decorateClass$A([
  action
], _ComponentInvoiceSettingsStore.prototype, "updateAllEmails", 2);
__decorateClass$A([
  action
], _ComponentInvoiceSettingsStore.prototype, "closeAddressChangeAllVisibility", 2);
__decorateClass$A([
  action
], _ComponentInvoiceSettingsStore.prototype, "closeEmailChangeAllVisibility", 2);
__decorateClass$A([
  action
], _ComponentInvoiceSettingsStore.prototype, "closeMobileNumberChangeAllVisibility", 2);
__decorateClass$A([
  action
], _ComponentInvoiceSettingsStore.prototype, "closeModal", 2);
__decorateClass$A([
  action.bound
], _ComponentInvoiceSettingsStore.prototype, "openModal", 1);
__decorateClass$A([
  action.bound
], _ComponentInvoiceSettingsStore.prototype, "setCustomSuccessText", 1);
__decorateClass$A([
  action.bound
], _ComponentInvoiceSettingsStore.prototype, "saveInvoices", 1);
__decorateClass$A([
  computed
], _ComponentInvoiceSettingsStore.prototype, "showChangeAllInvoiceMobileNumbersNotice", 1);
__decorateClass$A([
  computed
], _ComponentInvoiceSettingsStore.prototype, "showChangeAllPostInvoiceEmailNotice", 1);
__decorateClass$A([
  computed
], _ComponentInvoiceSettingsStore.prototype, "showChangeAllPostInvoiceAddressesNotice", 1);
__decorateClass$A([
  computed
], _ComponentInvoiceSettingsStore.prototype, "hasInvoices", 1);
let ComponentInvoiceSettingsStore = _ComponentInvoiceSettingsStore;
var __defProp$u = Object.defineProperty;
var __getOwnPropDesc$x = Object.getOwnPropertyDescriptor;
var __decorateClass$z = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$x(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$u(target, key, result);
  return result;
};
var ContactChannelsRequiredValidation = /* @__PURE__ */ ((ContactChannelsRequiredValidation2) => {
  ContactChannelsRequiredValidation2[ContactChannelsRequiredValidation2["EMAIL"] = 0] = "EMAIL";
  ContactChannelsRequiredValidation2[ContactChannelsRequiredValidation2["PHONE"] = 1] = "PHONE";
  ContactChannelsRequiredValidation2[ContactChannelsRequiredValidation2["EMAIL_AND_PHONE"] = 2] = "EMAIL_AND_PHONE";
  ContactChannelsRequiredValidation2[ContactChannelsRequiredValidation2["EMAIL_OR_PHONE"] = 3] = "EMAIL_OR_PHONE";
  return ContactChannelsRequiredValidation2;
})(ContactChannelsRequiredValidation || {});
class ContactChannelsData {
  constructor({ languageDisabled, phone, email, communicationLanguageCode, requiredValidation }) {
    __publicField(this, "languageDisabled");
    __publicField(this, "phone");
    __publicField(this, "email");
    __publicField(this, "communicationLanguageCode");
    __publicField(this, "requiredValidation");
    __publicField(this, "changeEmail", (email) => {
      this.email = email;
    });
    __publicField(this, "changePhone", (phone) => {
      this.phone = phone;
    });
    __publicField(this, "changeCommunicationLanguageCode", (communicationLanguageCode) => {
      this.communicationLanguageCode = communicationLanguageCode;
    });
    makeObservable(this);
    this.languageDisabled = languageDisabled || false;
    this.phone = phone || "";
    this.email = email || "";
    this.communicationLanguageCode = communicationLanguageCode;
    this.requiredValidation = requiredValidation || 3;
  }
  get isEmailValid() {
    return this.email ? isEmailValid(this.email) : true;
  }
  get isPhoneValid() {
    return this.phone ? isPhoneValid(this.phone) : true;
  }
  get isEmailRequired() {
    return this.requiredValidation === 0 || this.requiredValidation === 2 || this.requiredValidation === 3 && !this.phone;
  }
  get isPhoneRequired() {
    return this.requiredValidation === 1 || this.requiredValidation === 2 || this.requiredValidation === 3 && !this.email;
  }
  get isValid() {
    if (!this.communicationLanguageCode || this.isEmailRequired && !this.email || this.isPhoneRequired && !this.phone) {
      return false;
    }
    return this.isPhoneValid && this.isEmailValid;
  }
}
__decorateClass$z([
  observable
], ContactChannelsData.prototype, "languageDisabled", 2);
__decorateClass$z([
  observable
], ContactChannelsData.prototype, "phone", 2);
__decorateClass$z([
  observable
], ContactChannelsData.prototype, "email", 2);
__decorateClass$z([
  observable
], ContactChannelsData.prototype, "communicationLanguageCode", 2);
__decorateClass$z([
  observable
], ContactChannelsData.prototype, "requiredValidation", 2);
__decorateClass$z([
  action.bound
], ContactChannelsData.prototype, "changeEmail", 2);
__decorateClass$z([
  action.bound
], ContactChannelsData.prototype, "changePhone", 2);
__decorateClass$z([
  action.bound
], ContactChannelsData.prototype, "changeCommunicationLanguageCode", 2);
__decorateClass$z([
  computed
], ContactChannelsData.prototype, "isEmailValid", 1);
__decorateClass$z([
  computed
], ContactChannelsData.prototype, "isPhoneValid", 1);
__decorateClass$z([
  computed
], ContactChannelsData.prototype, "isEmailRequired", 1);
__decorateClass$z([
  computed
], ContactChannelsData.prototype, "isPhoneRequired", 1);
__decorateClass$z([
  computed
], ContactChannelsData.prototype, "isValid", 1);
var __defProp$t = Object.defineProperty;
var __decorateClass$y = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(target, key, result) || result;
  if (result) __defProp$t(target, key, result);
  return result;
};
class Signer {
  constructor() {
    __publicField(this, "firstName");
    __publicField(this, "lastName");
    __publicField(this, "personalCode");
    __publicField(this, "personalCodeCountryCode");
    __publicField(this, "selected");
    makeObservable(this);
  }
}
__decorateClass$y([
  observable
], Signer.prototype, "selected");
var __defProp$s = Object.defineProperty;
var __decorateClass$x = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(target, key, result) || result;
  if (result) __defProp$s(target, key, result);
  return result;
};
class ComponentSignerStore {
  constructor(rootStore) {
    __publicField(this, "isLoaded", false);
    __publicField(this, "signers", []);
    __publicField(this, "componentSsoStore");
    __publicField(this, "componentMandateStore");
    __publicField(this, "componentCreditInfoStore");
    __publicField(this, "initSigners", async () => {
      if (this.componentSsoStore.isBusiness) {
        if (!!this.componentSsoStore.customerId) {
          await this.initSignersBasedOnCustomer();
        } else {
          await this.initSignersBasedOnEntityToRegister();
        }
      }
      if ((!this.signers || this.signers.length === 0) && this.componentSsoStore.person) {
        this.signers = [this.getSignerFromMandate(this.componentSsoStore.person)];
      }
      this.isLoaded = true;
    });
    __publicField(this, "getSignerFromMandate", (mandate) => {
      const signer = new Signer();
      signer.firstName = mandate.firstName;
      signer.lastName = mandate.lastName;
      signer.personalCode = mandate.personalCode;
      signer.personalCodeCountryCode = mandate.personalCodeCountryCode;
      signer.selected = this.componentSsoStore.isSamePerson(mandate.personalCode);
      return signer;
    });
    __publicField(this, "getSelectedSigners", () => this.signers.filter((signer) => signer.selected).map((signer) => {
      return {
        firstName: signer.firstName,
        lastName: signer.lastName,
        personalCode: signer.personalCode,
        personalCodeCountryCode: signer.personalCodeCountryCode
      };
    }));
    makeObservable(this);
    this.componentSsoStore = rootStore.componentSsoStore;
    this.componentMandateStore = rootStore.componentMandateStore;
    this.componentCreditInfoStore = rootStore.componentCreditInfoStore;
  }
  async initSignersBasedOnEntityToRegister() {
    if (!this.componentCreditInfoStore.entityToRegister) {
      await this.componentCreditInfoStore.getAndSetEntityToRegister(this.componentSsoStore.customerRegistrationNumber);
    }
    const entityToRegister = this.componentCreditInfoStore.entityToRegister;
    if (entityToRegister && entityToRegister.personRelations && entityToRegister.personRelations.length > 0) {
      this.signers = entityToRegister.personRelations.map((relation) => this.getSignerFromMandate(relation.person));
      this.signers = this.signers && this.signers.filter((v, i, a) => a.findIndex((t) => t.personalCode === v.personalCode) === i);
    }
  }
  async initSignersBasedOnCustomer() {
    if (!this.componentMandateStore.customerMandates) {
      await this.componentMandateStore.initCustomerMandates();
    }
    const mandates = this.componentMandateStore.customerMandates;
    this.signers = mandates && mandates.map((mandate) => this.getSignerFromMandate(mandate.person));
  }
}
__decorateClass$x([
  observable
], ComponentSignerStore.prototype, "isLoaded");
__decorateClass$x([
  observable
], ComponentSignerStore.prototype, "signers");
__decorateClass$x([
  action.bound
], ComponentSignerStore.prototype, "initSigners");
var __defProp$r = Object.defineProperty;
var __getOwnPropDesc$w = Object.getOwnPropertyDescriptor;
var __decorateClass$w = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$w(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$r(target, key, result);
  return result;
};
class ComponentSsoStore {
  constructor(componentRootStore, disableTabSync = false, disableSso = false) {
    __publicField(this, "auth");
    __publicField(this, "isLoggingOut", false);
    __publicField(this, "newCustomerId");
    __publicField(this, "loginCallback");
    __publicField(this, "selectedSegment", { label: "SME", value: "SOHO" });
    __publicField(this, "ssoClient");
    __publicField(this, "clientState");
    __publicField(this, "componentRootStore");
    __publicField(this, "handleLogout", () => {
      this.isLoggingOut = true;
      this.clientState = null;
      this.auth = null;
      this.loginCallback = null;
    });
    __publicField(this, "handleLogin", (ssoResult) => {
      var _a2, _b2;
      const isSameCustomer = ((_a2 = this.auth) == null ? void 0 : _a2.customer) && ((_b2 = ssoResult == null ? void 0 : ssoResult.auth) == null ? void 0 : _b2.customer) && this.auth.customer.registrationNumber === ssoResult.auth.customer.registrationNumber && this.auth.customer.registrationNumberCountryCode === ssoResult.auth.customer.registrationNumberCountryCode;
      if (!isSameCustomer) {
        this.clientState = ssoResult;
        this.auth = ssoResult.auth;
      }
      if (this.loginCallback && typeof this.loginCallback === "function") {
        this.loginCallback();
        this.loginCallback = null;
      }
    });
    __publicField(this, "updateSessionByCustomerId", (customerId) => {
      this.ssoClient.updateRepresentativeByCustomerId(customerId);
    });
    __publicField(this, "onLoginWithCallback", (callback) => {
      this.setParameters(callback);
    });
    __publicField(this, "setParameters", (loginCallback) => {
      this.loginCallback = loginCallback;
    });
    __publicField(this, "setSelectedSegment", (newValue) => {
      this.customer.segment = newValue.value;
      this.selectedSegment = newValue;
    });
    __publicField(this, "isSamePerson", (personalCode) => {
      return this.personRegistrationNumber === personalCode;
    });
    __publicField(this, "hasDealerRole", (role) => {
      var _a2, _b2, _c2, _d2;
      return ((_b2 = (_a2 = this.dealer) == null ? void 0 : _a2.roles) == null ? void 0 : _b2.includes(this.getRoleWithEnvironmentSuffix(role))) || ((_d2 = (_c2 = this.dealer) == null ? void 0 : _c2.roles) == null ? void 0 : _d2.includes(role));
    });
    makeObservable(this);
    this.componentRootStore = componentRootStore;
    this.initializeAuthentication(disableTabSync, disableSso);
  }
  initializeAuthentication(disableTabSync, disableSso) {
    if (disableSso) {
      return;
    }
    this.ssoClient = SsoClient.connect(
      {
        onLogout: this.handleLogout,
        onLogin: this.handleLogin,
        disableTabSync
      },
      { authLevel: 2 }
    );
    this.ssoClient.loadInitialState();
  }
  get customerId() {
    return !!this.auth && !!this.auth.customer && this.auth.customer.customerId;
  }
  get customerRegistrationNumber() {
    return this.customer && this.auth.customer.registrationNumber;
  }
  get personRegistrationNumber() {
    return this.auth.person && this.auth.person.personalCode;
  }
  get person() {
    return this.auth && this.auth.person;
  }
  get loggedIn() {
    return !!this.auth && !!this.auth.person;
  }
  get dealer() {
    return this.auth && this.auth.dealer;
  }
  get customer() {
    return this.auth && this.auth.customer;
  }
  get loggedInWithHardAuth() {
    return this.loggedIn && this.auth.authLevel > 1;
  }
  get isSsoLoaded() {
    return !!this.ssoClientState;
  }
  get ssoClientState() {
    return toJS(this.clientState);
  }
  get isPrivate() {
    return this.customer && this.customer.type === "B2C";
  }
  get isBusiness() {
    return this.customer && this.customer.type === "B2B";
  }
  get isRepresentingSelf() {
    return this.person && this.customer && this.person.personalCode === this.customer.registrationNumber && this.person.personalCodeCountryCode === this.customer.registrationNumberCountryCode;
  }
  isUnderage() {
    if (this.person.personalCodeCountryCode === "EE") {
      return isUnderage(this.person.personalCode);
    }
    return false;
  }
  getSegmentOptions() {
    return [
      { label: "SME", value: "SOHO" },
      { label: "large", value: "CORPORATION" },
      { label: "operator", value: "OPERATOR" }
    ];
  }
  get hasAnyTeliaMandate() {
    return this.auth && this.auth.mandates && this.auth.mandates.some((mandate) => !!mandate.elionAccounts || !!mandate.emtAccounts);
  }
  isEstonianCitizen() {
    return this.person.personalCodeCountryCode === "EE";
  }
  getRoleWithEnvironmentSuffix(prefix) {
    const suffix = this.componentRootStore.environment !== "live" ? "_".concat(this.componentRootStore.environment) : "";
    return prefix + suffix;
  }
}
__decorateClass$w([
  observable
], ComponentSsoStore.prototype, "auth", 2);
__decorateClass$w([
  observable
], ComponentSsoStore.prototype, "isLoggingOut", 2);
__decorateClass$w([
  observable
], ComponentSsoStore.prototype, "newCustomerId", 2);
__decorateClass$w([
  observable
], ComponentSsoStore.prototype, "loginCallback", 2);
__decorateClass$w([
  observable
], ComponentSsoStore.prototype, "selectedSegment", 2);
__decorateClass$w([
  observable
], ComponentSsoStore.prototype, "clientState", 2);
__decorateClass$w([
  action.bound
], ComponentSsoStore.prototype, "handleLogout", 2);
__decorateClass$w([
  action.bound
], ComponentSsoStore.prototype, "handleLogin", 2);
__decorateClass$w([
  computed
], ComponentSsoStore.prototype, "customerId", 1);
__decorateClass$w([
  computed
], ComponentSsoStore.prototype, "customerRegistrationNumber", 1);
__decorateClass$w([
  computed
], ComponentSsoStore.prototype, "personRegistrationNumber", 1);
__decorateClass$w([
  computed
], ComponentSsoStore.prototype, "person", 1);
__decorateClass$w([
  computed
], ComponentSsoStore.prototype, "loggedIn", 1);
__decorateClass$w([
  computed
], ComponentSsoStore.prototype, "dealer", 1);
__decorateClass$w([
  computed
], ComponentSsoStore.prototype, "customer", 1);
__decorateClass$w([
  computed
], ComponentSsoStore.prototype, "loggedInWithHardAuth", 1);
__decorateClass$w([
  computed
], ComponentSsoStore.prototype, "isSsoLoaded", 1);
__decorateClass$w([
  computed
], ComponentSsoStore.prototype, "isPrivate", 1);
__decorateClass$w([
  computed
], ComponentSsoStore.prototype, "isBusiness", 1);
__decorateClass$w([
  computed
], ComponentSsoStore.prototype, "isRepresentingSelf", 1);
__decorateClass$w([
  action.bound
], ComponentSsoStore.prototype, "onLoginWithCallback", 2);
__decorateClass$w([
  action.bound
], ComponentSsoStore.prototype, "setParameters", 2);
__decorateClass$w([
  action.bound
], ComponentSsoStore.prototype, "setSelectedSegment", 2);
__decorateClass$w([
  computed
], ComponentSsoStore.prototype, "hasAnyTeliaMandate", 1);
function parseParams(textValue, paramObject) {
  return Object.keys(paramObject).reduce((text, key) => text.replace("${".concat(key, "}"), paramObject[key]), textValue);
}
function getHelperMessageProp(helperText, helperType) {
  switch (helperType) {
    case "valid":
      return { successMessage: helperText };
    case "error":
      return { errorMessage: helperText };
    case "help":
      return { helpMessage: helperText };
    case "employee":
      return { employeeMessage: helperText };
    default:
      return {};
  }
}
class TranslationApi {
  static getTranslations(lang) {
    return API.get(Config.apiUrl.concat("/translations/".concat(lang)));
  }
}
var __defProp$q = Object.defineProperty;
var __getOwnPropDesc$v = Object.getOwnPropertyDescriptor;
var __decorateClass$v = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$v(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$q(target, key, result);
  return result;
};
const containsHtml = (value) => {
  const htmlTagRegexp = new RegExp("<\\/?((?!(iframe)\\b)\\w*)\\/?>");
  return htmlTagRegexp.test(value);
};
class ComponentTranslateStore {
  constructor() {
    __publicField(this, "translations", {});
    __publicField(this, "defaultTranslateAppName", "crmcomponents");
    __publicField(this, "globalTranslateAppName", "global");
    __publicField(this, "translate", (key, paramObject, appName = this.defaultTranslateAppName) => {
      const value = this.getTranslationForGroup(appName, key, paramObject);
      if (containsHtml(value)) {
        return this.translateHtml(value);
      }
      return value;
    });
    __publicField(this, "translateGlobal", (key, paramObject) => this.translate(key, paramObject, this.globalTranslateAppName));
    __publicField(this, "translateHtml", (value) => {
      return /* @__PURE__ */ React__default.createElement("span", { dangerouslySetInnerHTML: { __html: value } });
    });
    __publicField(this, "getTranslationForGroup", (group, key, paramObject) => {
      const groupTranslations = this.translations[group];
      let textValue;
      if (groupTranslations) {
        textValue = groupTranslations[key];
      }
      if (textValue) {
        if (paramObject) {
          return parseParams(textValue, paramObject);
        }
        return textValue;
      }
      return "".concat(group, ":").concat(key);
    });
    makeObservable(this);
    this.fetchTranslations(getCurrentLanguage());
  }
  fetchTranslations(lang) {
    TranslationApi.getTranslations(lang).then(({ data: { translations } }) => this.setTranslations(translations));
  }
  setTranslations(translations) {
    this.translations = translations;
  }
  get globalTranslations() {
    return this.translations[this.globalTranslateAppName];
  }
}
__decorateClass$v([
  observable
], ComponentTranslateStore.prototype, "translations", 2);
__decorateClass$v([
  action.bound
], ComponentTranslateStore.prototype, "setTranslations", 1);
__decorateClass$v([
  computed
], ComponentTranslateStore.prototype, "globalTranslations", 1);
class DevEnv {
  constructor() {
    __publicField(this, "teliaSelfServiceURL", "https://iseteenindus-dev.telia.ee");
    __publicField(this, "diilSelfServiceURL", "https://iseteenindus-dev.diil.ee");
    __publicField(this, "ssoBackendURL", "https://sso-arendus.telia.ee");
    __publicField(this, "estGeneralTermsURL", "https://iseteenindus-dev.telia.ee/images/documents/lepingud/lepingud-ja-tingimused/telia_eesti_as_yldtingimused_est.pdf");
    __publicField(this, "rusGeneralTermsURL", "https://iseteenindus-dev.telia.ee/images/documents/lepingud/lepingud-ja-tingimused/telia_eesti_as_yldtingimused_rus.pdf");
    __publicField(this, "engGeneralTermsURL", "https://iseteenindus-dev.telia.ee/images/documents/lepingud/lepingud-ja-tingimused/telia_eesti_as_yldtingimused_eng.pdf");
    __publicField(this, "estPrivacyNoticeURL", "https://andmed-dev.telia.ee/privaatsusteade");
    __publicField(this, "engPrivacyNoticeURL", "https://andmed-dev.telia.ee/en/privaatsusteade");
    __publicField(this, "rusPrivacyNoticeURL", "https://andmed-dev.telia.ee/ru/privaatsusteade");
    __publicField(this, "estGoToShopUrl", "https://www-dev.telia.ee/kontaktid#esindused");
    __publicField(this, "rusGoToShopUrl", "https://www-dev.telia.ee/ru/kontaktid#esindused");
    __publicField(this, "estContacts", "https://www-dev.telia.ee/kontaktid");
    __publicField(this, "engContacts", "https://www-dev.telia.ee/en/kontaktid");
    __publicField(this, "rusContacts", "https://www-dev.telia.ee/ru/kontaktid");
    __publicField(this, "teliaInvoiceSettingsURL", "https://iseteenindus-dev.telia.ee/arved/seaded");
    __publicField(this, "diilInvoiceSettingsURL", "https://iseteenindus-dev.diil.ee/arved/seaded");
  }
}
class LiveEnv {
  constructor() {
    __publicField(this, "teliaSelfServiceURL", "https://iseteenindus.telia.ee");
    __publicField(this, "diilSelfServiceURL", "https://iseteenindus.diil.ee");
    __publicField(this, "ssoBackendURL", "https://sso.telia.ee");
    __publicField(this, "estGeneralTermsURL", "https://iseteenindus.telia.ee/images/documents/lepingud/lepingud-ja-tingimused/telia_eesti_as_yldtingimused_est.pdf");
    __publicField(this, "engGeneralTermsURL", "https://iseteenindus.telia.ee/images/documents/lepingud/lepingud-ja-tingimused/telia_eesti_as_yldtingimused_eng.pdf");
    __publicField(this, "rusGeneralTermsURL", "https://iseteenindus.telia.ee/images/documents/lepingud/lepingud-ja-tingimused/telia_eesti_as_yldtingimused_rus.pdf");
    __publicField(this, "estPrivacyNoticeURL", "https://andmed.telia.ee/privaatsusteade");
    __publicField(this, "engPrivacyNoticeURL", "https://andmed.telia.ee/en/privaatsusteade");
    __publicField(this, "rusPrivacyNoticeURL", "https://andmed.telia.ee/ru/privaatsusteade");
    __publicField(this, "estGoToShopUrl", "https://www.telia.ee/kontaktid#esindused");
    __publicField(this, "rusGoToShopUrl", "https://www.telia.ee/ru/kontaktid#esindused");
    __publicField(this, "estContacts", "https://www.telia.ee/kontaktid");
    __publicField(this, "engContacts", "https://www.telia.ee/en/kontaktid");
    __publicField(this, "rusContacts", "https://www.telia.ee/ru/kontaktid");
    __publicField(this, "teliaInvoiceSettingsURL", "https://iseteenindus.telia.ee/arved/seaded");
    __publicField(this, "diilInvoiceSettingsURL", "https://iseteenindus.diil.ee/arved/seaded");
  }
}
class TestEnv {
  constructor() {
    __publicField(this, "teliaSelfServiceURL", "https://iseteenindus-test.telia.ee");
    __publicField(this, "diilSelfServiceURL", "https://iseteenindus-test.diil.ee");
    __publicField(this, "ssoBackendURL", "https://sso-test.telia.ee");
    __publicField(this, "estGeneralTermsURL", "https://iseteenindus-test.telia.ee/images/documents/lepingud/lepingud-ja-tingimused/telia_eesti_as_yldtingimused_est.pdf");
    __publicField(this, "engGeneralTermsURL", "https://iseteenindus-test.telia.ee/images/documents/lepingud/lepingud-ja-tingimused/telia_eesti_as_yldtingimused_eng.pdf");
    __publicField(this, "rusGeneralTermsURL", "https://iseteenindus-test.telia.ee/images/documents/lepingud/lepingud-ja-tingimused/telia_eesti_as_yldtingimused_rus.pdf");
    __publicField(this, "estPrivacyNoticeURL", "https://andmed-test.telia.ee/privaatsusteade");
    __publicField(this, "engPrivacyNoticeURL", "https://andmed-test.telia.ee/en/privaatsusteade");
    __publicField(this, "rusPrivacyNoticeURL", "https://andmed-test.telia.ee/ru/privaatsusteade");
    __publicField(this, "estGoToShopUrl", "https://www-test.telia.ee/kontaktid#esindused");
    __publicField(this, "rusGoToShopUrl", "https://www-test.telia.ee/ru/kontaktid#esindused");
    __publicField(this, "estContacts", "https://www-test.telia.ee/kontaktid");
    __publicField(this, "engContacts", "https://www-test.telia.ee/en/kontaktid");
    __publicField(this, "rusContacts", "https://www-test.telia.ee/ru/kontaktid");
    __publicField(this, "teliaInvoiceSettingsURL", "https://iseteenindus-test.telia.ee/arved/seaded");
    __publicField(this, "diilInvoiceSettingsURL", "https://iseteenindus-test.diil.ee/arved/seaded");
  }
}
class EnvironmentPropertiesFactory {
  constructor(environment) {
    __publicField(this, "environment");
    switch (environment) {
      case "dev":
        this.environment = new DevEnv();
        break;
      case "test":
        this.environment = new TestEnv();
        break;
      case "live":
        this.environment = new LiveEnv();
        break;
      default:
        this.environment = new DevEnv();
        break;
    }
  }
  getEnvironment() {
    return this.environment;
  }
}
const _ComponentURLDataStore = class _ComponentURLDataStore {
  constructor(environment) {
    __publicField(this, "redirectUrl");
    __publicField(this, "environment");
    __publicField(this, "invoiceSettingsUrl", (brand) => {
      return brand === "TELIA" ? this.environment.teliaInvoiceSettingsURL : this.environment.diilInvoiceSettingsURL;
    });
    this.environment = new EnvironmentPropertiesFactory(environment).getEnvironment();
    Config.init(this);
  }
  get ssoBackendURL() {
    return this.environment.ssoBackendURL;
  }
  get selfServiceURL() {
    const hostname = window.location.hostname;
    let selfServiceURL = this.environment.teliaSelfServiceURL;
    if (hostname.includes("diil.ee")) {
      selfServiceURL = this.environment.diilSelfServiceURL;
    }
    return selfServiceURL;
  }
  get componentsAPIURL() {
    return this.selfServiceURL.concat("/crm-components-api");
  }
  get generalTermsUrl() {
    const locale = _ComponentURLDataStore.getLocaleFromPath();
    switch (locale) {
      case "en":
        return this.environment.engGeneralTermsURL;
      case "ru":
        return this.environment.rusGeneralTermsURL;
      default:
        return this.environment.estGeneralTermsURL;
    }
  }
  get privacyNoticeUrl() {
    const locale = _ComponentURLDataStore.getLocaleFromPath();
    switch (locale) {
      case "en":
        return this.environment.engPrivacyNoticeURL;
      case "ru":
        return this.environment.rusPrivacyNoticeURL;
      default:
        return this.environment.estPrivacyNoticeURL;
    }
  }
  get goToShopUrl() {
    const locale = _ComponentURLDataStore.getLocaleFromPath();
    if (locale === "ru") {
      return this.environment.rusGoToShopUrl;
    }
    return this.environment.estGoToShopUrl;
  }
  get contactsUrl() {
    const locale = _ComponentURLDataStore.getLocaleFromPath();
    switch (locale) {
      case "en":
        return this.environment.engContacts;
      case "ru":
        return this.environment.rusContacts;
      default:
        return this.environment.estContacts;
    }
  }
  get getPathWithoutLocale() {
    const path = _ComponentURLDataStore.getPath();
    if ((path.startsWith("/et") || path.startsWith("/ru") || path.startsWith("/en")) && path[3] === "/") {
      return path.substring(3);
    } else {
      return path;
    }
  }
  static getLocaleFromPath() {
    const path = _ComponentURLDataStore.getPath();
    if (path.startsWith("/et") || path.startsWith("/ru") || path.startsWith("/en")) {
      return path.substring(1, 3);
    } else {
      return "et";
    }
  }
  isCurrentPath(redirectLink) {
    return redirectLink === this.getPathWithoutLocale;
  }
  static getPath() {
    return window.location.pathname;
  }
};
__publicField(_ComponentURLDataStore, "hasCurrentHost", (url) => {
  return url.startsWith("".concat(window.location.protocol, "//").concat(window.location.host));
});
__publicField(_ComponentURLDataStore, "getPreviousURL", () => document.referrer);
__publicField(_ComponentURLDataStore, "redirectToPreviousUrl", () => {
  document.location.href = _ComponentURLDataStore.getPreviousURL();
});
let ComponentURLDataStore = _ComponentURLDataStore;
class ContactInfoValidationApi {
  static isContactInfoValidated(contactInfoId) {
    return API.get("".concat(Config.apiUrl, "/validation/contact-info/").concat(contactInfoId, "/is-validated"));
  }
  static sendContactInfoValidationCode(contactInfoId) {
    return API.post("".concat(Config.apiUrl, "/validation/contact-info/").concat(contactInfoId, "/send-code"));
  }
  static validateByValidationCodeAndContactInfoId(contactInfoId, validationCode) {
    return API.post("".concat(Config.apiUrl, "/validation/contact-info/").concat(contactInfoId, "/code/").concat(validationCode, "/validate"));
  }
}
var __defProp$p = Object.defineProperty;
var __getOwnPropDesc$u = Object.getOwnPropertyDescriptor;
var __decorateClass$u = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$u(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$p(target, key, result);
  return result;
};
const _ComponentContactInfoValidationStore = (_c = class {
  constructor() {
    __publicField(this, "contactInfo");
    __publicField(this, "validationCodeInputValue", "");
    __publicField(this, "isLoaded", false);
    __publicField(this, "isModalOpen", false);
    __publicField(this, "isErrorOnValidation", false);
    __publicField(this, "isValidationComplete", false);
    __publicField(this, "isResendAllowed", true);
    __publicField(this, "pollingIntervalId", null);
    __publicField(this, "pollingTimeoutId", null);
    makeObservable(this);
    reaction(
      () => this.contactInfo,
      action(() => {
        if (!this.isEmailValidation && this.pollingIntervalId) {
          this.stopPolling();
        }
      })
    );
  }
  init(contactInfo) {
    this.reset();
    this.contactInfo = contactInfo;
    if (this.isEmailValidation) {
      this.startPolling();
    }
    this.isLoaded = true;
  }
  reset() {
    this.stopPolling();
    this.validationCodeInputValue = "";
    this.contactInfo = null;
    this.isLoaded = false;
    this.isModalOpen = false;
    this.isErrorOnValidation = false;
    this.isValidationComplete = false;
    this.isResendAllowed = true;
  }
  get isPhoneInputValid() {
    return this.validationCodeInputValue.trim() !== "";
  }
  get isEmailValidation() {
    var _a2;
    return ((_a2 = this.contactInfo) == null ? void 0 : _a2.type) === ContactInfoType.EMAIL;
  }
  get isPhoneValidation() {
    var _a2;
    return ((_a2 = this.contactInfo) == null ? void 0 : _a2.type) === ContactInfoType.PHONE;
  }
  startPolling() {
    this.pollingIntervalId = setInterval(this.poll.bind(this), _c.POLLING_INTERVAL);
    this.pollingTimeoutId = setTimeout(() => this.stopPolling(), _c.POLLING_DURATION);
  }
  stopPolling() {
    clearInterval(this.pollingIntervalId);
    clearTimeout(this.pollingTimeoutId);
    this.pollingIntervalId = null;
    this.pollingTimeoutId = null;
  }
  poll() {
    ContactInfoValidationApi.isContactInfoValidated(this.contactInfo.contactInfoId).then(
      action((res) => {
        const isValidated = res.data;
        if (isValidated) {
          this.stopPolling();
          this.isValidationComplete = true;
        }
      })
    );
  }
  validatePhone() {
    ContactInfoValidationApi.validateByValidationCodeAndContactInfoId(this.contactInfo.contactInfoId, this.validationCodeInputValue).then(
      action((res) => {
        const isValidated = res.data;
        if (isValidated) {
          this.isValidationComplete = true;
        } else {
          this.isErrorOnValidation = true;
        }
      })
    );
  }
  forbidResend() {
    this.isResendAllowed = false;
    setTimeout(
      action(() => {
        this.isResendAllowed = true;
      }),
      _c.RESEND_COOLDOWN
    );
  }
  sendValidationCode() {
    if (this.isResendAllowed) {
      this.forbidResend();
      ContactInfoValidationApi.sendContactInfoValidationCode(this.contactInfo.contactInfoId);
    }
  }
}, __publicField(_c, "POLLING_INTERVAL", 1e3 * 3), __publicField(_c, "POLLING_DURATION", 1e3 * 60 * 10), __publicField(_c, "RESEND_COOLDOWN", 1e3 * 30), _c);
__decorateClass$u([
  observable
], _ComponentContactInfoValidationStore.prototype, "contactInfo", 2);
__decorateClass$u([
  observable
], _ComponentContactInfoValidationStore.prototype, "validationCodeInputValue", 2);
__decorateClass$u([
  observable
], _ComponentContactInfoValidationStore.prototype, "isLoaded", 2);
__decorateClass$u([
  observable
], _ComponentContactInfoValidationStore.prototype, "isModalOpen", 2);
__decorateClass$u([
  observable
], _ComponentContactInfoValidationStore.prototype, "isErrorOnValidation", 2);
__decorateClass$u([
  observable
], _ComponentContactInfoValidationStore.prototype, "isValidationComplete", 2);
__decorateClass$u([
  observable
], _ComponentContactInfoValidationStore.prototype, "isResendAllowed", 2);
__decorateClass$u([
  observable
], _ComponentContactInfoValidationStore.prototype, "pollingIntervalId", 2);
__decorateClass$u([
  observable
], _ComponentContactInfoValidationStore.prototype, "pollingTimeoutId", 2);
__decorateClass$u([
  action.bound
], _ComponentContactInfoValidationStore.prototype, "init", 1);
__decorateClass$u([
  action.bound
], _ComponentContactInfoValidationStore.prototype, "reset", 1);
__decorateClass$u([
  computed
], _ComponentContactInfoValidationStore.prototype, "isPhoneInputValid", 1);
__decorateClass$u([
  computed
], _ComponentContactInfoValidationStore.prototype, "isEmailValidation", 1);
__decorateClass$u([
  computed
], _ComponentContactInfoValidationStore.prototype, "isPhoneValidation", 1);
__decorateClass$u([
  action.bound
], _ComponentContactInfoValidationStore.prototype, "startPolling", 1);
__decorateClass$u([
  action.bound
], _ComponentContactInfoValidationStore.prototype, "stopPolling", 1);
__decorateClass$u([
  action.bound
], _ComponentContactInfoValidationStore.prototype, "forbidResend", 1);
let ComponentContactInfoValidationStore = _ComponentContactInfoValidationStore;
class CustomerApi {
  static postPrivateCustomer(privateCustomerResource) {
    return API.post("".concat(Config.apiUrl, "/private-customers"), privateCustomerResource);
  }
}
__publicField(CustomerApi, "getFullCustomer", () => {
  return API.get("".concat(Config.apiUrl, "/customer/full"));
});
var __defProp$o = Object.defineProperty;
var __getOwnPropDesc$t = Object.getOwnPropertyDescriptor;
var __decorateClass$t = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$t(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$o(target, key, result);
  return result;
};
class CustomerAccountStore {
  constructor() {
    __publicField(this, "customer");
    __publicField(this, "customerStatus", FetchStatus.UNINITIALIZED);
    __publicField(this, "fetchFullCustomerInfo", async () => {
      this.customerStatus = FetchStatus.FETCHING;
      try {
        const response = await CustomerApi.getFullCustomer();
        runInAction(() => {
          this.customer = response.data;
          this.customerStatus = FetchStatus.FETCHED;
        });
      } catch (e) {
        runInAction(() => {
          this.customerStatus = FetchStatus.ERROR;
        });
      }
    });
    makeObservable(this);
  }
  get isFullCustomerInfoFetching() {
    return [FetchStatus.UNINITIALIZED, FetchStatus.FETCHING].includes(this.customerStatus);
  }
}
__decorateClass$t([
  observable
], CustomerAccountStore.prototype, "customer", 2);
__decorateClass$t([
  observable
], CustomerAccountStore.prototype, "customerStatus", 2);
__decorateClass$t([
  computed
], CustomerAccountStore.prototype, "isFullCustomerInfoFetching", 1);
__decorateClass$t([
  action
], CustomerAccountStore.prototype, "fetchFullCustomerInfo", 2);
const ComponentRootStoreContext = createContext(null);
class ComponentRootStore {
  constructor(environment, brand, disableSsoClientTabSync = false, disableSso = false) {
    __publicField(this, "environment");
    __publicField(this, "brand");
    __publicField(this, "componentSsoStore");
    __publicField(this, "contractValidatorStore");
    __publicField(this, "componentMandateStore");
    __publicField(this, "componentAddressSuggestionStore");
    __publicField(this, "componentContactAddressStore");
    __publicField(this, "componentRegistryAddressEditStore");
    __publicField(this, "componentForeignAddressEditStore");
    __publicField(this, "urlDataStore");
    __publicField(this, "componentTranslateStore");
    __publicField(this, "componentCustomerContactInfoStore");
    __publicField(this, "componentContractStore");
    __publicField(this, "componentRegistrationStore");
    __publicField(this, "componentCreditInfoStore");
    __publicField(this, "componentSignerStore");
    __publicField(this, "componentInvoiceSettingsStore");
    __publicField(this, "componentInvoiceNameStore");
    __publicField(this, "componentInformationCheckStore");
    __publicField(this, "componentEmployeeSignatureStore");
    __publicField(this, "componentContactInfoValidationStore");
    __publicField(this, "componentCustomerAccountStore");
    __publicField(this, "informationUpdateNoticeStore");
    this.environment = environment;
    this.brand = brand;
    this.urlDataStore = new ComponentURLDataStore(environment);
    this.componentSsoStore = new ComponentSsoStore(this, disableSsoClientTabSync, disableSso);
    this.componentMandateStore = new ComponentMandateStore(this);
    this.contractValidatorStore = new ComponentContractValidatorStore(this);
    this.componentTranslateStore = new ComponentTranslateStore();
    this.componentCreditInfoStore = new ComponentCreditInfoStore(this);
    this.componentSignerStore = new ComponentSignerStore(this);
    this.componentContractStore = new ComponentContractStore(this);
    this.componentCustomerContactInfoStore = new ComponentCustomerContactInfoStore(this);
    this.componentRegistrationStore = new ComponentRegistrationStore(this);
    this.componentAddressSuggestionStore = new ComponentAddressSuggestionStore(this);
    this.componentContactAddressStore = new ComponentContactAddressStore(this);
    this.componentRegistryAddressEditStore = new ComponentRegistryAddressEditStore(this);
    this.componentForeignAddressEditStore = new ComponentForeignAddressEditStore(this);
    this.componentInvoiceSettingsStore = new ComponentInvoiceSettingsStore(this);
    this.componentInvoiceNameStore = new ComponentInvoiceNameStore(this);
    this.componentInformationCheckStore = new ComponentInformationCheckStore(this);
    this.componentEmployeeSignatureStore = new ComponentEmployeeSignatureStore(this);
    this.componentContactInfoValidationStore = new ComponentContactInfoValidationStore();
    this.componentCustomerAccountStore = new CustomerAccountStore();
    this.informationUpdateNoticeStore = new InformationUpdateNoticeStore(this);
  }
}
function useStores() {
  return React__default.useContext(MobXProviderContext);
}
const injectStores = (WrappedComponent) => {
  const ExtendedComponent = class extends WrappedComponent {
    UNSAFE_componentWillMount() {
      Object.getOwnPropertyNames(this.props.rootStore).forEach((propertyName) => {
        if (this[propertyName] === void 0) {
          Object.defineProperty(this, propertyName, {
            ...Object.getOwnPropertyDescriptor(this, propertyName),
            value: this.props.rootStore[propertyName]
          });
        }
      });
    }
  };
  return (props) => {
    const rootStore = React__default.useContext(ComponentRootStoreContext);
    return /* @__PURE__ */ React__default.createElement(ExtendedComponent, { ...props, rootStore }, props.children);
  };
};
var __defProp$n = Object.defineProperty;
var __getOwnPropDesc$s = Object.getOwnPropertyDescriptor;
var __decorateClass$s = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$s(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$n(target, key, result);
  return result;
};
let ContractValidator = class extends React.Component {
  constructor(props) {
    super(props);
    __publicField(this, "urlDataStore");
    __publicField(this, "contractValidatorStore");
    __publicField(this, "customer");
    makeObservable(this);
    this.customer = props.customer;
  }
  componentDidUpdate() {
    this.customer = this.props.customer;
  }
  componentDidMount() {
    reaction(
      () => this.customer,
      () => this.contractValidatorStore.customer = this.customer,
      { fireImmediately: true }
    );
  }
  render() {
    if (this.contractValidatorStore.isLoading) {
      return null;
    }
    if (!this.isAlreadyRedirected && this.contractValidatorStore.shouldRedirect) {
      LocationUtils.redirectToUrl(this.props.redirectLink);
      return null;
    }
    return this.props.children;
  }
  get isAlreadyRedirected() {
    return this.urlDataStore.isCurrentPath(this.props.redirectLink);
  }
};
__decorateClass$s([
  observable
], ContractValidator.prototype, "customer", 2);
ContractValidator = __decorateClass$s([
  injectStores,
  observer
], ContractValidator);
var __defProp$m = Object.defineProperty;
var __getOwnPropDesc$r = Object.getOwnPropertyDescriptor;
var __decorateClass$r = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$r(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$m(target, key, result);
  return result;
};
let ComponentRootStoreProvider = class extends React.Component {
  constructor(props) {
    super(props);
    __publicField(this, "componentRootStore");
    makeObservable(this);
    this.componentRootStore = new ComponentRootStore(this.props.environment, this.props.brand, this.props.disableSsoClientTabSync);
  }
  render() {
    return /* @__PURE__ */ React.createElement(LabelProvider, { labels: this.componentRootStore.componentTranslateStore.translations }, /* @__PURE__ */ React.createElement(LanguageContext$1.Provider, { value: this.props.language }, /* @__PURE__ */ React.createElement(Provider, { ...this.componentRootStore }, /* @__PURE__ */ React.createElement(ComponentRootStoreContext.Provider, { value: this.componentRootStore }, this.props.children))));
  }
};
__decorateClass$r([
  observable
], ComponentRootStoreProvider.prototype, "componentRootStore", 2);
ComponentRootStoreProvider = __decorateClass$r([
  observer
], ComponentRootStoreProvider);
const LanguageContext$1 = React.createContext(null);
class GaDataStore {
  static push(data) {
    var _a2;
    if (window.dataLayer) {
      (_a2 = window.dataLayer) == null ? void 0 : _a2.push({
        event: data.event,
        eventCategory: data.page,
        eventLabel: data.id,
        eventAction: data.group
      });
    }
  }
}
const customerIdAsKey = (WrappedComponent) => {
  return observer((props) => {
    const rootStore = useContext(ComponentRootStoreContext);
    return /* @__PURE__ */ React.createElement(WrappedComponent, { ...props, key: rootStore.componentSsoStore.customerId }, props.children);
  });
};
const customerIdAsKeyForFunctionalComponent = (WrappedComponent) => {
  return observer((props) => {
    const rootStore = useContext(MobXProviderContext);
    return /* @__PURE__ */ React.createElement(WrappedComponent, { ...props, key: rootStore.componentSsoStore.customerId }, props.children);
  });
};
var __getOwnPropDesc$q = Object.getOwnPropertyDescriptor;
var __decorateClass$q = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$q(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(result) || result;
  return result;
};
let CustomerContract = class extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "componentTranslateStore");
    __publicField(this, "componentContractStore");
    __publicField(this, "componentSsoStore");
    __publicField(this, "urlDataStore");
  }
  render() {
    const { translate } = this.componentTranslateStore;
    const contractStore = this.componentContractStore;
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Text, null, /* @__PURE__ */ React.createElement(Separator, { spacing: "medium", color: "invisible" }), /* @__PURE__ */ React.createElement(Heading$1, { element: "h2", className: "h4 text-bold" }, translate("registration.contract.heading")), /* @__PURE__ */ React.createElement("p", null, translate("registration.contract.informative.text")), /* @__PURE__ */ React.createElement(AnalyticsTrigger, { trigger: { id: "Link - contract download", callback: "onClick" } }, /* @__PURE__ */ React.createElement(
      Button,
      {
        text: translate("registration.contract.link"),
        link: true,
        iconLeft: "#file-pdf",
        isLoading: contractStore.isLoading || this.props.customerCreationInProgress,
        disabled: contractStore.isLoading || contractStore.isError || this.props.shouldDisableButtons || !!this.componentSsoStore.dealer,
        onClick: () => contractStore.getContractDocument()
      }
    )), /* @__PURE__ */ React.createElement(Separator, { spacing: "xsmall", color: "invisible" }), /* @__PURE__ */ React.createElement(
      ChoiceGroup,
      {
        id: "customer-contract-general-conditions",
        label: "Üldtingimused",
        type: "check",
        purpose: "agreement",
        hideLabel: "no-break",
        options: [
          {
            id: "customerContractAcceptContactConditions",
            labelText: contractStore.contractCheckboxValue.toString(),
            value: contractStore.contractCheckboxValue.toString(),
            disabled: contractStore.isLoading || contractStore.isError || this.props.shouldDisableButtons,
            children: this.getAgreementOptionChildren()
          }
        ],
        value: contractStore.contractCheckboxValue,
        onChange: contractStore.contractCheckboxValue.length === 0 ? () => this.setChoiceGroupCheckedValues() : () => this.setChoiceGroupUnCheckedValues()
      }
    )), /* @__PURE__ */ React.createElement(Separator, { spacing: "medium" }), /* @__PURE__ */ React.createElement(Grid, { align: ["center-xs", "middle-xs"] }, /* @__PURE__ */ React.createElement(GridColumn, { width: ["xs"] }, /* @__PURE__ */ React.createElement(AnalyticsTrigger, { trigger: { id: "Button - Confirm registration", callback: "onClick" } }, /* @__PURE__ */ React.createElement(
      Button,
      {
        text: translate("registration.confirm"),
        type: "expressive",
        iconRight: "#arrow-right",
        disabled: !contractStore.hasAgreedToTerms || contractStore.isLoading || !!this.componentSsoStore.dealer,
        onClick: async () => await contractStore.signContractAndRedirect(this.urlDataStore.redirectUrl || "")
      }
    )))));
  }
  setChoiceGroupCheckedValues() {
    this.componentContractStore.setAgreementChecked();
    this.componentContractStore.setContractCheckboxChecked();
  }
  setChoiceGroupUnCheckedValues() {
    this.componentContractStore.setAgreementUnChecked();
    this.componentContractStore.setContractCheckboxUnChecked();
  }
  getAgreementOptionChildren() {
    const { translate } = this.componentTranslateStore;
    const contractStore = this.componentContractStore;
    return /* @__PURE__ */ React.createElement("span", { className: "text-bold" }, translate("registration.contract.agreement", {
      generalTermsLink: contractStore.generalTermsLink
    }));
  }
};
CustomerContract = __decorateClass$q([
  injectStores,
  observer
], CustomerContract);
var __getOwnPropDesc$p = Object.getOwnPropertyDescriptor;
var __decorateClass$p = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$p(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(result) || result;
  return result;
};
let PaperSigningModal = class extends React__default.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "componentTranslateStore");
    __publicField(this, "componentContractStore");
    __publicField(this, "urlDataStore");
  }
  async componentDidMount() {
    this.componentContractStore.setContractType(ContractType.PAPER);
    await this.componentContractStore.ensurePreparedContractExists();
    await this.componentContractStore.refreshContractData();
  }
  render() {
    const { onClose, dealerRedirectUrl } = this.props;
    const { translate } = this.componentTranslateStore;
    return /* @__PURE__ */ React__default.createElement(Modal, { size: "8-col", hasContentComponent: true, isOpen: true, onClose }, /* @__PURE__ */ React__default.createElement(ModalContent, null, /* @__PURE__ */ React__default.createElement(Heading$1, { element: "h1", className: "h2" }, translate("registration.b2c.dealer.modal.title")), /* @__PURE__ */ React__default.createElement(Separator, { spacing: "xsmall", color: "invisible" }), /* @__PURE__ */ React__default.createElement("p", null, translate("registration.b2c.dealer.modal.info1")), /* @__PURE__ */ React__default.createElement("p", null, translate("registration.b2c.dealer.modal.info2")), /* @__PURE__ */ React__default.createElement(Separator, { spacing: "xsmall", color: "invisible" }), /* @__PURE__ */ React__default.createElement(AnalyticsTrigger, { trigger: { id: "Button - sign on paper download contract", callback: "onClick" } }, /* @__PURE__ */ React__default.createElement(
      Button,
      {
        text: translate("registration.b2c.dealer.modal.contract"),
        link: true,
        isLoading: this.componentContractStore.isLoading,
        disabled: this.componentContractStore.isLoading,
        iconLeft: "#file-pdf",
        onClick: () => this.componentContractStore.getContractDocument()
      }
    ))), /* @__PURE__ */ React__default.createElement(ModalFooter, null, /* @__PURE__ */ React__default.createElement(Grid, { align: ["center-xs"] }, /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs"] }, /* @__PURE__ */ React__default.createElement(AnalyticsTrigger, { trigger: { id: "Button - sign on paper confirm", callback: "onClick" } }, /* @__PURE__ */ React__default.createElement(
      Button,
      {
        type: "employee",
        text: translate("registration.b2c.dealer.modal.confirm"),
        disabled: this.componentContractStore.isLoading,
        onClick: async () => {
          onClose();
          await this.componentContractStore.signContractAndRedirect(dealerRedirectUrl || this.urlDataStore.redirectUrl || "");
        }
      }
    ))))));
  }
};
PaperSigningModal = __decorateClass$p([
  injectStores,
  observer
], PaperSigningModal);
var __defProp$l = Object.defineProperty;
var __getOwnPropDesc$o = Object.getOwnPropertyDescriptor;
var __decorateClass$o = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$o(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$l(target, key, result);
  return result;
};
let DealerSigningButtons = class extends React__default.Component {
  constructor(props) {
    super(props);
    __publicField(this, "currentView", CurrentView.CUSTOMER_INFO);
    __publicField(this, "componentTranslateStore");
    __publicField(this, "componentCustomerContactInfoStore");
    __publicField(this, "componentContractStore");
    __publicField(this, "componentSsoStore");
    __publicField(this, "urlDataStore");
    __publicField(this, "renderContentBlock", () => {
      const { translate } = this.componentTranslateStore;
      return /* @__PURE__ */ React__default.createElement(Text, { className: "text-center" }, /* @__PURE__ */ React__default.createElement(Heading$1, { element: "h4", className: "h3" }, translate("registration.b2c.dealer.title")), /* @__PURE__ */ React__default.createElement(Separator, { spacing: "xsmall", color: "invisible" }), /* @__PURE__ */ React__default.createElement(Grid, { align: ["center-xs"] }, /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs"] }, /* @__PURE__ */ React__default.createElement(AnalyticsTrigger, { trigger: { id: "Button - sign on paper", callback: "onClick" } }, /* @__PURE__ */ React__default.createElement(
        Button,
        {
          text: translate("registration.b2c.dealer.signing.paper"),
          type: "employee",
          onClick: () => this.updateView(CurrentView.DEALER_PAPER_CONTRACT_MODAL),
          disabled: !this.dealerButtonsEnabled
        }
      ))), /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs"] }, /* @__PURE__ */ React__default.createElement(AnalyticsTrigger, { trigger: { id: "Button - sign on screen", callback: "onClick" } }, /* @__PURE__ */ React__default.createElement(
        Button,
        {
          text: translate("registration.b2c.dealer.signing.onscreen"),
          type: "employee",
          onClick: () => this.updateView(CurrentView.DEALER_ON_SCREEN_SIGNING_VIEW),
          disabled: !this.dealerButtonsEnabled
        }
      ))), /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs"] }, /* @__PURE__ */ React__default.createElement(AnalyticsTrigger, { trigger: { id: "Button - sign on phone", callback: "onClick" } }, /* @__PURE__ */ React__default.createElement(
        Button,
        {
          text: translate("registration.dealer.signing.phone"),
          type: "employee",
          onClick: this.signViaPhone,
          disabled: this.componentSsoStore.isBusiness || !this.dealerButtonsEnabled
        }
      ))), this.componentSsoStore.isUnderage() && /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs"] }, /* @__PURE__ */ React__default.createElement(AnalyticsTrigger, { trigger: { id: "Button - enter with underage", callback: "onClick" } }, /* @__PURE__ */ React__default.createElement(
        Button,
        {
          text: translate("registration.dealer.enter.with.underage"),
          type: "employee",
          onClick: this.signViaPhone,
          disabled: this.dealerButtonsSelectUnderAgeDisabled
        }
      )))), this.componentSsoStore.customerId && /* @__PURE__ */ React__default.createElement(AnalyticsTrigger, { trigger: { id: "Button - show customer", callback: "onClick" } }, /* @__PURE__ */ React__default.createElement(
        Button,
        {
          text: translate("registration.dealer.showCustomer"),
          link: true,
          type: "employee",
          iconRight: "#arrow-right",
          onClick: () => this.componentContractStore.redirectToGivenUrl("")
        }
      )), this.currentView === CurrentView.DEALER_PAPER_CONTRACT_MODAL && /* @__PURE__ */ React__default.createElement(PaperSigningModal, { onClose: () => this.updateView(CurrentView.CUSTOMER_INFO), dealerRedirectUrl: this.props.dealerRedirectUrl }));
    });
    __publicField(this, "signViaPhone", async () => {
      this.componentContractStore.setContractType(ContractType.PAPER);
      await this.componentContractStore.ensurePreparedContractExists();
      await this.componentContractStore.refreshContractData();
      await this.componentContractStore.redirectToGivenUrl(this.props.dealerRedirectUrl || this.urlDataStore.redirectUrl || "");
    });
    makeObservable(this);
  }
  render() {
    const { isCiConfirmationChecked, contactInfoUpdated } = this.componentCustomerContactInfoStore;
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, isCiConfirmationChecked && !contactInfoUpdated && this.renderSpinner(), this.renderContentBlock());
  }
  get storesAreLoading() {
    return this.componentContractStore.isLoading || this.componentCustomerContactInfoStore.isLoading();
  }
  updateView(view) {
    this.currentView = view;
    this.props.updateView(this.currentView);
  }
  get dealerButtonsEnabled() {
    if (this.currentView !== CurrentView.CUSTOMER_INFO) {
      return false;
    }
    const { isCiConfirmationChecked, contactInfoUpdated } = this.componentCustomerContactInfoStore;
    const { hasAgreedToTerms } = this.componentContractStore;
    return !this.storesAreLoading && contactInfoUpdated && isCiConfirmationChecked && hasAgreedToTerms;
  }
  get dealerButtonsSelectUnderAgeDisabled() {
    return this.componentContractStore.isLoading || !this.componentSsoStore.customerId || this.componentCustomerContactInfoStore.isLoading();
  }
  renderSpinner() {
    return /* @__PURE__ */ React__default.createElement(Overlay, { className: "overlay--fixed", spinner: true });
  }
};
__decorateClass$o([
  observable
], DealerSigningButtons.prototype, "currentView", 2);
__decorateClass$o([
  computed
], DealerSigningButtons.prototype, "storesAreLoading", 1);
__decorateClass$o([
  action.bound
], DealerSigningButtons.prototype, "updateView", 1);
__decorateClass$o([
  computed
], DealerSigningButtons.prototype, "dealerButtonsEnabled", 1);
__decorateClass$o([
  computed
], DealerSigningButtons.prototype, "dealerButtonsSelectUnderAgeDisabled", 1);
DealerSigningButtons = __decorateClass$o([
  injectStores,
  observer
], DealerSigningButtons);
const SignatureComponent = (signatureProps) => {
  const { label, employee, signature, isDisabled } = signatureProps;
  const canvasRef = React__default.useRef(null);
  function onEnd() {
    if (signatureProps.onEnd && canvasRef.current) {
      signatureProps.onEnd(canvasRef.current.toDataURL("image/svg+xml", {}), signatureProps.index);
    }
  }
  function onClear() {
    canvasRef.current.clear();
    canvasRef.current.on();
    if (signatureProps.onClear) {
      signatureProps.onClear(signatureProps.index);
    }
  }
  return /* @__PURE__ */ React__default.createElement(
    Signature,
    {
      className: isDisabled ? "signature--disabled" : "",
      label,
      employee,
      elementRef: (ref) => {
        if (ref && signature) {
          ref.fromDataURL(signature, {});
          isDisabled && ref.off();
        }
        canvasRef.current = ref;
      },
      onEnd,
      clearButton: { text: "Tühjenda väli", iconLeft: void 0 },
      onClear
    }
  );
};
var __defProp$k = Object.defineProperty;
var __getOwnPropDesc$n = Object.getOwnPropertyDescriptor;
var __decorateClass$n = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$n(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$k(target, key, result);
  return result;
};
let OnScreenSigningView = class extends React__default.Component {
  constructor(props) {
    super(props);
    __publicField(this, "contractDocument");
    __publicField(this, "signatures");
    __publicField(this, "postingSignatures", false);
    __publicField(this, "hasEmployeeSignatureChanged", false);
    __publicField(this, "employeeSignaturePrefilled", false);
    __publicField(this, "componentContractStore");
    __publicField(this, "componentSsoStore");
    __publicField(this, "componentTranslateStore");
    __publicField(this, "componentSignerStore");
    __publicField(this, "urlDataStore");
    __publicField(this, "componentEmployeeSignatureStore");
    __publicField(this, "getCustomerSignaturesBlock", () => {
      const { translate } = this.componentTranslateStore;
      return this.signatures.customerSigners.map((signer, index) => {
        return /* @__PURE__ */ React__default.createElement("div", { key: index }, /* @__PURE__ */ React__default.createElement(Heading$1, { element: "h2", className: "h4" }, "".concat(signer.firstName, " ").concat(signer.lastName), " ", translate("registration.b2c.dealer.signing.onscreen.signature")), /* @__PURE__ */ React__default.createElement(
          SignatureComponent,
          {
            label: [
              translate("registration.b2c.dealer.signing.onscreen.legalRepresentation"),
              translate("registration.b2c.dealer.signing.onscreen.signatureHeading")
            ].join(" "),
            index,
            onEnd: this.onCustomerEnd,
            onClear: this.onCustomerClear
          }
        ));
      });
    });
    __publicField(this, "onCustomerEnd", (signature, index) => {
      this.signatures.customerSigners[index].signature = signature;
    });
    __publicField(this, "onEmployeeEnd", (signature) => {
      this.hasEmployeeSignatureChanged = true;
      this.signatures.employeeSigner.signature = signature;
    });
    __publicField(this, "onCustomerClear", (index) => {
      this.signatures.customerSigners[index].signature = "";
    });
    __publicField(this, "onEmployeeClear", () => {
      this.hasEmployeeSignatureChanged = true;
      this.employeeSignaturePrefilled = false;
      this.componentEmployeeSignatureStore.deleteSignature();
      this.signatures.employeeSigner.signature = "";
    });
    __publicField(this, "sign", async () => {
      this.postingSignatures = true;
      try {
        await this.componentContractStore.contractAPI.postOnScreenSignatures(this.componentContractStore.preparedContract.contractId, this.signatures);
        await this.updateEmployeeSignatureIfChanged();
      } finally {
        runInAction(() => {
          this.postingSignatures = false;
        });
      }
      LocationUtils.redirectToUrl(this.props.redirectUrl || this.urlDataStore.redirectUrl || "");
    });
    makeObservable(this);
  }
  async componentDidMount() {
    window.scrollTo({ top: 0 });
    await this.componentEmployeeSignatureStore.initSignature();
    const { dealer } = this.componentSsoStore;
    const { signature } = this.componentEmployeeSignatureStore;
    if (!!signature) {
      this.employeeSignaturePrefilled = true;
    }
    this.signatures = {
      customerSigners: this.getCustomerSigners,
      employeeSigner: {
        employeeUsername: dealer.userName,
        signature
      }
    };
    this.componentContractStore.setContractType(ContractType.ON_SCREEN);
    await this.componentContractStore.ensurePreparedContractExists();
    await this.componentContractStore.refreshContractData();
    const doc = await this.componentContractStore.contractAPI.getContractDocument(this.componentContractStore.preparedContract.contractId);
    runInAction(() => this.contractDocument = doc.data);
  }
  render() {
    const { translate } = this.componentTranslateStore;
    if (!this.signatures) {
      return /* @__PURE__ */ React__default.createElement(Spinner, null);
    }
    return /* @__PURE__ */ React__default.createElement(Text, null, /* @__PURE__ */ React__default.createElement(Heading$1, { element: "h1", className: "h2" }, translate("registration.b2c.dealer.signing.onscreen.title")), /* @__PURE__ */ React__default.createElement(Heading$1, { element: "h2", className: "h4" }, translate("registration.b2c.dealer.signing.onscreen.documentHeading")), !this.componentContractStore.isLoading && this.contractDocument && /* @__PURE__ */ React__default.createElement("iframe", { src: window.URL.createObjectURL(this.contractDocument), width: "100%", height: "1000" }), this.componentContractStore.isLoading && /* @__PURE__ */ React__default.createElement(Spinner, null), this.getCustomerSignaturesBlock(), /* @__PURE__ */ React__default.createElement(Heading$1, { element: "h2", className: "h4" }, translate("registration.b2c.dealer.signing.onscreen.dealer"), " ", translate("registration.b2c.dealer.signing.onscreen.signature")), /* @__PURE__ */ React__default.createElement(
      SignatureComponent,
      {
        label: translate("registration.b2c.dealer.signing.onscreen.signatureHeading"),
        employee: true,
        onEnd: this.onEmployeeEnd,
        onClear: this.onEmployeeClear,
        signature: this.signatures.employeeSigner.signature,
        isDisabled: this.employeeSignaturePrefilled
      }
    ), /* @__PURE__ */ React__default.createElement(Separator, { color: "invisible", spacing: "medium" }), /* @__PURE__ */ React__default.createElement(Grid, { align: ["middle-xs", "center-xs"] }, /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs"] }, /* @__PURE__ */ React__default.createElement(AnalyticsTrigger, { trigger: { id: "Button - Back from on screen signing", callback: "onClick" } }, /* @__PURE__ */ React__default.createElement(
      Button,
      {
        text: translate("registration.b2c.dealer.signing.onscreen.back"),
        link: true,
        type: "employee",
        iconLeft: "#arrow-left",
        onClick: this.props.onBack
      }
    ))), /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs"] }, /* @__PURE__ */ React__default.createElement(AnalyticsTrigger, { trigger: { id: "Button - sign on screen", callback: "onClick" } }, /* @__PURE__ */ React__default.createElement(
      Button,
      {
        text: translate("registration.b2c.dealer.signing.onscreen.sign"),
        type: "employee",
        isLoading: this.postingSignatures,
        disabled: this.signingDisabled,
        onClick: this.sign
      }
    )))));
  }
  get signingDisabled() {
    return this.postingSignatures || this.signatures.customerSigners[0] && (!this.signatures.customerSigners[0].signature || !this.signatures.employeeSigner.signature);
  }
  get getCustomerSigners() {
    return this.componentSignerStore.getSelectedSigners().map((signer) => {
      return {
        firstName: signer.firstName,
        lastName: signer.lastName,
        personalCode: signer.personalCode,
        personalCodeCountryCode: signer.personalCodeCountryCode,
        basisOfRepresentationCode: "LEGAL",
        signature: ""
      };
    });
  }
  async updateEmployeeSignatureIfChanged() {
    if (this.hasEmployeeSignatureChanged) {
      return this.componentEmployeeSignatureStore.saveSignature(this.signatures.employeeSigner.signature);
    }
    return null;
  }
};
__decorateClass$n([
  observable
], OnScreenSigningView.prototype, "contractDocument", 2);
__decorateClass$n([
  observable
], OnScreenSigningView.prototype, "signatures", 2);
__decorateClass$n([
  observable
], OnScreenSigningView.prototype, "postingSignatures", 2);
__decorateClass$n([
  action.bound
], OnScreenSigningView.prototype, "sign", 2);
__decorateClass$n([
  computed
], OnScreenSigningView.prototype, "signingDisabled", 1);
OnScreenSigningView = __decorateClass$n([
  injectStores,
  observer
], OnScreenSigningView);
var __defProp$j = Object.defineProperty;
var __getOwnPropDesc$m = Object.getOwnPropertyDescriptor;
var __decorateClass$m = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$m(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$j(target, key, result);
  return result;
};
let CountrySelect = class extends React.Component {
  constructor(props) {
    super(props);
    __publicField(this, "componentContactAddressStore");
    __publicField(this, "componentTranslateStore");
    __publicField(this, "changeCountry", (value) => {
      this.componentContactAddressStore.countrySelected = value;
      this.componentContactAddressStore.setIsAddressDirtyTrue();
      this.componentContactAddressStore.setAddressChanged();
    });
    makeObservable(this);
  }
  render() {
    const { translate } = this.componentTranslateStore;
    return /* @__PURE__ */ React.createElement(
      Select,
      {
        id: "country-select",
        isInvalid: !CountryUtil.getCountriesContainingSearchTerm("", this.props.currentLanguage),
        label: translate("countrySelect.country"),
        live: true,
        onChange: this.changeCountry,
        options: CountryUtil.countriesForView("", this.props.currentLanguage),
        placeholder: this.placeHolder(),
        value: this.componentContactAddressStore.countrySelected
      }
    );
  }
  placeHolder() {
    return CountryUtil.getCountryNameByCountryCode(this.componentContactAddressStore.getCountryCode(), this.props.currentLanguage);
  }
};
__decorateClass$m([
  action.bound
], CountrySelect.prototype, "changeCountry", 2);
CountrySelect = __decorateClass$m([
  injectStores,
  observer
], CountrySelect);
var __defProp$i = Object.defineProperty;
var __getOwnPropDesc$l = Object.getOwnPropertyDescriptor;
var __decorateClass$l = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$l(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$i(target, key, result);
  return result;
};
let ForeignContactAddress = class extends React.Component {
  constructor(props) {
    super(props);
    __publicField(this, "componentTranslateStore");
    __publicField(this, "componentForeignAddressEditStore");
    __publicField(this, "onRegionChange", (value) => {
      this.componentForeignAddressEditStore.newForeignAddress.region = value;
      this.setIsAddressDirtyTrue();
    });
    __publicField(this, "onCityChange", (value) => {
      this.componentForeignAddressEditStore.newForeignAddress.city = value;
      this.setIsAddressDirtyTrue();
    });
    __publicField(this, "onStreetChange", (value) => {
      this.componentForeignAddressEditStore.newForeignAddress.street = value;
      this.setIsAddressDirtyTrue();
    });
    __publicField(this, "onBuildingChange", (value) => {
      this.componentForeignAddressEditStore.newForeignAddress.building = value;
      this.setIsAddressDirtyTrue();
    });
    __publicField(this, "onRoomChange", (value) => {
      this.componentForeignAddressEditStore.newForeignAddress.room = value;
      this.setIsAddressDirtyTrue();
    });
    __publicField(this, "onPostalCodeChange", (value) => {
      this.componentForeignAddressEditStore.newForeignAddress.postalCode = value;
      this.setIsAddressDirtyTrue();
    });
    makeObservable(this);
  }
  render() {
    const { translate } = this.componentTranslateStore;
    return /* @__PURE__ */ React.createElement(Grid, null, /* @__PURE__ */ React.createElement(GridColumn, { width: this.props.addressWidth }, /* @__PURE__ */ React.createElement(Text, null, /* @__PURE__ */ React.createElement(
      TextField,
      {
        id: "foreignAddress-region",
        label: translate("foreignAddress.region"),
        value: this.componentForeignAddressEditStore.newForeignAddress.region,
        onChange: this.onRegionChange
      }
    ), /* @__PURE__ */ React.createElement(
      TextField,
      {
        id: "foreignAddress-city",
        label: translate("foreignAddress.city"),
        value: this.componentForeignAddressEditStore.newForeignAddress.city,
        onChange: this.onCityChange,
        isInvalid: !this.componentForeignAddressEditStore.isCityValid
      }
    ), /* @__PURE__ */ React.createElement(
      TextField,
      {
        id: "foreignAddress-street",
        label: translate("foreignAddress.street"),
        value: this.componentForeignAddressEditStore.newForeignAddress.street,
        onChange: this.onStreetChange,
        isInvalid: !this.componentForeignAddressEditStore.isStreetValid
      }
    ), /* @__PURE__ */ React.createElement(
      TextField,
      {
        id: "foreignAddress-building",
        label: translate("foreignAddress.building"),
        value: this.componentForeignAddressEditStore.newForeignAddress.building,
        onChange: this.onBuildingChange
      }
    ), /* @__PURE__ */ React.createElement(
      TextField,
      {
        id: "foreignAddress-room",
        label: translate("foreignAddress.room"),
        value: this.componentForeignAddressEditStore.newForeignAddress.room,
        onChange: this.onRoomChange
      }
    ), /* @__PURE__ */ React.createElement(
      TextField,
      {
        id: "foreignAddress-postal-code",
        label: translate("foreignAddress.postalCode"),
        value: this.componentForeignAddressEditStore.newForeignAddress.postalCode,
        onChange: this.onPostalCodeChange,
        isInvalid: !this.componentForeignAddressEditStore.isPostalCodeValid
      }
    ))));
  }
  setIsAddressDirtyTrue() {
    this.componentForeignAddressEditStore.setIsAddressDirtyTrue();
    if (this.props.onAddressChange) {
      this.props.onAddressChange(this.componentForeignAddressEditStore.getAsContactAddress());
    }
  }
};
__decorateClass$l([
  action.bound
], ForeignContactAddress.prototype, "onRegionChange", 2);
__decorateClass$l([
  action.bound
], ForeignContactAddress.prototype, "onCityChange", 2);
__decorateClass$l([
  action.bound
], ForeignContactAddress.prototype, "onStreetChange", 2);
__decorateClass$l([
  action.bound
], ForeignContactAddress.prototype, "onBuildingChange", 2);
__decorateClass$l([
  action.bound
], ForeignContactAddress.prototype, "onRoomChange", 2);
__decorateClass$l([
  action.bound
], ForeignContactAddress.prototype, "onPostalCodeChange", 2);
ForeignContactAddress = __decorateClass$l([
  injectStores,
  observer
], ForeignContactAddress);
var __defProp$h = Object.defineProperty;
var __getOwnPropDesc$k = Object.getOwnPropertyDescriptor;
var __decorateClass$k = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$k(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$h(target, key, result);
  return result;
};
let RegistryContactAddress = class extends React.Component {
  constructor(props) {
    super(props);
    __publicField(this, "componentTranslateStore");
    __publicField(this, "componentAddressSuggestionStore");
    __publicField(this, "componentRegistryAddressEditStore");
    __publicField(this, "debouncedFetchAddressAutocompleteOptions");
    __publicField(this, "onRoomChange", (value) => {
      this.componentRegistryAddressEditStore.setIsAddressDirtyTrue();
      this.componentRegistryAddressEditStore.roomText = value;
      this.componentRegistryAddressEditStore.submitChange();
      if (this.props.onAddressChange) {
        this.props.onAddressChange(this.componentRegistryAddressEditStore.getAsContactAddress());
      }
    });
    __publicField(this, "onAddressAutocompleteChange", (searchTerm) => {
      this.componentRegistryAddressEditStore.setIsAddressDirtyTrue();
      if (this.componentRegistryAddressEditStore.addressText === searchTerm) {
        return;
      }
      this.setNewSearchTerm(searchTerm);
      const suggestionItem = findSuggestionItemByLabel(this.suggestions, this.componentRegistryAddressEditStore.addressText);
      if (!suggestionItem) {
        this.debouncedFetchAddressAutocompleteOptions();
      } else {
        this.onAddressAutocompleteSelection(suggestionItem);
      }
    });
    __publicField(this, "onAddressAutocompleteSelection", async (item) => {
      const address = await this.componentAddressSuggestionStore.getAddressById(item.id);
      this.componentRegistryAddressEditStore.initSelectedAddress(address);
      this.componentRegistryAddressEditStore.initRooms(this.componentRegistryAddressEditStore.roomText);
      this.componentRegistryAddressEditStore.submitChange();
      if (this.props.onAddressChange) {
        this.props.onAddressChange(this.componentRegistryAddressEditStore.getAsContactAddress());
      }
    });
    makeObservable(this);
  }
  componentDidMount() {
    this.debouncedFetchAddressAutocompleteOptions = debounce(350, this.componentRegistryAddressEditStore.fetchAddressSuggestions);
  }
  get roomSuggestions() {
    const { roomText, roomOptions } = this.componentRegistryAddressEditStore;
    return roomOptions.filter((room) => room.label.toLowerCase().startsWith(roomText.toLowerCase()));
  }
  get suggestions() {
    return this.componentRegistryAddressEditStore.addressAutocompleteItems.slice();
  }
  render() {
    return this.renderRegistryAddress();
  }
  renderRegistryAddress() {
    const { translate } = this.componentTranslateStore;
    const { helper } = this.props;
    const helperType = helper == null ? void 0 : helper.type;
    const helperText = String(helper == null ? void 0 : helper.text);
    return /* @__PURE__ */ React.createElement(Grid, { align: ["bottom-xs"] }, /* @__PURE__ */ React.createElement(GridColumn, { noGutter: !this.componentRegistryAddressEditStore.addressValidatedOrChanged, width: this.props.addressWidth }, /* @__PURE__ */ React.createElement(
      SuggestionField,
      {
        id: "address-field",
        value: this.componentRegistryAddressEditStore.addressText,
        label: translate("registryAddress.address"),
        isInvalid: !this.componentRegistryAddressEditStore.newAddress,
        items: this.suggestions,
        onChange: this.onAddressAutocompleteChange,
        onSelect: this.onAddressAutocompleteSelection,
        ...getHelperMessageProp(helperText, helperType)
      }
    )), /* @__PURE__ */ React.createElement(GridColumn, { noGutter: !this.componentRegistryAddressEditStore.addressValidatedOrChanged, width: this.props.roomWidth }, /* @__PURE__ */ React.createElement(
      SuggestionField,
      {
        id: "apartment-field",
        value: this.componentRegistryAddressEditStore.roomText,
        label: translate("registryAddress.room"),
        items: this.roomSuggestions,
        isInvalid: this.componentRegistryAddressEditStore.hasRoomsButNoneSelected(),
        onChange: this.onRoomChange,
        showSuggestionsOnFocus: true
      }
    )), !this.componentRegistryAddressEditStore.addressValidatedOrChanged && /* @__PURE__ */ React.createElement(GridColumn, null, /* @__PURE__ */ React.createElement(Icon, { className: "text-attention", modifiers: "#alert-round", align: "middle" }), /* @__PURE__ */ React.createElement("span", { className: "text-small" }, translate("common.contactInfo.addressUnvalidated"))));
  }
  setNewSearchTerm(searchTerm) {
    this.componentRegistryAddressEditStore.addressText = searchTerm;
    this.componentRegistryAddressEditStore.selectedAddress = null;
    this.componentRegistryAddressEditStore.roomOptions = [];
    this.componentRegistryAddressEditStore.roomText = "";
  }
};
__decorateClass$k([
  computed
], RegistryContactAddress.prototype, "roomSuggestions", 1);
__decorateClass$k([
  computed
], RegistryContactAddress.prototype, "suggestions", 1);
__decorateClass$k([
  action.bound
], RegistryContactAddress.prototype, "onRoomChange", 2);
__decorateClass$k([
  action.bound
], RegistryContactAddress.prototype, "setNewSearchTerm", 1);
RegistryContactAddress = __decorateClass$k([
  injectStores,
  observer
], RegistryContactAddress);
const findSuggestionItemByLabel = (suggestions, label) => {
  return suggestions.find((item) => item.label === label);
};
var __defProp$g = Object.defineProperty;
var __getOwnPropDesc$j = Object.getOwnPropertyDescriptor;
var __decorateClass$j = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$j(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$g(target, key, result);
  return result;
};
let ContactAddress = class extends React.Component {
  constructor(props) {
    super(props);
    __publicField(this, "componentContactAddressStore");
    __publicField(this, "componentSsoStore");
    makeObservable(this);
  }
  get areStoresLoaded() {
    return this.componentContactAddressStore.isLoaded;
  }
  componentDidMount() {
    reaction(
      () => this.componentSsoStore.customerId,
      () => {
        this.componentContactAddressStore.init();
      },
      { fireImmediately: true }
    );
  }
  render() {
    if (!this.areStoresLoaded) {
      return this.renderSpinner();
    }
    if (this.componentContactAddressStore.hasAddress) {
      return this.renderContactAddressComponent();
    }
    if (!this.componentContactAddressStore.hasCountrySelected) {
      return this.renderEmptyRegistryAddressComponent();
    }
    if (!this.componentContactAddressStore.isRegistryAddressSelected) {
      return this.renderEmptyForeignAddressComponent();
    }
    return this.renderEmptyRegistryAddressComponent();
  }
  renderSpinner() {
    return /* @__PURE__ */ React.createElement(GridColumn, { width: ["xs-12", "md-4"] }, /* @__PURE__ */ React.createElement(Spinner, null));
  }
  renderEmptyRegistryAddressComponent() {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, this.renderCountrySelect(), /* @__PURE__ */ React.createElement(RegistryContactAddress, { addressWidth: this.props.addressWidth, roomWidth: this.props.roomWidth }));
  }
  renderEmptyForeignAddressComponent() {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, this.renderCountrySelect(), /* @__PURE__ */ React.createElement(ForeignContactAddress, { addressWidth: this.props.addressWidth }));
  }
  renderContactAddressComponent() {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, this.renderCountrySelect(), this.componentContactAddressStore.isRegistryAddressSelected ? /* @__PURE__ */ React.createElement(RegistryContactAddress, { addressWidth: this.props.addressWidth, roomWidth: this.props.roomWidth, helper: this.props.registryAddressHelper }) : /* @__PURE__ */ React.createElement(ForeignContactAddress, { addressWidth: this.props.addressWidth }));
  }
  renderCountrySelect() {
    return /* @__PURE__ */ React.createElement(Grid, null, /* @__PURE__ */ React.createElement(GridColumn, { width: this.props.countrySelectWidth }, /* @__PURE__ */ React.createElement(CountrySelect, { currentLanguage: this.props.currentLanguage })));
  }
};
__decorateClass$j([
  computed
], ContactAddress.prototype, "areStoresLoaded", 1);
ContactAddress = __decorateClass$j([
  customerIdAsKey,
  injectStores,
  observer
], ContactAddress);
const ContactAddress$1 = ContactAddress;
var __getOwnPropDesc$i = Object.getOwnPropertyDescriptor;
var __decorateClass$i = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$i(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(result) || result;
  return result;
};
let B2cCustomerInfo = class extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "componentTranslateStore");
    __publicField(this, "componentCustomerContactInfoStore");
    __publicField(this, "componentContractStore");
    __publicField(this, "componentSsoStore");
    __publicField(this, "componentContactAddressStore");
  }
  componentDidMount() {
    reaction(
      () => this.componentContactAddressStore.isAddressDirty,
      (data) => {
        if (data) {
          this.componentCustomerContactInfoStore.setCiConfirmationUnChecked();
        }
      }
    );
  }
  render() {
    const customer = this.componentSsoStore.customer;
    const { translate } = this.componentTranslateStore;
    return /* @__PURE__ */ React.createElement(React.Fragment, null, this.renderReadOnlyNameRegNumberFields(customer), /* @__PURE__ */ React.createElement(Heading$1, { element: "h2", className: "h4 text-bold" }, translate("registration.contactInfo.header")), /* @__PURE__ */ React.createElement(
      ContactAddress$1,
      {
        translations: this.componentTranslateStore.translations,
        currentLanguage: this.props.currentLanguage,
        countrySelectWidth: ["lg-4", "md-6", "sm-8", "xs-12"],
        addressWidth: ["lg-4", "md-6", "sm-8", "xs-12"],
        roomWidth: ["lg-2", "md-2", "sm-3", "xs-12"]
      }
    ), this.renderContactInfoFields(), /* @__PURE__ */ React.createElement(Separator, { spacing: "small", color: "invisible" }), this.renderConfirmContactInfoCheckBox());
  }
  renderConfirmContactInfoCheckBox() {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      ChoiceGroup,
      {
        id: "b2c-confirm-contact-info",
        label: "Kontaktandmete kinnitamine",
        type: "check",
        purpose: "agreement",
        hideLabel: "no-break",
        options: [
          {
            id: "confirm-contactInfo",
            labelText: this.componentCustomerContactInfoStore.ciCheckBoxValue.toString(),
            value: this.componentCustomerContactInfoStore.ciCheckBoxValue.toString(),
            disabled: !this.componentCustomerContactInfoStore.areMandatoryValuesValid() || !this.componentContactAddressStore.isAddressValid() || this.componentCustomerContactInfoStore.isCiConfirmationChecked,
            children: this.getConfirmContactInfoOptionChildren()
          }
        ],
        value: this.componentCustomerContactInfoStore.ciCheckBoxValue,
        onChange: () => {
          this.componentCustomerContactInfoStore.setCiConfirmationChecked();
          this.updateB2cInfo();
        }
      }
    ));
  }
  renderContactInfoFields() {
    const { translate } = this.componentTranslateStore;
    const { email, phone, isEmailValid: isEmailValid2, isPhoneValid: isPhoneValid2 } = this.componentCustomerContactInfoStore;
    return /* @__PURE__ */ React.createElement(Grid, null, /* @__PURE__ */ React.createElement(GridColumn, { width: ["lg-4", "md-6", "sm-8", "xs-12"] }, /* @__PURE__ */ React.createElement(Text, null, /* @__PURE__ */ React.createElement(
      TextField,
      {
        id: "phone-number",
        label: translate("registration.b2c.contactInfo.phone"),
        value: phone.value,
        onChange: (value) => {
          this.componentCustomerContactInfoStore.setCiConfirmationUnChecked();
          phone.onChange(value);
        },
        isInvalid: !isPhoneValid2
      }
    ), /* @__PURE__ */ React.createElement(
      TextField,
      {
        id: "email",
        label: translate("registration.b2c.contactInfo.email"),
        value: email.value,
        onChange: (value) => {
          this.componentCustomerContactInfoStore.setCiConfirmationUnChecked();
          email.onChange(value);
        },
        isInvalid: !isEmailValid2
      }
    ), this.renderLanguageSelector())));
  }
  renderReadOnlyNameRegNumberFields(customer) {
    return /* @__PURE__ */ React.createElement(Grid, null, /* @__PURE__ */ React.createElement(GridColumn, { width: ["xs"] }, /* @__PURE__ */ React.createElement(
      TextField,
      {
        id: "name",
        label: this.componentTranslateStore.translate("registration.b2c.contactInfo.name"),
        isStatic: true,
        onChange: () => void 0,
        value: customer.displayName
      }
    )), /* @__PURE__ */ React.createElement(GridColumn, { width: ["xs"] }, /* @__PURE__ */ React.createElement(
      TextField,
      {
        id: "personal-code",
        label: this.componentTranslateStore.translate("registration.b2c.contactInfo.registrationNumber"),
        isStatic: true,
        onChange: () => void 0,
        value: customer.registrationNumber
      }
    )));
  }
  renderLanguageSelector() {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      Selector,
      {
        items: getCommunicationLanguageProps(this.componentCustomerContactInfoStore.contactInfoUpdated, this.componentTranslateStore),
        label: this.componentTranslateStore.translate("registration.b2c.contactInfo.communicationLanguage"),
        value: this.componentCustomerContactInfoStore.communicationLanguage.value,
        onChange: (item) => {
          this.componentCustomerContactInfoStore.setCiConfirmationUnChecked();
          this.componentCustomerContactInfoStore.onCommunicationLanguageChange(item);
        },
        size: "small",
        id: "b2c-communication-language"
      }
    ));
  }
  async updateB2cInfo() {
    this.componentCustomerContactInfoStore.setIsLoading();
    if (this.componentCustomerContactInfoStore.shouldUpdateContactInfo()) {
      !!this.componentSsoStore.customerId ? await this.updateExistingCustomerInfo() : await this.updateNewCustomerInfo();
    }
    this.componentCustomerContactInfoStore.onLoaded();
  }
  async refreshData() {
    if (!this.componentContractStore.isError) {
      if (this.componentCustomerContactInfoStore.ciCheckBoxCheckedTimes <= 1 || this.componentContactAddressStore.hasAddressChanged()) {
        await this.componentContractStore.refreshContractData();
      }
    }
  }
  setStates() {
    if (!this.componentContractStore.isError) {
      this.componentContactAddressStore.setIsAddressDirtyFalse();
      this.componentCustomerContactInfoStore.setContactInfoUpdated();
    }
  }
  async updateNewCustomerInfo() {
    await this.componentCustomerContactInfoStore.createNewCustomer(this.componentSsoStore.person, this.componentContactAddressStore.getAddress());
    if (!this.componentCustomerContactInfoStore.isError) {
      this.componentSsoStore.onLoginWithCallback(async () => {
        await this.componentContractStore.ensurePreparedContractExists();
        await this.refreshData();
        this.setStates();
      });
    }
  }
  async updateExistingCustomerInfo() {
    await this.componentContactAddressStore.saveAddress();
    await this.componentCustomerContactInfoStore.updateContactInfo();
    if (!this.componentCustomerContactInfoStore.isError && this.componentContactAddressStore.status !== "ERROR" && !this.componentSsoStore.dealer) {
      this.componentContractStore.setContractType(ContractType.CLICK_ACCEPT);
      await this.componentContractStore.ensurePreparedContractExists();
    }
    if (!this.componentSsoStore.dealer) {
      await this.refreshData();
    }
    this.setStates();
  }
  getConfirmContactInfoOptionChildren() {
    const { translate } = this.componentTranslateStore;
    return /* @__PURE__ */ React.createElement("span", { className: "text-bold" }, translate("registration.contactInfo.confirmContactInfo"));
  }
};
B2cCustomerInfo = __decorateClass$i([
  injectStores,
  observer
], B2cCustomerInfo);
var __defProp$f = Object.defineProperty;
var __getOwnPropDesc$h = Object.getOwnPropertyDescriptor;
var __decorateClass$h = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$h(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$f(target, key, result);
  return result;
};
var CurrentView = /* @__PURE__ */ ((CurrentView2) => {
  CurrentView2[CurrentView2["CUSTOMER_INFO"] = 0] = "CUSTOMER_INFO";
  CurrentView2[CurrentView2["DEALER_PAPER_CONTRACT_MODAL"] = 1] = "DEALER_PAPER_CONTRACT_MODAL";
  CurrentView2[CurrentView2["DEALER_ON_SCREEN_SIGNING_VIEW"] = 2] = "DEALER_ON_SCREEN_SIGNING_VIEW";
  return CurrentView2;
})(CurrentView || {});
let B2cRegistration$1 = class B2cRegistration extends React.Component {
  constructor(props) {
    super(props);
    __publicField(this, "componentTranslateStore");
    __publicField(this, "componentCustomerContactInfoStore");
    __publicField(this, "componentSsoStore");
    __publicField(this, "componentContractStore");
    __publicField(this, "currentView", 0);
    __publicField(this, "updateView", (view) => {
      this.currentView = view;
    });
    makeObservable(this);
  }
  render() {
    if (this.currentView === 0 || this.currentView === 1) {
      return this.renderRegistrationComponent();
    }
    if (this.currentView === 2) {
      return this.renderOnScreenSigningComponent();
    }
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  renderOnScreenSigningComponent() {
    return /* @__PURE__ */ React.createElement(OnScreenSigningView, { onBack: () => this.updateView(
      0
      /* CUSTOMER_INFO */
    ), redirectUrl: this.props.redirectUrl });
  }
  renderRegistrationComponent() {
    const { translate } = this.componentTranslateStore;
    const { isCiConfirmationChecked, contactInfoUpdated, isLoading } = this.componentCustomerContactInfoStore;
    const ssoStore = this.componentSsoStore;
    return /* @__PURE__ */ React.createElement(React.Fragment, null, !!ssoStore.dealer && ssoStore.isUnderage() && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Notice, { type: "employee" }, this.componentTranslateStore.translate("registration.underage.notice")), /* @__PURE__ */ React.createElement(Separator, { spacing: "small", color: "invisible" })), this.componentContractStore.isLoading && contactInfoUpdated && isLoading() && this.renderSpinner(), /* @__PURE__ */ React.createElement(Text, null, /* @__PURE__ */ React.createElement(Heading$1, { element: "h1", className: "h2" }, translate("registration.header")), /* @__PURE__ */ React.createElement("p", null, this.componentCustomerContactInfoStore.initialCustomerId ? translate("registration.general.existingCustomer.text") : translate("registration.general.newCustomer.text")), /* @__PURE__ */ React.createElement(B2cCustomerInfo, { currentLanguage: this.props.currentLanguage }), /* @__PURE__ */ React.createElement(Separator, { spacing: "medium" })), /* @__PURE__ */ React.createElement(
      CustomerContract,
      {
        shouldDisableButtons: !(contactInfoUpdated || isCiConfirmationChecked) || this.componentCustomerContactInfoStore.isLoading(),
        customerCreationInProgress: this.componentCustomerContactInfoStore.isLoading()
      }
    ), /* @__PURE__ */ React.createElement(Separator, { spacing: "small", color: "invisible" }), !!this.componentSsoStore.dealer && /* @__PURE__ */ React.createElement(DealerSigningButtons, { updateView: this.updateView, dealerRedirectUrl: this.props.redirectUrl }));
  }
  renderSpinner() {
    return /* @__PURE__ */ React.createElement(Overlay, { className: "overlay--fixed", spinner: true });
  }
};
__decorateClass$h([
  observable
], B2cRegistration$1.prototype, "currentView", 2);
__decorateClass$h([
  action.bound
], B2cRegistration$1.prototype, "updateView", 2);
B2cRegistration$1 = __decorateClass$h([
  customerIdAsKey,
  injectStores,
  observer
], B2cRegistration$1);
var __getOwnPropDesc$g = Object.getOwnPropertyDescriptor;
var __decorateClass$g = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$g(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(result) || result;
  return result;
};
let B2bCustomerInfo = class extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "componentTranslateStore");
    __publicField(this, "componentCreditInfoStore");
    __publicField(this, "componentCustomerContactInfoStore");
    __publicField(this, "componentContactAddressStore");
    __publicField(this, "componentContractStore");
    __publicField(this, "componentSsoStore");
  }
  componentDidMount() {
    reaction(
      () => this.componentContactAddressStore.isAddressDirty,
      (data) => {
        if (data) {
          this.componentCustomerContactInfoStore.setCiConfirmationUnChecked();
        }
      }
    );
  }
  render() {
    return /* @__PURE__ */ React.createElement(Text, null, this.renderB2bData(), /* @__PURE__ */ React.createElement(Separator, { spacing: "medium" }), this.renderRepresentativeData(), /* @__PURE__ */ React.createElement(Separator, { spacing: "small", color: "invisible" }), this.renderConfirmContactInfoCheckBox(), /* @__PURE__ */ React.createElement(Separator, { spacing: "medium" }));
  }
  renderRepresentativeData() {
    const { translate } = this.componentTranslateStore;
    const { person } = this.componentSsoStore;
    const { email, phone } = this.componentCustomerContactInfoStore;
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Heading$1, { element: "h2", className: "h4" }, translate("registration.b2b.representative.title")), /* @__PURE__ */ React.createElement(Notice, { size: "small" }, translate("registration.b2b.representative.notice")), /* @__PURE__ */ React.createElement(Grid, null, /* @__PURE__ */ React.createElement(GridColumn, { width: ["xs"] }, /* @__PURE__ */ React.createElement(
      TextField,
      {
        id: "representative-name",
        label: translate("registration.b2b.representative.name"),
        isStatic: true,
        defaultValue: "".concat(person.firstName, " ").concat(person.lastName)
      }
    )), /* @__PURE__ */ React.createElement(GridColumn, { width: ["xs"] }, /* @__PURE__ */ React.createElement(
      TextField,
      {
        id: "representative-personal-code",
        label: translate("registration.b2b.representative.personalCode"),
        isStatic: true,
        defaultValue: person.personalCode
      }
    ))), /* @__PURE__ */ React.createElement(Grid, null, /* @__PURE__ */ React.createElement(GridColumn, { width: ["lg-5", "md-7", "sm-8", "xs-12"] }, /* @__PURE__ */ React.createElement(Text, null, /* @__PURE__ */ React.createElement(
      TextField,
      {
        id: "email",
        label: translate("registration.b2b.representative.email"),
        isInvalid: email.isUserInputError,
        value: email.value,
        onChange: (value) => {
          this.componentCustomerContactInfoStore.setCiConfirmationUnChecked();
          email.onChange(value);
        }
      }
    ), /* @__PURE__ */ React.createElement(Separator, { color: "invisible", spacing: "xxsmall" }), /* @__PURE__ */ React.createElement(Grid, null, /* @__PURE__ */ React.createElement(GridColumn, { width: ["xs-12"] }, /* @__PURE__ */ React.createElement(
      TextField,
      {
        id: "phoneNumber",
        label: translate("registration.b2b.representative.phone"),
        isInvalid: phone.isUserInputError,
        value: phone.value,
        onChange: (value) => {
          this.componentCustomerContactInfoStore.setCiConfirmationUnChecked();
          phone.onChange(value);
        }
      }
    ))), /* @__PURE__ */ React.createElement(Separator, { color: "invisible", spacing: "xxsmall" }), this.renderLanguageSelector()))));
  }
  renderB2bData() {
    var _a2;
    const { currentLanguage } = this.props;
    const { entityToRegister } = this.componentCreditInfoStore;
    const { translate } = this.componentTranslateStore;
    const { dealer, setSelectedSegment, selectedSegment, getSegmentOptions } = this.componentSsoStore;
    const hasManagerRole = (_a2 = dealer == null ? void 0 : dealer.roles) == null ? void 0 : _a2.some((role) => ["web_p_b2b_manager", "web_p_b2b_manager_".concat(this.props.env)].includes(role.toLowerCase()));
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Grid, null, /* @__PURE__ */ React.createElement(GridColumn, { width: ["xl"] }, /* @__PURE__ */ React.createElement(Heading$1, { element: "h1", className: "h2" }, translate("registration.b2b.company.contactInfo")))), /* @__PURE__ */ React.createElement(Grid, null, /* @__PURE__ */ React.createElement(GridColumn, { width: ["xs"] }, /* @__PURE__ */ React.createElement(
      TextField,
      {
        id: "business-name",
        label: translate("registration.b2b.company.name"),
        isStatic: true,
        defaultValue: (entityToRegister == null ? void 0 : entityToRegister.name) ? entityToRegister.name : this.componentSsoStore.customer.displayName
      }
    )), /* @__PURE__ */ React.createElement(GridColumn, { width: ["xs"] }, /* @__PURE__ */ React.createElement(
      TextField,
      {
        id: "registry-code",
        label: translate("registration.b2b.company.regCode"),
        isStatic: true,
        defaultValue: (entityToRegister == null ? void 0 : entityToRegister.registrationNumber) ? entityToRegister.registrationNumber : this.componentSsoStore.customer.registrationNumber
      }
    )), this.isNewCustomer() && hasManagerRole && /* @__PURE__ */ React.createElement(GridColumn, { width: ["sm-3"] }, /* @__PURE__ */ React.createElement(
      Select,
      {
        id: "segment-select",
        isInvalid: false,
        label: translate("registration.b2b.company.segment"),
        employee: true,
        live: true,
        onChange: (selectedValue) => setSelectedSegment(selectedValue),
        options: getSegmentOptions(),
        value: selectedSegment
      }
    ))), /* @__PURE__ */ React.createElement(
      ContactAddress$1,
      {
        translations: this.componentTranslateStore.translations,
        currentLanguage,
        countrySelectWidth: ["lg-5", "md-7", "sm-8", "xs-12"],
        addressWidth: ["md-5", "sm-5", "xs-12"],
        roomWidth: ["md-2", "sm-3", "xs-12"]
      }
    ));
  }
  renderLanguageSelector() {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      Selector,
      {
        id: "b2b-communication-language",
        items: getCommunicationLanguageProps(this.componentCustomerContactInfoStore.contactInfoUpdated, this.componentTranslateStore),
        label: this.componentTranslateStore.translate("registration.b2c.contactInfo.communicationLanguage"),
        value: this.componentCustomerContactInfoStore.communicationLanguage.value,
        onChange: (item) => {
          this.componentCustomerContactInfoStore.setCiConfirmationUnChecked();
          this.componentCustomerContactInfoStore.onCommunicationLanguageChange(item);
        },
        inputType: "radio"
      }
    ));
  }
  renderConfirmContactInfoCheckBox() {
    return /* @__PURE__ */ React.createElement(
      ChoiceGroup,
      {
        id: "contactDataConfirm",
        label: "Kontaktandmete kinnitamine",
        type: "check",
        purpose: "agreement",
        hideLabel: true,
        options: [
          {
            id: "confirm-contactInfo",
            labelText: this.componentCustomerContactInfoStore.ciCheckBoxValue.toString(),
            value: this.componentCustomerContactInfoStore.ciCheckBoxValue.toString(),
            disabled: !this.componentCustomerContactInfoStore.areMandatoryValuesValid() || !this.componentContactAddressStore.isAddressValid() || this.componentCustomerContactInfoStore.isCiConfirmationChecked,
            children: this.getConfirmContactInfoOptionChildren()
          }
        ],
        value: this.componentCustomerContactInfoStore.ciCheckBoxValue,
        onChange: async () => {
          this.componentCustomerContactInfoStore.setCiConfirmationChecked();
          await this.updateB2bInfo();
        }
      }
    );
  }
  getConfirmContactInfoOptionChildren() {
    const { translate } = this.componentTranslateStore;
    return /* @__PURE__ */ React.createElement("span", { className: "text-bold" }, translate("registration.contactInfo.confirmContactInfo"));
  }
  async updateB2bInfo() {
    this.componentCustomerContactInfoStore.setIsLoading();
    if (this.componentCustomerContactInfoStore.shouldUpdateContactInfo()) {
      this.isNewCustomer() ? await this.createB2bCustomer() : await this.updateB2bCustomer();
    }
    this.componentCustomerContactInfoStore.onLoaded();
  }
  isNewCustomer() {
    const { customer, customerId } = this.componentSsoStore;
    const { entityToRegister } = this.componentCreditInfoStore;
    return !customerId || entityToRegister && (entityToRegister.registrationNumber !== customer.registrationNumber || entityToRegister.registrationNumberCountryCode !== customer.registrationNumberCountryCode);
  }
  async createB2bCustomer() {
    await this.componentCustomerContactInfoStore.createNewB2bCustomer(this.componentContactAddressStore.getAddress());
    if (!this.componentCustomerContactInfoStore.isError) {
      this.componentSsoStore.onLoginWithCallback(async () => {
        await this.componentContractStore.fetchExistingPreparedContract();
        await this.refreshDataAndSetStates();
      });
    }
  }
  async refreshDataAndSetStates() {
    if (!this.componentContractStore.isError) {
      if (this.componentCustomerContactInfoStore.ciCheckBoxCheckedTimes <= 1 || this.componentContactAddressStore.hasAddressChanged()) {
        await this.componentContractStore.refreshContractData();
      }
      this.componentContactAddressStore.setIsAddressDirtyFalse();
      this.componentCustomerContactInfoStore.setContactInfoUpdated();
    }
  }
  async updateB2bCustomer() {
    await this.componentContactAddressStore.saveAddress();
    await this.componentCustomerContactInfoStore.updateContactInfo();
    if (!this.componentCustomerContactInfoStore.isError && this.componentContactAddressStore.status !== "ERROR") {
      if (!this.componentSsoStore.dealer) {
        this.componentContractStore.setContractType(ContractType.CLICK_ACCEPT);
        await this.componentContractStore.ensurePreparedContractExists();
      }
    }
    await this.refreshDataAndSetStates();
  }
};
B2bCustomerInfo = __decorateClass$g([
  customerIdAsKey,
  injectStores,
  observer
], B2bCustomerInfo);
var __defProp$e = Object.defineProperty;
var __getOwnPropDesc$f = Object.getOwnPropertyDescriptor;
var __decorateClass$f = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$f(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$e(target, key, result);
  return result;
};
let RepresentationStipulationModal = class extends React__default.Component {
  constructor(props) {
    super(props);
    __publicField(this, "modalIsOpen", true);
    __publicField(this, "componentTranslateStore");
    __publicField(this, "componentSsoStore");
    __publicField(this, "componentSignerStore");
    __publicField(this, "componentRegistrationStore");
    __publicField(this, "renderModal", () => {
      const { translate } = this.componentTranslateStore;
      return /* @__PURE__ */ React__default.createElement(Modal, { hasContentComponent: true, isClosable: false, isOpen: this.modalIsOpen }, /* @__PURE__ */ React__default.createElement(ModalContent, null, /* @__PURE__ */ React__default.createElement(Text, null, /* @__PURE__ */ React__default.createElement("h1", null, translate("contract.signers.modal.title")), /* @__PURE__ */ React__default.createElement("p", null, translate("contract.signers.modal.description")), this.renderStipulation(), /* @__PURE__ */ React__default.createElement(Table$2, null, /* @__PURE__ */ React__default.createElement("thead", null, /* @__PURE__ */ React__default.createElement(TableRow, null, /* @__PURE__ */ React__default.createElement(TableCell, { type: "th", scope: "col" }, "Test"), /* @__PURE__ */ React__default.createElement(TableCell, { type: "th", scope: "col" }, translate("contract.signers.modal.column.personalCode")))), /* @__PURE__ */ React__default.createElement("tbody", null, this.renderRows())), /* @__PURE__ */ React__default.createElement(Separator, { color: "invisible" }), /* @__PURE__ */ React__default.createElement("p", { className: "text-center" }, /* @__PURE__ */ React__default.createElement(
        AnalyticsTrigger,
        {
          trigger: {
            id: "Button - representation stipulation modal continue",
            callback: "onClick"
          }
        },
        /* @__PURE__ */ React__default.createElement(
          Button,
          {
            id: "continue-btn",
            type: "employee",
            text: translate("contract.signers.modal.continue"),
            iconRight: "#arrow-right",
            onClick: this.onContinueClick
          }
        )
      )))));
    });
    __publicField(this, "onContinueClick", async () => {
      this.modalIsOpen = false;
    });
    makeObservable(this);
  }
  async componentDidMount() {
    await this.componentSignerStore.initSigners();
  }
  render() {
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, !this.componentSignerStore.isLoaded ? this.renderSpinner() : this.renderModal());
  }
  renderStipulation() {
    const { translate } = this.componentTranslateStore;
    return /* @__PURE__ */ React__default.createElement("p", null, translate("contract.signers.modal.stipulation"), this.componentRegistrationStore.getRepresentationStipulation);
  }
  renderRows() {
    const { isSamePerson } = this.componentSsoStore;
    return this.componentSignerStore.signers.map((signer, index) => {
      return /* @__PURE__ */ React__default.createElement(TableRow, { key: signer.personalCode }, /* @__PURE__ */ React__default.createElement(TableCell, null, /* @__PURE__ */ React__default.createElement(
        Check,
        {
          labelText: "".concat(signer.firstName, " ").concat(signer.lastName),
          id: "rep-".concat(index),
          value: index.toString(),
          checked: signer.selected,
          onChange: (isChecked) => signer.selected = isChecked,
          disabled: isSamePerson(signer.personalCode)
        },
        "".concat(signer.firstName, " ").concat(signer.lastName)
      )), /* @__PURE__ */ React__default.createElement(TableCell, null, signer.personalCode));
    });
  }
  renderSpinner() {
    return /* @__PURE__ */ React__default.createElement(Overlay, { className: "overlay--fixed", spinner: true });
  }
};
__decorateClass$f([
  observable
], RepresentationStipulationModal.prototype, "modalIsOpen", 2);
__decorateClass$f([
  action.bound
], RepresentationStipulationModal.prototype, "onContinueClick", 2);
RepresentationStipulationModal = __decorateClass$f([
  injectStores,
  observer
], RepresentationStipulationModal);
var __defProp$d = Object.defineProperty;
var __getOwnPropDesc$e = Object.getOwnPropertyDescriptor;
var __decorateClass$e = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$e(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$d(target, key, result);
  return result;
};
let B2bRegistration = class extends React.Component {
  constructor(props) {
    super(props);
    __publicField(this, "currentView", CurrentView.CUSTOMER_INFO);
    __publicField(this, "componentCustomerContactInfoStore");
    __publicField(this, "componentTranslateStore");
    __publicField(this, "componentContractStore");
    __publicField(this, "urlDataStore");
    __publicField(this, "componentSsoStore");
    __publicField(this, "componentRegistrationStore");
    __publicField(this, "componentSignerStore");
    __publicField(this, "updateView", (currentView) => {
      this.currentView = currentView;
    });
    makeObservable(this);
  }
  async componentDidMount() {
    await this.componentSignerStore.initSigners();
  }
  render() {
    const { isLoading, isCiConfirmationChecked, contactInfoUpdated } = this.componentCustomerContactInfoStore;
    const { hasRepresentationStipulation } = this.componentRegistrationStore;
    const { dealer, customerId } = this.componentSsoStore;
    const shouldShowStipulationModal = !!dealer && hasRepresentationStipulation && !!customerId;
    if (!this.componentSsoStore.isEstonianCitizen() && !dealer) {
      return this.renderForeignCitizenWarning();
    }
    if (!dealer && hasRepresentationStipulation) {
      return this.renderRepresentationStipulationNotice();
    }
    if (this.currentView === CurrentView.DEALER_ON_SCREEN_SIGNING_VIEW) {
      return this.renderOnScreenSigningComponent();
    }
    return /* @__PURE__ */ React.createElement(Card, { background: "transparent", type: "light" }, /* @__PURE__ */ React.createElement(CardContent, null, shouldShowStipulationModal && /* @__PURE__ */ React.createElement(RepresentationStipulationModal, null), this.componentContractStore.isLoading && contactInfoUpdated && isLoading() && this.renderSpinner(), /* @__PURE__ */ React.createElement(B2bCustomerInfo, { currentLanguage: this.props.currentLanguage, env: this.props.env }), /* @__PURE__ */ React.createElement(CustomerContract, { shouldDisableButtons: !(contactInfoUpdated || isCiConfirmationChecked) || isLoading(), customerCreationInProgress: isLoading() }), /* @__PURE__ */ React.createElement(Separator, { spacing: "small", color: "invisible" }), !!dealer && /* @__PURE__ */ React.createElement(DealerSigningButtons, { updateView: this.updateView, dealerRedirectUrl: this.props.redirectUrl })));
  }
  renderRepresentationStipulationNotice() {
    const { translate } = this.componentTranslateStore;
    return /* @__PURE__ */ React.createElement(Notice, { id: "representation-stipulation-notice" }, translate("registration.representationStipulation.notice", {
      goToShopUrl: this.urlDataStore.goToShopUrl
    }));
  }
  renderSpinner() {
    return /* @__PURE__ */ React.createElement(Overlay, { className: "overlay--fixed", spinner: true });
  }
  renderOnScreenSigningComponent() {
    return /* @__PURE__ */ React.createElement(OnScreenSigningView, { onBack: () => this.currentView = CurrentView.CUSTOMER_INFO, redirectUrl: this.props.redirectUrl });
  }
  renderForeignCitizenWarning() {
    const { translate } = this.componentTranslateStore;
    return /* @__PURE__ */ React.createElement(Notice, { id: "representation-stipulation-notice" }, translate("registration.foreignCitizen.warning", {
      contactsUrl: this.urlDataStore.contactsUrl
    }));
  }
};
__decorateClass$e([
  observable
], B2bRegistration.prototype, "currentView", 2);
__decorateClass$e([
  action.bound
], B2bRegistration.prototype, "updateView", 2);
B2bRegistration = __decorateClass$e([
  customerIdAsKey,
  injectStores,
  observer
], B2bRegistration);
var __getOwnPropDesc$d = Object.getOwnPropertyDescriptor;
var __decorateClass$d = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$d(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(result) || result;
  return result;
};
let RegisterableCompaniesList = class extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "componentCreditInfoStore");
  }
  render() {
    const { creditInfoLegalEntities } = this.componentCreditInfoStore;
    return this.componentCreditInfoStore.isInitialized && /* @__PURE__ */ React.createElement(Card, { background: "transparent", type: "light" }, /* @__PURE__ */ React.createElement(CardContent, null, ArrowList && /* @__PURE__ */ React.createElement(ArrowList, null, creditInfoLegalEntities.map((entity, index) => {
      return /* @__PURE__ */ React.createElement(
        ArrowListItem,
        {
          url: "#",
          key: index,
          onClick: async () => await this.componentCreditInfoStore.getAndSetEntityToRegister(entity.registrationNumber)
        },
        entity.name
      );
    }))));
  }
};
RegisterableCompaniesList = __decorateClass$d([
  injectStores,
  observer
], RegisterableCompaniesList);
var Role = /* @__PURE__ */ ((Role2) => {
  Role2["WEB_P_SECOND_LEVEL"] = "WEB_P_second_level";
  return Role2;
})(Role || {});
var __defProp$c = Object.defineProperty;
var __getOwnPropDesc$c = Object.getOwnPropertyDescriptor;
var __decorateClass$c = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$c(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$c(target, key, result);
  return result;
};
let ApplicationErrorBoundary = class extends React__default.Component {
  constructor(props) {
    super(props);
    __publicField(this, "hasError");
    __publicField(this, "brand");
    makeObservable(this);
  }
  render() {
    if (this.hasError) {
      return /* @__PURE__ */ React__default.createElement(Container, null, /* @__PURE__ */ React__default.createElement(Separator, { spacing: "medium", color: "invisible" }), /* @__PURE__ */ React__default.createElement(Grid, { align: ["center-sm"] }, /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["sm-12", "md-12"] }, /* @__PURE__ */ React__default.createElement(Grid, null, /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["sm-6", "md-6"] }, /* @__PURE__ */ React__default.createElement(Text, null, /* @__PURE__ */ React__default.createElement(Logo, { text: "Telia" }), /* @__PURE__ */ React__default.createElement("h1", null, "Vabandame, tekkis tehniline viga"), /* @__PURE__ */ React__default.createElement(Separator, { spacing: "small", color: "invisible" }), /* @__PURE__ */ React__default.createElement("h1", null, "Извините, произошла техническая ошибк"))), /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["sm-6", "md-6"] }, /* @__PURE__ */ React__default.createElement(Separator, { spacing: "small", color: "invisible" }), /* @__PURE__ */ React__default.createElement(
        Image,
        {
          srcset: this.brand === "TELIA" ? "https://res.cloudinary.com/telia/image/upload/f_auto,fl_lossy,q_auto:best/404_dcvqgh.jpg" : "//res.cloudinary.com/telia/image/upload/c_scale,w_400,fl_lossy,f_auto,q_auto:best/diil/veeb/404/diil-raamatuga-valge2.gif 400w",
          width: 400,
          align: "center",
          alt: "Technical error fallback image"
        }
      ))))), /* @__PURE__ */ React__default.createElement(Separator, { spacing: "medium", color: "invisible" }));
    }
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, this.props.children);
  }
  componentDidCatch() {
    this.hasError = true;
  }
};
__decorateClass$c([
  observable
], ApplicationErrorBoundary.prototype, "hasError", 2);
__decorateClass$c([
  action.bound
], ApplicationErrorBoundary.prototype, "componentDidCatch", 1);
ApplicationErrorBoundary = __decorateClass$c([
  injectStores,
  observer
], ApplicationErrorBoundary);
const GUEST_LANGUAGE_COOKIE_NAME = "LANGUAGE_EXT";
const LANGUAGE_ID_TO_LOCALE_MAP = { et_EE: Language.ET, ru_RU: Language.RU, en_GB: Language.EN };
const CookieApi = {
  getLanguageCookieValue() {
    const pair = document.cookie.match(new RegExp("".concat(GUEST_LANGUAGE_COOKIE_NAME, "=([^;]+)")));
    if (!!pair) {
      return LANGUAGE_ID_TO_LOCALE_MAP[pair[1]];
    }
    return void 0;
  },
  setLanguageCookie: (language, domain = ".telia.ee", expires) => {
    const expirationDate = /* @__PURE__ */ new Date();
    expirationDate.setFullYear((/* @__PURE__ */ new Date()).getFullYear() + 1);
    const locale = Object.keys(LANGUAGE_ID_TO_LOCALE_MAP).find((key) => LANGUAGE_ID_TO_LOCALE_MAP[key] === language);
    document.cookie = "".concat(GUEST_LANGUAGE_COOKIE_NAME, "=").concat(locale, "; expires=").concat(expires || expirationDate.toUTCString(), "; domain=").concat(domain, "; path=/;");
  }
};
const _NavigationUtil = class _NavigationUtil {
  constructor() {
    __publicField(this, "currentLanguage", _NavigationUtil.currentLanguageFromCookie || _NavigationUtil.currentLanguageFromUrl || _NavigationUtil.DEFAULT_LANGUAGE);
    __publicField(this, "navigateFn");
    __publicField(this, "routeMap", /* @__PURE__ */ new Map());
    __publicField(this, "routeErrorsMap", /* @__PURE__ */ new Map());
    __publicField(this, "brand");
    __publicField(this, "translateStore");
  }
  set navigateFunction(navigateFunction) {
    this.navigateFn = navigateFunction;
  }
  static init(brand = "TELIA", translateStore) {
    _NavigationUtil.get().brand = brand;
    _NavigationUtil.get().translateStore = translateStore;
    if (!!_NavigationUtil.currentLanguageFromCookie && _NavigationUtil.currentLanguageFromCookie !== _NavigationUtil.currentLanguageFromUrl) {
      navigate(window.location.pathname + window.location.search, true);
    }
  }
  get navigate() {
    return this.navigateFn;
  }
  getRoute(path) {
    if (path === "*") {
      return this.routeMap.get("*");
    }
    if (path.charAt(0) !== "/") {
      return void 0;
    }
    const pathToCheck = path.length > 1 && path.endsWith("/") ? path.substring(0, path.length - 1) : path;
    return this.routeMap.get(new URL(removeLanguageSlug(pathToCheck), "https://".concat(window.location.host)).pathname);
  }
  setRoute(path, route) {
    this.routeMap.set(path, route);
  }
  setCurrentLanguage(language) {
    if (this.currentLanguage !== language) {
      this.translateStore.fetchTranslations(language);
      this.currentLanguage = language;
    }
    CookieApi.setLanguageCookie(language, this.brand === "TELIA" ? ".telia.ee" : ".diil.ee");
    document.querySelector("html").setAttribute("lang", language);
    const navTarget = window.location.pathname + window.location.search;
    navigate(navTarget, true);
  }
  setRouteErrors(path, errors) {
    this.routeErrorsMap.set(path, errors);
  }
  getRouteErrors(path) {
    return this.routeErrorsMap.get(removeLanguageSlug(path)) || [];
  }
  static getCurrentLanguageFromUrl() {
    for (const lang in Language) {
      const langStr = Language[lang];
      const path = window.location.pathname;
      if (path === "/".concat(langStr) || path.startsWith("/".concat(langStr, "?")) || path.startsWith("/".concat(langStr, "/"))) {
        return langStr;
      }
    }
    return void 0;
  }
};
__publicField(_NavigationUtil, "DEFAULT_LANGUAGE", Language.ET);
__publicField(_NavigationUtil, "currentLanguageFromUrl", _NavigationUtil.getCurrentLanguageFromUrl());
__publicField(_NavigationUtil, "currentLanguageFromCookie", CookieApi.getLanguageCookieValue());
__publicField(_NavigationUtil, "instance");
__publicField(_NavigationUtil, "get", () => {
  if (!_NavigationUtil.instance) {
    _NavigationUtil.instance = new _NavigationUtil();
  }
  return _NavigationUtil.instance;
});
let NavigationUtil = _NavigationUtil;
const removeLanguageSlug = (path) => {
  for (const lang in Language) {
    const langStr = Language[lang];
    if (path.startsWith("/".concat(langStr, "/")) || path.startsWith("/".concat(langStr, "?"))) {
      return path.substring("/".concat(langStr, "/").length - 1);
    }
    if (path === "/".concat(langStr)) {
      return path.substring("/".concat(langStr).length);
    }
  }
  return path;
};
const addLanguageSlug = (path) => {
  const currentLanguageIsDefault = NavigationUtil.get().currentLanguage === NavigationUtil.DEFAULT_LANGUAGE;
  const pathWithoutLang = removeLanguageSlug(path);
  return (currentLanguageIsDefault ? "" : "/".concat(NavigationUtil.get().currentLanguage)).concat(pathWithoutLang);
};
const navigate = (to, keepLanguageSlug = false) => {
  if (to.charAt(0) !== "/" && to !== "*") {
    if (keepLanguageSlug) {
      const url = new URL(to);
      window.location.assign(to.replace(url.pathname, addLanguageSlug(url.pathname)));
    } else {
      window.location.assign(removeLanguageSlug(to));
    }
  } else {
    const slugWithLang = addLanguageSlug(to);
    NavigationUtil.get().navigate(slugWithLang);
  }
};
const useParams = () => useParams$1();
const ApplicationWrapper = observer((props) => {
  var _a2;
  const [componentRootStore, setComponentRootStore] = React.useState(null);
  const { environment, brand, sso, icons, children, disableSsoClientTabSync, disableSso, themeProvider } = props;
  React.useEffect(() => {
    const rootStore = new ComponentRootStore(environment, brand, disableSsoClientTabSync, disableSso);
    rootStore.urlDataStore.redirectUrl = new URLSearchParams(window.location.search).get("goToUrl");
    setComponentRootStore(rootStore);
  }, []);
  if (!((_a2 = componentRootStore == null ? void 0 : componentRootStore.componentTranslateStore) == null ? void 0 : _a2.globalTranslations)) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(ComponentRootStoreContext.Provider, { value: componentRootStore }, /* @__PURE__ */ React.createElement(ApplicationErrorBoundary, null, /* @__PURE__ */ React.createElement(SsoContext.Provider, { value: sso }, /* @__PURE__ */ React.createElement(ThemeProvider, { locale: themeProvider.locale, getIconPath: (name) => icons + name, brand: themeProvider.brand, theme: themeProvider.theme }, /* @__PURE__ */ React.createElement(LabelProvider, { labels: componentRootStore.componentTranslateStore.globalTranslations }, /* @__PURE__ */ React.createElement(AnalyticsProvider, null, /* @__PURE__ */ React.createElement(Provider, { ...componentRootStore }, /* @__PURE__ */ React.createElement(LanguageContext.Provider, { value: NavigationUtil.get().currentLanguage }, /* @__PURE__ */ React.createElement(BrowserRouter, null, children)))))))));
});
const SsoContext = React.createContext(null);
const LanguageContext = React.createContext(Language.ET);
const setLanguage = (language) => NavigationUtil.get().setCurrentLanguage(language);
const getCurrentLanguage = () => NavigationUtil.get().currentLanguage;
class RegistryAddressAPI {
  static getRegistryAddress(addressId, requestType) {
    const requestConf = { params: { type: requestType }, timeout: API_CONF.timeout };
    return API.get(Config.apiUrl.concat("/address/".concat(addressId)), requestConf).then((response) => response.data);
  }
  static getRegistryAddressSuggestions(searchTerm) {
    const requestConf = { params: { term: searchTerm }, timeout: API_CONF.timeout };
    return API.get(Config.apiUrl.concat("/address/suggest"), requestConf).then((response) => response.data);
  }
}
var __defProp$b = Object.defineProperty;
var __getOwnPropDesc$b = Object.getOwnPropertyDescriptor;
var __decorateClass$b = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$b(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$b(target, key, result);
  return result;
};
class ComponentAddressStore {
  constructor() {
    __publicField(this, "registryAddressLabel");
    __publicField(this, "registryRoomLabel");
    __publicField(this, "isLoading", true);
    __publicField(this, "registryAddressAutocompleteItems");
    __publicField(this, "registryRoomAutocompleteItems");
    __publicField(this, "registryAddressSearchTerm");
    __publicField(this, "registryAddressSuggestions", []);
    __publicField(this, "selectedRegistryAddress");
    __publicField(this, "selectedForeignAddress");
    __publicField(this, "_selectedCountry");
    __publicField(this, "registryAddress");
    __publicField(this, "foreignAddress");
    __publicField(this, "debounceActive", false);
    __publicField(this, "debounceDelay", 350);
    // in milliseconds
    __publicField(this, "registryAddressConfig");
    __publicField(this, "filteredRooms", []);
    __publicField(this, "fetchRegistryAddressSuggestions", () => {
      const addressItems = [];
      const setRegistryAddressSuggestions = (values) => {
        this.registryAddressSuggestions = values.map((value) => {
          return { ...value, countryCode: "EE" };
        });
        values.forEach((value) => {
          const address = { id: value.id, label: value.label2, subLabel: value.buildingType };
          const rooms = value.rooms.map((room) => {
            return { id: room.roomId, label: room.roomName };
          });
          addressItems.push({ ...address, rooms });
        });
      };
      const setRegistryAddressAutocompleteItems = () => this.registryAddressAutocompleteItems.replace(addressItems);
      return RegistryAddressAPI.getRegistryAddressSuggestions(this.registryAddressSearchTerm || this.registryAddressLabel).then(setRegistryAddressSuggestions).then(action(setRegistryAddressAutocompleteItems)).then(() => this.debounceActive = false);
    });
    makeObservable(this);
  }
  init(registryAddress, foreignAddress, registryAddressConfig) {
    this.registryAddress = registryAddress;
    this.foreignAddress = foreignAddress;
    this.registryAddressConfig = registryAddressConfig;
    this.setConfigDefaultValues();
    this.registryAddressAutocompleteItems = observable.array([]);
    this.registryRoomAutocompleteItems = observable.array([]);
    runInAction(() => {
      this.isLoading = true;
      this.registryAddressLabel = "";
      this.registryRoomLabel = "";
      this.registryAddressSearchTerm = "";
    });
    this.initializeAddresses().then(action(() => this.isLoading = false));
  }
  initializeAddresses() {
    var _a2;
    this.selectedRegistryAddress = { countryCode: "EE" };
    this.selectedForeignAddress = { countryCode: "OTHER" };
    if (this.registryAddress) {
      this.selectedCountryCode = "EE";
      const { addressRegistryId, buildingRegistryId, roomRegistryId, fallbackLabel } = this.registryAddress;
      const requestId = addressRegistryId || buildingRegistryId || roomRegistryId;
      if (requestId) {
        const requestType = addressRegistryId ? "ADDRESS" : buildingRegistryId ? "BUILDING" : roomRegistryId ? "ROOM" : null;
        let selectedRegistryAddressId;
        const setRegistryAddressLabel = (value) => {
          this.registryAddressLabel = value.label2 || "";
          selectedRegistryAddressId = value.id;
        };
        const setSelectedRegistryAddressSuggestion = () => {
          if (this.registryAddressAutocompleteItems.length > 0) {
            this.selectedAddressId = this.registryAddressAutocompleteItems.find((adr) => adr.id.toString() === selectedRegistryAddressId.toString()).id;
          }
        };
        const setSelectedRegistryRoomLabel = () => {
          this.registryRoomLabel = this.registryAddress.room;
          if (this.registryRoomAutocompleteItems.length > 0 && this.registryAddress.roomRegistryId) {
            this.selectedRoomId = this.registryRoomAutocompleteItems.find((room) => room.id.toString() === this.registryAddress.roomRegistryId.toString()).id;
          }
        };
        return RegistryAddressAPI.getRegistryAddress(requestId, requestType).then(action(setRegistryAddressLabel)).then(this.fetchRegistryAddressSuggestions).then(action(setSelectedRegistryAddressSuggestion)).then(action(setSelectedRegistryRoomLabel));
      } else if (fallbackLabel) {
        this.registryAddressLabel = fallbackLabel;
        this.registryRoomLabel = this.registryAddress.room;
        const assumeFirstSuggestionIsSelectedIfNeeded = () => {
          const autoselectFirstMatch = this.registryAddressConfig.autoselectFirstMatchOnInitialLoad && this.registryAddressAutocompleteItems.length > 0;
          if (autoselectFirstMatch) {
            this.selectedAddressId = this.registryAddressAutocompleteItems[0].id;
          }
        };
        return this.fetchRegistryAddressSuggestions().then(action(assumeFirstSuggestionIsSelectedIfNeeded));
      }
    }
    if (this.foreignAddress && Object.keys(toJS(this.foreignAddress)).length !== 0) {
      this.selectedCountryCode = this.foreignAddress.countryCode;
      this.selectedForeignAddress = { ...this.foreignAddress, id: (_a2 = this.foreignAddress.id) == null ? void 0 : _a2.toString(), countryCode: this.selectedCountry.value };
    }
    return Promise.resolve();
  }
  setConfigDefaultValues() {
    const getOrDefault = (existingValue, defaultValue) => existingValue !== void 0 ? existingValue : defaultValue;
    if (!this.registryAddressConfig) {
      this.registryAddressConfig = {};
    }
    const { autoselectFirstMatchOnInitialLoad } = this.registryAddressConfig;
    this.registryAddressConfig.autoselectFirstMatchOnInitialLoad = getOrDefault(autoselectFirstMatchOnInitialLoad, true);
  }
  set addressSearchTerm(value) {
    this.registryAddressSearchTerm = value;
    runInAction(() => {
      this.registryRoomAutocompleteItems.clear();
    });
    if (value && !this.debounceActive) {
      this.debounceActive = true;
      debounce(this.debounceDelay, this.fetchRegistryAddressSuggestions)();
    }
  }
  set selectedAddressId(id) {
    runInAction(() => {
      this.registryAddressAutocompleteItems.forEach((address) => address.isSelected = address.id === id);
      const rooms = this.registryAddressAutocompleteItems.find((adr) => adr.id === id).rooms;
      if (rooms.length > 0) {
        this.registryRoomAutocompleteItems.replace(rooms);
      }
    });
    const foundAddress = this.registryAddressSuggestions.find((adr) => adr.id === id);
    this.selectedRegistryAddress = foundAddress;
    this.registryAddressLabel = foundAddress.label2;
    this.selectedRegistryAddress.addressRegistryId = foundAddress.id;
    this.selectedRegistryAddress.buildingRegistryId = foundAddress.buildingId;
    this.selectedRegistryAddress.selectedRoom = void 0;
  }
  set selectedRoomId(id) {
    runInAction(() => {
      this.registryRoomAutocompleteItems.forEach((room) => room.isSelected = room.id === id);
    });
    const foundRoom = this.selectedRegistryAddress.rooms.find((room) => room.roomId === id);
    this.selectedRegistryAddress.selectedRoom = foundRoom;
    this.registryRoomLabel = foundRoom == null ? void 0 : foundRoom.roomName;
    this.selectedRegistryAddress.roomRegistryId = foundRoom.roomId;
  }
  get selectedAddress() {
    return this.selectedCountryIsEstonia ? this.selectedRegistryAddress : this.selectedForeignAddress;
  }
  set selectedCountryCode(code) {
    this.selectedCountry = CountryUtil.getByCountryCode(code);
  }
  set selectedCountry(country) {
    runInAction(() => {
      this._selectedCountry = country;
      if (this.selectedCountry && this.selectedCountry.value) {
        this.selectedAddress.countryCode = this.selectedCountry.value;
      }
    });
  }
  get selectedCountry() {
    return this._selectedCountry;
  }
  get selectedCountryIsEstonia() {
    if (this.selectedCountry.value) {
      return this.selectedCountry.value === CountryUtil.getByCountryCode("EE").value;
    }
    return false;
  }
  setForeignAddressFieldValue(field, value) {
    this.selectedForeignAddress[field] = value;
  }
}
__decorateClass$b([
  observable
], ComponentAddressStore.prototype, "isLoading", 2);
__decorateClass$b([
  observable
], ComponentAddressStore.prototype, "_selectedCountry", 2);
__decorateClass$b([
  observable
], ComponentAddressStore.prototype, "filteredRooms", 2);
__decorateClass$b([
  action.bound
], ComponentAddressStore.prototype, "initializeAddresses", 1);
__decorateClass$b([
  computed
], ComponentAddressStore.prototype, "selectedAddress", 1);
__decorateClass$b([
  computed
], ComponentAddressStore.prototype, "selectedCountry", 1);
__decorateClass$b([
  computed
], ComponentAddressStore.prototype, "selectedCountryIsEstonia", 1);
var __defProp$a = Object.defineProperty;
var __getOwnPropDesc$a = Object.getOwnPropertyDescriptor;
var __decorateClass$a = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$a(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$a(target, key, result);
  return result;
};
let Address = class extends React__default.Component {
  constructor(props) {
    var _a2, _b2;
    super(props);
    __publicField(this, "registryAddressValid", true);
    __publicField(this, "foreignAddressValid", true);
    __publicField(this, "displayRegistryAddress", true);
    __publicField(this, "displayCountrySelect", false);
    // local instance so there can be more than 1 address in a component
    __publicField(this, "componentAddressStore");
    __publicField(this, "registryAddress");
    __publicField(this, "foreignAddress");
    __publicField(this, "registryAddressWidth");
    __publicField(this, "foreignAddressWidth");
    __publicField(this, "countrySelectWidth");
    __publicField(this, "registryAddressRequiredFields");
    __publicField(this, "foreignAddressRequiredFields");
    __publicField(this, "onCountryChange", action(() => {
      this.displayRegistryAddress = this.componentAddressStore.selectedCountryIsEstonia;
      this.onAddressChange();
    }));
    __publicField(this, "onAddressChange", () => {
      this.props.onChange(this.componentAddressStore.selectedAddress, this.displayRegistryAddress ? this.registryAddressValid : this.foreignAddressValid);
    });
    __publicField(this, "onRoomChange", () => {
      this.props.onChange(this.componentAddressStore.selectedAddress, this.displayRegistryAddress ? this.registryAddressValid : this.foreignAddressValid);
    });
    __publicField(this, "onValidityChange", (valid) => {
      if (this.displayRegistryAddress) {
        this.registryAddressValid = valid;
      } else {
        this.foreignAddressValid = valid;
      }
    });
    makeObservable(this);
    const isRegistryAddress = !!this.props.type && this.props.type === "registry";
    const isForeignAddress = !!this.props.type && this.props.type === "foreign";
    const isCombinedAddress = !this.props.type || this.props.type === "combined";
    if (isCombinedAddress) {
      if (!this.props.defaultValue) {
        this.registryAddress = {};
      } else {
        const getRegistryId = (value) => value.addressRegistryId || value.buildingRegistryId || value.roomRegistryId;
        const getCountryCode = (value) => value.countryCode;
        if (getRegistryId(this.props.defaultValue) || getCountryCode(this.props.defaultValue) === "EE") {
          this.registryAddress = this.props.defaultValue;
        } else {
          this.foreignAddress = this.props.defaultValue;
        }
      }
      this.registryAddressWidth = this.props.width.registryAddress;
      this.foreignAddressWidth = this.props.width.foreignAddress;
      this.countrySelectWidth = this.props.width.countrySelect;
      this.displayCountrySelect = true;
      if (this.props.requiredFields) {
        this.registryAddressRequiredFields = this.props.requiredFields.registryAddress;
        this.foreignAddressRequiredFields = this.props.requiredFields.foreignAddress;
      } else {
        this.registryAddressRequiredFields = [];
        this.foreignAddressRequiredFields = [];
      }
    }
    if (isRegistryAddress) {
      this.registryAddress = this.props.defaultValue;
      this.registryAddressWidth = this.props.width;
      this.registryAddressRequiredFields = this.props.requiredFields ? this.props.requiredFields : [];
      this.displayCountrySelect = false;
    }
    if (isForeignAddress) {
      this.foreignAddress = this.props.defaultValue;
      this.foreignAddressWidth = this.props.width;
      this.foreignAddressRequiredFields = this.props.requiredFields ? this.props.requiredFields : [];
      this.displayCountrySelect = false;
    }
    const registryAddressConfig = isRegistryAddress ? this.props.config : isForeignAddress ? void 0 : (_a2 = this.props.config) == null ? void 0 : _a2.registryAddress;
    this.displayRegistryAddress = isRegistryAddress || !!this.registryAddress;
    this.componentAddressStore = new ComponentAddressStore();
    this.componentAddressStore.init(this.registryAddress, this.foreignAddress, registryAddressConfig);
    this.componentAddressStore.selectedCountryCode = !!this.registryAddress ? "EE" : ((_b2 = this.foreignAddress) == null ? void 0 : _b2.countryCode) || "EE";
    this.registryAddressValid = !!this.registryAddress && (!this.registryAddressRequiredFields.includes("address") || !!this.registryAddress.addressRegistryId) && (!this.registryAddressRequiredFields.includes("room") || !!this.registryAddress.roomRegistryId);
    this.foreignAddressValid = !!this.foreignAddress && (!this.foreignAddressRequiredFields.includes("region") || !!this.foreignAddress.region) && (!this.foreignAddressRequiredFields.includes("city") || !!this.foreignAddress.city) && (!this.foreignAddressRequiredFields.includes("street") || !!this.foreignAddress.street) && (!this.foreignAddressRequiredFields.includes("building") || !!this.foreignAddress.building) && (!this.foreignAddressRequiredFields.includes("room") || !!this.foreignAddress.room) && (!this.foreignAddressRequiredFields.includes("postalCode") || !!this.foreignAddress.postalCode);
  }
  render() {
    var _a2, _b2, _c2, _d2, _e, _f;
    if (this.componentAddressStore.isLoading) {
      return /* @__PURE__ */ React__default.createElement(Spinner, null);
    }
    if (this.displayRegistryAddress) {
      return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, this.displayCountrySelect && /* @__PURE__ */ React__default.createElement(
        CountrySelectComponent,
        {
          onChange: this.onCountryChange,
          width: this.countrySelectWidth,
          value: "EE",
          componentAddressStore: this.componentAddressStore
        }
      ), /* @__PURE__ */ React__default.createElement(
        RegistryAddressComponent,
        {
          addressWidth: this.registryAddressWidth.address,
          onAddressChange: this.onAddressChange,
          addressRequired: this.registryAddressRequiredFields.includes("address"),
          roomWidth: this.registryAddressWidth.room,
          onRoomChange: this.onRoomChange,
          onRoomSelect: this.onRoomChange,
          roomRequired: this.registryAddressRequiredFields.includes("room"),
          validityCallback: this.onValidityChange,
          componentAddressStore: this.componentAddressStore,
          helper: this.props.helper,
          contentRenderer: this.props.contentRenderer,
          fieldId: this.props.id
        }
      ));
    }
    const getForeignAddressField = (type, value) => {
      return { type, value, isRequired: this.foreignAddressRequiredFields.includes(type) };
    };
    const foreignAddressFields = [
      getForeignAddressField("region", (_a2 = this.foreignAddress) == null ? void 0 : _a2.region),
      getForeignAddressField("city", (_b2 = this.foreignAddress) == null ? void 0 : _b2.city),
      getForeignAddressField("street", (_c2 = this.foreignAddress) == null ? void 0 : _c2.street),
      getForeignAddressField("building", (_d2 = this.foreignAddress) == null ? void 0 : _d2.building),
      getForeignAddressField("room", (_e = this.foreignAddress) == null ? void 0 : _e.room),
      getForeignAddressField("postalCode", (_f = this.foreignAddress) == null ? void 0 : _f.postalCode)
    ];
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, this.displayCountrySelect && /* @__PURE__ */ React__default.createElement(CountrySelectComponent, { onChange: this.onCountryChange, width: this.countrySelectWidth, componentAddressStore: this.componentAddressStore }), /* @__PURE__ */ React__default.createElement(
      ForeignAddressComponent,
      {
        width: this.foreignAddressWidth,
        fields: foreignAddressFields,
        onChange: this.onAddressChange,
        validityCallback: this.onValidityChange,
        componentAddressStore: this.componentAddressStore
      }
    ));
  }
};
__decorateClass$a([
  observable
], Address.prototype, "displayRegistryAddress", 2);
Address = __decorateClass$a([
  injectStores,
  observer
], Address);
const CountrySelectComponent = observer((props) => {
  const {
    componentTranslateStore: { translate }
  } = React__default.useContext(ComponentRootStoreContext);
  const currentLanguage = React__default.useContext(LanguageContext);
  const getValue = () => {
    return { value: props.componentAddressStore.selectedCountry.value, label: props.componentAddressStore.selectedCountry.label[currentLanguage] };
  };
  const onChange = (newValue) => {
    props.componentAddressStore.selectedCountryCode = newValue.value;
    props.onChange();
  };
  return /* @__PURE__ */ React__default.createElement(Grid, null, /* @__PURE__ */ React__default.createElement(GridColumn, { width: props.width }, /* @__PURE__ */ React__default.createElement(
    Select,
    {
      id: "country-select",
      isInvalid: !CountryUtil.getCountriesContainingSearchTerm("", currentLanguage),
      label: translate("countrySelect.country"),
      live: true,
      onChange,
      options: CountryUtil.countriesForView("", currentLanguage),
      placeholder: CountryUtil.getCountryNameByCountryCode("EE", currentLanguage),
      value: getValue()
    }
  )));
});
const RegistryAddressComponent = observer((props) => {
  var _a2, _b2;
  const { componentAddressStore } = props;
  const {
    componentTranslateStore: { translate }
  } = React__default.useContext(ComponentRootStoreContext);
  const convert = (item) => {
    return {
      id: item.id,
      label: item.label,
      subLabel: item.subLabel,
      url: "#",
      isActive: item.isSelected
    };
  };
  const [addressValid, setAddressValid] = React__default.useState(props.addressRequired ? !!componentAddressStore.registryAddressLabel : true);
  const [roomValid, setRoomValid] = React__default.useState(
    props.roomRequired ? componentAddressStore.registryRoomAutocompleteItems.length === 0 || !!componentAddressStore.registryRoomLabel && componentAddressStore.registryRoomLabel.length < 8 : true
  );
  const [roomText, setRoomText] = React__default.useState(componentAddressStore.registryRoomLabel || "");
  const hasExactRoomMatch = (roomValue) => {
    return componentAddressStore.registryRoomAutocompleteItems.find((room) => room.label.toLowerCase() === roomValue.toLowerCase());
  };
  const onAddressChange = (newValue) => {
    componentAddressStore.addressSearchTerm = newValue;
    const addressIsValid = !!newValue && !props.addressRequired;
    setAddressValid(addressIsValid);
    setRoomText("");
    props.validityCallback(addressIsValid);
    props.onAddressChange();
  };
  const onAddressSelect = (id) => {
    componentAddressStore.selectedAddressId = id;
    const newRoomValid = props.roomRequired ? componentAddressStore.registryRoomAutocompleteItems.length === 0 || !!componentAddressStore.selectedAddress.selectedRoom && componentAddressStore.registryRoomLabel.length < 8 : true;
    setAddressValid(true);
    setRoomValid(newRoomValid);
    props.validityCallback(newRoomValid);
    props.onAddressChange();
  };
  const onRoomSelect = (room) => {
    componentAddressStore.selectedRoomId = room.roomId;
    setRoomValid(true);
    props.validityCallback(true);
    props.onRoomSelect();
  };
  const onRoomChange = (newValue) => {
    componentAddressStore.filteredRooms = componentAddressStore.registryRoomAutocompleteItems.filter(
      (room) => room.label.toLowerCase().startsWith(newValue.toLowerCase())
    );
    let newRoomValid;
    if (props.roomRequired) {
      newRoomValid = componentAddressStore.registryRoomAutocompleteItems.length === 0 && newValue.length <= 8;
    } else if (componentAddressStore.registryRoomAutocompleteItems.length === 0) {
      newRoomValid = newValue.length <= 8;
    } else {
      newRoomValid = true;
    }
    if (hasExactRoomMatch(newValue)) {
      newRoomValid = true;
    }
    if (componentAddressStore.registryRoomAutocompleteItems.length === 0) {
      props.componentAddressStore.selectedAddress.selectedRoom = { roomName: newValue };
    }
    setRoomValid(newRoomValid);
    setRoomText(newValue);
    props.validityCallback(newRoomValid);
    props.onRoomChange();
  };
  const onRoomBlur = (event) => {
    const newValue = event.target.value.trim();
    const exactMatchRoom = hasExactRoomMatch(newValue);
    if (exactMatchRoom) {
      componentAddressStore.selectedRoomId = exactMatchRoom.id;
      props.onRoomSelect();
    } else if (componentAddressStore.registryRoomAutocompleteItems.length === 0) {
      componentAddressStore.selectedAddress.selectedRoom = { roomName: newValue };
    }
  };
  const helperType = (_a2 = props.helper) == null ? void 0 : _a2.type;
  const helperText = String((_b2 = props.helper) == null ? void 0 : _b2.text);
  return /* @__PURE__ */ React__default.createElement(Grid, null, /* @__PURE__ */ React__default.createElement(GridColumn, { width: props.addressWidth }, /* @__PURE__ */ React__default.createElement(
    SuggestionField,
    {
      id: props.fieldId || "registry-address-address",
      defaultValue: componentAddressStore.registryAddressLabel,
      label: translate("registryAddress.address"),
      isInvalid: !addressValid,
      items: componentAddressStore.registryAddressAutocompleteItems.map((item) => convert(item)),
      onChange: onAddressChange,
      onSelect: (value) => onAddressSelect(value.id),
      ...getHelperMessageProp(helperText, helperType)
    }
  )), /* @__PURE__ */ React__default.createElement(GridColumn, { width: props.roomWidth }, /* @__PURE__ */ React__default.createElement(
    SuggestionField,
    {
      id: "registry-address-room",
      value: roomText,
      label: props.customRoomLabel || translate("registryAddress.room"),
      items: componentAddressStore.filteredRooms.map((item) => convert(item)),
      isInvalid: !roomValid,
      onChange: onRoomChange,
      onSelect: (value) => onRoomSelect(componentAddressStore.selectedAddress.rooms.find((room) => room.roomId === value.id)),
      onBlur: onRoomBlur,
      contentRenderer: props.contentRenderer,
      onFocus: () => {
        if (!roomText.trim()) {
          componentAddressStore.filteredRooms = [...componentAddressStore.registryRoomAutocompleteItems];
        }
      },
      showSuggestionsOnFocus: true,
      errorMessage: roomText.length > 8 && componentAddressStore.registryRoomAutocompleteItems.length === 0 ? translate("common.contactInfo.roomNameTooLongError") : helperType === "error" ? helperText : void 0,
      ...getHelperMessageProp(helperText, helperType)
    }
  )));
});
const ForeignAddressComponent = observer((props) => {
  const {
    componentTranslateStore: { translate }
  } = React__default.useContext(ComponentRootStoreContext);
  const fieldOrder = [
    "region",
    "city",
    "street",
    "building",
    "room",
    "postalCode"
    /* POSTALCODE */
  ];
  const sorted = props.fields.sort((f1, f2) => fieldOrder.indexOf(f1.type) > fieldOrder.indexOf(f2.type) ? 1 : -1);
  const onChange = action((newValue, field) => {
    props.componentAddressStore.setForeignAddressFieldValue(field.type.valueOf(), newValue);
    validityMap.set(field.type, !field.isRequired || newValue.length > 0);
    let hasInvalidValues = false;
    validityMap.forEach((value) => {
      if (!value) {
        hasInvalidValues = true;
        return;
      }
    });
    props.validityCallback(!hasInvalidValues);
    props.onChange();
  });
  const getFieldValue = (fieldType) => props.componentAddressStore.selectedAddress[fieldType.valueOf()];
  const validityMap = observable.map();
  sorted.forEach((field) => {
    const fieldValue = getFieldValue(field.type);
    validityMap.set(field.type, !field.isRequired || fieldValue && fieldValue.length > 0);
  });
  return /* @__PURE__ */ React__default.createElement(Grid, null, /* @__PURE__ */ React__default.createElement(GridColumn, { width: props.width }, /* @__PURE__ */ React__default.createElement(Text, null, sorted.map((field, index) => {
    return /* @__PURE__ */ React__default.createElement(
      TextField,
      {
        id: "foreign-address-".concat(field.type),
        key: "foreign-address-field-".concat(field.type, "-").concat(index),
        label: translate("foreignAddress.".concat(field.type)),
        defaultValue: getFieldValue(field.type),
        isInvalid: !validityMap.get(field.type),
        onChange: (newValue) => onChange(newValue, field)
      }
    );
  }))));
});
class ContactAddressApi {
  static getPersonAddresses() {
    return API.get("".concat(Config.apiUrl, "/person/contact-address"));
  }
  static createPersonRegistryAddress(registryAddress) {
    return API.post("".concat(Config.apiUrl, "/person/contact-address/registry-address"), registryAddress);
  }
  static updatePersonRegistryAddress(registryAddress) {
    return API.put("".concat(Config.apiUrl, "/person/contact-address/registry-address"), registryAddress);
  }
  static createPersonForeignAddress(foreignAddress) {
    return API.post("".concat(Config.apiUrl, "/person/contact-address/foreign-address"), foreignAddress);
  }
  static updatePersonForeignAddress(foreignAddress) {
    return API.put("".concat(Config.apiUrl, "/person/contact-address/foreign-address"), foreignAddress);
  }
}
const AddressStep = observer(() => {
  const {
    componentTranslateStore: { translate }
  } = useContext(ComponentRootStoreContext);
  const { index, setIndex } = useContext(RegistrationIndexContext);
  const { registrationCreation, setRegistrationCreation } = useContext(RegistrationCreationContext);
  const [existingAddress, setExistingAddress] = useState(null);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [addressComponentValidationError, setAddressComponentValidationError] = useState(false);
  const [isAddressFetching, setIsAddressFetching] = useState(false);
  const [isAddressUpdating, setIsAddressUpdating] = useState(false);
  const [addressUpdateError, setAddressUpdateError] = useState(false);
  const isRegistryAddressSelected = CountryUtil.isEstonia(selectedAddress == null ? void 0 : selectedAddress.countryCode);
  const hasAddressChanged = () => {
    if (!existingAddress && !!selectedAddress) {
      return true;
    }
    if (isRegistryAddressSelected) {
      return existingAddress.countryCode !== selectedAddress.countryCode || !existingAddress.addressRegistryId && !!selectedAddress.addressRegistryId || !!existingAddress.addressRegistryId && String(existingAddress.addressRegistryId) !== String(selectedAddress.addressRegistryId) || !existingAddress.buildingRegistryId && !!selectedAddress.buildingRegistryId || !!existingAddress.buildingRegistryId && String(existingAddress.buildingRegistryId) !== String(selectedAddress.buildingRegistryId) || !existingAddress.roomRegistryId && !!selectedAddress.roomRegistryId || !!existingAddress.roomRegistryId && String(existingAddress.roomRegistryId) !== String(selectedAddress.roomRegistryId) || existingAddress.room !== selectedAddress.room;
    } else {
      return (selectedAddress == null ? void 0 : selectedAddress.building) !== (existingAddress == null ? void 0 : existingAddress.building) || (selectedAddress == null ? void 0 : selectedAddress.city) !== (existingAddress == null ? void 0 : existingAddress.city) || (selectedAddress == null ? void 0 : selectedAddress.countryCode) !== (existingAddress == null ? void 0 : existingAddress.countryCode) || (selectedAddress == null ? void 0 : selectedAddress.municipality) !== (existingAddress == null ? void 0 : existingAddress.municipality) || (selectedAddress == null ? void 0 : selectedAddress.postalCode) !== (existingAddress == null ? void 0 : existingAddress.postalCode) || (selectedAddress == null ? void 0 : selectedAddress.region) !== (existingAddress == null ? void 0 : existingAddress.region) || (selectedAddress == null ? void 0 : selectedAddress.room) !== (existingAddress == null ? void 0 : existingAddress.room) || (selectedAddress == null ? void 0 : selectedAddress.street) !== (existingAddress == null ? void 0 : existingAddress.street);
    }
  };
  const isSelectedAddressValid = () => {
    if (isRegistryAddressSelected) {
      return !!(selectedAddress == null ? void 0 : selectedAddress.addressRegistryId) || !!(selectedAddress == null ? void 0 : selectedAddress.buildingRegistryId) || !!(selectedAddress == null ? void 0 : selectedAddress.roomRegistryId);
    } else {
      return !!(selectedAddress == null ? void 0 : selectedAddress.city) && !!(selectedAddress == null ? void 0 : selectedAddress.street) && !!(selectedAddress == null ? void 0 : selectedAddress.postalCode);
    }
  };
  const convertContactAddress = (contactAddress) => {
    if (!contactAddress) {
      return null;
    }
    return {
      addressRegistryId: contactAddress.addressRegistryId,
      buildingRegistryId: contactAddress.buildingRegistryId,
      roomRegistryId: contactAddress.roomRegistryId,
      privatePostalCode: contactAddress.postalCode,
      room: contactAddress.room,
      countryCode: contactAddress.countryCode,
      building: contactAddress.building,
      city: contactAddress.city,
      municipality: contactAddress.municipality,
      postalCode: contactAddress.postalCode,
      region: contactAddress.region,
      street: contactAddress.street
    };
  };
  const convertAddressFullInformation = (addressFullInformation) => {
    var _a2;
    if (!addressFullInformation) {
      return null;
    }
    const isEstonia = CountryUtil.isEstonia(addressFullInformation.countryCode);
    return {
      addressRegistryId: addressFullInformation.addressRegistryId,
      buildingRegistryId: addressFullInformation.buildingRegistryId,
      roomRegistryId: addressFullInformation.roomRegistryId,
      privatePostalCode: addressFullInformation.postalCode,
      countryCode: addressFullInformation.countryCode,
      city: addressFullInformation.city,
      municipality: addressFullInformation.municipality,
      postalCode: addressFullInformation.postalCode,
      region: addressFullInformation.region,
      street: addressFullInformation.street,
      // @ts-ignore - foreign AddressFullInformation has a different property for the selected building
      building: isEstonia ? addressFullInformation.house : addressFullInformation.building,
      // @ts-ignore - foreign AddressFullInformation has a different property for the selected room
      room: isEstonia ? (_a2 = addressFullInformation.selectedRoom) == null ? void 0 : _a2.roomName : addressFullInformation.room
    };
  };
  const createAddress = () => {
    if (isRegistryAddressSelected) {
      return ContactAddressApi.createPersonRegistryAddress(selectedAddress);
    } else {
      return ContactAddressApi.createPersonForeignAddress(selectedAddress);
    }
  };
  const updateAddress = () => {
    if (isRegistryAddressSelected) {
      return ContactAddressApi.updatePersonRegistryAddress(selectedAddress);
    } else {
      return ContactAddressApi.updatePersonForeignAddress(selectedAddress);
    }
  };
  const createOrUpdateAddress = async () => {
    if (hasAddressChanged() && isSelectedAddressValid()) {
      if (!existingAddress) {
        await createAddress();
      } else {
        await updateAddress();
      }
    }
  };
  const proceed = async () => {
    setAddressUpdateError(false);
    setIsAddressUpdating(true);
    try {
      await createOrUpdateAddress();
    } catch (e) {
      setAddressUpdateError(true);
      setIsAddressUpdating(false);
      return;
    }
    setRegistrationCreation({ ...registrationCreation, address: selectedAddress });
    setIndex(index + 1);
    setIsAddressUpdating(false);
  };
  const showHelperIfNecessary = () => {
    if (addressUpdateError) {
      return { text: translate("registration.addressStep.helper.savingError"), type: "error" };
    }
    return void 0;
  };
  useEffect(() => {
    setIsAddressFetching(true);
    ContactAddressApi.getPersonAddresses().then(({ data }) => {
      if (!data || data.length === 0) {
        setIsAddressFetching(false);
        return;
      }
      const address = getFirstContactInfoPreferringPrime(data).address;
      setExistingAddress(address);
      setSelectedAddress(convertContactAddress(address));
    }).finally(() => setIsAddressFetching(false));
  }, []);
  const isProceedButtonDisabled = isAddressUpdating || !isSelectedAddressValid() || addressComponentValidationError;
  return /* @__PURE__ */ React__default.createElement(Card, { padding: "medium", background: "transparent", type: "light" }, /* @__PURE__ */ React__default.createElement(CardHeader, null, /* @__PURE__ */ React__default.createElement(Heading$1, { element: "h2", className: "h3" }, translate("registration.addressStep.title"))), /* @__PURE__ */ React__default.createElement(Separator, { weight: "thin", spacing: "xsmall" }), /* @__PURE__ */ React__default.createElement(CardContent, null, /* @__PURE__ */ React__default.createElement(Text, null, /* @__PURE__ */ React__default.createElement(Heading$1, { element: "h3", className: "h4 text-bold" }, translate("registration.addressStep.subTitle")), /* @__PURE__ */ React__default.createElement(List, { size: "xsmall" }, /* @__PURE__ */ React__default.createElement(ListItem, null, translate("registration.addressStep.info.part1")), /* @__PURE__ */ React__default.createElement(ListItem, null, translate("registration.addressStep.info.part2"))), isAddressFetching ? /* @__PURE__ */ React__default.createElement(Spinner, null) : /* @__PURE__ */ React__default.createElement(
    Address,
    {
      defaultValue: selectedAddress,
      type: "combined",
      width: {
        registryAddress: { address: ["xs-12", "sm-9"], room: ["xs-12", "sm-3"] },
        foreignAddress: ["xs-12", "sm-9"],
        countrySelect: ["xs-12"]
      },
      requiredFields: { registryAddress: ["address", "room"], foreignAddress: ["street", "city", "postalCode"] },
      onChange: (addressFullInformation, isValid) => {
        setSelectedAddress(convertAddressFullInformation(addressFullInformation));
        setAddressComponentValidationError(!isValid);
      },
      helper: showHelperIfNecessary()
    }
  ))), /* @__PURE__ */ React__default.createElement(CardFooter, { background: "primary-3" }, /* @__PURE__ */ React__default.createElement(Grid, { align: ["middle-xs", "between-xs"], reverse: ["xs"] }, /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs"] }, /* @__PURE__ */ React__default.createElement(
    Button,
    {
      id: "address-step-proceed-button",
      text: translate("registration.step.proceed"),
      iconRight: "#arrow-right",
      isLoading: isAddressUpdating,
      disabled: isProceedButtonDisabled,
      onClick: proceed
    }
  )), /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs"] }, /* @__PURE__ */ React__default.createElement(Button, { link: true, text: translate("registration.step.back"), iconLeft: "#arrow-left", onClick: () => setIndex(index - 1) })))));
});
const CustomerContractStep = observer((props) => {
  const {
    componentTranslateStore: { translate },
    componentContractStore,
    componentSsoStore,
    urlDataStore
  } = useContext(ComponentRootStoreContext);
  const { index, setIndex } = useContext(RegistrationIndexContext);
  const [agreedToTerms, setAgreedToTerms] = useState(false);
  const [paperSigningModalShown, setPaperSigningModalShown] = useState(false);
  const [onScreenSigningShown, setOnScreenSigningShown] = useState(false);
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, paperSigningModalShown && /* @__PURE__ */ React__default.createElement(PaperSigningModal, { onClose: () => setPaperSigningModalShown(false), dealerRedirectUrl: props.redirectUrl }), onScreenSigningShown && /* @__PURE__ */ React__default.createElement(OnScreenSigningView, { onBack: () => setOnScreenSigningShown(false), redirectUrl: props.redirectUrl }), !onScreenSigningShown && /* @__PURE__ */ React__default.createElement(Card, { padding: "medium", background: "transparent", type: "light" }, /* @__PURE__ */ React__default.createElement(CardHeader, null, /* @__PURE__ */ React__default.createElement(Heading$1, { element: "h2", className: "h3" }, translate("registration.contractStep.title"))), /* @__PURE__ */ React__default.createElement(Separator, { weight: "thin", spacing: "xsmall" }), /* @__PURE__ */ React__default.createElement(CardContent, null, /* @__PURE__ */ React__default.createElement(Text, null, /* @__PURE__ */ React__default.createElement(Heading$1, { element: "h3", className: "h4 text-bold" }, translate("registration.contractStep.subTitle")), /* @__PURE__ */ React__default.createElement("p", null, translate("registration.contractStep.info", {
    generalTermsLink: urlDataStore.generalTermsUrl,
    privacyNoticeLink: urlDataStore.privacyNoticeUrl
  })), /* @__PURE__ */ React__default.createElement(Card, null, /* @__PURE__ */ React__default.createElement(CardContent, null, /* @__PURE__ */ React__default.createElement(Text, null, /* @__PURE__ */ React__default.createElement(
    Button,
    {
      text: translate("registration.contractStep.downloadContract"),
      link: true,
      iconLeft: "#download",
      isLoading: componentContractStore.isLoading,
      onClick: () => componentContractStore.getContractDocument()
    }
  ), /* @__PURE__ */ React__default.createElement(Separator, { className: "text__margin", weight: "thin" }), /* @__PURE__ */ React__default.createElement(
    Check,
    {
      id: "customer-contract-agreement",
      labelText: translate("registration.contractStep.agreedToTerms"),
      value: "customer-contract-agreement",
      checked: agreedToTerms,
      onChange: (checked) => setAgreedToTerms(checked)
    }
  )))))), /* @__PURE__ */ React__default.createElement(CardFooter, { background: "primary-3" }, /* @__PURE__ */ React__default.createElement(Grid, { align: ["middle-xs", "between-xs"], reverse: ["xs"], horizontalGutter: "small" }, /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs"] }, !componentSsoStore.dealer ? /* @__PURE__ */ React__default.createElement(
    Button,
    {
      id: "contract-step-proceed-button",
      text: translate("registration.contractStep.signContract"),
      iconRight: "#arrow-right",
      disabled: !agreedToTerms || componentContractStore.isLoading,
      isLoading: componentContractStore.isLoading,
      onClick: () => componentContractStore.signContractAndRedirect(props.redirectUrl)
    }
  ) : /* @__PURE__ */ React__default.createElement(Grid, { align: ["middle-xs"] }, (componentSsoStore.customerId || componentSsoStore.newCustomerId) && /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs"] }, /* @__PURE__ */ React__default.createElement(
    Button,
    {
      text: translate("registration.dealer.showCustomer"),
      link: true,
      type: "employee",
      iconRight: "#arrow-right",
      onClick: () => navigate(urlDataStore.selfServiceURL)
    }
  )), /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs"] }, /* @__PURE__ */ React__default.createElement(
    Button,
    {
      text: translate("registration.contractStep.dealer.signContract.paper"),
      type: "employee",
      onClick: () => setPaperSigningModalShown(true),
      disabled: !agreedToTerms
    }
  )), /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs"] }, /* @__PURE__ */ React__default.createElement(
    Button,
    {
      text: translate("registration.contractStep.dealer.signContract.onScreen"),
      type: "employee",
      onClick: () => setOnScreenSigningShown(true),
      disabled: !agreedToTerms
    }
  )))), /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs"] }, /* @__PURE__ */ React__default.createElement(Button, { link: true, text: translate("registration.step.back"), iconLeft: "#arrow-left", onClick: () => setIndex(index - 1) }))))));
});
const PhoneValidation = observer((props) => {
  const { isDealer } = props;
  const {
    componentTranslateStore: { translate },
    componentContactInfoValidationStore
  } = useContext(ComponentRootStoreContext);
  const placeholderValue = " ";
  const [displayValue, setDisplayValue] = useState(placeholderValue);
  const isNumber = (input) => /^\d+$/.test(input);
  if (!componentContactInfoValidationStore.isLoaded || !componentContactInfoValidationStore.contactInfo) {
    return null;
  }
  return /* @__PURE__ */ React__default.createElement(Text, null, /* @__PURE__ */ React__default.createElement(Heading$1, { element: "h1", className: "h3" }, translate(isDealer ? "contactInfo.validation.modal.phone.heading.dealer" : "contactInfo.validation.modal.phone.heading")), /* @__PURE__ */ React__default.createElement("p", { className: isDealer ? "text__margin-double" : null }, translate("contactInfo.validation.modal.phone.codeSent", {
    number: componentContactInfoValidationStore.contactInfo.value
  })), isDealer && /* @__PURE__ */ React__default.createElement("p", null, translate("contactInfo.validation.modal.phone.dealerInfo")), /* @__PURE__ */ React__default.createElement(Grid, { align: ["start-md", "center-xs"] }, /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs-6"] }, /* @__PURE__ */ React__default.createElement(
    TextField,
    {
      id: "phone-validation-code-input",
      label: translate("contactInfo.validation.modal.phone.code"),
      size: "medium",
      align: "center",
      value: displayValue,
      defaultIsFocused: true,
      errorMessage: componentContactInfoValidationStore.isErrorOnValidation && translate("contactInfo.validation.modal.phone.incorrect"),
      onChange: action((value) => {
        if (isNumber(value) && value.length <= 4 || value === "") {
          componentContactInfoValidationStore.validationCodeInputValue = value;
          setDisplayValue(value);
        }
      }),
      onFocus: () => {
        if (!componentContactInfoValidationStore.validationCodeInputValue) {
          setDisplayValue("");
        }
      },
      onBlur: () => {
        if (!componentContactInfoValidationStore.validationCodeInputValue) {
          setDisplayValue(placeholderValue);
        }
      }
    }
  ))), /* @__PURE__ */ React__default.createElement("p", null, translate(isDealer ? "contactInfo.validation.modal.phone.question.dealer" : "contactInfo.validation.modal.phone.question"), " ", /* @__PURE__ */ React__default.createElement(
    AnalyticsTrigger,
    {
      trigger: {
        group: "crm-components",
        id: "Link - ".concat(isDealer ? "Dealer " : "", "Resend Validation Code Phone"),
        callback: "onClick"
      }
    },
    /* @__PURE__ */ React__default.createElement(Anchor, { url: "#", color: isDealer ? "employee" : null, onClick: () => componentContactInfoValidationStore.sendValidationCode() }, translate("contactInfo.validation.modal.phone.resend"))
  )), !componentContactInfoValidationStore.isResendAllowed && /* @__PURE__ */ React__default.createElement(Notice, { type: "success", size: "small" }, translate("contactInfo.validation.modal.phone.resent")));
});
const EmailValidation = observer((props) => {
  const { isDealer } = props;
  const {
    componentTranslateStore: { translate },
    componentContactInfoValidationStore
  } = useContext(ComponentRootStoreContext);
  if (!componentContactInfoValidationStore.isLoaded || !componentContactInfoValidationStore.contactInfo) {
    return null;
  }
  return /* @__PURE__ */ React__default.createElement(Text, null, /* @__PURE__ */ React__default.createElement(Heading$1, { element: "h1", className: "h3" }, translate(isDealer ? "contactInfo.validation.modal.email.heading.dealer" : "contactInfo.validation.modal.email.heading")), /* @__PURE__ */ React__default.createElement("p", null, translate("contactInfo.validation.modal.email.codeSent", {
    email: componentContactInfoValidationStore.contactInfo.value
  })), isDealer && /* @__PURE__ */ React__default.createElement("p", null, translate("contactInfo.validation.modal.email.dealerInfo")), /* @__PURE__ */ React__default.createElement("p", null, translate(isDealer ? "contactInfo.validation.modal.email.question.dealer" : "contactInfo.validation.modal.email.question"), " ", /* @__PURE__ */ React__default.createElement(
    AnalyticsTrigger,
    {
      trigger: {
        group: "crm-components",
        id: "Link - ".concat(isDealer ? "Dealer " : "", "Resend Validation Code Email"),
        callback: "onClick"
      }
    },
    /* @__PURE__ */ React__default.createElement(Anchor, { url: "#", color: isDealer ? "employee" : null, onClick: () => componentContactInfoValidationStore.sendValidationCode() }, translate(isDealer ? "contactInfo.validation.modal.email.resend.dealer" : "contactInfo.validation.modal.email.resend"))
  )), !componentContactInfoValidationStore.isResendAllowed && /* @__PURE__ */ React__default.createElement(Notice, { type: "success", size: "small" }, translate("contactInfo.validation.modal.email.resent")));
});
const ContactInfoValidationModal = observer((props) => {
  const {
    componentContactInfoValidationStore: { isModalOpen, isValidationComplete, isLoaded, isEmailValidation, isPhoneValidation },
    componentContactInfoValidationStore,
    componentTranslateStore: { translate }
  } = useContext(ComponentRootStoreContext);
  useEffect(
    action(() => {
      var _a2;
      if ((_a2 = props.contactInfo) == null ? void 0 : _a2.contactInfoId) {
        componentContactInfoValidationStore.init(props.contactInfo);
      }
      componentContactInfoValidationStore.isModalOpen = props.isOpen;
    }),
    [props.isOpen, props.contactInfo]
  );
  useEffect(() => {
    if (isModalOpen !== props.isOpen || isValidationComplete) {
      props.onClose(isValidationComplete);
      componentContactInfoValidationStore.reset();
    }
  }, [isModalOpen, isValidationComplete]);
  if (!props.contactInfo || !isLoaded) {
    return null;
  }
  return /* @__PURE__ */ React__default.createElement(Container, null, /* @__PURE__ */ React__default.createElement(Modal, { size: "6-col", isOpen: isModalOpen, hasContentComponent: true, isClosable: false }, /* @__PURE__ */ React__default.createElement(ModalContent, null, isEmailValidation && /* @__PURE__ */ React__default.createElement(EmailValidation, { isDealer: props.isDealer }), isPhoneValidation && /* @__PURE__ */ React__default.createElement(PhoneValidation, { isDealer: props.isDealer })), /* @__PURE__ */ React__default.createElement(ModalFooter, null, /* @__PURE__ */ React__default.createElement(Grid, { align: ["between-xs", "middle-xs"] }, /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs"] }, /* @__PURE__ */ React__default.createElement(AnalyticsTrigger, { trigger: { id: "CTA - Cancel Validation Modal", callback: "onClick" } }, /* @__PURE__ */ React__default.createElement(
    Button,
    {
      text: translate("contactInfo.validation.modal.cancel"),
      type: props.isDealer ? "employee" : null,
      iconLeft: "#close",
      link: true,
      onClick: () => componentContactInfoValidationStore.reset()
    }
  ))), isPhoneValidation && /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs"] }, /* @__PURE__ */ React__default.createElement(AnalyticsTrigger, { trigger: { id: "Button - contactinfo phone modal confirm", callback: "onClick" } }, /* @__PURE__ */ React__default.createElement(
    Button,
    {
      text: translate("contactInfo.validation.modal.phone.confirm"),
      type: props.isDealer ? "employee" : null,
      iconRight: "#arrow-right",
      onClick: () => componentContactInfoValidationStore.validatePhone(),
      disabled: !componentContactInfoValidationStore.isPhoneInputValid
    }
  )))))));
});
const EmailStep = observer(() => {
  var _a2, _b2, _c2, _d2;
  const {
    componentSsoStore: { dealer },
    componentSsoStore,
    componentContractStore,
    componentTranslateStore: { translate }
  } = useContext(ComponentRootStoreContext);
  const { index, setIndex } = useContext(RegistrationIndexContext);
  const { registrationCreation, setRegistrationCreation } = useContext(RegistrationCreationContext);
  const [isLoading, setLoading] = useState(true);
  const [isValidationModalOpen, setValidationModalOpen] = useState(false);
  const [customerWillValidateLater, setCustomerWillValidateLater] = useState(false);
  const [customerCreationLoading, setCustomerCreationLoading] = useState(false);
  const [customerCreationError, setCustomerCreationError] = useState(false);
  const email = useLocalObservable(() => new ContactInfo(ContactInfoType.EMAIL));
  const mandateApi = new MandateAPI(Config.apiUrl);
  useEffect(() => {
    ContactInfoAPI.getPersonContactInfos().then(({ data }) => {
      if (!data || data.length === 0) {
        setLoading(false);
        return;
      }
      const existingEmail = getFirstContactInfoPreferringPrime(data.filter((ci) => ci.type === ContactInfoType.EMAIL));
      if (existingEmail) {
        email.set(existingEmail);
      }
      setLoading(false);
    });
  }, []);
  const showHelperIfNecessary = () => {
    if (email.isUserInputError) {
      return {
        text: translate("registration.emailStep.helper.error"),
        type: "error"
      };
    } else if (email.isSavingError) {
      return {
        text: translate("registration.emailStep.helper.savingError"),
        type: "error"
      };
    } else if (customerCreationError) {
      return {
        text: translate("registration.emailStep.helper.customerCreationError"),
        type: "error"
      };
    } else if (email.validated === false || email.validated === null && email.oldValue !== "") {
      return {
        text: translate("registration.emailStep.helper.notValidated"),
        type: "error"
      };
    } else if (email.hasValue && !email.hasValueChanged) {
      return {
        text: translate("registration.emailStep.helper.validated"),
        type: "valid"
      };
    }
    return void 0;
  };
  const saveEmail = async () => {
    email.setSavingError(false);
    if (email.hasValue) {
      return createOrUpdateEmail();
    } else {
      return deleteEmail();
    }
  };
  const createOrUpdateEmail = async () => {
    try {
      if (email.contactInfoId) {
        await ContactInfoAPI.putPersonContactInfo(email.getContactInfoResource());
      } else {
        await ContactInfoAPI.postPersonContactInfo(email.getContactInfoResource()).then(action(({ data }) => email.contactInfoId = data));
      }
      email.oldValue = email.value;
      email.validated = false;
    } catch (e) {
      email.setSavingError(true);
    }
  };
  const deleteEmail = async () => {
    if (!!dealer) {
      ContactInfoAPI.deletePersonContactInfo(email.contactInfoId);
      setRegistrationCreation({ ...registrationCreation, email: null });
      setIndex(index + 1);
    }
  };
  const createCustomer = async () => {
    await CustomerApi.postPrivateCustomer(
      getPrivateCustomerResource(
        componentSsoStore.person,
        email,
        registrationCreation.phone,
        registrationCreation.communicationLanguage,
        registrationCreation.address
      )
    );
  };
  const updateSessionWithNewCustomer = async () => {
    await mandateApi.getPersonMandates().then(({ data }) => {
      const personMandate = data.find(
        (mandate) => mandate.registrationNumber === componentSsoStore.person.personalCode && mandate.registrationNumberCountryCode === componentSsoStore.person.personalCodeCountryCode
      );
      componentSsoStore.updateSessionByCustomerId(personMandate.customerId);
      runInAction(() => componentSsoStore.newCustomerId = personMandate.customerId);
    });
  };
  const createOrRefreshCustomerAndContract = async () => {
    if (!componentSsoStore.customerId && !componentSsoStore.newCustomerId) {
      await createCustomer();
      await updateSessionWithNewCustomer();
      componentSsoStore.onLoginWithCallback(async () => {
        await ensurePreparedContractExistsAndRefresh();
      });
    } else {
      await ensurePreparedContractExistsAndRefresh();
    }
  };
  const proceed = action(async () => {
    if (email.isInputValid && email.hasValueChanged) {
      await saveEmail();
    }
    if ((email.validated === false || email.validated == null) && email.hasValue && !email.isSavingError && !customerWillValidateLater) {
      ContactInfoValidationApi.sendContactInfoValidationCode(email.contactInfoId);
      email.initializeValidation();
      setValidationModalOpen(true);
      return;
    }
    if (email.isValidatedAndUnchanged || customerWillValidateLater) {
      setCustomerCreationError(false);
      setCustomerCreationLoading(true);
      try {
        await createOrRefreshCustomerAndContract();
      } catch (e) {
        setCustomerCreationError(true);
        setCustomerCreationLoading(false);
        return;
      }
    }
    setCustomerCreationLoading(false);
    setRegistrationCreation({ ...registrationCreation, email });
    setIndex(index + 1);
  });
  const ensurePreparedContractExistsAndRefresh = async () => {
    await componentContractStore.ensurePreparedContractExists();
    await componentContractStore.refreshContractData();
  };
  const isInvalid = email.isUserInputError || email.isSavingError;
  const requiredContactInfoFieldsEmpty = !dealer ? !((_a2 = registrationCreation.phone) == null ? void 0 : _a2.hasValue) || !email.hasValue : !((_b2 = registrationCreation.phone) == null ? void 0 : _b2.hasValue) && !email.hasValue;
  const isProceedButtonDisabled = customerCreationLoading || email.isUserInputError || requiredContactInfoFieldsEmpty;
  const helperType = (_c2 = showHelperIfNecessary()) == null ? void 0 : _c2.type;
  const helperText = String((_d2 = showHelperIfNecessary()) == null ? void 0 : _d2.text);
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Card, { padding: "medium", background: "transparent", type: "light" }, /* @__PURE__ */ React__default.createElement(CardHeader, null, /* @__PURE__ */ React__default.createElement(Heading$1, { element: "h2", className: "h3" }, translate("registration.emailStep.title"))), /* @__PURE__ */ React__default.createElement(Separator, { weight: "thin", spacing: "xsmall" }), /* @__PURE__ */ React__default.createElement(CardContent, null, /* @__PURE__ */ React__default.createElement(Text, null, /* @__PURE__ */ React__default.createElement(Heading$1, { element: "h3", className: "h4 text-bold" }, translate("registration.emailStep.subTitle")), /* @__PURE__ */ React__default.createElement(List, { size: "xsmall" }, /* @__PURE__ */ React__default.createElement(ListItem, null, translate("registration.emailStep.info.part1")), /* @__PURE__ */ React__default.createElement(ListItem, null, translate("registration.emailStep.info.part2")), /* @__PURE__ */ React__default.createElement(ListItem, null, translate("registration.emailStep.info.part3"))), isLoading ? /* @__PURE__ */ React__default.createElement(Spinner, null) : /* @__PURE__ */ React__default.createElement(Grid, null, /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs-12", "sm-7"] }, /* @__PURE__ */ React__default.createElement(
    TextField,
    {
      id: "email",
      label: translate("registration.emailStep.form.title"),
      value: email.value,
      isInvalid,
      onChange: action((value) => email.onChange(value, !!dealer)),
      ...getHelperMessageProp(helperText, helperType)
    }
  )), !!dealer && email.hasValue && (email.hasValueChanged || email.validated === false || email.validated == null) && /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs-12", "sm-5"], align: ["middle-xs"] }, !!showHelperIfNecessary() && /* @__PURE__ */ React__default.createElement(Separator, { spacing: "xsmall", color: "invisible" }), /* @__PURE__ */ React__default.createElement(
    Toggle,
    {
      checked: customerWillValidateLater,
      onChange: (value) => setCustomerWillValidateLater(value),
      label: translate("registration.emailStep.dealer.customerWillValidateLater"),
      id: "validate-later-toggle"
    }
  ))))), /* @__PURE__ */ React__default.createElement(CardFooter, { background: "primary-3" }, /* @__PURE__ */ React__default.createElement(Grid, { align: ["middle-xs", "between-xs"], reverse: ["xs"] }, /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs"] }, /* @__PURE__ */ React__default.createElement(
    Button,
    {
      id: "email-step-proceed-button",
      text: translate("registration.step.proceed"),
      iconRight: "#arrow-right",
      isLoading: customerCreationLoading,
      disabled: isProceedButtonDisabled,
      onClick: proceed
    }
  )), /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs"] }, /* @__PURE__ */ React__default.createElement(Button, { link: true, text: translate("registration.step.back"), iconLeft: "#arrow-left", onClick: () => setIndex(index - 1) }))))), /* @__PURE__ */ React__default.createElement(
    ContactInfoValidationModal,
    {
      isOpen: isValidationModalOpen,
      isDealer: !!dealer,
      contactInfo: email,
      onClose: action((validationSuccessful) => {
        if (validationSuccessful) {
          email.validated = true;
        }
        setValidationModalOpen(false);
      })
    }
  ));
});
var __defProp$9 = Object.defineProperty;
var __getOwnPropDesc$9 = Object.getOwnPropertyDescriptor;
var __decorateClass$9 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$9(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$9(target, key, result);
  return result;
};
let CommunicationLanguageSelector = class extends React__default.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "componentTranslateStore");
    __publicField(this, "getCommunicationLanguageProps", (isDisabled) => {
      const { translate } = this.componentTranslateStore;
      return [
        {
          id: "ET",
          label: translate("registration.contactInfo.communicationLanguage.ET"),
          name: "eesti",
          value: "ET",
          disabled: isDisabled
        },
        {
          id: "EN",
          label: translate("registration.contactInfo.communicationLanguage.EN"),
          name: "inglise",
          value: "EN",
          disabled: isDisabled
        },
        {
          id: "RU",
          label: translate("registration.contactInfo.communicationLanguage.RU"),
          name: "vene",
          value: "RU",
          disabled: isDisabled
        }
      ];
    });
  }
  render() {
    const { defaultValue, helper, label } = this.props;
    const { translate } = this.componentTranslateStore;
    const isDisabled = this.props.isDisabled || false;
    const helperType = helper == null ? void 0 : helper.type;
    const helperText = String(helper == null ? void 0 : helper.text);
    return /* @__PURE__ */ React__default.createElement(
      Selector,
      {
        id: "contact-channels-language",
        items: this.getCommunicationLanguageProps(isDisabled),
        label: label || translate("contactChannels.language"),
        defaultValue,
        size: this.props.size ? this.props.size : void 0,
        onChange: (val) => this.onChange(val),
        ...getHelperMessageProp(helperText, helperType)
      }
    );
  }
  onChange(value) {
    this.props.onChange(value);
  }
};
__decorateClass$9([
  action.bound
], CommunicationLanguageSelector.prototype, "onChange", 1);
CommunicationLanguageSelector = __decorateClass$9([
  injectStores,
  observer
], CommunicationLanguageSelector);
var CommunicationLanguage = /* @__PURE__ */ ((CommunicationLanguage2) => {
  CommunicationLanguage2["ET"] = "ET";
  CommunicationLanguage2["EN"] = "EN";
  CommunicationLanguage2["RU"] = "RU";
  return CommunicationLanguage2;
})(CommunicationLanguage || {});
const PersonalDataStep = observer(() => {
  const {
    componentTranslateStore: { translate },
    componentSsoStore: { person, dealer, customerId, newCustomerId },
    urlDataStore: { selfServiceURL }
  } = useContext(ComponentRootStoreContext);
  const { index, setIndex } = useContext(RegistrationIndexContext);
  const { registrationCreation, setRegistrationCreation } = useContext(RegistrationCreationContext);
  const currentLanguage = React__default.useContext(LanguageContext);
  const [communicationLanguage, setCommunicationLanguage] = useState(null);
  const [existingPerson, setExistingPerson] = useState(null);
  const [isLoadingPerson, setLoadingPerson] = useState(false);
  const [isUpdatingPerson, setIsUpdatingPerson] = useState(false);
  const [personUpdateFailed, setPersonUpdateFailed] = useState(false);
  useEffect(() => {
    setLoadingPerson(true);
    PersonApi.getPerson().then(({ data }) => {
      setExistingPerson(data);
      setCommunicationLanguage(data.communicationLanguageCode);
    }).finally(() => setLoadingPerson(false));
  }, []);
  const personExists = !!existingPerson;
  const proceed = async () => {
    setIsUpdatingPerson(true);
    try {
      if (!personExists) {
        await PersonApi.createPerson({
          firstName: person.firstName,
          lastName: person.lastName,
          personalCode: person.personalCode,
          personalCodeCountryCode: person.personalCodeCountryCode,
          communicationLanguageCode: communicationLanguage
        });
      } else if (existingPerson.communicationLanguageCode !== communicationLanguage) {
        await PersonApi.updateCommunicationLanguage(communicationLanguage);
      }
    } catch (e) {
      setPersonUpdateFailed(true);
      setIsUpdatingPerson(false);
      return;
    }
    setRegistrationCreation({
      ...registrationCreation,
      person: {
        firstName: person.firstName,
        lastName: person.lastName,
        personalCode: person.personalCode,
        personalCodeCountryCode: person.personalCodeCountryCode
      },
      communicationLanguage
    });
    setIndex(index + 1);
    setIsUpdatingPerson(false);
  };
  const isProceedButtonDisabled = !communicationLanguage || isUpdatingPerson;
  return /* @__PURE__ */ React__default.createElement(Card, { padding: "medium", background: "transparent", type: "light" }, /* @__PURE__ */ React__default.createElement(CardHeader, null, /* @__PURE__ */ React__default.createElement(Heading$1, { element: "h2", className: "h3" }, translate("registration.personalDataStep.title"))), /* @__PURE__ */ React__default.createElement(Separator, { weight: "thin", spacing: "xsmall" }), /* @__PURE__ */ React__default.createElement(CardContent, null, /* @__PURE__ */ React__default.createElement(Notice, { size: "small" }, translate("registration.personalDataStep.info")), /* @__PURE__ */ React__default.createElement(Separator, { color: "invisible", spacing: "small" }), isLoadingPerson ? /* @__PURE__ */ React__default.createElement(Spinner, null) : /* @__PURE__ */ React__default.createElement(Grid, null, /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs-12", "sm-1"] }, /* @__PURE__ */ React__default.createElement(Icon, { size: "lg", modifiers: "#contact" })), /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs-12", "sm-11"] }, /* @__PURE__ */ React__default.createElement(Heading$1, { element: "h3", className: "h4 text-bold" }, translate("registration.personalDataStep.customer")), /* @__PURE__ */ React__default.createElement("p", null, "".concat(person.firstName, " ").concat(person.lastName)), /* @__PURE__ */ React__default.createElement("p", null, person.personalCode, " (", CountryUtil.getCountryNameByCountryCode(person.personalCodeCountryCode, currentLanguage), ")"), /* @__PURE__ */ React__default.createElement(Separator, { color: "invisible", spacing: "xsmall" }), /* @__PURE__ */ React__default.createElement(
    CommunicationLanguageSelector,
    {
      size: "small",
      defaultValue: communicationLanguage,
      onChange: (language) => setCommunicationLanguage(language)
    }
  ), personUpdateFailed && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Separator, { spacing: "xsmall", color: "invisible" }), /* @__PURE__ */ React__default.createElement(Notice, { type: "error" }, translate("registration.personalDataStep.error")))))), /* @__PURE__ */ React__default.createElement(CardFooter, { background: "primary-3" }, /* @__PURE__ */ React__default.createElement(Grid, { align: ["end-xs", "middle-xs"] }, !!dealer && (customerId || newCustomerId) && /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs"] }, /* @__PURE__ */ React__default.createElement(
    Button,
    {
      text: translate("registration.dealer.showCustomer"),
      link: true,
      type: "employee",
      iconRight: "#arrow-right",
      onClick: () => navigate(selfServiceURL)
    }
  )), /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs"] }, /* @__PURE__ */ React__default.createElement(
    Button,
    {
      id: "personal-data-step-proceed-button",
      text: translate("registration.step.proceed"),
      iconRight: "#arrow-right",
      disabled: isProceedButtonDisabled,
      isLoading: isUpdatingPerson,
      onClick: proceed
    }
  )))));
});
const PhoneNumberStep = observer(() => {
  var _a2, _b2;
  const {
    componentSsoStore: { dealer },
    componentTranslateStore: { translate }
  } = useContext(ComponentRootStoreContext);
  const { index, setIndex } = useContext(RegistrationIndexContext);
  const { registrationCreation, setRegistrationCreation } = useContext(RegistrationCreationContext);
  const [isLoading, setLoading] = useState(true);
  const [isValidationModalOpen, setValidationModalOpen] = useState(false);
  const [customerWillValidateLater, setCustomerWillValidateLater] = useState(false);
  const phone = useLocalObservable(() => new ContactInfo(ContactInfoType.PHONE));
  useEffect(() => {
    ContactInfoAPI.getPersonContactInfos().then(({ data }) => {
      if (!data || data.length === 0) {
        setLoading(false);
        return;
      }
      const existingPhone = getFirstContactInfoPreferringPrime(data.filter((ci) => ci.type === ContactInfoType.PHONE));
      if (existingPhone) {
        phone.set(existingPhone);
      }
      setLoading(false);
    });
  }, []);
  const showHelperIfNecessary = () => {
    if (phone.isUserInputError) {
      return {
        text: translate("registration.phoneStep.helper.error"),
        type: "error"
      };
    } else if (phone.isSavingError) {
      return {
        text: translate("registration.phoneStep.helper.savingError"),
        type: "error"
      };
    } else if (phone.validated === false || phone.validated === null && phone.oldValue !== "" && phone.isEstonianMobilePhoneNumber) {
      return {
        text: translate("registration.phoneStep.helper.notValidated"),
        type: "error"
      };
    } else if (phone.hasValue && !phone.hasValueChanged && phone.isEstonianMobilePhoneNumber) {
      return {
        text: translate("registration.phoneStep.helper.validated"),
        type: "valid"
      };
    }
    return void 0;
  };
  const savePhone = async () => {
    phone.setSavingError(false);
    if (phone.hasValue) {
      return createOrUpdatePhone();
    } else {
      return deletePhone();
    }
  };
  const createOrUpdatePhone = async () => {
    try {
      if (phone.contactInfoId) {
        await ContactInfoAPI.putPersonContactInfo(phone.getContactInfoResource());
      } else {
        await ContactInfoAPI.postPersonContactInfo(phone.getContactInfoResource()).then(action(({ data }) => phone.contactInfoId = data));
      }
      phone.oldValue = phone.value;
      phone.validated = !phone.isEstonianMobilePhoneNumber;
    } catch (e) {
      phone.setSavingError(true);
    }
  };
  const deletePhone = async () => {
    if (!!dealer) {
      ContactInfoAPI.deletePersonContactInfo(phone.contactInfoId);
      setRegistrationCreation({ ...registrationCreation, phone: null });
      setIndex(index + 1);
    }
  };
  const proceed = action(async () => {
    if (phone.isInputValid && phone.hasValueChanged) {
      await savePhone();
    }
    if ((phone.validated === false || phone.validated == null) && phone.hasValue && phone.isEstonianMobilePhoneNumber && !phone.isSavingError && !customerWillValidateLater) {
      ContactInfoValidationApi.sendContactInfoValidationCode(phone.contactInfoId);
      phone.initializeValidation();
      setValidationModalOpen(true);
    }
    if (phone.isValidatedAndUnchanged || customerWillValidateLater) {
      setRegistrationCreation({ ...registrationCreation, phone });
      setIndex(index + 1);
      return;
    }
  });
  const isInvalid = phone.isUserInputError || phone.isSavingError;
  const isProceedButtonDisabled = phone.isUserInputError || !dealer && !phone.hasValue;
  const helperType = (_a2 = showHelperIfNecessary()) == null ? void 0 : _a2.type;
  const helperText = String((_b2 = showHelperIfNecessary()) == null ? void 0 : _b2.text);
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Card, { padding: "medium", background: "transparent", type: "light" }, /* @__PURE__ */ React__default.createElement(CardHeader, null, /* @__PURE__ */ React__default.createElement(Heading$1, { element: "h2", className: "h3" }, translate("registration.phoneStep.title"))), /* @__PURE__ */ React__default.createElement(Separator, { weight: "thin", spacing: "xsmall" }), /* @__PURE__ */ React__default.createElement(CardContent, null, /* @__PURE__ */ React__default.createElement(Text, null, /* @__PURE__ */ React__default.createElement(Heading$1, { element: "h3", className: "h4 text-bold" }, translate("registration.phoneStep.subTitle")), /* @__PURE__ */ React__default.createElement(List, { size: "xsmall" }, /* @__PURE__ */ React__default.createElement(ListItem, null, translate("registration.phoneStep.info.part1")), /* @__PURE__ */ React__default.createElement(ListItem, null, translate("registration.phoneStep.info.part2")), /* @__PURE__ */ React__default.createElement(ListItem, null, translate("registration.phoneStep.info.part3"))), isLoading ? /* @__PURE__ */ React__default.createElement(Spinner, null) : /* @__PURE__ */ React__default.createElement(Grid, null, /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs-12", "sm-4"] }, /* @__PURE__ */ React__default.createElement(
    TextField,
    {
      id: "phone-number",
      label: translate("registration.phoneStep.form.title"),
      value: phone.value,
      isInvalid,
      onChange: action((value) => phone.onChange(value, !!dealer)),
      ...getHelperMessageProp(helperText, helperType)
    }
  )), !!dealer && phone.hasValue && (phone.hasValueChanged || phone.validated === false || phone.validated == null) && phone.isEstonianMobilePhoneNumber && /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs-12", "sm-5"], align: ["middle-xs"] }, !!showHelperIfNecessary() && /* @__PURE__ */ React__default.createElement(Separator, { spacing: "xsmall", color: "invisible" }), /* @__PURE__ */ React__default.createElement(
    Toggle,
    {
      checked: customerWillValidateLater,
      onChange: (value) => setCustomerWillValidateLater(value),
      label: translate("registration.phoneStep.dealer.customerWillValidateLater"),
      id: "validate-later-toggle"
    }
  ))))), /* @__PURE__ */ React__default.createElement(CardFooter, { background: "primary-3" }, /* @__PURE__ */ React__default.createElement(Grid, { align: ["middle-xs", "between-xs"], reverse: ["xs"] }, /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs"] }, /* @__PURE__ */ React__default.createElement(
    Button,
    {
      id: "phone-step-proceed-button",
      text: translate("registration.step.proceed"),
      iconRight: "#arrow-right",
      disabled: isProceedButtonDisabled,
      onClick: proceed
    }
  )), /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs"] }, /* @__PURE__ */ React__default.createElement(Button, { link: true, text: translate("registration.step.back"), iconLeft: "#arrow-left", onClick: () => setIndex(index - 1) }))))), /* @__PURE__ */ React__default.createElement(
    ContactInfoValidationModal,
    {
      isOpen: isValidationModalOpen,
      isDealer: !!dealer,
      contactInfo: phone,
      onClose: action((validationSuccessful) => {
        if (validationSuccessful) {
          phone.validated = true;
        }
        setValidationModalOpen(false);
      })
    }
  ));
});
const RegistrationIndexContext = createContext({});
const RegistrationCreationContext = createContext({});
const B2cRegistration2 = observer((props) => {
  var _a2, _b2;
  const {
    componentSsoStore,
    componentTranslateStore: { translate },
    urlDataStore
  } = useContext(ComponentRootStoreContext);
  const currentLanguage = React__default.useContext(LanguageContext);
  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const [registrationCreation, setRegistrationCreation] = useState({});
  const shouldRenderForeignCitizenMessage = !componentSsoStore.isEstonianCitizen() && !componentSsoStore.dealer;
  const shouldNotRenderFlowWithUnderageClient = componentSsoStore.dealer && componentSsoStore.isUnderage() && !(componentSsoStore.hasDealerRole(Role.WEB_P_SECOND_LEVEL) || componentSsoStore.customerId);
  const getState = (index) => {
    if (index < currentStepIndex) {
      return "done";
    } else if (index === currentStepIndex) {
      return "current";
    } else {
      return "disabled";
    }
  };
  if (shouldRenderForeignCitizenMessage) {
    return /* @__PURE__ */ React__default.createElement(
      RegistrationCreationContext.Provider,
      {
        value: {
          registrationCreation,
          setRegistrationCreation
        }
      },
      /* @__PURE__ */ React__default.createElement(
        RegistrationIndexContext.Provider,
        {
          value: {
            index: currentStepIndex,
            setIndex: setCurrentStepIndex
          }
        },
        /* @__PURE__ */ React__default.createElement(Heading$1, { element: "h1", className: "h2" }, translate("registration.header")),
        /* @__PURE__ */ React__default.createElement(Separator, { color: "invisible", spacing: "small" }),
        /* @__PURE__ */ React__default.createElement(Notice, null, translate("registration.foreignCitizen.warning", {
          contactsUrl: urlDataStore.contactsUrl
        }))
      )
    );
  }
  if (shouldNotRenderFlowWithUnderageClient) {
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Heading$1, { element: "h1", className: "h2" }, translate("registration.header")), /* @__PURE__ */ React__default.createElement(Separator, { color: "invisible", spacing: "small" }), /* @__PURE__ */ React__default.createElement(Notice, { type: "employee" }, translate("registration.underage.notice.noflow")));
  }
  return /* @__PURE__ */ React__default.createElement(
    RegistrationCreationContext.Provider,
    {
      value: {
        registrationCreation,
        setRegistrationCreation
      }
    },
    /* @__PURE__ */ React__default.createElement(
      RegistrationIndexContext.Provider,
      {
        value: {
          index: currentStepIndex,
          setIndex: setCurrentStepIndex
        }
      },
      /* @__PURE__ */ React__default.createElement(Heading$1, { element: "h1", className: "h2" }, translate("registration.header")),
      /* @__PURE__ */ React__default.createElement(Separator, { color: "invisible", spacing: "small" }),
      !!componentSsoStore.dealer && componentSsoStore.isUnderage() && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Notice, { type: "employee" }, translate("registration.underage.notice")), /* @__PURE__ */ React__default.createElement(Separator, { spacing: "small", color: "invisible" })),
      /* @__PURE__ */ React__default.createElement(Progress, { style: "card" }, /* @__PURE__ */ React__default.createElement(
        ProgressItem,
        {
          title: translate("registration.personalDataStep.title"),
          onClick: () => setCurrentStepIndex(0),
          state: getState(0),
          info: currentStepIndex > 0 && /* @__PURE__ */ React__default.createElement("p", null, "".concat(registrationCreation.person.firstName, " ").concat(registrationCreation.person.lastName, ", ").concat(registrationCreation.person.personalCode, " (").concat(CountryUtil.getCountryNameByCountryCode(registrationCreation.person.personalCodeCountryCode, currentLanguage), ")"))
        },
        /* @__PURE__ */ React__default.createElement(PersonalDataStep, null)
      ), /* @__PURE__ */ React__default.createElement(
        ProgressItem,
        {
          title: translate("registration.addressStep.title"),
          onClick: () => setCurrentStepIndex(1),
          state: getState(1),
          info: currentStepIndex > 1 && /* @__PURE__ */ React__default.createElement("p", null, formatShortAddress(registrationCreation.address))
        },
        /* @__PURE__ */ React__default.createElement(AddressStep, null)
      ), /* @__PURE__ */ React__default.createElement(
        ProgressItem,
        {
          title: translate("registration.phoneStep.title"),
          onClick: () => setCurrentStepIndex(2),
          state: getState(2),
          info: currentStepIndex > 2 && /* @__PURE__ */ React__default.createElement("p", null, (_a2 = registrationCreation.phone) == null ? void 0 : _a2.value)
        },
        /* @__PURE__ */ React__default.createElement(PhoneNumberStep, null)
      ), /* @__PURE__ */ React__default.createElement(
        ProgressItem,
        {
          title: translate("registration.emailStep.title"),
          onClick: () => setCurrentStepIndex(3),
          state: getState(3),
          info: currentStepIndex > 3 && /* @__PURE__ */ React__default.createElement("p", null, (_b2 = registrationCreation.email) == null ? void 0 : _b2.value)
        },
        /* @__PURE__ */ React__default.createElement(EmailStep, null)
      ), /* @__PURE__ */ React__default.createElement(ProgressItem, { title: translate("registration.contractStep.title"), onClick: () => setCurrentStepIndex(4), state: getState(4) }, /* @__PURE__ */ React__default.createElement(CustomerContractStep, { redirectUrl: props.redirectUrl })))
    )
  );
});
var __defProp$8 = Object.defineProperty;
var __getOwnPropDesc$8 = Object.getOwnPropertyDescriptor;
var __decorateClass$8 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$8(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$8(target, key, result);
  return result;
};
let Registration = class extends React.Component {
  constructor(props) {
    super(props);
    __publicField(this, "brand");
    __publicField(this, "componentSsoStore");
    __publicField(this, "componentTranslateStore");
    __publicField(this, "componentContractStore");
    __publicField(this, "componentCustomerContactInfoStore");
    __publicField(this, "componentCreditInfoStore");
    __publicField(this, "componentMandateStore");
    __publicField(this, "isError", false);
    __publicField(this, "hasLegalMandate", false);
    __publicField(this, "isLoaded", false);
    makeObservable(this);
  }
  async componentDidMount() {
    this.setIsLoaded(false);
    await this.componentContractStore.init();
    if (this.componentSsoStore.isBusiness && !this.componentContractStore.hasSignedContract && !!this.componentSsoStore.customerId) {
      await this.getCustomerHasLegalMandate();
    }
    await this.componentCustomerContactInfoStore.init();
    if (this.brand === "TELIA") {
      await this.componentCreditInfoStore.init();
    }
    this.setIsLoaded(true);
  }
  render() {
    if (this.isLoaded && this.componentSsoStore.person) {
      if (this.componentSsoStore.isPrivate && !this.componentSsoStore.isRepresentingSelf) {
        return this.renderNoMandatesMessage();
      }
      if (!(this.componentSsoStore.dealer && this.componentSsoStore.isPrivate) && this.componentSsoStore.isUnderage()) {
        return this.renderUnderageMessage();
      }
      if (this.areStoresLoaded()) {
        if (this.componentSsoStore.customer && this.componentContractStore.hasSignedContract && !this.componentCreditInfoStore.hasRegistrableEntities && this.props.onNoRegistrableEntities) {
          this.props.onNoRegistrableEntities();
          return null;
        }
        if ((this.componentSsoStore.customer && this.componentContractStore.hasSignedContract || !this.componentSsoStore.customer) && !this.componentCreditInfoStore.hasRegistrableEntities) {
          return this.renderNoRegistrableLegalEntitiesMessage();
        }
        if (!!this.componentSsoStore.customerId && this.componentSsoStore.isBusiness && !this.componentContractStore.hasSignedContract && this.shouldRenderLegalMandateError() && !this.hasLegalMandate) {
          return this.renderMissingLegalMandateErrorMessage();
        }
        if (this.areStoresInError() || this.isError && this.shouldRenderLegalMandateError()) {
          return this.renderErrorMessage();
        } else {
          return this.renderRegistrationComponent();
        }
      }
    }
    return this.renderSpinner();
  }
  areStoresInError() {
    return this.componentContractStore.isError || this.componentCustomerContactInfoStore.isError;
  }
  areStoresLoaded() {
    return this.componentContractStore.isLoaded && this.componentSsoStore.isSsoLoaded && (this.brand !== "TELIA" || this.componentCreditInfoStore.isInitialized);
  }
  setIsLoaded(isLoaded) {
    this.isLoaded = isLoaded;
  }
  async getCustomerHasLegalMandate() {
    return this.componentMandateStore.hasCustomerMandate(["LEGAL"]).then(
      action((response) => {
        this.hasLegalMandate = response;
      })
    ).catch(
      action(() => {
        this.isError = true;
      })
    );
  }
  renderRegistrationComponent() {
    const analyticsContext2 = {
      group: "registration",
      event: "AutoEvent",
      page: "crm-components-registration",
      onPush: GaDataStore.push
    };
    return /* @__PURE__ */ React.createElement(AnalyticsProvider, { ...analyticsContext2 }, this.shouldShowCompanyList() && /* @__PURE__ */ React.createElement(RegisterableCompaniesList, null), this.shouldRenderB2bRegistration() && /* @__PURE__ */ React.createElement(B2bRegistration, { currentLanguage: this.props.currentLanguage, env: this.props.env, redirectUrl: this.props.redirectUrl }), this.shouldRenderB2cRegistration() && /* @__PURE__ */ React.createElement(B2cRegistration2, { redirectUrl: this.props.redirectUrl }));
  }
  shouldRenderB2bRegistration() {
    return !!this.componentCreditInfoStore.entityToRegister || this.componentSsoStore.isBusiness && !this.componentContractStore.hasSignedContract;
  }
  shouldRenderB2cRegistration() {
    return !this.componentContractStore.hasSignedContract && this.componentSsoStore.isPrivate;
  }
  shouldShowCompanyList() {
    return (!this.componentSsoStore.customer && this.componentCreditInfoStore.creditInfoLegalEntities.length > 0 || this.componentSsoStore.customer && this.componentContractStore.hasSignedContract && this.componentCreditInfoStore.creditInfoLegalEntities.length > 0) && this.componentCreditInfoStore.entityToRegister === null && this.brand === "TELIA";
  }
  shouldRenderLegalMandateError() {
    const representingBusinessInCreditInfo = !!this.componentCreditInfoStore.creditInfoLegalEntities.find(
      (legalEntity) => legalEntity.registrationNumber === this.componentSsoStore.customer.registrationNumber
    );
    return !representingBusinessInCreditInfo && !!this.componentSsoStore.customerId;
  }
  renderErrorMessage() {
    return /* @__PURE__ */ React.createElement(Notice, { type: "error" }, this.componentTranslateStore.translate("technical.error"));
  }
  renderMissingLegalMandateErrorMessage() {
    return /* @__PURE__ */ React.createElement(Notice, { type: "error" }, this.componentTranslateStore.translate("registration.noRequiredLegalMandate.error"));
  }
  renderNoMandatesMessage() {
    return /* @__PURE__ */ React.createElement(Notice, null, this.componentTranslateStore.translate("registration.noMandates.warning"));
  }
  renderNoRegistrableLegalEntitiesMessage() {
    return /* @__PURE__ */ React.createElement(Notice, null, this.componentTranslateStore.translate("registration.noRegistrableLegalEntities.warning"));
  }
  renderSpinner() {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  renderUnderageMessage() {
    return /* @__PURE__ */ React.createElement(Notice, null, this.componentTranslateStore.translate("registration.underage.warning"));
  }
};
__decorateClass$8([
  observable
], Registration.prototype, "isError", 2);
__decorateClass$8([
  observable
], Registration.prototype, "hasLegalMandate", 2);
__decorateClass$8([
  observable
], Registration.prototype, "isLoaded", 2);
__decorateClass$8([
  action.bound
], Registration.prototype, "setIsLoaded", 1);
__decorateClass$8([
  action.bound
], Registration.prototype, "getCustomerHasLegalMandate", 1);
Registration = __decorateClass$8([
  customerIdAsKey,
  injectStores,
  observer
], Registration);
const Registration$1 = Registration;
var __defProp$7 = Object.defineProperty;
var __getOwnPropDesc$7 = Object.getOwnPropertyDescriptor;
var __decorateClass$7 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$7(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$7(target, key, result);
  return result;
};
let CountrySuggestionField = class extends React.Component {
  constructor(props) {
    super(props);
    __publicField(this, "selectTriggered");
    __publicField(this, "searchTerm");
    __publicField(this, "getSearchTermFromCountry", () => {
      return this.props.country ? this.props.country.label[this.props.currentLanguage] : "";
    });
    __publicField(this, "onCountryChange", (searchTerm) => {
      this.searchTerm = searchTerm;
      this.props.onChange(CountryUtil.getSelectedCountry(searchTerm, this.props.currentLanguage));
      if (this.selectTriggered) {
        if (this.props.onSelect) {
          this.props.onSelect();
        }
        this.selectTriggered = false;
      }
    });
    __publicField(this, "onBlur", () => {
      if (this.props.onBlur) {
        this.props.onBlur();
      }
    });
    __publicField(this, "onFocus", () => {
      if (this.props.onFocus) {
        this.props.onFocus();
      }
    });
    __publicField(this, "onSelect", () => {
      this.selectTriggered = true;
      if (this.props.onSelect) {
        this.props.onSelect();
      }
    });
    makeObservable(this);
    this.selectTriggered = true;
    this.searchTerm = this.getSearchTermFromCountry();
  }
  componentDidMount() {
    reaction(
      () => this.props.currentLanguage,
      () => {
        this.searchTerm = this.getSearchTermFromCountry();
      }
    );
  }
  render() {
    const { helper, label, id, isInvalid, currentLanguage } = this.props;
    return /* @__PURE__ */ React.createElement(
      SuggestionField,
      {
        id,
        label,
        onBlur: this.onBlur,
        onChange: this.onCountryChange,
        onFocus: this.onFocus,
        items: CountryUtil.mapCountriesForSuggestionField(this.searchTerm, currentLanguage),
        value: this.searchTerm,
        onSelect: this.onSelect,
        isInvalid,
        ...getHelperMessageProp(helper == null ? void 0 : helper.text.toString(), helper == null ? void 0 : helper.type)
      }
    );
  }
};
__decorateClass$7([
  observable
], CountrySuggestionField.prototype, "selectTriggered", 2);
__decorateClass$7([
  observable
], CountrySuggestionField.prototype, "searchTerm", 2);
__decorateClass$7([
  action.bound
], CountrySuggestionField.prototype, "onCountryChange", 2);
__decorateClass$7([
  action.bound
], CountrySuggestionField.prototype, "onSelect", 2);
CountrySuggestionField = __decorateClass$7([
  observer
], CountrySuggestionField);
var __defProp$6 = Object.defineProperty;
var __getOwnPropDesc$6 = Object.getOwnPropertyDescriptor;
var __decorateClass$6 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$6(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$6(target, key, result);
  return result;
};
let Phone = class extends React__default.Component {
  constructor(props) {
    super(props);
    __publicField(this, "valid");
    __publicField(this, "required");
    __publicField(this, "componentTranslateStore");
    makeObservable(this);
    this.required = !!props.required ? props.required : false;
    this.valid = this.required ? !!props.defaultValue : !props.defaultValue || isPhoneValid(props.defaultValue);
  }
  render() {
    const { defaultValue, helper, label, id } = this.props;
    const { translate } = this.componentTranslateStore;
    const helperType = helper == null ? void 0 : helper.type;
    const helperText = String(helper == null ? void 0 : helper.text);
    return /* @__PURE__ */ React__default.createElement(
      TextField,
      {
        id: id || "contact-channel-phone",
        label: label || translate("contactChannel.phone"),
        defaultValue,
        isInvalid: !this.valid,
        onChange: (val) => this.onChange(val),
        ...getHelperMessageProp(helperText, helperType)
      }
    );
  }
  async onChange(value) {
    this.valid = !!value ? await (this.props.customPhoneValidation ? this.props.customPhoneValidation(value) : Promise.resolve(isPhoneValid(value))) : !this.required;
    this.props.onChange(value, this.valid);
  }
};
__decorateClass$6([
  observable
], Phone.prototype, "valid", 2);
__decorateClass$6([
  action.bound
], Phone.prototype, "onChange", 1);
Phone = __decorateClass$6([
  injectStores,
  observer
], Phone);
var __defProp$5 = Object.defineProperty;
var __getOwnPropDesc$5 = Object.getOwnPropertyDescriptor;
var __decorateClass$5 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$5(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$5(target, key, result);
  return result;
};
let Email = class extends React__default.Component {
  constructor(props) {
    super(props);
    __publicField(this, "valid");
    __publicField(this, "required");
    __publicField(this, "componentTranslateStore");
    makeObservable(this);
    this.required = !!props.required ? props.required : false;
    this.valid = this.required ? !!props.defaultValue : !props.defaultValue || isEmailValid(props.defaultValue);
  }
  render() {
    const { defaultValue, helper, label, id, key } = this.props;
    const { translate } = this.componentTranslateStore;
    const helperType = helper == null ? void 0 : helper.type;
    const helperText = String(helper == null ? void 0 : helper.text);
    return /* @__PURE__ */ React__default.createElement(
      TextField,
      {
        id: id || "email",
        key: key || "email",
        label: label || translate("contactChannel.email"),
        defaultValue,
        isInvalid: !this.valid,
        onChange: (val) => this.onChange(val),
        ...getHelperMessageProp(helperText, helperType)
      }
    );
  }
  onChange(value) {
    this.valid = !!value ? isEmailValid(value) : !this.required;
    this.props.onChange(value, this.valid);
  }
};
__decorateClass$5([
  observable
], Email.prototype, "valid", 2);
__decorateClass$5([
  action.bound
], Email.prototype, "onChange", 1);
Email = __decorateClass$5([
  injectStores,
  observer
], Email);
const EditContactInfo = observer(() => {
  var _a2, _b2, _c2, _d2;
  const {
    componentTranslateStore: { translate },
    componentSsoStore: { customerId, customer, dealer },
    componentCustomerContactInfoStore,
    componentRegistryAddressEditStore,
    componentInvoiceSettingsStore
  } = useContext(ComponentRootStoreContext);
  const [isLoaded, setLoaded] = useState(false);
  const [contactInfoToValidate, setContactInfoToValidate] = useState(null);
  useEffect(() => {
    init();
  }, [customerId]);
  const init = action(async () => {
    setLoaded(false);
    await componentCustomerContactInfoStore.init();
    setLoaded(true);
  });
  useEffect(() => {
    if (!componentInvoiceSettingsStore.oldEmailValue) {
      runInAction(() => componentInvoiceSettingsStore.oldEmailValue = componentCustomerContactInfoStore.email.oldValue);
    }
    if (!componentInvoiceSettingsStore.oldPhoneValue) {
      runInAction(() => componentInvoiceSettingsStore.oldPhoneValue = componentCustomerContactInfoStore.phone.oldValue);
    }
  }, [componentCustomerContactInfoStore.email.oldValue, componentCustomerContactInfoStore.phone.oldValue]);
  if (!isLoaded) {
    return /* @__PURE__ */ React__default.createElement(Spinner, null);
  }
  const isPhoneInvalid = () => {
    if (dealer) {
      return !componentCustomerContactInfoStore.email.hasValue && !componentCustomerContactInfoStore.phone.hasValue || componentCustomerContactInfoStore.phone.isUserInputError;
    }
    return !componentCustomerContactInfoStore.phone.hasValue || componentCustomerContactInfoStore.phone.isUserInputError;
  };
  const isEmailInvalid = () => {
    if (dealer) {
      return !componentCustomerContactInfoStore.email.hasValue && !componentCustomerContactInfoStore.phone.hasValue || componentCustomerContactInfoStore.email.isUserInputError;
    }
    return !componentCustomerContactInfoStore.email.hasValue || componentCustomerContactInfoStore.email.isUserInputError;
  };
  const ContactInfoValidationButton = (props) => {
    const { email: email2, phone: phone2 } = componentCustomerContactInfoStore;
    let contactInfo;
    if (props.type === ContactInfoType.PHONE) {
      if (isPhoneInvalid() || !phone2.hasValue || phone2.isValidatedAndUnchanged && phone2.validated !== null || !phone2.isEstonianMobilePhoneNumber) {
        return null;
      }
      contactInfo = phone2;
    }
    if (props.type === ContactInfoType.EMAIL) {
      if (isEmailInvalid() || !email2.hasValue || email2.isValidatedAndUnchanged && email2.validated !== null) {
        return null;
      }
      contactInfo = email2;
    }
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs-12", "lg-7"], className: "text__margin-half" }, /* @__PURE__ */ React__default.createElement(AnalyticsTrigger, { trigger: { id: "CTA - Validate ".concat(contactInfo.type.toLowerCase()), callback: "onClick" } }, /* @__PURE__ */ React__default.createElement(
      Button,
      {
        text: translate("dataconfirm.contactInfo.".concat(contactInfo.type.toLowerCase(), ".sendValidationCode")),
        iconLeft: "#email",
        onClick: () => {
          contactInfo.setSavingError(false);
          componentCustomerContactInfoStore.updateSingleContactInfo(contactInfo, false).then(() => {
            if (contactInfo.isSavingError) {
              return;
            }
            ContactInfoValidationApi.sendContactInfoValidationCode(contactInfo.contactInfoId);
            contactInfo.initializeValidation();
            setContactInfoToValidate(contactInfo);
          });
        },
        responsive: [
          { breakPoint: "xs", props: { block: true } },
          { breakPoint: "lg", props: { block: false } }
        ]
      }
    ), " ")));
  };
  const showHelperIfNecessary = (contactInfo) => {
    if (contactInfo.isUserInputError) {
      return {
        text: translate("dataconfirm.contactInfo.".concat(contactInfo.type.toLowerCase(), ".helper.error")),
        type: "error"
      };
    } else if (contactInfo.isSavingError) {
      return {
        text: translate("dataconfirm.contactInfo.".concat(contactInfo.type.toLowerCase(), ".helper.savingError")),
        type: "error"
      };
    } else if ((contactInfo.type === ContactInfoType.PHONE ? contactInfo.isEstonianMobilePhoneNumber : true) && (contactInfo.validated === false || contactInfo.validated == null && contactInfo.oldValue !== "")) {
      return {
        text: translate("dataconfirm.contactInfo.".concat(contactInfo.type.toLowerCase(), ".helper.notValidated")),
        type: "error"
      };
    } else if (contactInfo.isValidatedSuccessfully && !contactInfo.hasValueChanged) {
      return {
        text: translate("dataconfirm.contactInfo.".concat(contactInfo.type.toLowerCase(), ".helper.saveSuccess")),
        type: "valid"
      };
    }
    return void 0;
  };
  const failedToSave = (contactInfo) => {
    return contactInfo.isSavingError;
  };
  const phone = componentCustomerContactInfoStore.phone;
  const email = componentCustomerContactInfoStore.email;
  return /* @__PURE__ */ React__default.createElement(Text, null, /* @__PURE__ */ React__default.createElement(Card, null, /* @__PURE__ */ React__default.createElement(CardContent, null, /* @__PURE__ */ React__default.createElement(Grid, null, /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["sm-12", "md"] }, /* @__PURE__ */ React__default.createElement("div", { className: "text-small" }, translate("dataconfirm.contactInfo.name")), /* @__PURE__ */ React__default.createElement("div", { className: "text-bold" }, customer.displayName)), /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["sm-12", "md"] }, /* @__PURE__ */ React__default.createElement("div", { className: "text-small" }, translate("dataconfirm.contactInfo.personalCode")), /* @__PURE__ */ React__default.createElement("div", { className: "text-bold" }, customer.registrationNumber)), /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["sm-12", "md"] }, /* @__PURE__ */ React__default.createElement("div", { className: "text-small" }, translate("dataconfirm.contactInfo.countryCode")), /* @__PURE__ */ React__default.createElement("div", { className: "text-bold" }, CountryUtil.getByCountryCode(customer.registrationNumberCountryCode) ? CountryUtil.getByCountryCode(customer.registrationNumberCountryCode).label.et : translate("dataconfirm.contactInfo.else")))))), /* @__PURE__ */ React__default.createElement(Grid, { className: "text__margin-double", gutter: "small", horizontalGutter: "default", align: ["bottom-xs"] }, /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs-12", "lg-5"] }, /* @__PURE__ */ React__default.createElement(
    TextField,
    {
      id: "text-phone",
      label: translate("dataconfirm.contactInfo.phone"),
      value: phone == null ? void 0 : phone.value,
      onChange: (value) => phone.onChange(value, !!dealer),
      isInvalid: isPhoneInvalid() || failedToSave(phone) || (phone.validated === false || phone.validated === null) && phone.isEstonianMobilePhoneNumber,
      ...getHelperMessageProp(String((_a2 = showHelperIfNecessary(phone)) == null ? void 0 : _a2.text), (_b2 = showHelperIfNecessary(phone)) == null ? void 0 : _b2.type)
    }
  )), /* @__PURE__ */ React__default.createElement(ContactInfoValidationButton, { type: ContactInfoType.PHONE })), /* @__PURE__ */ React__default.createElement(Grid, { gutter: "small", horizontalGutter: "default", align: ["bottom-xs"] }, /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs-12", "lg-5"] }, /* @__PURE__ */ React__default.createElement(
    TextField,
    {
      id: "text-epost",
      label: translate("dataconfirm.contactInfo.email"),
      value: email == null ? void 0 : email.value,
      onChange: (value) => email.onChange(value, !!dealer),
      isInvalid: isEmailInvalid() || failedToSave(email) || !email.validated,
      ...getHelperMessageProp(String((_c2 = showHelperIfNecessary(email)) == null ? void 0 : _c2.text), (_d2 = showHelperIfNecessary(email)) == null ? void 0 : _d2.type)
    }
  )), /* @__PURE__ */ React__default.createElement(ContactInfoValidationButton, { type: ContactInfoType.EMAIL })), /* @__PURE__ */ React__default.createElement(
    ContactAddress$1,
    {
      currentLanguage: "et",
      countrySelectWidth: ["xs-12", "lg-7"],
      addressWidth: ["xs-12", "md-8", "lg-4"],
      roomWidth: ["xs-12", "md-4", "lg-3"],
      registryAddressHelper: componentRegistryAddressEditStore.addressError && {
        text: translate("dataconfirm.contactInfo.address.helper.error"),
        type: "error"
      }
    }
  ), /* @__PURE__ */ React__default.createElement(
    Selector,
    {
      id: "contact-info-communication-language",
      className: "text__margin-double",
      label: translate("dataconfirm.contactInfo.communicationLanguage"),
      defaultValue: componentCustomerContactInfoStore.communicationLanguage.oldValue,
      items: [
        {
          id: "communication-language-et",
          label: translate("communicationLanguage.ET"),
          name: "eesti",
          value: "ET"
        },
        {
          id: "communication-language-ru",
          label: translate("communicationLanguage.RU"),
          name: "vene",
          value: "RU"
        },
        {
          id: "communication-language-en",
          label: translate("communicationLanguage.EN"),
          name: "inglise",
          value: "EN"
        }
      ],
      helpMessage: translate("dataconfirm.contactInfo.communicationLanguage.helpText"),
      onChange: (value) => componentCustomerContactInfoStore.onCommunicationLanguageChange(value)
    }
  ), /* @__PURE__ */ React__default.createElement(
    ContactInfoValidationModal,
    {
      isOpen: !!contactInfoToValidate,
      isDealer: !!dealer,
      contactInfo: contactInfoToValidate,
      onClose: action((validationSuccessful) => {
        if (validationSuccessful) {
          contactInfoToValidate.validated = true;
          contactInfoToValidate.isValidatedSuccessfully = true;
        }
        setContactInfoToValidate(null);
      })
    }
  ));
});
const useIsMobileHook = () => {
  const currentBreak = useCurrentBreakPoint();
  const isMobile = currentBreak === "xs" || currentBreak === "sm";
  const isMobileOrTablet = isMobile || currentBreak === "md";
  return { isMobile, isMobileOrTablet };
};
const ERRORED_HELPER_FIELD_ID_SUFFIX = "-invalid";
const PHONE_FIELD_ID = "phone";
const EMAIL_FIELD_ID = "email";
const ADDRESS_FIELD_ID = "address";
const PASSWORD_ID = "password";
const PASSWORD_HINT_ID = "passwordHint";
const getErroredHelperId = (fieldId) => fieldId + ERRORED_HELPER_FIELD_ID_SUFFIX;
const baseFieldHelper = (translate, value, dirty, callback, fieldId) => {
  if (!dirty) {
    return void 0;
  }
  if (!value) {
    return { type: "error", text: translate("error.emptyMandatoryField"), id: fieldId ? getErroredHelperId(fieldId) : void 0 };
  }
  if (callback) {
    return callback();
  }
  return void 0;
};
const helperInErrorState = (helper) => {
  return !!(helper && helper.type === "error");
};
const removeIdIndexFromString = (string) => {
  return string.replace(/-\d+$/, "");
};
const phoneFieldHelper = (translate, value, dirty, isPhoneValid2) => {
  return baseFieldHelper(
    translate,
    value,
    dirty,
    () => {
      if (!isPhoneValid2) {
        return { type: "error", text: translate("phone.invalid.format"), id: getErroredHelperId(PHONE_FIELD_ID) };
      }
      return null;
    },
    PHONE_FIELD_ID
  );
};
const emailFieldHelper = (translate, value, dirty, isEmailValid2, fieldId) => {
  return baseFieldHelper(
    translate,
    value,
    dirty,
    () => {
      if (!isEmailValid2) {
        return { type: "error", text: translate("email.invalid.format"), id: getErroredHelperId(fieldId) };
      }
      return null;
    },
    fieldId
  );
};
const addressFieldHelper = (translate, value, dirty, isAddressValid) => {
  return baseFieldHelper(
    translate,
    value,
    dirty,
    () => {
      if (!isAddressValid) {
        return { type: "error", text: translate("address.invalid.format"), id: getErroredHelperId(ADDRESS_FIELD_ID) };
      }
      return null;
    },
    ADDRESS_FIELD_ID
  );
};
const scrollUpToElement = (elementId, isMobileOrTablet) => {
  scrollToElement(document.getElementById(elementId), null, isMobileOrTablet ? 112 : 125);
};
const FormErrorNotice = observer((props) => {
  const { erroredFields } = props;
  const {
    componentTranslateStore: { translate }
  } = useStores();
  const { isMobileOrTablet } = useIsMobileHook();
  React.useEffect(() => {
    scrollUpToElement("form-error-notice", isMobileOrTablet);
  }, []);
  const erroredFieldIds = erroredFields.filter((helper) => helper !== void 0).map((helper) => helper == null ? void 0 : helper.id).filter((fieldId) => fieldId !== void 0).map((fieldId) => fieldId.replace(ERRORED_HELPER_FIELD_ID_SUFFIX, ""));
  const focusField = (id) => {
    document.querySelectorAll("#".concat(id)).forEach((element) => {
      element.offsetParent !== null && element.focus();
    });
  };
  return /* @__PURE__ */ React.createElement(Notice, { id: "form-error-notice", type: "error", attributes: { "aria-live": "polite", "aria-atomic": "true" } }, /* @__PURE__ */ React.createElement("strong", null, translate("form.error")), erroredFieldIds && erroredFieldIds.length > 0 && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Separator, { spacing: "xxsmall", color: "invisible" }), /* @__PURE__ */ React.createElement(List, { type: "unstyled" }, erroredFieldIds.map((erroredField) => /* @__PURE__ */ React.createElement(ListItem, { key: "erroredField-".concat(erroredField, "-button"), className: "text-small" }, /* @__PURE__ */ React.createElement(
    Button,
    {
      text: translate("errored.field.button.".concat(removeIdIndexFromString(erroredField))),
      type: "withdrawal",
      link: true,
      onClick: () => {
        focusField(erroredField);
        focusField("".concat(erroredField, "-input"));
      }
    }
  ))))));
});
const EditInvoiceDetailsModal = observer((props) => {
  const [invoiceChanged, setInvoiceChanged] = useState(false);
  const [mobileChanged, setMobileChanged] = useState(false);
  const [emailChanged, setEmailChanged] = useState(false);
  const [addressChanged, setAddressChanged] = useState(false);
  const [currentAddressValid, setCurrentAddressValid] = useState(true);
  const [currentMobileNumberValid, setCurrentMobileNumberValid] = useState(true);
  const [currentAddress, setCurrentAddress] = useState(null);
  const [currentEmails, setCurrentEmails] = useState(
    () => props.invoice.emailAddresses.map((value) => ({
      value,
      valid: true
    }))
  );
  const [currentMobileNumber, setCurrentMobileNumber] = useState("");
  const { componentTranslateStore, componentInvoiceSettingsStore, componentInvoiceNameStore, urlDataStore, brand } = useStores();
  const { translate } = componentTranslateStore;
  const onClose = () => {
    GaDataStore.push({
      event: "AutoEvent",
      page: "crm-components-editInvoices",
      group: "crm-components",
      id: "CTA - Close Edit Invoice Details Modal"
    });
    props.onClose();
  };
  const getPhoneFieldHelper = () => {
    const { translate: translate2 } = componentTranslateStore;
    const { invoice } = props;
    const { mobileNumber } = invoice;
    return phoneFieldHelper(translate2, currentMobileNumber || mobileNumber, mobileChanged, currentMobileNumberValid);
  };
  const getEmailFieldHelper = (emailIndex) => {
    var _a2, _b2;
    const { translate: translate2 } = componentTranslateStore;
    return emailFieldHelper(translate2, (_a2 = currentEmails[emailIndex]) == null ? void 0 : _a2.value, emailChanged, (_b2 = currentEmails[emailIndex]) == null ? void 0 : _b2.valid, "".concat(EMAIL_FIELD_ID, "-").concat(emailIndex));
  };
  const getAddressFieldHelper = () => {
    const { translate: translate2 } = componentTranslateStore;
    return addressFieldHelper(translate2, currentAddress == null ? void 0 : currentAddress.label, addressChanged, currentAddressValid);
  };
  const formHasErrors = () => {
    return helperInErrorState(getPhoneFieldHelper()) || currentEmails.some((_, index) => helperInErrorState(getEmailFieldHelper(index))) || helperInErrorState(getAddressFieldHelper());
  };
  const renderData = () => {
    const { invoice } = props;
    const { translate: translate2 } = componentTranslateStore;
    const invoiceName = componentInvoiceNameStore.getRefNumberName(invoice.contentType, invoice.title, invoice.source);
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("p", { className: "text-tiny text-color-normal" }, translate2("dataconfirm.invoices.invoice.nameAndRefNr")), /* @__PURE__ */ React__default.createElement("span", { className: "text-bold" }, invoiceName), /* @__PURE__ */ React__default.createElement("span", null, " / ", invoice.refNumber)), /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("p", { className: "text-tiny text-color-normal" }, translate2("dataconfirm.invoices.invoice.invoiceDeliveryTypes")), /* @__PURE__ */ React__default.createElement("p", { className: "text-bold" }, invoice.invoiceDeliveries.length === 0 ? translate2("dataconfirm.invoices.invoice.delivery.invoiceToSelfService") : invoice.invoiceDeliveries.map((it) => translate2("dataconfirm.invoices.invoice.delivery.".concat(it))).join(", "))));
  };
  const renderInputs = () => {
    const {
      invoice: { address, emailAddresses, invoiceDeliveries, mobileNumber }
    } = props;
    const { translate: translate2 } = componentTranslateStore;
    const invoiceDeliveriesComponents = invoiceDeliveries.slice().sort((type) => type === "POST" ? -1 : 0).map((type, index) => {
      if (type === "EMAIL") {
        const emailAddressComponents = emailAddresses.map((email, emailIndex) => {
          return /* @__PURE__ */ React__default.createElement(
            Email,
            {
              id: "".concat(EMAIL_FIELD_ID, "-").concat(emailIndex),
              key: "email-".concat(emailIndex),
              defaultValue: email,
              required: true,
              onChange: (value, valid) => onEmailChange(value, valid, emailIndex),
              label: translate2("dataconfirm.invoices.invoice.delivery.emailAddress"),
              helper: getEmailFieldHelper(emailIndex)
            }
          );
        });
        return /* @__PURE__ */ React__default.createElement(Text, { key: "email-".concat(type, "-").concat(index) }, emailAddressComponents);
      }
      if (type === "MOBILE") {
        return /* @__PURE__ */ React__default.createElement(Grid, { key: "mobile-delivery-component-".concat(index) }, /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs-9", "md-5"] }, /* @__PURE__ */ React__default.createElement(
          Phone,
          {
            id: PHONE_FIELD_ID,
            defaultValue: mobileNumber,
            required: true,
            onChange: (value, valid) => onMobileNumberChange(value, valid),
            customPhoneValidation: (mobileNumber2) => componentInvoiceSettingsStore.isMobileNumberValidForInvoice(mobileNumber2),
            label: translate2("dataconfirm.invoices.invoice.delivery.mobileNumber"),
            helper: getPhoneFieldHelper()
          }
        )));
      }
      if (type === "POST") {
        const addressWidth = ["xs-12", "md-12", "xl-12"];
        const roomWidth = ["xs-4", "md-3", "xl-3"];
        const adr = ComponentInvoiceSettingsStore.convertToRegistryAddress(address);
        return /* @__PURE__ */ React__default.createElement(
          Address,
          {
            id: ADDRESS_FIELD_ID,
            key: "address-".concat(type, "-").concat(index),
            customRoomLabel: translate2("dataconfirm.invoices.invoice.delivery.address.room"),
            type: "registry",
            defaultValue: adr,
            width: { address: addressWidth, room: roomWidth },
            onChange: onAddressChange,
            requiredFields: ["address", "room"],
            helper: getAddressFieldHelper()
          }
        );
      }
      return null;
    });
    return /* @__PURE__ */ React__default.createElement(Text, null, invoiceDeliveriesComponents);
  };
  const renderSpinner = () => {
    return /* @__PURE__ */ React__default.createElement(Overlay, { className: "overlay--fixed", spinner: true });
  };
  const onAddressChange = (value, isValid) => {
    setInvoiceChanged(true);
    setAddressChanged(true);
    setCurrentAddress(value);
    setCurrentAddressValid(isValid);
  };
  const onEmailChange = (value, valid, index) => {
    setInvoiceChanged(true);
    setEmailChanged(true);
    const newEmails = currentEmails.map((email, i) => i === index ? { value, valid } : email);
    setCurrentEmails(newEmails);
  };
  const onMobileNumberChange = (value, valid) => {
    setInvoiceChanged(true);
    setMobileChanged(true);
    setCurrentMobileNumber(value);
    setCurrentMobileNumberValid(valid);
  };
  const onSave = () => {
    props.onSave(
      currentEmails.map((email) => email.value),
      currentAddress,
      currentMobileNumber
    );
  };
  const isConfirmEnabled = () => {
    return invoiceChanged && !currentEmails.some((email) => !email.valid) && currentAddressValid && currentMobileNumberValid;
  };
  return /* @__PURE__ */ React__default.createElement(Modal, { isOpen: true, hasContentComponent: true, size: "6-col", "aria-labelledby": "change-invoice-details-heading", onClose }, /* @__PURE__ */ React__default.createElement(ModalContent, null, componentInvoiceSettingsStore.saving && renderSpinner(), /* @__PURE__ */ React__default.createElement(Text, null, /* @__PURE__ */ React__default.createElement(Heading$1, { className: "h3", id: "change-invoice-details-heading" }, translate("dataconfirm.invoices.invoice.serviceDetailsChange")), /* @__PURE__ */ React__default.createElement("p", null, translate("dataconfirm.invoices.invoice.changeInvoiceDeliveryInfo", { invoicesLink: urlDataStore.invoiceSettingsUrl(brand) })), /* @__PURE__ */ React__default.createElement(Card, { className: "text__margin-double" }, /* @__PURE__ */ React__default.createElement(CardContent, null, /* @__PURE__ */ React__default.createElement(Text, null, renderData()))), formHasErrors() && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Separator, { color: "invisible", spacing: "small" }), /* @__PURE__ */ React__default.createElement(
    FormErrorNotice,
    {
      erroredFields: [getPhoneFieldHelper(), getAddressFieldHelper()].concat(currentEmails.map((_, index) => getEmailFieldHelper(index)))
    }
  )), /* @__PURE__ */ React__default.createElement("div", { className: "text__margin-double" }, renderInputs()))), /* @__PURE__ */ React__default.createElement(ModalFooter, null, /* @__PURE__ */ React__default.createElement(Grid, { reverse: ["xs"], align: ["between-xs", "middle-xs"] }, /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs"] }, /* @__PURE__ */ React__default.createElement(AnalyticsTrigger, { trigger: { id: "CTA - Confirm Invoice Changes", callback: "onClick" } }, /* @__PURE__ */ React__default.createElement(
    Button,
    {
      text: translate("dataconfirm.confirm"),
      type: "expressive",
      isLoading: componentInvoiceSettingsStore.saving,
      disabled: !isConfirmEnabled(),
      onClick: onSave
    }
  ))), /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs"] }, /* @__PURE__ */ React__default.createElement(Button, { text: translate("dataconfirm.invoices.invoice.back"), link: true, iconLeft: "#close", onClick: onClose })))));
});
const ChangeAllInvoiceInfoNotice = (props) => {
  const { componentTranslateStore } = useStores();
  const { translate } = componentTranslateStore;
  const { label, updateContact, closeNotice } = props;
  return /* @__PURE__ */ React__default.createElement(Notice, { onCloseClick: closeNotice, align: "center" }, /* @__PURE__ */ React__default.createElement(Grid, { align: ["between-xs", "middle-xs"], noWrap: ["sm"] }, /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs", "max-sm"] }, /* @__PURE__ */ React__default.createElement("p", null, label)), /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs", "min-sm"] }, /* @__PURE__ */ React__default.createElement(Button, { text: translate("dataconfirm.invoices.invoice.confirmUpdate"), onClick: updateContact }))));
};
const InvoicesSaveResultNotice = observer(() => {
  const { componentInvoiceSettingsStore, componentTranslateStore } = useStores();
  const { translate } = componentTranslateStore;
  const { saveError, customSuccessText, saveInvoices, customerInvoiceSettings } = componentInvoiceSettingsStore;
  return /* @__PURE__ */ React__default.createElement(Notice, { type: saveError ? "error" : "success" }, saveError ? /* @__PURE__ */ React__default.createElement(Grid, { align: ["middle-xs"], noWrap: ["sm"] }, /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["max-sm"] }, /* @__PURE__ */ React__default.createElement("p", null, translate("dataconfirm.invoices.invoiceDataChange.fail"))), /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["min-sm"] }, /* @__PURE__ */ React__default.createElement(
    Button,
    {
      text: translate("dataconfirm.invoices.invoiceDataChange.fail.tryAgain"),
      iconRight: "#arrow-right",
      size: "small",
      onClick: () => saveInvoices(customerInvoiceSettings.failedToUpdateInvoiceSettings)
    }
  ))) : /* @__PURE__ */ React__default.createElement("p", null, customSuccessText || translate("dataconfirm.invoices.invoiceDataChange.success")));
});
const EditInvoices = observer(() => {
  const {
    componentTranslateStore,
    componentInvoiceSettingsStore,
    componentSsoStore,
    componentCustomerContactInfoStore,
    componentInvoiceNameStore,
    urlDataStore,
    brand
  } = useStores();
  const { translate } = componentTranslateStore;
  const { isMobile } = useIsMobileHook();
  useEffect(() => {
    componentInvoiceSettingsStore.init();
  }, [componentSsoStore.customerId, componentInvoiceSettingsStore]);
  const mobileNumberChangeNotice = () => {
    const { updateAllOldMobileNumbers, showChangeAllInvoiceMobileNumbersNotice, mobileNumberChangeAllVisibility, closeMobileNumberChangeAllVisibility } = componentInvoiceSettingsStore;
    const { phone } = componentCustomerContactInfoStore;
    return mobileNumberChangeAllVisibility && showChangeAllInvoiceMobileNumbersNotice && /* @__PURE__ */ React__default.createElement(
      ChangeAllInvoiceInfoNotice,
      {
        label: translate("dataconfirm.invoices.invoice.button.applyPhoneToAll", { mobileNumber: phone.value }),
        updateContact: updateAllOldMobileNumbers,
        closeNotice: closeMobileNumberChangeAllVisibility
      }
    );
  };
  const saveResultNotice = () => {
    const {
      showSaveResultNotice,
      showChangeAllPostInvoiceAddressesNotice,
      showChangeAllPostInvoiceEmailNotice,
      showChangeAllInvoiceMobileNumbersNotice,
      mobileNumberChangeAllVisibility,
      emailChangeAllVisibility,
      addressChangeAllVisibility
    } = componentInvoiceSettingsStore;
    if (!showSaveResultNotice || showChangeAllInvoiceMobileNumbersNotice && mobileNumberChangeAllVisibility || showChangeAllPostInvoiceEmailNotice && emailChangeAllVisibility || showChangeAllPostInvoiceAddressesNotice && addressChangeAllVisibility) {
      return null;
    }
    return /* @__PURE__ */ React__default.createElement(InvoicesSaveResultNotice, null);
  };
  const emailChangeNotice = () => {
    const { updateAllEmails, showChangeAllPostInvoiceEmailNotice, emailChangeAllVisibility, closeEmailChangeAllVisibility } = componentInvoiceSettingsStore;
    const { email } = componentCustomerContactInfoStore;
    return emailChangeAllVisibility && showChangeAllPostInvoiceEmailNotice && /* @__PURE__ */ React__default.createElement(
      ChangeAllInvoiceInfoNotice,
      {
        label: translate("dataconfirm.invoices.invoice.button.applyEmailToAll", { email: email.value }),
        updateContact: updateAllEmails,
        closeNotice: closeEmailChangeAllVisibility
      }
    );
  };
  const addressChangeNotice = () => {
    const {
      updateAllAddresses,
      showChangeAllPostInvoiceAddressesNotice,
      selectedRegistryAddressToInvoiceAddress,
      addressChangeAllVisibility,
      closeAddressChangeAllVisibility
    } = componentInvoiceSettingsStore;
    return addressChangeAllVisibility && showChangeAllPostInvoiceAddressesNotice && /* @__PURE__ */ React__default.createElement(
      ChangeAllInvoiceInfoNotice,
      {
        label: translate("dataconfirm.invoices.invoice.button.applyAddressToAll", {
          address: formatInvoiceAddress(selectedRegistryAddressToInvoiceAddress())
        }),
        updateContact: updateAllAddresses,
        closeNotice: closeAddressChangeAllVisibility
      }
    );
  };
  const openInvoiceDetailsModalButton = (invoice) => {
    const { openModal } = componentInvoiceSettingsStore;
    return /* @__PURE__ */ React__default.createElement(AnalyticsTrigger, { trigger: { id: "Button - Open Edit Invoice Details Modal", callback: "onClick" } }, /* @__PURE__ */ React__default.createElement(
      Button,
      {
        onClick: () => openModal(invoice),
        disabled: !invoice.invoiceDeliveries.some((delivery) => ["POST", "EMAIL"].includes(delivery)),
        text: translate("dataconfirm.invoices.invoice.button.change"),
        iconLeft: "#edit",
        link: !isMobile,
        size: isMobile ? "small" : "default",
        variant: isMobile ? "secondary" : void 0
      }
    ));
  };
  const invoiceDeliveryChannels = (invoice) => {
    var _a2;
    const { toDeliveryChannels } = componentInvoiceSettingsStore;
    return /* @__PURE__ */ React__default.createElement("div", null, (_a2 = toDeliveryChannels(invoice)) == null ? void 0 : _a2.map((channel) => /* @__PURE__ */ React__default.createElement("div", { key: channel.title }, /* @__PURE__ */ React__default.createElement("span", { className: "text-bold" }, channel.title, ": "), /* @__PURE__ */ React__default.createElement("span", null, channel.description))));
  };
  const invoiceTableRow = (invoice, key) => {
    const { title, refNumber, contentType, invoiceDeliveries } = invoice;
    const hasInvoiceDeliveries = invoiceDeliveries && invoiceDeliveries.length > 0;
    return /* @__PURE__ */ React__default.createElement(TableRow, { key }, /* @__PURE__ */ React__default.createElement(TableCell, { width: 5 }, /* @__PURE__ */ React__default.createElement("p", { className: "text-bold" }, title || componentInvoiceNameStore.getDefaultInvoiceName(contentType)), /* @__PURE__ */ React__default.createElement("p", null, refNumber)), /* @__PURE__ */ React__default.createElement(TableCell, null, !hasInvoiceDeliveries ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("div", null, "-"), /* @__PURE__ */ React__default.createElement("span", { className: "sr-only" }, translate("userData.missing"))) : invoiceDeliveryChannels(invoice)), /* @__PURE__ */ React__default.createElement(TableCell, null, openInvoiceDetailsModalButton(invoice)));
  };
  const invoices = () => {
    return isMobile ? invoiceCardsForMobile() : invoiceTable();
  };
  const invoiceCardsForMobile = () => {
    const { invoiceSettings } = componentInvoiceSettingsStore.customerInvoiceSettings;
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, invoiceSettings.map((invoice) => /* @__PURE__ */ React__default.createElement(Card, { key: invoice.refNumber }, /* @__PURE__ */ React__default.createElement(CardContent, null, /* @__PURE__ */ React__default.createElement(Text, null, /* @__PURE__ */ React__default.createElement(Grid, null, /* @__PURE__ */ React__default.createElement(GridColumn, null, /* @__PURE__ */ React__default.createElement("p", null, translate("dataconfirm.invoices.invoice.nameAndRefNr"))), /* @__PURE__ */ React__default.createElement(GridColumn, null, /* @__PURE__ */ React__default.createElement("p", { className: "text-bold" }, invoice.title || componentInvoiceNameStore.getDefaultInvoiceName(invoice.contentType)), /* @__PURE__ */ React__default.createElement("p", null, invoice.refNumber))), /* @__PURE__ */ React__default.createElement(Separator, { spacing: "small" }), /* @__PURE__ */ React__default.createElement("p", null, translate("dataconfirm.invoices.invoice.invoiceDeliveryTypes")), invoiceDeliveryChannels(invoice), openInvoiceDetailsModalButton(invoice))))));
  };
  const invoiceTable = () => {
    const { invoiceSettings } = componentInvoiceSettingsStore.customerInvoiceSettings;
    return /* @__PURE__ */ React__default.createElement(Table$2, { responsive: "cols", break: "sm" }, /* @__PURE__ */ React__default.createElement("thead", null, /* @__PURE__ */ React__default.createElement(TableRow, null, /* @__PURE__ */ React__default.createElement(TableCell, { type: "th", scope: "col" }, translate("dataconfirm.invoices.invoice.nameAndRefNr")), /* @__PURE__ */ React__default.createElement(TableCell, { type: "th", scope: "col" }, translate("dataconfirm.invoices.invoice.invoiceDeliveryTypes")), /* @__PURE__ */ React__default.createElement(TableCell, { type: "th", scope: "col" }, /* @__PURE__ */ React__default.createElement("span", { className: "sr-only" }, translate("dataconfirm.invoices.invoice.change"))))), /* @__PURE__ */ React__default.createElement("tbody", null, invoiceSettings.map(invoiceTableRow)));
  };
  const renderNoInvoicesNotice = () => /* @__PURE__ */ React__default.createElement(Notice, { size: "small" }, /* @__PURE__ */ React__default.createElement("p", { className: "text-left" }, translate("dataconfirm.invoices.noInvoices")));
  const onInvoiceSave = async (newEmails, newAddress, newMobileNumber) => {
    const { updateAddress, updateEmails, updateMobileNumber, saveInvoices, closeModal, selectedInvoice, setCustomSuccessText, customerInvoiceSettings } = componentInvoiceSettingsStore;
    const invoiceToUpdate = { ...selectedInvoice };
    if (newAddress) {
      updateAddress(invoiceToUpdate, newAddress);
    }
    if (newEmails) {
      updateEmails(invoiceToUpdate, newEmails);
    }
    if (newMobileNumber) {
      updateMobileNumber(invoiceToUpdate, newMobileNumber);
    }
    await saveInvoices([invoiceToUpdate]);
    setCustomSuccessText(null);
    closeModal();
  };
  if (!componentInvoiceSettingsStore.isLoaded) {
    return /* @__PURE__ */ React__default.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Heading$1, { element: "h2", className: "h3" }, translate("dataconfirm.invoices.invoice.invoiceDetails")), /* @__PURE__ */ React__default.createElement(Separator, { spacing: "xsmall", color: "invisible" }), componentInvoiceSettingsStore.hasInvoices && /* @__PURE__ */ React__default.createElement(Grid, null, /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["md-8"] }, /* @__PURE__ */ React__default.createElement("p", null, translate("dataconfirm.invoices.invoice.changeInvoiceReceivalInfo", {
    invoicesLink: urlDataStore.invoiceSettingsUrl(brand)
  })))), emailChangeNotice(), addressChangeNotice(), mobileNumberChangeNotice(), saveResultNotice(), componentInvoiceSettingsStore.hasInvoices ? invoices() : renderNoInvoicesNotice(), componentInvoiceSettingsStore.selectedInvoice && /* @__PURE__ */ React__default.createElement(
    EditInvoiceDetailsModal,
    {
      invoice: componentInvoiceSettingsStore.selectedInvoice,
      onSave: onInvoiceSave,
      onClose: componentInvoiceSettingsStore.closeModal
    }
  ));
});
const EditInvoices$1 = customerIdAsKeyForFunctionalComponent(EditInvoices);
var __defProp$4 = Object.defineProperty;
var __getOwnPropDesc$4 = Object.getOwnPropertyDescriptor;
var __decorateClass$4 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$4(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$4(target, key, result);
  return result;
};
let InformationUpdateOld = class extends React__default.Component {
  constructor(props) {
    super(props);
    __publicField(this, "isSaving", false);
    __publicField(this, "isErrorDuringSaving", false);
    __publicField(this, "goToUrl");
    __publicField(this, "componentTranslateStore");
    __publicField(this, "componentCustomerContactInfoStore");
    __publicField(this, "componentContactAddressStore");
    __publicField(this, "componentSsoStore");
    __publicField(this, "componentInvoiceSettingsStore");
    __publicField(this, "componentRegistryAddressEditStore");
    __publicField(this, "componentForeignAddressEditStore");
    __publicField(this, "onSave", () => {
      if (this.isSaving) {
        return;
      }
      this.isSaving = true;
      this.isErrorDuringSaving = false;
      Promise.all([
        this.componentContactAddressStore.saveAddress(),
        this.componentCustomerContactInfoStore.updateContactInfo(false),
        this.componentInvoiceSettingsStore.saveInvoices()
      ]).then(
        action(async () => {
          if (this.componentContactAddressStore.isErrorDuringSave || this.componentCustomerContactInfoStore.isError || this.componentInvoiceSettingsStore.saveError) {
            this.isErrorDuringSaving = true;
          } else {
            await this.componentCustomerContactInfoStore.updateContactInfoConfirmedTs();
            if (this.goToUrl) {
              navigate(this.goToUrl);
            } else {
              this.props.onSave();
            }
          }
        })
      ).finally(action(() => this.isSaving = false));
    });
    this.goToUrl = new URLSearchParams(location.search).get("goToUrl");
    makeObservable(this);
  }
  isSubmitButtonDisabled() {
    const isAddressInvalid = this.componentContactAddressStore.isRegistryAddressSelected ? this.componentRegistryAddressEditStore.addressError : this.componentForeignAddressEditStore.addressError;
    const { email, phone } = this.componentCustomerContactInfoStore;
    const isEmailInvalid = this.componentSsoStore.dealer && !email.isUserInputError ? false : email.isUserInputError || !email.hasValue;
    const isPhoneInvalid = this.componentSsoStore.dealer && !phone.isUserInputError ? false : phone.isUserInputError || !phone.hasValue;
    const isContactInfoMissing = !phone.hasValue && !email.hasValue;
    const isEmailNotValidated = email.validated === false || email.hasValueChanged || email.validated === null;
    const isPhoneNotValidated = phone.isEstonianMobilePhoneNumber && (phone.hasValueChanged || phone.validated === false || phone.validated === null);
    const isContactInfoNotValidated = this.componentSsoStore.dealer ? false : isEmailNotValidated || isPhoneNotValidated;
    return isEmailInvalid || isPhoneInvalid || isAddressInvalid || isContactInfoMissing || isContactInfoNotValidated;
  }
  render() {
    const { translate } = this.componentTranslateStore;
    const { isSsoLoaded, customer } = this.componentSsoStore;
    if (!customer) {
      this.componentSsoStore.initializeAuthentication(false, false);
    }
    if (!isSsoLoaded || !customer) {
      return /* @__PURE__ */ React__default.createElement(Spinner, null);
    }
    const analyticsContext2 = {
      page: "InformationUpdate",
      group: "crm-components",
      event: "AutoEvent",
      onPush: GaDataStore.push
    };
    return /* @__PURE__ */ React__default.createElement(Container, null, /* @__PURE__ */ React__default.createElement(AnalyticsProvider, { ...analyticsContext2 }, /* @__PURE__ */ React__default.createElement(Text, null, /* @__PURE__ */ React__default.createElement(Heading$1, { className: "h2" }, translate("dataconfirm.title")), /* @__PURE__ */ React__default.createElement(Separator, { color: "invisible", spacing: "small" }), /* @__PURE__ */ React__default.createElement(InformationUpdateCard, { icon: "#contact", heading: translate("dataconfirm.contactInfo.title") }, /* @__PURE__ */ React__default.createElement(EditContactInfo, null)), /* @__PURE__ */ React__default.createElement(InformationUpdateCard, { icon: "#file-settings", heading: translate("dataconfirm.invoices.invoice.invoiceDetails") }, /* @__PURE__ */ React__default.createElement(EditInvoices$1, null)), this.isErrorDuringSaving && /* @__PURE__ */ React__default.createElement(Notice, { type: "error" }, /* @__PURE__ */ React__default.createElement("span", null, translate("dataconfirm.saving.error"))), /* @__PURE__ */ React__default.createElement(Grid, { className: "text__margin-double" }, /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs-12"], className: "text-right" }, /* @__PURE__ */ React__default.createElement(AnalyticsTrigger, { trigger: { id: "CTA - Confirm Data", callback: "onClick" } }, /* @__PURE__ */ React__default.createElement(
      Button,
      {
        text: translate("dataconfirm.confirm"),
        onClick: this.onSave,
        disabled: this.isSubmitButtonDisabled(),
        iconRight: "#arrow-right",
        isLoading: this.isSaving,
        responsive: [
          { breakPoint: "xs", props: { block: true } },
          { breakPoint: "lg", props: { block: false } }
        ]
      }
    )))))));
  }
};
__decorateClass$4([
  observable
], InformationUpdateOld.prototype, "isSaving", 2);
__decorateClass$4([
  observable
], InformationUpdateOld.prototype, "isErrorDuringSaving", 2);
__decorateClass$4([
  action.bound
], InformationUpdateOld.prototype, "onSave", 2);
InformationUpdateOld = __decorateClass$4([
  injectStores,
  observer
], InformationUpdateOld);
const InformationUpdateCard = (props) => {
  return /* @__PURE__ */ React__default.createElement(Card, { padding: "medium", background: "transparent", type: "light" }, /* @__PURE__ */ React__default.createElement(CardContent, null, /* @__PURE__ */ React__default.createElement(Text, null, /* @__PURE__ */ React__default.createElement(Grid, { align: ["middle-xs"] }, /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs"] }, /* @__PURE__ */ React__default.createElement(Icon, { modifiers: props.icon, size: "md" })), /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs"] }, /* @__PURE__ */ React__default.createElement(Heading$1, { element: "h2", className: "h3" }, props.heading))), props.children)));
};
const renderDataWithLabel = (id, label, data) => {
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("p", { id, className: "text-small" }, label), /* @__PURE__ */ React__default.createElement("strong", { "aria-labelledby": id }, data));
};
const renderEditButton = (translate, gaCategory) => {
  return /* @__PURE__ */ React__default.createElement(AnalyticsTrigger, { trigger: { callback: "onClick", id: "Button - Muudan andmeid - ".concat(gaCategory) } }, /* @__PURE__ */ React__default.createElement(ModalTrigger, null, /* @__PURE__ */ React__default.createElement(Button, { text: translate("userData.changeInformation"), size: "small", variant: "secondary", iconLeft: "#edit" })));
};
const RenderDataWithError = observer((props) => {
  const {
    componentTranslateStore: { translate }
  } = useStores();
  const { children, checkSimpleValue, simpleValue } = props;
  return /* @__PURE__ */ React__default.createElement(Grid, { align: ["middle-xs"], noWrap: true, horizontalGutter: "small" }, (checkSimpleValue ? !!simpleValue : !!children) ? /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["min"] }, children) : null, /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["min"] }, /* @__PURE__ */ React__default.createElement(Icon, { modifiers: "#alert", className: "text-error", size: "xs", align: "middle" }), (checkSimpleValue ? !simpleValue : !children) && /* @__PURE__ */ React__default.createElement("span", { className: "sr-only" }, translate("userData.missing"))));
});
const InformationCard = observer((props) => {
  const { icon, children, isLoading, ...rest } = props;
  const {
    componentTranslateStore: { translate }
  } = useStores();
  if (isLoading) {
    return /* @__PURE__ */ React__default.createElement(Skeleton, { label: translate("skeleton.loading") }, /* @__PURE__ */ React__default.createElement(SkeletonItem, { height: "282px" }));
  }
  return /* @__PURE__ */ React__default.createElement(Card, { background: "transparent", type: "light", ...rest }, /* @__PURE__ */ React__default.createElement(CardContent, null, /* @__PURE__ */ React__default.createElement(Icon, { modifiers: "#".concat(icon), size: "lg" }), /* @__PURE__ */ React__default.createElement(Separator, { spacing: "xsmall", color: "invisible" }), children));
});
const AddressAndLanguage = observer((props) => {
  const {
    componentTranslateStore: { translate },
    componentCustomerContactInfoStore: { communicationLanguage },
    componentContactAddressStore: { contactAddress }
  } = useStores();
  const { isLoading } = props;
  const buildAddressText = (address) => {
    if (!address) {
      return "";
    }
    const addressParts = [
      "".concat(address.street).concat(address.building ? " ".concat(address.building) : "").concat(address.room ? "-".concat(address.room) : ""),
      address.postalCode,
      address.city,
      address.region,
      address.countryCode ? CountryUtil.getByCountryCode(address.countryCode).label.et : ""
    ];
    return addressParts.filter((e) => e).join(", ");
  };
  const addressText = buildAddressText(contactAddress == null ? void 0 : contactAddress.address);
  return /* @__PURE__ */ React__default.createElement(ModalProvider, null, /* @__PURE__ */ React__default.createElement(InformationCard, { icon: "home", type: !addressText ? "error" : "light", isLoading }, /* @__PURE__ */ React__default.createElement(EqualHeight, { group: "userData" }, /* @__PURE__ */ React__default.createElement(Text, null, renderDataWithLabel(
    "address",
    translate("userData.address"),
    !contactAddress ? /* @__PURE__ */ React__default.createElement(RenderDataWithError, null, addressText) : addressText
  ), renderDataWithLabel(
    "communicationLanguage",
    translate("userData.communicationLanguage"),
    translate("userData.communicationLanguage.".concat(communicationLanguage.value))
  ))), /* @__PURE__ */ React__default.createElement(Separator, { spacing: "xsmall", color: "invisible" }), renderEditButton(translate, "Aadress ja suhtluskeel")), /* @__PURE__ */ React__default.createElement(Modal, { hasContentComponent: true }, /* @__PURE__ */ React__default.createElement(ModalContent, null, "Andmete muutmine")));
});
const BasicInformation = observer((props) => {
  const {
    componentTranslateStore: { translate },
    componentSsoStore: { customer }
  } = useStores();
  const { isLoading } = props;
  return /* @__PURE__ */ React__default.createElement(InformationCard, { icon: "contact", isLoading }, /* @__PURE__ */ React__default.createElement(Text, null, renderDataWithLabel("name", translate("userData.name"), customer.displayName), renderDataWithLabel("personalCode", translate("userData.personalCode"), customer.registrationNumber), renderDataWithLabel(
    "personalCodeCountry",
    translate("userData.personalCodeCountry"),
    CountryUtil.getByCountryCode(customer.registrationNumberCountryCode) ? CountryUtil.getByCountryCode(customer.registrationNumberCountryCode).label.et : translate("userData.information.else")
  )));
});
const ContactInformation = observer((props) => {
  const {
    componentTranslateStore: { translate },
    componentCustomerContactInfoStore: { email, phone },
    informationUpdateNoticeStore: { phoneHasError, isPhoneUnvalidated, emailHasError, isEmailUnvalidated }
  } = useStores();
  const { isLoading } = props;
  const renderEmail = () => {
    const emailValue = /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("span", { className: "sr-only", id: "email" }, translate("userData.contactInformation.email")), /* @__PURE__ */ React__default.createElement("span", { className: "text-break", "aria-labelledby": "email" }, isEmailUnvalidated ? /* @__PURE__ */ React__default.createElement(Tooltip, { referenceElement: /* @__PURE__ */ React__default.createElement(TooltipToggle, null, email.value) }, translate("userData.unvalidated")) : email.value));
    return emailHasError ? /* @__PURE__ */ React__default.createElement(RenderDataWithError, { checkSimpleValue: true, simpleValue: email.value }, emailValue) : emailValue;
  };
  const renderPhoneNumber = () => {
    const phoneNumber = /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("span", { className: "sr-only", id: "phone" }, translate("userData.contactInformation.phone")), /* @__PURE__ */ React__default.createElement("span", { "aria-labelledby": "phone" }, isPhoneUnvalidated ? /* @__PURE__ */ React__default.createElement(Tooltip, { referenceElement: /* @__PURE__ */ React__default.createElement(TooltipToggle, null, phone.value) }, translate("userData.unvalidated")) : phone.value));
    return phoneHasError ? /* @__PURE__ */ React__default.createElement(RenderDataWithError, { checkSimpleValue: true, simpleValue: phone.value }, phoneNumber) : phoneNumber;
  };
  return /* @__PURE__ */ React__default.createElement(ModalProvider, null, /* @__PURE__ */ React__default.createElement(InformationCard, { icon: "email", type: emailHasError || phoneHasError ? "error" : "light", isLoading }, /* @__PURE__ */ React__default.createElement(EqualHeight, { group: "userData" }, /* @__PURE__ */ React__default.createElement(Text, null, renderDataWithLabel(
    "contactInformation",
    translate("userData.contactInformation"),
    /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, renderPhoneNumber(), renderEmail())
  ))), /* @__PURE__ */ React__default.createElement(Separator, { spacing: "xsmall", color: "invisible" }), renderEditButton(translate, "Kontaktandmed")), /* @__PURE__ */ React__default.createElement(Modal, { hasContentComponent: true }, /* @__PURE__ */ React__default.createElement(ModalContent, null, "Andmete muutmine")));
});
const CUSTOMER_SENIORITY_PREFIX = "account.seniority.";
const getCustomerSinceYearTranslation = (years, translate) => {
  let yearsLabel;
  const lastDigit = years % 10;
  if (years === 1) {
    yearsLabel = "year";
  } else if (lastDigit === 1 && years !== 11) {
    yearsLabel = "yearsEndingWith1";
  } else if (lastDigit >= 2 && lastDigit <= 4 && !(years >= 12 && years <= 14)) {
    yearsLabel = "yearsEndingWith2to4";
  } else {
    yearsLabel = "years";
  }
  return "".concat(years, " ").concat(translate("".concat(CUSTOMER_SENIORITY_PREFIX).concat(yearsLabel)));
};
const getCustomerSinceMonthTranslation = (months, translate) => {
  let monthsLabel;
  if (months === 1) {
    monthsLabel = "month";
  } else if (months >= 2 && months <= 4) {
    monthsLabel = "monthsEndingWith2to4";
  } else {
    monthsLabel = "months";
  }
  return "".concat(months, " ").concat(translate("".concat(CUSTOMER_SENIORITY_PREFIX).concat(monthsLabel)));
};
const getCustomerSinceWeekTranslation = (weeks, translate) => {
  const weeksLabel = weeks === 1 ? "week" : "weeks";
  return "".concat(weeks, " ").concat(translate("".concat(CUSTOMER_SENIORITY_PREFIX).concat(weeksLabel)));
};
const getCustomerSinceUnits = (customerSince) => {
  if (!customerSince) {
    return { years: 0, months: 0, weeks: 0 };
  }
  const duration = intervalToDuration({ start: new Date(customerSince), end: /* @__PURE__ */ new Date() });
  return { years: duration.years, months: duration.months, weeks: Math.floor(duration.days / 7) };
};
const CustomerSeniority = observer((props) => {
  const {
    componentTranslateStore: { translate },
    componentCustomerAccountStore: { customer: fullCustomer }
  } = useStores();
  const { isLoading } = props;
  const customerSinceUnits = getCustomerSinceUnits(fullCustomer == null ? void 0 : fullCustomer.customerSinceTs);
  return /* @__PURE__ */ React__default.createElement(InformationCard, { icon: "file-contact", isLoading }, /* @__PURE__ */ React__default.createElement(Text, null, renderDataWithLabel(
    "seniority",
    translate("userData.seniority"),
    !(fullCustomer == null ? void 0 : fullCustomer.customerSinceTs) ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("span", { className: "sr-only" }, translate("userData.missing")), "-") : /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, getCustomerSinceYearTranslation(customerSinceUnits.years, translate), ", ", getCustomerSinceMonthTranslation(customerSinceUnits.months, translate), ", ", getCustomerSinceWeekTranslation(customerSinceUnits.weeks, translate))
  )));
});
const MAX_PASSWORD_LENGTH = 8;
const CustomerServicePassword = observer(() => {
  const {
    componentTranslateStore: { translate },
    informationUpdateNoticeStore: { setShowCustomerServicePasswordSubmitSuccess }
  } = useStores();
  const { isMobile } = useIsMobileHook();
  const [oldPassword, setOldPassword] = React__default.useState("");
  const [password, setPassword] = React__default.useState("");
  const [oldPasswordHint, setOldPasswordHint] = React__default.useState("");
  const [passwordHint, setPasswordHint] = React__default.useState("");
  const [fetchStatus, setFetchStatus] = React__default.useState(FetchStatus.UNINITIALIZED);
  const [submitStatus, setSubmitStatus] = React__default.useState(FetchStatus.UNINITIALIZED);
  const [hasSubmitted, setHasSubmitted] = React__default.useState(false);
  const [passwordHelper, setPasswordHelper] = React__default.useState(void 0);
  const [passwordHintHelper, setPasswordHintHelper] = React__default.useState(void 0);
  React__default.useEffect(() => {
    fetchPassword();
  }, []);
  React__default.useEffect(() => {
    setPasswordHelper(getPasswordHelper());
  }, [password]);
  React__default.useEffect(() => {
    setPasswordHintHelper(getPasswordHintHelper());
  }, [passwordHint]);
  const fetchPassword = async () => {
    try {
      setFetchStatus(FetchStatus.FETCHING);
      const { data } = await PersonApi.getCustomerServicePassword();
      if (data.password) {
        setOldPassword(data.password);
        setPassword(data.password);
      }
      if (data.passwordHint) {
        setOldPasswordHint(data.passwordHint);
        setPasswordHint(data.passwordHint);
      }
      setFetchStatus(FetchStatus.FETCHED);
    } catch (e) {
      setFetchStatus(FetchStatus.ERROR);
    }
  };
  const submitPassword = async () => {
    setShowCustomerServicePasswordSubmitSuccess(false);
    setHasSubmitted(true);
    setPasswordHelper(getPasswordHelper(true));
    setPasswordHintHelper(getPasswordHintHelper(true));
    if (formHasErrors(true)) {
      return;
    }
    try {
      setSubmitStatus(FetchStatus.FETCHING);
      await PersonApi.setCustomerServicePassword(password, passwordHint);
      setOldPassword(password);
      setOldPasswordHint(passwordHint);
      setSubmitStatus(FetchStatus.FETCHED);
      setShowCustomerServicePasswordSubmitSuccess(true);
    } catch (e) {
      setSubmitStatus(FetchStatus.ERROR);
    } finally {
      setHasSubmitted(false);
    }
  };
  const isFetching = () => {
    return [FetchStatus.UNINITIALIZED, FetchStatus.FETCHING].includes(fetchStatus);
  };
  const isSubmitLoading = () => {
    return submitStatus === FetchStatus.FETCHING;
  };
  const formHasErrors = (submitted) => {
    return helperInErrorState(submitted ? getPasswordHelper(true) : passwordHelper) || helperInErrorState(submitted ? getPasswordHintHelper(true) : passwordHintHelper);
  };
  const getPasswordHintHelper = (submitted = hasSubmitted) => {
    let errorCode = "";
    if (submitted && !passwordHint.length) {
      errorCode = "requiredField";
    } else if (submitted && passwordHint === oldPasswordHint) {
      errorCode = "samePasswordHintError";
    }
    return errorCode ? {
      id: getErroredHelperId(PASSWORD_HINT_ID),
      text: translate("userData.customerServicePassword.passwordHint.".concat(errorCode)),
      type: "error"
    } : void 0;
  };
  const getPasswordHelper = (submitted = hasSubmitted) => {
    let errorCode = "";
    if (submitted && !password.length) {
      errorCode = "requiredField";
    } else if (password.length > MAX_PASSWORD_LENGTH) {
      errorCode = "tooLongError";
    } else if (submitted && password === oldPassword) {
      errorCode = "samePasswordError";
    }
    return errorCode ? { id: getErroredHelperId(PASSWORD_ID), text: translate("userData.customerServicePassword.password.".concat(errorCode)), type: "error" } : void 0;
  };
  if (isFetching()) {
    return /* @__PURE__ */ React__default.createElement(Skeleton, { label: translate("skeleton.loading") }, /* @__PURE__ */ React__default.createElement(SkeletonItem, { height: isMobile ? "112px" : "92px" }));
  }
  return /* @__PURE__ */ React__default.createElement(Accordion, { type: "card" }, /* @__PURE__ */ React__default.createElement(AccordionItem, { id: "customer-service-password", icon: "#support" }, /* @__PURE__ */ React__default.createElement(AccordionHeader, null, /* @__PURE__ */ React__default.createElement(AccordionTitle, null, translate("userData.customerServicePassword.title")), /* @__PURE__ */ React__default.createElement("p", null, translate("userData.customerServicePassword.description"))), /* @__PURE__ */ React__default.createElement(AccordionContent, null, /* @__PURE__ */ React__default.createElement(Text, null, /* @__PURE__ */ React__default.createElement("p", null, translate("userData.customerServicePassword.info")), /* @__PURE__ */ React__default.createElement("p", null, translate("userData.customerServicePassword.obligationInfo")), formHasErrors() && /* @__PURE__ */ React__default.createElement(FormErrorNotice, { erroredFields: [getPasswordHelper(), getPasswordHintHelper()] }), /* @__PURE__ */ React__default.createElement(Grid, null, /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs-12", "md-6", "lg-5", "xl-4"] }, /* @__PURE__ */ React__default.createElement(
    PassField,
    {
      id: PASSWORD_ID,
      label: translate("userData.customerServicePassword.password"),
      value: password,
      onChange: setPassword,
      isInvalid: helperInErrorState(passwordHelper),
      errorMessage: helperInErrorState(passwordHelper) ? passwordHelper.text : void 0
    }
  ))), /* @__PURE__ */ React__default.createElement(Grid, null, /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs-12", "md-6", "lg-5", "xl-4"] }, /* @__PURE__ */ React__default.createElement(
    TextField,
    {
      id: PASSWORD_HINT_ID,
      label: translate("userData.customerServicePassword.passwordHint"),
      value: passwordHint,
      onChange: setPasswordHint,
      isInvalid: helperInErrorState(passwordHintHelper),
      errorMessage: helperInErrorState(passwordHintHelper) ? passwordHintHelper.text : void 0
    }
  ))), /* @__PURE__ */ React__default.createElement(Grid, null, /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs-6", "md-4", "lg-2"] }, /* @__PURE__ */ React__default.createElement(AnalyticsTrigger, { trigger: { callback: "onClick", id: "Button - Salvesta klienditeeninduse salasõna" } }, /* @__PURE__ */ React__default.createElement(
    Button,
    {
      text: translate("userData.customerServicePassword.save"),
      type: "expressive",
      onClick: submitPassword,
      disabled: isSubmitLoading(),
      isLoading: isSubmitLoading()
    }
  ))))))));
});
const analyticsContext = {
  page: "InformationUpdate",
  group: "crm-components",
  event: "AutoEvent",
  onPush: GaDataStore.push
};
const InformationUpdate = observer(() => {
  const {
    componentTranslateStore: { translate },
    componentSsoStore: { customer, isSsoLoaded, initializeAuthentication },
    componentCustomerAccountStore: { isFullCustomerInfoFetching, fetchFullCustomerInfo },
    componentCustomerContactInfoStore: { init: initCustomerContactInfoStore },
    componentContactAddressStore: { init: initContactAddressStore },
    informationUpdateNoticeStore: { isPhoneUnvalidated, isEmailUnvalidated, showCustomerServicePasswordSubmitSuccess }
  } = useStores();
  const { isMobileOrTablet } = useIsMobileHook();
  const goToUrl = new URLSearchParams(location.search).get("goToUrl");
  const isLoading = !isSsoLoaded || !customer || isFullCustomerInfoFetching;
  React__default.useEffect(() => {
    initStores();
    if (!customer) {
      initializeAuthentication(false, false);
    }
  }, []);
  React__default.useEffect(() => {
    initStores();
  }, [customer == null ? void 0 : customer.customerId]);
  React__default.useEffect(() => {
    if (showCustomerServicePasswordSubmitSuccess) {
      scrollUpToElement("passwordSubmitSuccess", isMobileOrTablet);
    }
  }, [showCustomerServicePasswordSubmitSuccess]);
  const initStores = async () => {
    const initStorePromises = [initCustomerContactInfoStore(), initContactAddressStore(), fetchFullCustomerInfo()];
    await Promise.all(initStorePromises);
  };
  const renderNotices = () => {
    let notices = [];
    if (goToUrl) {
      notices.push(
        /* @__PURE__ */ React__default.createElement(Notice, { type: "info", key: "backNotice" }, /* @__PURE__ */ React__default.createElement(Grid, { align: ["middle-xs"], noWrap: true }, /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["max"] }, translate("userData.notice.back")), /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["min"] }, /* @__PURE__ */ React__default.createElement(Button, { text: translate("userData.notice.back.cta"), size: "small", iconRight: "#arrow-right", onClick: () => navigate(goToUrl) }))))
      );
    }
    if (showCustomerServicePasswordSubmitSuccess) {
      notices.push(
        /* @__PURE__ */ React__default.createElement(Notice, { id: "passwordSubmitSuccess", type: "success", key: "passwordSubmitSuccessNotice" }, translate("userData.notice.customerServicePassword.submitSuccess"))
      );
    }
    if (isPhoneUnvalidated || isEmailUnvalidated) {
      notices.push(
        /* @__PURE__ */ React__default.createElement(Notice, { type: "attention", key: "unvalidatedDataNotice" }, translate("userData.notice.unvalidated"))
      );
    }
    if (notices.length > 1) {
      notices = notices.map(
        (notice, index) => index < notices.length - 1 ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, { key: "notice".concat(index) }, notice, /* @__PURE__ */ React__default.createElement(Separator, { spacing: "xsmall", color: "invisible" })) : notice
      );
    }
    return notices.length ? notices : void 0;
  };
  return /* @__PURE__ */ React__default.createElement(Container, null, /* @__PURE__ */ React__default.createElement(AnalyticsProvider, { ...analyticsContext }, /* @__PURE__ */ React__default.createElement(
    PageHeading,
    {
      backButton: {
        text: translate("userData.page.back"),
        onClick: () => navigate(goToUrl || "/konto")
      },
      className: "h2"
    },
    translate("userData.page.title")
  ), /* @__PURE__ */ React__default.createElement(Separator, { spacing: "small", color: "invisible" }), /* @__PURE__ */ React__default.createElement("div", { "aria-live": "polite" }, renderNotices()), /* @__PURE__ */ React__default.createElement(Separator, { spacing: "small", color: "invisible" }), /* @__PURE__ */ React__default.createElement(EqualHeightProvider, { groups: ["userData"] }, /* @__PURE__ */ React__default.createElement(Grid, { equalHeight: true }, /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs-12", "md-6", "lg-3"] }, /* @__PURE__ */ React__default.createElement(BasicInformation, { isLoading })), /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs-12", "md-6", "lg-3"] }, /* @__PURE__ */ React__default.createElement(AddressAndLanguage, { isLoading })), /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs-12", "md-6", "lg-3"] }, /* @__PURE__ */ React__default.createElement(ContactInformation, { isLoading })), /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs-12", "md-6", "lg-3"] }, /* @__PURE__ */ React__default.createElement(CustomerSeniority, { isLoading })))), /* @__PURE__ */ React__default.createElement(Separator, { spacing: "small", color: "invisible" }), /* @__PURE__ */ React__default.createElement(Card, { background: "transparent", type: "light" }, /* @__PURE__ */ React__default.createElement(CardContent, null, /* @__PURE__ */ React__default.createElement(EditInvoices$1, null))), /* @__PURE__ */ React__default.createElement(Separator, { spacing: "small", color: "invisible" }), /* @__PURE__ */ React__default.createElement(CustomerServicePassword, null)));
});
const UpdateInformationCheck = observer((props) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const {
    componentCustomerContactInfoStore,
    componentSsoStore,
    componentInformationCheckStore: {
      customerCommunicationLanguage,
      isLoading,
      customerPhoneValue,
      customerEmailValue,
      customerAddressFormatted,
      amountOfInvoices,
      contactAddressIsMatchingOnInvoicesAndContactInfo,
      customerPhoneValidated,
      customerEmailValidated,
      customerAddressValidated
    },
    componentContactAddressStore,
    componentTranslateStore: { translate },
    componentSsoStore: { person },
    brand
  } = useContext(ComponentRootStoreContext);
  useEffect(() => {
    if (!!componentSsoStore.customerId) {
      setModalOpen(true);
      GaDataStore.push({
        event: "AutoEvent",
        page: "Account - My data and authorisations",
        group: "Updating of data",
        id: "Show - update-information-modal-open"
      });
    }
  }, [componentSsoStore.customerId]);
  const handleChangeNowOnClick = () => {
    if (!props.redirectToInformationUpdate) {
      LocationUtils.changePath("/konto/andmete-uuendamine");
      return;
    }
    props.redirectToInformationUpdate();
  };
  const isRequiredContactInformationPresent = () => {
    return componentContactAddressStore.isAddressValid() && (!!customerPhoneValue || !!customerEmailValue);
  };
  const confirmData = () => {
    Promise.all([
      componentContactAddressStore.saveAddress(),
      componentCustomerContactInfoStore.updateContactInfo(false),
      componentCustomerContactInfoStore.updateContactInfoConfirmedTs()
    ]).then(() => setModalOpen(false));
  };
  const analyticsContext2 = {
    group: "Updating of data",
    event: "AutoEvent",
    page: "Account - My data and authorisations",
    onPush: GaDataStore.push
  };
  return /* @__PURE__ */ React__default.createElement(AnalyticsProvider, { ...analyticsContext2 }, /* @__PURE__ */ React__default.createElement(
    Modal,
    {
      hasContentComponent: true,
      isOpen: isModalOpen,
      "aria-labelledby": "information-check-heading",
      initialFocusedElementId: "change-data",
      cover: brand === "TELIA" ? {
        backgroundColor: "#999999",
        minHeight: 500,
        image: {
          srcset: "https://res.cloudinary.com/telia/image/upload/q_5/w_400,h_800,c_fill/crm-components/Telia_Company_112_2.png",
          role: "presentation"
        },
        fillImage: true
      } : void 0,
      onClose: () => {
        setModalOpen(false);
        GaDataStore.push({
          event: "AutoEvent",
          page: "Account - My data and authorisations",
          group: "Updating of data",
          id: "Button - update-information-modal-cancel"
        });
      }
    },
    /* @__PURE__ */ React__default.createElement(ModalContent, null, isLoading ? /* @__PURE__ */ React__default.createElement(Spinner, null) : /* @__PURE__ */ React__default.createElement(Text, null, /* @__PURE__ */ React__default.createElement(Heading$1, { className: "h2", id: "information-check-heading" }, translate("dataconfirm.informationcheck.heading")), /* @__PURE__ */ React__default.createElement("p", { className: "h4 text-bold" }, translate("dataconfirm.informationcheck.greeting", { name: person.firstName })), /* @__PURE__ */ React__default.createElement("p", null, translate("dataconfirm.informationcheck.checkyourinformation")), /* @__PURE__ */ React__default.createElement(LabelValue, { label: "dataconfirm.informationcheck.phone", value: customerPhoneValue, className: "text__margin-double" }), !customerPhoneValidated && /* @__PURE__ */ React__default.createElement("p", { className: "text__margin-none" }, /* @__PURE__ */ React__default.createElement(Icon, { className: "text-attention", modifiers: "#alert-round", align: "middle" }), /* @__PURE__ */ React__default.createElement("span", { className: "text-small" }, translate("common.contactInfo.phoneUnvalidated"))), /* @__PURE__ */ React__default.createElement(LabelValue, { label: "dataconfirm.informationcheck.email", value: customerEmailValue }), !customerEmailValidated && /* @__PURE__ */ React__default.createElement("p", { className: "text__margin-none" }, /* @__PURE__ */ React__default.createElement(Icon, { className: "text-attention", modifiers: "#alert-round", align: "middle" }), /* @__PURE__ */ React__default.createElement("span", { className: "text-small" }, translate("common.contactInfo.emailUnvalidated"))), /* @__PURE__ */ React__default.createElement(LabelValue, { label: "dataconfirm.informationcheck.postAddress", value: customerAddressFormatted }), !customerAddressValidated && /* @__PURE__ */ React__default.createElement("p", { className: "text__margin-none" }, /* @__PURE__ */ React__default.createElement(Icon, { className: "text-attention", modifiers: "#alert-round", align: "middle" }), /* @__PURE__ */ React__default.createElement("span", { className: "text-small" }, translate("common.contactInfo.addressUnvalidated"))), /* @__PURE__ */ React__default.createElement(
      LabelValue,
      {
        label: "dataconfirm.informationcheck.communicationLanguage",
        value: getTranslatedCommunicationLanguage(customerCommunicationLanguage, translate)
      }
    ), amountOfInvoices ? /* @__PURE__ */ React__default.createElement(LabelValue, { label: "dataconfirm.informationcheck.monthlyInvoices", value: amountOfInvoices }) : null, !contactAddressIsMatchingOnInvoicesAndContactInfo && /* @__PURE__ */ React__default.createElement(Notice, { type: "error", size: "small", className: "text__margin-double" }, translate("dataconfirm.informationcheck.notice")))),
    /* @__PURE__ */ React__default.createElement(ModalFooter, null, /* @__PURE__ */ React__default.createElement(Grid, { align: ["middle-xs", "center-xs", "start-md"], reverse: ["xs"], className: "text-center" }, /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs-12", "md"] }, /* @__PURE__ */ React__default.createElement(AnalyticsTrigger, { trigger: { id: "Button - change-data", callback: "onClick" } }, /* @__PURE__ */ React__default.createElement(Button, { text: translate("dataconfirm.informationcheck.changeNow"), onClick: handleChangeNowOnClick, id: "change-data" }))), /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs-12", "md"] }, /* @__PURE__ */ React__default.createElement(AnalyticsTrigger, { trigger: { id: "Button - confirm-data", callback: "onClick" } }, /* @__PURE__ */ React__default.createElement(
      Button,
      {
        text: translate("dataconfirm.informationcheck.confirmData"),
        variant: "secondary",
        onClick: confirmData,
        disabled: !isRequiredContactInformationPresent()
      }
    ))), /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs-12", "md"] }, /* @__PURE__ */ React__default.createElement(AnalyticsTrigger, { trigger: { id: "Button - change-later", callback: "onClick" } }, /* @__PURE__ */ React__default.createElement(Button, { text: translate("dataconfirm.informationcheck.changeLater"), iconRight: "#arrow-right", link: true, onClick: () => setModalOpen(false) })))))
  ));
});
const LabelValue = ({ label, value, className = "text__margin-half" }) => {
  const {
    componentTranslateStore: { translate }
  } = useContext(ComponentRootStoreContext);
  return /* @__PURE__ */ React__default.createElement("p", { className }, /* @__PURE__ */ React__default.createElement(Grid, { element: "span" }, /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs-4", "lg-3"] }, translate(label)), /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs-8", "lg-9"], className: "text-bold" }, valueOrDash(value))));
};
const EXCLUDED_PATHS = ["/konto/registreerimine", "/konto/andmete-uuendamine", "/konto/pakkumiste-ja-uudiste-seaded"];
const InformationCheckWrapper = ({ children, redirectToInformationUpdate }) => {
  const {
    componentCustomerContactInfoStore,
    componentSsoStore: { customerId, dealer, isSsoLoaded, isRepresentingSelf },
    componentInformationCheckStore: { isLoading, init, shouldShowValidationCheck, isContactInfoOutdated, hasAllContactInfo }
  } = useContext(ComponentRootStoreContext);
  const [shouldShowModal, setShowModal] = useState(false);
  const location2 = useLocation();
  useEffect(() => {
    toggleModalVisibilityIfNeeded();
  }, [location2]);
  useEffect(() => {
    if (isSsoLoaded && !!customerId && (!componentCustomerContactInfoStore.isLoaded || componentCustomerContactInfoStore.initialCustomerId !== customerId || isLoading)) {
      Promise.all([init(), componentCustomerContactInfoStore.init()]).finally(() => {
        toggleModalVisibilityIfNeeded();
      });
    }
  }, [customerId]);
  const isOnExcludedPath = () => {
    const route = NavigationUtil.get().getRoute(location2.pathname);
    return EXCLUDED_PATHS.includes(route == null ? void 0 : route.path);
  };
  const toggleModalVisibilityIfNeeded = () => {
    setShowModal(
      !isOnExcludedPath() && !dealer && isRepresentingSelf && !isLoading && (shouldShowValidationCheck || isContactInfoOutdated || !hasAllContactInfo)
    );
  };
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, shouldShowModal && shouldShowValidationCheck && /* @__PURE__ */ React__default.createElement(ContactInfoValidationCheck, { redirectToInformationUpdate }), shouldShowModal && (isContactInfoOutdated && !shouldShowValidationCheck || !hasAllContactInfo) && /* @__PURE__ */ React__default.createElement(UpdateInformationCheck, { redirectToInformationUpdate }), children);
};
const InformationCheckWrapper$1 = observer(InformationCheckWrapper);
class Route extends React.Component {
  constructor(props) {
    super(props);
  }
}
var __defProp$3 = Object.defineProperty;
var __getOwnPropDesc$3 = Object.getOwnPropertyDescriptor;
var __decorateClass$3 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$3(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$3(target, key, result);
  return result;
};
let RouteErrorBoundary = class extends React__default.Component {
  constructor(props) {
    super(props);
    __publicField(this, "componentTranslateStore");
    __publicField(this, "hasError");
    makeObservable(this);
  }
  render() {
    if (this.hasError) {
      const { translateGlobal } = this.componentTranslateStore;
      return /* @__PURE__ */ React__default.createElement(Container, null, /* @__PURE__ */ React__default.createElement(Separator, { spacing: "large", color: "invisible" }), /* @__PURE__ */ React__default.createElement(Notice, { type: "error" }, translateGlobal("general.error.message")), /* @__PURE__ */ React__default.createElement(Separator, { spacing: "large", color: "invisible" }));
    }
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, this.props.children);
  }
  componentDidCatch() {
    this.hasError = true;
  }
};
__decorateClass$3([
  observable
], RouteErrorBoundary.prototype, "hasError", 2);
__decorateClass$3([
  action.bound
], RouteErrorBoundary.prototype, "componentDidCatch", 1);
RouteErrorBoundary = __decorateClass$3([
  injectStores,
  observer
], RouteErrorBoundary);
class RouteValidationAPI {
  static async validateRoute(routeRestrictions, brand) {
    return API.post(Config.apiUrl.concat("/validation/route"), { ...routeRestrictions, brand }).then((response) => response.data);
  }
}
var __defProp$2 = Object.defineProperty;
var __getOwnPropDesc$2 = Object.getOwnPropertyDescriptor;
var __decorateClass$2 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$2(target, key, result);
  return result;
};
var RouteErrorType = /* @__PURE__ */ ((RouteErrorType2) => {
  RouteErrorType2["AUTH_LEVEL"] = "AUTH_LEVEL";
  RouteErrorType2["USER_TYPE"] = "USER_TYPE";
  RouteErrorType2["CUSTOMER_TYPE"] = "CUSTOMER_TYPE";
  RouteErrorType2["REPRESENTATIVE"] = "REPRESENTATIVE";
  RouteErrorType2["MANDATE"] = "MANDATE";
  RouteErrorType2["DEALER_ROLE"] = "DEALER_ROLE";
  RouteErrorType2["STIPULATION_PRESENT"] = "STIPULATION_PRESENT";
  return RouteErrorType2;
})(RouteErrorType || {});
const _RouteUtil = class _RouteUtil2 {
  constructor(args) {
    __publicField(this, "sso");
    __publicField(this, "brand");
    __publicField(this, "mainRestrictions");
    __publicField(this, "mainFallbackElement");
    // from Routes.tsx
    __publicField(this, "notFoundElement");
    __publicField(this, "routeObjects", []);
    makeObservable(this);
    this.sso = args.sso;
    this.brand = args.brand;
    this.mainRestrictions = args.restrictions;
    this.mainFallbackElement = args.fallbackElement;
    this.notFoundElement = args.notFoundElement;
  }
  async setRoutes(routes) {
    const allPromisesOfRoutes = React__default.Children.map(routes, (c) => this.setRoute(c));
    await Promise.all(allPromisesOfRoutes);
    if (!this.routeObjects.some((route) => route.path === "*")) {
      this.routeObjects = [...this.routeObjects, this.getCatchAllRoute()];
    }
    return this.routeObjects;
  }
  async setRoute(c) {
    const routeElement = _RouteUtil2.verifyRouteElementType(c);
    const renderElement = await this.getRenderElement(routeElement);
    this.routeObjects = [...this.routeObjects, { path: routeElement.props.path, element: renderElement }];
    NavigationUtil.get().setRoute(routeElement.props.path, routeElement.props);
    this.routeObjects = [...this.routeObjects, ..._RouteUtil2.getLanguageElements(routeElement, renderElement)];
  }
  getCatchAllRoute() {
    const routeElement = { path: "*", element: this.notFoundElement };
    NavigationUtil.get().setRoute("*", routeElement);
    return routeElement;
  }
  static verifyRouteElementType(routeElement) {
    const element = routeElement;
    if (element.type !== Route) {
      throw new Error("Children of Routes need to be of type Route (from CRM-Components)");
    }
    return element;
  }
  async getRenderElement(routeElement) {
    const restrictions = this.getRestrictions(routeElement);
    if (!restrictions) {
      const el = this.getRenderElementByCustomerType(routeElement, void 0);
      return Promise.resolve(/* @__PURE__ */ React__default.createElement(RouteErrorBoundary, null, el));
    } else {
      return RouteValidationAPI.validateRoute(restrictions, this.brand).then((routeErrors) => {
        NavigationUtil.get().setRouteErrors(routeElement.props.path, routeErrors);
        const isValidRoute = routeErrors.length === 0;
        const { customerType, customerContract } = restrictions;
        const FallbackElement = () => null;
        let el = isValidRoute ? this.getRenderElementByCustomerType(routeElement, customerType) : routeElement.props.fallbackElement || this.mainFallbackElement || /* @__PURE__ */ React__default.createElement(FallbackElement, null);
        if (customerContract == null ? void 0 : customerContract.requiresContract) {
          el = /* @__PURE__ */ React__default.createElement(ContractValidator, { customer: this.sso.isLoggedIn ? this.sso.representative : void 0, redirectLink: customerContract.redirectLink }, el);
        }
        return /* @__PURE__ */ React__default.createElement(RouteErrorBoundary, null, el);
      });
    }
  }
  getRestrictions(routeElement) {
    return routeElement.props.restrictions !== null ? { ...this.mainRestrictions, ...routeElement.props.restrictions } : null;
  }
  getRenderElementByCustomerType(routeElement, customerType) {
    switch (customerType) {
      case "both":
        const rc = routeElement.props.element;
        if (this.sso.representative.type === "B2C") {
          return rc.b2c;
        } else if (this.sso.representative.type === "B2B") {
          return rc.b2b;
        } else if (this.sso.representative.type === void 0) {
          return null;
        }
        throw new Error("Unknown customer type: ".concat(this.sso.representative.type));
      default:
        return routeElement.props.element;
    }
  }
  static getLanguageElements(routeElement, renderElement) {
    const result = [];
    if (routeElement.props.path !== "*") {
      for (const lang in Language) {
        const langStr = Language[lang];
        const pathWithLang = "/".concat(langStr).concat(routeElement.props.path);
        result.push({ path: pathWithLang, element: renderElement });
      }
    }
    return result;
  }
};
__decorateClass$2([
  observable
], _RouteUtil.prototype, "routeObjects", 2);
__decorateClass$2([
  action.bound
], _RouteUtil.prototype, "setRoutes", 1);
__decorateClass$2([
  action.bound
], _RouteUtil.prototype, "setRoute", 1);
let RouteUtil = _RouteUtil;
const Routes = (props) => {
  var _a2, _b2, _c2, _d2;
  const location2 = useLocation$1();
  const [routesReady, setRoutesReady] = useState(false);
  const [routes, setRoutes] = useState([]);
  const [routeErrors, setRouteErrors] = useState([]);
  const NotFoundElement = () => /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(Notice, { type: "error" }, translateGlobal("404.text")));
  const {
    componentTranslateStore: { translateGlobal },
    componentTranslateStore,
    brand
  } = React.useContext(ComponentRootStoreContext);
  const sso = React.useContext(SsoContext);
  const routeUtilProps = {
    sso,
    brand,
    restrictions: props.restrictions,
    fallbackElement: props.fallbackElement,
    notFoundElement: /* @__PURE__ */ React.createElement(NotFoundElement, null)
  };
  NavigationUtil.get().navigateFunction = useNavigate();
  const routeUtil = new RouteUtil(routeUtilProps);
  React.useEffect(() => {
    NavigationUtil.init(brand, componentTranslateStore);
    routeUtil.setRoutes(props.children).then((routes2) => {
      setRoutes(routes2);
      setRoutesReady(true);
    });
  }, []);
  React.useEffect(() => {
    routeUtil.setRoutes(props.children).then((routes2) => {
      setRoutes((prev) => {
        return routes2.map((newRoute) => {
          const existingRoute = prev.find((previousRoute) => previousRoute.path === newRoute.path);
          if (existingRoute) {
            existingRoute.element = newRoute.element;
          }
          return existingRoute || newRoute;
        });
      });
    });
  }, [routeErrors]);
  React.useEffect(() => {
    if (!routesReady) {
      return;
    }
    const [{ route }] = matchRoutes(routes, location2);
    const routeProps = NavigationUtil.get().getRoute(removeLanguageSlug(route.path)) || NavigationUtil.get().getRoute("*");
    if (routeProps) {
      if (routeProps.title) {
        document.title = routeProps.title;
      }
    }
    if (props.onChange) {
      const routeErrors2 = NavigationUtil.get().getRouteErrors(routeProps.path);
      props.onChange(routeProps, routeErrors2);
      setRouteErrors(routeErrors2);
    }
  }, [
    routesReady,
    location2,
    (_a2 = sso.representative) == null ? void 0 : _a2.type,
    (_b2 = sso.representative) == null ? void 0 : _b2.registrationNumber,
    (_c2 = sso.representative) == null ? void 0 : _c2.registrationNumberCountryCode,
    (_d2 = sso.representative) == null ? void 0 : _d2.customerId
  ]);
  return useRoutes(routes);
};
const Footer = (props) => {
  const {
    componentTranslateStore: { translate }
  } = React__default.useContext(ComponentRootStoreContext);
  return /* @__PURE__ */ React__default.createElement(Grid, { align: ["middle-xs", "between-xs"], reverse: ["xs"] }, /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs"] }, /* @__PURE__ */ React__default.createElement(
    Button,
    {
      id: "reference-numbers-modal-save",
      type: !!props.employee ? "employee" : void 0,
      text: translate("referenceNumbersModal.footer.confirm"),
      onClick: props.onSave,
      iconLeft: "#save"
    }
  )), /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs"] }, /* @__PURE__ */ React__default.createElement(
    Button,
    {
      id: "reference-numbers-modal-save-cancel",
      text: translate("referenceNumbersModal.footer.cancel"),
      link: true,
      iconLeft: "#close",
      type: !!props.employee ? "employee" : void 0,
      onClick: props.onClose
    }
  )));
};
var ReferenceNumbersView = /* @__PURE__ */ ((ReferenceNumbersView2) => {
  ReferenceNumbersView2["ALL"] = "ALL";
  ReferenceNumbersView2["SINGLE"] = "SINGLE";
  return ReferenceNumbersView2;
})(ReferenceNumbersView || {});
var MandateType = /* @__PURE__ */ ((MandateType2) => {
  MandateType2["LEGAL"] = "LEGAL";
  MandateType2["SERVICE"] = "SERVICE";
  MandateType2["GOODS"] = "GOODS";
  MandateType2["SERVICE_USAGE_DISTINCTION"] = "SERVICE_USAGE_DISTINCTION";
  MandateType2["LEASING"] = "LEASING";
  MandateType2["BILLING"] = "BILLING";
  return MandateType2;
})(MandateType || {});
const Search = (props) => {
  const { currentView } = React__default.useContext(ReferenceNumbersModalContext);
  const {
    componentTranslateStore: { translate }
  } = React__default.useContext(ComponentRootStoreContext);
  if (currentView !== ReferenceNumbersView.SINGLE) {
    return null;
  }
  return /* @__PURE__ */ React__default.createElement(Grid, null, /* @__PURE__ */ React__default.createElement(GridColumn, { width: props.width || ["xs", "sm-8", "md-6"] }, /* @__PURE__ */ React__default.createElement(
    Search$1,
    {
      id: "ref-num-search",
      label: translate("referenceNumbersModal.search.placeholder"),
      placeholder: translate("referenceNumbersModal.search.placeholder"),
      onChange: (value) => props.onChange(value),
      onSubmit: (event) => {
        event.preventDefault();
      }
    }
  )));
};
const MAX_REF_NUMS_WITHOUT_TOGGLES = 10;
const Heading = (props) => {
  const { currentView, referenceNumbers } = React__default.useContext(ReferenceNumbersModalContext);
  const globalTogglesVisible = currentView === ReferenceNumbersView.SINGLE && referenceNumbers.length > MAX_REF_NUMS_WITHOUT_TOGGLES;
  return globalTogglesVisible ? /* @__PURE__ */ React__default.createElement(Toggle, { id: props.id, label: props.label, onChange: props.onToggle, checked: props.toggleEnabled, disabled: !!props.toggleDisabled }, /* @__PURE__ */ React__default.createElement("span", { className: "text-bold" }, props.label)) : /* @__PURE__ */ React__default.createElement("span", { className: "text-bold" }, props.label);
};
const Row = (props) => {
  const {
    componentTranslateStore: { translate }
  } = React__default.useContext(ComponentRootStoreContext);
  const wasDelegatable = props.referenceNumber.delegatable;
  return /* @__PURE__ */ React__default.createElement(TableRow, { id: props.key, key: props.key }, /* @__PURE__ */ React__default.createElement(TableCell, null, /* @__PURE__ */ React__default.createElement(Grid, { verticalGutter: "none", horizontalGutter: "small", noWrap: true, align: ["start-xs"] }, /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["max"] }, /* @__PURE__ */ React__default.createElement(Text, null, props.referenceNumber.accountId !== -1 && /* @__PURE__ */ React__default.createElement("p", null, props.referenceNumber.title || "-"), /* @__PURE__ */ React__default.createElement("p", null, props.referenceNumber.referenceNumber))))), /* @__PURE__ */ React__default.createElement(TableCell, { className: "text-left" }, /* @__PURE__ */ React__default.createElement(
    Toggle,
    {
      id: "enabled-".concat(props.referenceNumber.referenceNumber),
      label: translate("referenceNumbersModal.table.row.no"),
      onLabel: translate("referenceNumbersModal.table.row.yes"),
      disabled: !props.referenceNumber.enabledEditable,
      checked: !!props.referenceNumber.enabled,
      onChange: (value) => {
        props.referenceNumber.enabled = value;
        if (!value) {
          props.referenceNumber.delegatable = false;
        }
        if (!props.referenceNumber.delegatableEditable && wasDelegatable) {
          props.referenceNumber.delegatable = value;
        }
        props.onChange(props.referenceNumber);
      }
    }
  )), /* @__PURE__ */ React__default.createElement(TableCell, { className: "text-left" }, /* @__PURE__ */ React__default.createElement(
    Toggle,
    {
      id: "delegatable-".concat(props.referenceNumber.referenceNumber),
      label: translate("referenceNumbersModal.table.row.no"),
      onLabel: translate("referenceNumbersModal.table.row.yes"),
      disabled: !props.referenceNumber.enabled || !props.referenceNumber.delegatableEditable,
      checked: props.referenceNumber.delegatable,
      onChange: (value) => {
        props.referenceNumber.delegatable = value;
        props.onChange(props.referenceNumber);
      }
    }
  )));
};
const Table = (props) => {
  const {
    componentTranslateStore: { translate }
  } = React__default.useContext(ComponentRootStoreContext);
  const { referenceNumbers, currentView } = React__default.useContext(ReferenceNumbersModalContext);
  const [allEnabled, setAllEnabled] = React__default.useState(referenceNumbers.filter((refNum) => refNum.accountId !== -1).every((refNum) => refNum.enabled));
  const [allDelegatable, setAllDelegatable] = React__default.useState(
    referenceNumbers.filter((refNum) => refNum.accountId !== -1).every((refNum) => refNum.delegatable)
  );
  const toggleAllEnabled = (value) => {
    setAllEnabled(value);
    if (!value) {
      toggleAllDelegatable(value);
    }
    referenceNumbers.forEach((refNum) => {
      refNum.enabled = value;
      props.onChange(refNum);
    });
  };
  const toggleAllDelegatable = (value) => {
    setAllDelegatable(value);
    referenceNumbers.forEach((refNum) => {
      refNum.delegatable = value;
      props.onChange(refNum);
    });
  };
  const hasNoRefNums = referenceNumbers.length === 0 || referenceNumbers.length === 1 && referenceNumbers[0].accountId === -1 && currentView === ReferenceNumbersView.SINGLE;
  if (hasNoRefNums) {
    return /* @__PURE__ */ React__default.createElement(Notice, { type: "info", size: "small" }, translate("referenceNumbersModal.table.notice.noRefNums"));
  }
  return /* @__PURE__ */ React__default.createElement(Table$2, { className: "text__margin-double", responsive: "rows", break: "sm" }, /* @__PURE__ */ React__default.createElement("thead", null, /* @__PURE__ */ React__default.createElement(TableRow, null, /* @__PURE__ */ React__default.createElement(TableCell, { type: "th", className: "text-bold", scope: "col" }, translate("referenceNumbersModal.table.header.title")), /* @__PURE__ */ React__default.createElement(TableCell, { type: "th", className: "text-bold text-left", scope: "col" }, /* @__PURE__ */ React__default.createElement(
    Heading,
    {
      id: "manage-enabled",
      label: translate("referenceNumbersModal.table.header.allValid"),
      toggleEnabled: allEnabled,
      onToggle: toggleAllEnabled
    }
  )), /* @__PURE__ */ React__default.createElement(TableCell, { type: "th", className: "text-bold text-left", scope: "col" }, /* @__PURE__ */ React__default.createElement(
    Heading,
    {
      id: "manage-delegatable",
      label: translate("referenceNumbersModal.table.header.allDelegatable"),
      toggleEnabled: allDelegatable,
      onToggle: toggleAllDelegatable,
      toggleDisabled: !allEnabled || !referenceNumbers.filter((refNum) => refNum.accountId !== -1).every((refNum) => refNum.delegatableEditable)
    }
  )), /* @__PURE__ */ React__default.createElement(TableCell, { type: "th", scope: "col" }))), /* @__PURE__ */ React__default.createElement("tbody", null, getRows({ onChange: props.onChange })));
};
const getRows = (props) => {
  const { currentView, referenceNumbers, currentFilter } = React__default.useContext(ReferenceNumbersModalContext);
  const result = referenceNumbers.filter((refNum) => {
    var _a2, _b2;
    return refNum.accountId === -1 || !currentFilter || ((_a2 = refNum.referenceNumber) == null ? void 0 : _a2.includes(currentFilter)) || ((_b2 = refNum.title) == null ? void 0 : _b2.includes(currentFilter));
  }).map((refNum) => Row({ referenceNumber: refNum, onChange: props.onChange, key: "ref-num-row-".concat(refNum.referenceNumber) }));
  return currentView === ReferenceNumbersView.ALL ? result.slice(0, 1) : result.slice(1);
};
const Table$1 = observer(Table);
const ViewSelector = (props) => {
  const {
    componentTranslateStore: { translate }
  } = React__default.useContext(ComponentRootStoreContext);
  const { employee } = React__default.useContext(ReferenceNumbersModalContext);
  const allRefNumsOption = {
    id: "all-reference-numbers",
    labelText: translate("referenceNumbersModal.view.all"),
    value: ReferenceNumbersView.ALL,
    employee
  };
  const singleRefNumsOption = {
    id: "single-reference-numbers",
    labelText: translate("referenceNumbersModal.view.single"),
    value: ReferenceNumbersView.SINGLE,
    employee
  };
  return /* @__PURE__ */ React__default.createElement(Grid, null, /* @__PURE__ */ React__default.createElement(GridColumn, { width: props.width || ["xs", "sm-8", "md-6"] }, /* @__PURE__ */ React__default.createElement(
    ChoiceGroup,
    {
      id: "ref-numbers-choice-group",
      type: "radio",
      label: translate("referenceNumbersModal.view.title"),
      onChange: (value) => props.onViewChange(value),
      options: [allRefNumsOption, singleRefNumsOption],
      defaultValue: props.defaultValue,
      labelClass: "text-normal"
    }
  )));
};
const ReferenceNumbersModalContent = (props) => {
  var _a2, _b2;
  const viewBasedOnAllAccounts = () => {
    var _a3;
    if ((_a3 = props.referenceNumbers.find((refNum) => refNum.accountId === -1)) == null ? void 0 : _a3.enabled) {
      return ReferenceNumbersView.ALL;
    }
    if (props.referenceNumbers.every((refNum) => !refNum.enabled)) {
      return ReferenceNumbersView.ALL;
    }
    return ReferenceNumbersView.SINGLE;
  };
  const views = React__default.useContext(ReferenceNumbersModalViewContext);
  const defaultView = props.canSwitchViews ? views.get(props.mandateType) || viewBasedOnAllAccounts() : ReferenceNumbersView.SINGLE;
  const [view, setView] = React__default.useState(defaultView);
  const [filter, setFilter] = React__default.useState("");
  const changeView = (view2) => {
    setView(view2);
    props.onViewChange(view2);
  };
  return /* @__PURE__ */ React__default.createElement(
    ReferenceNumbersModalContext.Provider,
    {
      value: {
        currentView: view,
        currentFilter: filter,
        referenceNumbers: props.referenceNumbers,
        employee: props.employee
      }
    },
    /* @__PURE__ */ React__default.createElement(Text, null, props.canSwitchViews && /* @__PURE__ */ React__default.createElement(ViewSelector, { defaultValue: view, onViewChange: changeView, width: (_a2 = props.widths) == null ? void 0 : _a2.viewSelector }), /* @__PURE__ */ React__default.createElement(Search, { onChange: setFilter, width: (_b2 = props.widths) == null ? void 0 : _b2.search }), /* @__PURE__ */ React__default.createElement(Table$1, { onChange: props.onChange }))
  );
};
const ReferenceNumbersModalContext = React__default.createContext(null);
const ORDERED_MODIFIABLE_MANDATE_TYPES = [
  MandateType.SERVICE,
  MandateType.BILLING,
  MandateType.SERVICE_USAGE_DISTINCTION,
  MandateType.LEASING,
  MandateType.GOODS
];
var __defProp$1 = Object.defineProperty;
var __getOwnPropDesc$1 = Object.getOwnPropertyDescriptor;
var __decorateClass$1 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp$1(target, key, result);
  return result;
};
const getAccountId = (refNum) => {
  return refNum.elionAccountId || refNum.emtAccountId || refNum.diilAccountId;
};
const _RepresentationRightUtil = class _RepresentationRightUtil2 {
  constructor(representationRight, billingRefNums) {
    __publicField(this, "legalMandate");
    __publicField(this, "billingRefNums");
    __publicField(this, "representationRight");
    __publicField(this, "getExistingMandateByType", (type) => {
      var _a2;
      return (_a2 = this.representationRight.mandates) == null ? void 0 : _a2.find((m) => m.type === type);
    });
    makeObservable(this);
    this.billingRefNums = billingRefNums;
    this.representationRight = representationRight;
    this.legalMandate = representationRight.mandates.find((mandate) => mandate.type === MandateType.LEGAL);
  }
  static init(representationRight, billingRefNums) {
    return new _RepresentationRightUtil2(representationRight, billingRefNums);
  }
  for(mandateType) {
    return new ReferenceNumberUtil(mandateType, this.billingRefNums, this.existingRefNums(mandateType), { hasLegal: this.hasLegalMandate });
  }
  get hasLegalMandate() {
    return !!this.legalMandate;
  }
  existingRefNums(mandateType) {
    var _a2;
    return !!this.hasLegalMandate ? this.legalMandate.referenceNumbers : ((_a2 = this.representationRight.mandates.find((mandate) => mandate.type === mandateType)) == null ? void 0 : _a2.referenceNumbers) || [];
  }
  get canModifyAnyReferenceNumbers() {
    return this.hasLegalMandate || this.representationRight.mandates.filter((mandate) => mandate.type !== MandateType.LEGAL).map((mandate) => new ReferenceNumberUtil(mandate.type, this.billingRefNums, this.existingRefNums(mandate.type), { hasLegal: this.hasLegalMandate })).some((refNumUtil) => refNumUtil.canModifyReferenceNumbers);
  }
};
__decorateClass$1([
  observable
], _RepresentationRightUtil.prototype, "legalMandate", 2);
__decorateClass$1([
  observable
], _RepresentationRightUtil.prototype, "representationRight", 2);
__decorateClass$1([
  computed
], _RepresentationRightUtil.prototype, "hasLegalMandate", 1);
__decorateClass$1([
  computed
], _RepresentationRightUtil.prototype, "canModifyAnyReferenceNumbers", 1);
let RepresentationRightUtil = _RepresentationRightUtil;
const copyOf = (obj) => JSON.parse(JSON.stringify(obj));
class ReferenceNumberUtil {
  constructor(mandateType, billingRefNums, existingRefNums, utilProps) {
    __publicField(this, "mandateType");
    __publicField(this, "billingRefNums");
    __publicField(this, "existingRefNums");
    __publicField(this, "hasLegal");
    makeObservable(this);
    this.mandateType = mandateType;
    this.billingRefNums = billingRefNums;
    this.existingRefNums = existingRefNums;
    this.hasLegal = utilProps.hasLegal || false;
  }
  getBillingReferenceNumbers() {
    if (this.mandateTypeIsOneOf(MandateType.BILLING, MandateType.SERVICE_USAGE_DISTINCTION)) {
      return this.hasLegal || this.hasAllAccounts ? copyOf(this.sourceBILLReferenceNumbers) : copyOf(this.sourceBILLDelegatableReferenceNumbers);
    }
    return this.hasLegal || this.hasAllAccounts ? copyOf(this.sourceNonBILLReferenceNumbers) : copyOf(this.sourceNonBILLDelegatableReferenceNumbers);
  }
  getDisplayableReferenceNumbers() {
    const billingRefNums = this.getBillingReferenceNumbers();
    return billingRefNums.map((billingRefNum) => {
      const existing = this.findExistingByAccountIdIncludingAll(billingRefNum.refNumberId);
      return {
        referenceNumber: billingRefNum.refNumber,
        title: billingRefNum.title,
        accountId: billingRefNum.refNumberId,
        enabled: true,
        enabledEditable: true,
        delegatable: existing == null ? void 0 : existing.delegatable,
        delegatableEditable: this.hasLegal
      };
    });
  }
  getReferenceNumbers(accountId) {
    if (this.isSourceBILLReferenceNumber(accountId)) {
      const nonBillAccountIds = this.getSourceNonBILLReferenceNumbers(accountId).map((refNum) => refNum.refNumberId);
      return copyOf(nonBillAccountIds.map((accountId2) => this.findExistingByAccountIds(accountId2)).filter((refNum) => !!refNum));
    }
    return copyOf([this.findExistingByAccountIds(accountId)].filter((refNum) => !!refNum));
  }
  exists(accountId) {
    return !!this.findExistingByAccountIdIncludingAll(accountId);
  }
  isDelegatable(accountId) {
    var _a2;
    return !!((_a2 = this.findExistingByAccountIdIncludingAll(accountId)) == null ? void 0 : _a2.delegatable);
  }
  labelFor(accountId) {
    return this.findBillingByAccountId(accountId).refNumber;
  }
  get canModifyReferenceNumbers() {
    return this.hasLegal || this.existingRefNums.some((referenceNumber) => referenceNumber.delegatable);
  }
  get hasAllAccounts() {
    return this.existingRefNums.length > 0 && this.existingRefNums.every((refNum) => getAccountId(refNum) === -1);
  }
  get allAccountsDelegatable() {
    var _a2;
    return this.existingRefNums.length > 0 && !!((_a2 = this.existingRefNums.find((refNum) => getAccountId(refNum) === -1)) == null ? void 0 : _a2.delegatable);
  }
  get allAccountsReferenceNumber() {
    return this.hasAllAccounts ? { ...this.existingRefNums.find((refNum) => getAccountId(refNum) === -1) } : null;
  }
  newAllAccountsReferenceNumber() {
    return this.generateNewReferenceNumber(-1);
  }
  get allAccountsDelegatabilityEditable() {
    return this.hasLegal;
  }
  get sourceBILLReferenceNumbers() {
    const hasChildren = (refNum) => this.billingRefNums.some((potentialChild) => potentialChild.masterRefNum === refNum.refNumber);
    return this.billingRefNums.filter((refNum) => refNum.source === "BILL" && hasChildren(refNum));
  }
  get sourceBILLDelegatableReferenceNumbers() {
    const childrenFilter = (billRefNum) => {
      const nonBILLReferenceNumbers = this.getSourceNonBILLReferenceNumbers(billRefNum.refNumberId);
      return nonBILLReferenceNumbers.length > 0 && nonBILLReferenceNumbers.every((nonBillRefNum) => this.isDelegatable(nonBillRefNum.refNumberId));
    };
    return this.sourceBILLReferenceNumbers.filter(childrenFilter);
  }
  get sourceNonBILLReferenceNumbers() {
    return this.billingRefNums.filter((billingRefNum) => !["BILL", "BALANCEAPI"].includes(billingRefNum.source));
  }
  get sourceNonBILLDelegatableReferenceNumbers() {
    return this.billingRefNums.filter((billingRefNum) => this.exists(billingRefNum.refNumberId) && this.isDelegatable(billingRefNum.refNumberId));
  }
  isSourceBILLReferenceNumber(accountId) {
    var _a2;
    return ((_a2 = this.findBillingByAccountId(accountId)) == null ? void 0 : _a2.source) === "BILL";
  }
  getSourceNonBILLReferenceNumbers(accountId) {
    const label = this.labelFor(accountId);
    return this.sourceNonBILLReferenceNumbers.filter((billingRefNum) => billingRefNum.masterRefNum === label);
  }
  mandateTypeIsOneOf(...mandateTypes) {
    return mandateTypes.includes(this.mandateType);
  }
  findBillingByAccountId(accountId) {
    return this.billingRefNums.find((refNum) => refNum.refNumberId === accountId);
  }
  findExistingByAccountIdIncludingAll(accountId) {
    return this.findExistingByAccountIds(accountId, -1);
  }
  findExistingByAccountIds(...accountIds) {
    if (this.hasAllAccounts) {
      const singleAccountIds = accountIds.filter((accountId) => accountId !== -1);
      const allAccountIds = accountIds.filter((accountId) => accountId === -1);
      if (accountIds.length > 2 || singleAccountIds.length > 1) {
        throw new Error("Invalid input, cannot generate reference number");
      }
      if (singleAccountIds.length === 0 && allAccountIds.length !== 0) {
        return this.allAccountsReferenceNumber;
      }
      return this.generateNewReferenceNumber(accountIds.find((accountId) => accountId !== -1));
    }
    return this.existingRefNums.find((refNum) => accountIds.includes(getAccountId(refNum)));
  }
  generateNewReferenceNumber(accountId) {
    if (!accountId) {
      return void 0;
    }
    const newRefNum = {
      emtAccountId: null,
      elionAccountId: null,
      source: "STANDARD",
      validUntil: endOfDay(addYears(/* @__PURE__ */ new Date(), 3)),
      representationStipulation: "",
      delegatable: this.hasLegal,
      diilAccountId: null,
      validFrom: /* @__PURE__ */ new Date(),
      brand: "TELIA",
      note: "",
      id: null
    };
    if (accountId === -1) {
      newRefNum.emtAccountId = -1;
      newRefNum.elionAccountId = -1;
      return newRefNum;
    }
    const billRefNum = this.billingRefNums.find((billRefNum2) => billRefNum2.refNumberId === accountId);
    newRefNum.elionAccountId = billRefNum.source === "ARGOS" ? accountId : null;
    newRefNum.emtAccountId = billRefNum.source === "TBCIS" ? accountId : null;
    return newRefNum;
  }
}
__decorateClass$1([
  observable
], ReferenceNumberUtil.prototype, "existingRefNums", 2);
__decorateClass$1([
  computed
], ReferenceNumberUtil.prototype, "canModifyReferenceNumbers", 1);
__decorateClass$1([
  computed
], ReferenceNumberUtil.prototype, "hasAllAccounts", 1);
__decorateClass$1([
  computed
], ReferenceNumberUtil.prototype, "allAccountsDelegatable", 1);
__decorateClass$1([
  computed
], ReferenceNumberUtil.prototype, "allAccountsReferenceNumber", 1);
__decorateClass$1([
  computed
], ReferenceNumberUtil.prototype, "allAccountsDelegatabilityEditable", 1);
__decorateClass$1([
  computed
], ReferenceNumberUtil.prototype, "sourceBILLReferenceNumbers", 1);
__decorateClass$1([
  computed
], ReferenceNumberUtil.prototype, "sourceBILLDelegatableReferenceNumbers", 1);
__decorateClass$1([
  computed
], ReferenceNumberUtil.prototype, "sourceNonBILLReferenceNumbers", 1);
__decorateClass$1([
  computed
], ReferenceNumberUtil.prototype, "sourceNonBILLDelegatableReferenceNumbers", 1);
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp2(target, key, result);
  return result;
};
var InitialSettings = /* @__PURE__ */ ((InitialSettings2) => {
  InitialSettings2[InitialSettings2["FROM_PERSON"] = 0] = "FROM_PERSON";
  InitialSettings2[InitialSettings2["CHECKED"] = 1] = "CHECKED";
  InitialSettings2[InitialSettings2["DELEGATABLE"] = 2] = "DELEGATABLE";
  InitialSettings2[InitialSettings2["UNCHECKED"] = 3] = "UNCHECKED";
  return InitialSettings2;
})(InitialSettings || {});
const _DisplayableReferenceNumbersHelper = (_d = class {
  constructor(representationRights, billingReferenceNumbers) {
    __publicField(this, "billingReferenceNumbers");
    __publicField(this, "representationRightsGivenByCustomer");
    __publicField(this, "customMandates");
    __publicField(this, "_byPerson");
    __publicField(this, "_forPerson");
    __publicField(this, "_newRepresentationRight");
    __publicField(this, "giverRepresentationRightUtil");
    __publicField(this, "receiverRepresentationRightUtil");
    __publicField(this, "displayableMandates", observable.array([]));
    __publicField(this, "overriddenMandates", observable.array([]));
    __publicField(this, "modalViews", observable.map());
    __publicField(this, "initialSettings");
    __publicField(this, "allAccountsRefNumTitleTranslation");
    __publicField(this, "filterByActualRepresentationRightsForPerson", (mandate) => {
      const actualMandates = this.findActualRepresentationRightForPerson(this._forPerson);
      return !this._newRepresentationRight && actualMandates ? this.findActualRepresentationRightForPerson(this._forPerson).mandates.some((man) => man.type === mandate) : true;
    });
    makeObservable(this);
    if (!!representationRights.representationRightsGivenByCustomer) {
      this.representationRightsGivenByCustomer = representationRights.representationRightsGivenByCustomer;
      this.billingReferenceNumbers = representationRights.billingReferenceNumbers;
    } else if (!!billingReferenceNumbers) {
      this.representationRightsGivenByCustomer = representationRights;
      this.billingReferenceNumbers = billingReferenceNumbers;
    } else {
      this.customMandates = representationRights;
    }
    this.initialSettings = 0;
    if (this.usesCustomMandates) {
      this.initCustomMandates();
    }
  }
  static init(representationRights, billingReferenceNumbers) {
    return new _d(representationRights, billingReferenceNumbers);
  }
  initCustomMandates() {
    this.customMandates.forEach((repRight) => {
      const repRightCopy = JSON.parse(JSON.stringify(repRight));
      repRightCopy.displayableReferenceNumbers.sort(_d.SORT_BY.allAccountsFirst);
      this.displayableMandates.push(repRightCopy);
    });
    if (this.displayableMandates.length === 0) {
      throw new Error("No modifiable mandate types were given");
    }
    this.setUpDisplayableMandates();
  }
  initActualMandates() {
    if (!this.usesActualMandates || !this.giverRepresentationRightUtil) {
      return;
    }
    this.modifiableMandateTypes.forEach((mandateType) => {
      const refNumsUtil = this.giverRepresentationRightUtil.for(mandateType);
      const result = { mandateType, displayableReferenceNumbers: [] };
      result.displayableReferenceNumbers.push({
        referenceNumber: this.allAccountsRefNumTitleTranslation,
        accountId: -1,
        enabled: refNumsUtil.hasAllAccounts,
        enabledEditable: refNumsUtil.hasAllAccounts,
        delegatable: refNumsUtil.allAccountsDelegatable,
        delegatableEditable: refNumsUtil.allAccountsDelegatabilityEditable
      });
      result.displayableReferenceNumbers.push(...refNumsUtil.getDisplayableReferenceNumbers());
      result.displayableReferenceNumbers.sort(_d.SORT_BY.allAccountsFirst);
      this.displayableMandates.push(result);
    });
    this.setUpDisplayableMandates();
  }
  initModalViews() {
    this.displayableMandates.forEach((mandate) => {
      var _a2;
      const allRefNums = mandate.displayableReferenceNumbers.find((refNum) => refNum.accountId === -1);
      const hasAllAccounts = this.usesActualMandates && this.giverRepresentationRightUtil.for(mandate.mandateType).hasAllAccounts || !!((_a2 = this.customMandates) == null ? void 0 : _a2.find((customMandate) => customMandate.mandateType === mandate.mandateType).displayableReferenceNumbers.find((refNum) => refNum.accountId === -1));
      const defaultAllView = !hasAllAccounts ? false : allRefNums.enabled || mandate.displayableReferenceNumbers.every((refNum) => !refNum.enabled);
      this.modalViews.set(mandate.mandateType, defaultAllView ? ReferenceNumbersView.ALL : ReferenceNumbersView.SINGLE);
    });
  }
  forPerson(person) {
    this._forPerson = person;
    if (this.usesActualMandates && !!this.receiverRepresentationRight) {
      this.receiverRepresentationRightUtil = RepresentationRightUtil.init(this.receiverRepresentationRight, this.billingReferenceNumbers);
    }
    return this;
  }
  byPerson(person) {
    this._byPerson = person;
    if (this.usesActualMandates && !!this.giverRepresentationRight) {
      this.giverRepresentationRightUtil = RepresentationRightUtil.init(this.giverRepresentationRight, this.billingReferenceNumbers);
      this.initActualMandates();
    }
    return this;
  }
  withAllAccountsTitleTranslation(translation) {
    this.allAccountsRefNumTitleTranslation = translation;
    return this;
  }
  withReferenceNumbers(initialSettings) {
    this.initialSettings = initialSettings;
    return this;
  }
  withOverriddenMandates(overriddenMandates) {
    if (!!overriddenMandates && overriddenMandates.length > 0) {
      this.overriddenMandates = overriddenMandates;
    }
    return this;
  }
  get receiverRepresentationRight() {
    return this.findActualRepresentationRightForPerson(this._forPerson);
  }
  get giverRepresentationRight() {
    return this.findActualRepresentationRightForPerson(this._byPerson);
  }
  get usesActualMandates() {
    return !!this.representationRightsGivenByCustomer && !!this.billingReferenceNumbers;
  }
  get usesCustomMandates() {
    return !this.usesActualMandates;
  }
  get mandates() {
    this.initModalViews();
    this.setUpReferenceNumbersBasedOnMandateType();
    return this.displayableMandates;
  }
  get views() {
    return this.modalViews;
  }
  get anyRefNumsEnabled() {
    const hasAnyRefNumsEnabled = (mandateType) => {
      var _a2;
      const view = this.modalViews.get(mandateType);
      const mandate = this.displayableMandates.find((mandate2) => mandate2.mandateType === mandateType);
      return view === ReferenceNumbersView.ALL ? (_a2 = mandate.displayableReferenceNumbers.find((refNum) => refNum.accountId === -1)) == null ? void 0 : _a2.enabled : !!mandate.displayableReferenceNumbers.find((refNum) => refNum.accountId !== -1 && refNum.enabled);
    };
    let hasOtherNonDisplayableMandates = false;
    if (this.usesActualMandates && !!this.receiverRepresentationRightUtil) {
      const nonDisplayableReceiverMandateTypes = this.receiverRepresentationRight.mandates.map((mandate) => mandate.type).filter((mandateType) => !this.modifiableMandateTypes.includes(mandateType));
      hasOtherNonDisplayableMandates = nonDisplayableReceiverMandateTypes.length > 0;
    }
    return this.modifiableMandateTypes.some(hasAnyRefNumsEnabled) || hasOtherNonDisplayableMandates;
  }
  get modifiableMandateTypes() {
    const displayOrder = (a, b) => {
      return ORDERED_MODIFIABLE_MANDATE_TYPES.indexOf(a) - ORDERED_MODIFIABLE_MANDATE_TYPES.indexOf(b);
    };
    if (this.usesActualMandates) {
      if (this.giverRepresentationRightUtil.hasLegalMandate) {
        return ORDERED_MODIFIABLE_MANDATE_TYPES.filter(this.filterByActualRepresentationRightsForPerson);
      }
      return this.giverRepresentationRight.mandates.filter((mandate) => mandate.referenceNumbers.some((refNum) => refNum.delegatable)).map((mandate) => mandate.type).filter(this.filterByActualRepresentationRightsForPerson).sort(displayOrder);
    }
    return this.customMandates.filter((repRight) => repRight.displayableReferenceNumbers.length > 0).map((repRight) => repRight.mandateType).filter(this.filterByActualRepresentationRightsForPerson).sort(displayOrder);
  }
  onDisplayedReferenceNumberChange(mandateType, referenceNumber) {
    const mandate = this.displayableMandates.find((mandate2) => mandate2.mandateType === mandateType);
    const refNum = mandate.displayableReferenceNumbers.find((refNum2) => refNum2.referenceNumber === referenceNumber.referenceNumber);
    refNum.enabled = referenceNumber.enabled;
    refNum.delegatable = referenceNumber.delegatable;
    this.setUpReferenceNumbersBasedOnMandateType();
  }
  onViewChange(newView, mandateType) {
    this.modalViews.set(mandateType, newView);
    this.setUpReferenceNumbersBasedOnMandateType();
  }
  setNewRepresentationRight(isNewRepresentationRight) {
    this._newRepresentationRight = isNewRepresentationRight;
    return this;
  }
  get newRepresentationRight() {
    if (this.usesCustomMandates) {
      return this.displayableMandates;
    }
    const result = this.displayableMandates.slice();
    this.modifiableMandateTypes.forEach((mandateType) => {
      const displayableMandate = result.find((mandate) => mandate.mandateType === mandateType);
      const hasEnabledRefNums = displayableMandate.displayableReferenceNumbers.some((refNum) => refNum.enabled);
      if (hasEnabledRefNums) {
        const actualRefNums = [];
        displayableMandate.displayableReferenceNumbers.filter((refNum) => refNum.enabled).forEach((refNum) => {
          var _a2, _b2, _c2;
          if (refNum.accountId === -1) {
            const existing = (_b2 = (_a2 = this.receiverRepresentationRightUtil) == null ? void 0 : _a2.for(mandateType).getReferenceNumbers(refNum.accountId)) != null ? _b2 : this.giverRepresentationRightUtil.for(mandateType).getReferenceNumbers(refNum.accountId);
            const existingRefNum = (_c2 = this.receiverRepresentationRightUtil) == null ? void 0 : _c2.getExistingMandateByType(mandateType).referenceNumbers[0];
            if (existingRefNum && !(existing == null ? void 0 : existing.length)) {
              const newRefNumber = this.receiverRepresentationRightUtil.for(mandateType).newAllAccountsReferenceNumber();
              newRefNumber.validUntil = (existingRefNum == null ? void 0 : existingRefNum.validUntil) || newRefNumber.validUntil;
              existing.push(newRefNumber);
            }
            actualRefNums.push({ ...refNum, emtAccountId: -1, elionAccountId: -1, ...existing[0], delegatable: refNum.delegatable });
          } else {
            const referenceNumbers = [];
            if (!!this.receiverRepresentationRightUtil) {
              referenceNumbers.push(...this.receiverRepresentationRightUtil.for(mandateType).getReferenceNumbers(refNum.accountId));
            }
            if (referenceNumbers.length === 0) {
              referenceNumbers.push(...this.giverRepresentationRightUtil.for(mandateType).getReferenceNumbers(refNum.accountId));
            }
            referenceNumbers.forEach((actualRefNum) => actualRefNum.delegatable = refNum.delegatable);
            actualRefNums.push(...referenceNumbers);
          }
        });
        displayableMandate.referenceNumbers = actualRefNums;
      } else {
        displayableMandate.referenceNumbers = [];
      }
    });
    return result;
  }
  setUpDisplayableMandates() {
    switch (this.initialSettings) {
      case 1:
        this.setAllRefNums(true, false);
        break;
      case 2:
        this.setAllRefNums(true, true);
        break;
      case 3:
        this.setAllRefNums(false, false);
        break;
      default:
        this.setUpReferenceNumbersBasedOnReceiver();
    }
    this.setUpOverriddenMandates();
  }
  setAllRefNums(checked, delegatable) {
    this.displayableMandates.forEach((mandate) => {
      mandate.displayableReferenceNumbers.forEach((refNum) => {
        refNum.enabled = checked;
        refNum.delegatable = delegatable;
      });
    });
  }
  setUpReferenceNumbersBasedOnReceiver() {
    if (this.usesCustomMandates || this.initialSettings !== 0) {
      return;
    }
    this.displayableMandates.forEach((mandate) => {
      const receiverRefNumUtil = this.receiverRepresentationRightUtil.for(mandate.mandateType);
      const receiverDisplayableRefNums = receiverRefNumUtil.getDisplayableReferenceNumbers();
      mandate.displayableReferenceNumbers.forEach((displayableRefNum) => {
        const actualRefNums = receiverRefNumUtil.getReferenceNumbers(displayableRefNum.accountId);
        const checked = receiverRefNumUtil.hasAllAccounts || actualRefNums.length > 0 && actualRefNums.every(
          (actualRefNum) => receiverRefNumUtil.exists(actualRefNum.elionAccountId || actualRefNum.emtAccountId || actualRefNum.diilAccountId)
        );
        const delegatable = receiverRefNumUtil.hasAllAccounts ? receiverRefNumUtil.allAccountsDelegatable : !!receiverDisplayableRefNums.find((refNum) => refNum.accountId === displayableRefNum.accountId);
        displayableRefNum.enabled = checked;
        displayableRefNum.delegatable = delegatable;
      });
    });
  }
  setUpReferenceNumbersBasedOnMandateType() {
    if (this.modalViews.size === 0) {
      return;
    }
    const billingMandate = this.displayableMandates.find((mandate) => mandate.mandateType === MandateType.BILLING);
    if (!billingMandate) {
      return;
    }
    const distinctionMandate = this.displayableMandates.find((mandate) => mandate.mandateType === MandateType.SERVICE_USAGE_DISTINCTION);
    if (!distinctionMandate) {
      return;
    }
    const billingMandateView = this.modalViews.get(MandateType.BILLING);
    const disableAndUncheck = (refNum) => {
      if (!!refNum) {
        refNum.enabledEditable = false;
        refNum.delegatableEditable = false;
        refNum.enabled = false;
        refNum.delegatable = false;
      }
    };
    const setDelegatableEditability = (refNum) => {
      refNum.delegatableEditable = this.giverRepresentationRightUtil.hasLegalMandate || this.giverRepresentationRightUtil.for(MandateType.SERVICE_USAGE_DISTINCTION).isDelegatable(refNum.accountId);
      if (!refNum.delegatableEditable) {
        refNum.delegatable = false;
      }
    };
    if (billingMandateView === ReferenceNumbersView.ALL) {
      const billingMandateAllRefNums = billingMandate.displayableReferenceNumbers.find((refNum) => refNum.accountId === -1);
      if (!billingMandateAllRefNums.enabled) {
        distinctionMandate.displayableReferenceNumbers.forEach(disableAndUncheck);
      } else {
        distinctionMandate.displayableReferenceNumbers.forEach((distinctionRefNum) => {
          distinctionRefNum.enabledEditable = true;
          setDelegatableEditability(distinctionRefNum);
        });
      }
      if (!billingMandateAllRefNums.delegatable) {
        distinctionMandate.displayableReferenceNumbers.forEach((distinctionRefNum) => {
          distinctionRefNum.delegatableEditable = false;
          distinctionRefNum.delegatable = false;
        });
      } else {
        distinctionMandate.displayableReferenceNumbers.forEach(setDelegatableEditability);
      }
    } else {
      const distinctionMandateAllRefNums = distinctionMandate.displayableReferenceNumbers.find((refNum) => refNum.accountId === -1);
      if (!!distinctionMandateAllRefNums) {
        disableAndUncheck(distinctionMandateAllRefNums);
      }
      billingMandate.displayableReferenceNumbers.filter((refNum) => refNum.accountId !== -1).forEach((billingRefNum) => {
        const distinctionRefNum = distinctionMandate.displayableReferenceNumbers.find(
          (distinctionRefNum2) => distinctionRefNum2.accountId === billingRefNum.accountId
        );
        if (!distinctionRefNum) {
          return;
        }
        if (billingRefNum.enabled) {
          distinctionRefNum.enabledEditable = true;
          setDelegatableEditability(distinctionRefNum);
        } else {
          disableAndUncheck(distinctionRefNum);
        }
        if (billingRefNum.delegatable) {
          setDelegatableEditability(distinctionRefNum);
        } else {
          distinctionRefNum.delegatableEditable = false;
          distinctionRefNum.delegatable = false;
        }
      });
    }
  }
  setUpOverriddenMandates() {
    var _a2;
    if (!((_a2 = this.overriddenMandates) == null ? void 0 : _a2.length)) {
      return;
    }
    this.displayableMandates.forEach((mandate) => {
      const overriddenMandate = this.overriddenMandates.find((overriddenMandate2) => overriddenMandate2.mandateType === mandate.mandateType);
      if (!!overriddenMandate) {
        mandate.displayableReferenceNumbers.forEach((displayableRefNum) => {
          const overriddenRefNum = overriddenMandate.displayableReferenceNumbers.find((refNum) => refNum.accountId === displayableRefNum.accountId);
          if (!!overriddenRefNum) {
            displayableRefNum.enabled = overriddenRefNum.enabled;
            displayableRefNum.delegatable = overriddenRefNum.delegatable;
          }
        });
      }
    });
    this.resolveConflicts();
  }
  resolveConflicts() {
    this.displayableMandates.forEach((mandate) => {
      mandate.displayableReferenceNumbers.forEach((refNum) => {
        if (refNum.enabledEditable === false && refNum.enabled) {
          refNum.enabled = false;
        }
        if (refNum.delegatableEditable === false && refNum.delegatable) {
          refNum.delegatable = false;
        }
      });
    });
  }
  findActualRepresentationRightForPerson(person) {
    if (this.usesCustomMandates) {
      return void 0;
    }
    return this.representationRightsGivenByCustomer.find(
      (repRight) => repRight.relevantParty.registrationNumber === person.personalCode && repRight.relevantParty.countryCode === person.personalCodeCountryCode
    );
  }
}, __publicField(_d, "SORT_BY", {
  allAccountsFirst: (refNum1, refNum2) => {
    if (refNum1.accountId === -1) {
      return -1;
    }
    if (refNum2.accountId === -1) {
      return 1;
    }
    return 0;
  }
}), _d);
__decorateClass([
  observable
], _DisplayableReferenceNumbersHelper.prototype, "billingReferenceNumbers", 2);
__decorateClass([
  observable
], _DisplayableReferenceNumbersHelper.prototype, "representationRightsGivenByCustomer", 2);
__decorateClass([
  observable
], _DisplayableReferenceNumbersHelper.prototype, "customMandates", 2);
__decorateClass([
  observable
], _DisplayableReferenceNumbersHelper.prototype, "_byPerson", 2);
__decorateClass([
  observable
], _DisplayableReferenceNumbersHelper.prototype, "_forPerson", 2);
__decorateClass([
  observable
], _DisplayableReferenceNumbersHelper.prototype, "_newRepresentationRight", 2);
__decorateClass([
  observable
], _DisplayableReferenceNumbersHelper.prototype, "giverRepresentationRightUtil", 2);
__decorateClass([
  observable
], _DisplayableReferenceNumbersHelper.prototype, "receiverRepresentationRightUtil", 2);
__decorateClass([
  observable
], _DisplayableReferenceNumbersHelper.prototype, "displayableMandates", 2);
__decorateClass([
  observable
], _DisplayableReferenceNumbersHelper.prototype, "overriddenMandates", 2);
__decorateClass([
  observable
], _DisplayableReferenceNumbersHelper.prototype, "modalViews", 2);
__decorateClass([
  observable
], _DisplayableReferenceNumbersHelper.prototype, "initialSettings", 2);
__decorateClass([
  action.bound
], _DisplayableReferenceNumbersHelper.prototype, "initCustomMandates", 1);
__decorateClass([
  action.bound
], _DisplayableReferenceNumbersHelper.prototype, "initActualMandates", 1);
__decorateClass([
  action.bound
], _DisplayableReferenceNumbersHelper.prototype, "initModalViews", 1);
__decorateClass([
  action.bound
], _DisplayableReferenceNumbersHelper.prototype, "forPerson", 1);
__decorateClass([
  action.bound
], _DisplayableReferenceNumbersHelper.prototype, "byPerson", 1);
__decorateClass([
  action.bound
], _DisplayableReferenceNumbersHelper.prototype, "withReferenceNumbers", 1);
__decorateClass([
  action.bound
], _DisplayableReferenceNumbersHelper.prototype, "withOverriddenMandates", 1);
__decorateClass([
  computed
], _DisplayableReferenceNumbersHelper.prototype, "receiverRepresentationRight", 1);
__decorateClass([
  computed
], _DisplayableReferenceNumbersHelper.prototype, "giverRepresentationRight", 1);
__decorateClass([
  computed
], _DisplayableReferenceNumbersHelper.prototype, "usesActualMandates", 1);
__decorateClass([
  computed
], _DisplayableReferenceNumbersHelper.prototype, "usesCustomMandates", 1);
__decorateClass([
  computed
], _DisplayableReferenceNumbersHelper.prototype, "mandates", 1);
__decorateClass([
  computed
], _DisplayableReferenceNumbersHelper.prototype, "views", 1);
__decorateClass([
  computed
], _DisplayableReferenceNumbersHelper.prototype, "anyRefNumsEnabled", 1);
__decorateClass([
  computed
], _DisplayableReferenceNumbersHelper.prototype, "modifiableMandateTypes", 1);
__decorateClass([
  action.bound
], _DisplayableReferenceNumbersHelper.prototype, "onDisplayedReferenceNumberChange", 1);
__decorateClass([
  action.bound
], _DisplayableReferenceNumbersHelper.prototype, "onViewChange", 1);
__decorateClass([
  action.bound
], _DisplayableReferenceNumbersHelper.prototype, "setNewRepresentationRight", 1);
__decorateClass([
  computed
], _DisplayableReferenceNumbersHelper.prototype, "newRepresentationRight", 1);
__decorateClass([
  action.bound
], _DisplayableReferenceNumbersHelper.prototype, "setAllRefNums", 1);
__decorateClass([
  action.bound
], _DisplayableReferenceNumbersHelper.prototype, "setUpReferenceNumbersBasedOnReceiver", 1);
__decorateClass([
  action.bound
], _DisplayableReferenceNumbersHelper.prototype, "setUpReferenceNumbersBasedOnMandateType", 1);
__decorateClass([
  action.bound
], _DisplayableReferenceNumbersHelper.prototype, "setUpOverriddenMandates", 1);
__decorateClass([
  action.bound
], _DisplayableReferenceNumbersHelper.prototype, "resolveConflicts", 1);
let DisplayableReferenceNumbersHelper = _DisplayableReferenceNumbersHelper;
const ReferenceNumbersModal = observer((props) => {
  var _a2, _b2;
  const {
    componentSsoStore: {
      person: { personalCode, personalCodeCountryCode }
    },
    componentTranslateStore: { translate }
  } = React__default.useContext(ComponentRootStoreContext);
  const [mandates, setMandates] = React__default.useState([]);
  const [currentPersonRepRightsUtil, setCurrentPersonRepRightsUtil] = React__default.useState(null);
  const [helper, setHelper] = React__default.useState(null);
  const modalWidth = ((_a2 = props.widths) == null ? void 0 : _a2.main) === "12-col" ? void 0 : ((_b2 = props.widths) == null ? void 0 : _b2.main) || "8-col";
  const isRepresentationRight = !!props.representationRights.representationRightsGivenByCustomer;
  React__default.useEffect(() => {
    let refNumSettings;
    switch (props.initialValues) {
      case "ALL_ENABLED":
        refNumSettings = InitialSettings.CHECKED;
        break;
      case "ALL_DELEGATABLE":
        refNumSettings = InitialSettings.DELEGATABLE;
        break;
      case "NONE_ENABLED":
        refNumSettings = InitialSettings.UNCHECKED;
        break;
      default:
        refNumSettings = InitialSettings.FROM_PERSON;
    }
    const helper2 = DisplayableReferenceNumbersHelper.init(props.representationRights).withOverriddenMandates(props.overriddenMandates).withReferenceNumbers(refNumSettings).withAllAccountsTitleTranslation(translate("referenceNumbersModal.table.row.allAccounts")).forPerson(props.forPerson).byPerson({ personalCode, personalCodeCountryCode }).setNewRepresentationRight(!!props.newRepresentationRight);
    if (helper2.usesActualMandates && !helper2.giverRepresentationRight) {
      throw new Error("User is not a representative");
    }
    setHelper(helper2);
    if (helper2.usesCustomMandates) {
      setMandates(helper2.mandates);
      return;
    }
    const currentPersonRepRightUtil = RepresentationRightUtil.init(helper2.giverRepresentationRight, helper2.billingReferenceNumbers);
    if (!currentPersonRepRightUtil.canModifyAnyReferenceNumbers) {
      throw new Error("You cannot modify reference numbers for this person: ".concat(props.forPerson.personalCode, "-").concat(props.forPerson.personalCodeCountryCode));
    }
    setCurrentPersonRepRightsUtil(currentPersonRepRightUtil);
    setMandates(helper2.mandates);
  }, []);
  if (mandates.length === 0 || isRepresentationRight && !currentPersonRepRightsUtil) {
    return null;
  }
  const canSwitchViews = (representationRight) => {
    var _a3;
    return !currentPersonRepRightsUtil && !!((_a3 = representationRight.displayableReferenceNumbers.find((refNum) => refNum.accountId === -1)) == null ? void 0 : _a3.enabled) || !!(currentPersonRepRightsUtil == null ? void 0 : currentPersonRepRightsUtil.hasLegalMandate) || !!(currentPersonRepRightsUtil == null ? void 0 : currentPersonRepRightsUtil.for(representationRight.mandateType).allAccountsDelegatable);
  };
  const isFromPerson = !!!props.initialValues || props.initialValues === "FROM_PERSON";
  return /* @__PURE__ */ React__default.createElement(ReferenceNumbersModalViewContext.Provider, { value: helper.views }, /* @__PURE__ */ React__default.createElement(Modal, { size: modalWidth, hasContentComponent: true, isOpen: true, onClose: props.onClose }, /* @__PURE__ */ React__default.createElement(ModalContent, null, /* @__PURE__ */ React__default.createElement(Text, null, /* @__PURE__ */ React__default.createElement(Heading$1, { element: "h2" }, translate("referenceNumbersModal.title")), /* @__PURE__ */ React__default.createElement(Tabs, { defaultCurrentTab: "ref-num-modal-tab-".concat(mandates[0].mandateType), border: "top", "aria-labelledby": "ref-num-modal-tabs" }, mandates.map((mandate) => /* @__PURE__ */ React__default.createElement(
    TabsItem,
    {
      key: "ref-num-modal-".concat(mandate.mandateType),
      type: !!props.employee ? "employee" : void 0,
      id: "ref-num-modal-tab-".concat(mandate.mandateType),
      label: translate("referenceNumbersModal.mandates.".concat(mandate.mandateType))
    },
    /* @__PURE__ */ React__default.createElement(
      ReferenceNumbersModalContent,
      {
        key: "reference-numbers-modal-content-".concat(mandate.mandateType),
        referenceNumbers: mandate.displayableReferenceNumbers,
        mandateType: mandate.mandateType,
        canSwitchViews: canSwitchViews(mandate),
        employee: props.employee,
        onChange: (refNum) => helper.onDisplayedReferenceNumberChange(mandate.mandateType, refNum),
        onViewChange: (view) => helper.onViewChange(view, mandate.mandateType)
      }
    ),
    isFromPerson && !helper.anyRefNumsEnabled && /* @__PURE__ */ React__default.createElement(Notice, { type: "info" }, translate("referenceNumbersModal.removalWarning"))
  ))))), /* @__PURE__ */ React__default.createElement(ModalFooter, null, /* @__PURE__ */ React__default.createElement(
    Footer,
    {
      employee: props.employee,
      onSave: () => {
        const callbackObject = helper.newRepresentationRight.slice();
        helper.newRepresentationRight.forEach((mandate, index) => {
          const view = helper.views.get(mandate.mandateType);
          const displayedRefNums = callbackObject[index].displayableReferenceNumbers;
          const actualRefNums = callbackObject[index].referenceNumbers;
          if (view === ReferenceNumbersView.ALL) {
            callbackObject[index].referenceNumbers = actualRefNums.filter(
              (refNum) => refNum.elionAccountId === -1 || refNum.emtAccountId === -1 || refNum.diilAccountId === -1
            );
            callbackObject[index].displayableReferenceNumbers = displayedRefNums.filter((refNum) => refNum.accountId === -1);
          } else {
            callbackObject[index].referenceNumbers = actualRefNums.filter(
              (refNum) => refNum.elionAccountId !== -1 && refNum.emtAccountId !== -1 && refNum.diilAccountId !== -1
            );
            callbackObject[index].displayableReferenceNumbers = displayedRefNums.filter((refNum) => refNum.accountId !== -1);
          }
        });
        props.onSave(callbackObject);
      },
      onClose: props.onClose
    }
  ))));
});
const ReferenceNumbersModalViewContext = React__default.createContext(null);
const ContactInfoValidationCheck = observer((props) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const {
    componentInformationCheckStore: {
      customerCommunicationLanguage,
      isLoading,
      customerPhoneValue,
      customerEmailValue,
      customerAddressFormatted,
      customerPhoneValidated,
      customerEmailValidated,
      customerAddressValidated
    },
    componentTranslateStore: { translate },
    componentSsoStore,
    componentSsoStore: { person },
    brand
  } = useContext(ComponentRootStoreContext);
  useEffect(() => {
    if (!!componentSsoStore.customerId) {
      setModalOpen(true);
      GaDataStore.push({
        event: "AutoEvent",
        page: "Account - My data and authorisations",
        group: "Contact details unconfirmed",
        id: "Show - contact-info-validation-modal-open"
      });
    }
  }, [componentSsoStore.customerId]);
  const handleChangeNowOnClick = () => {
    if (!props.redirectToInformationUpdate) {
      LocationUtils.changePath("/konto/andmete-uuendamine");
      return;
    }
    props.redirectToInformationUpdate();
  };
  const LabelValue2 = ({ label, value, className = "text__margin-half", validated }) => {
    const {
      componentTranslateStore: { translate: translate2 }
    } = useContext(ComponentRootStoreContext);
    if (!validated) {
      return /* @__PURE__ */ React__default.createElement("div", { className }, /* @__PURE__ */ React__default.createElement(Grid, { element: "span" }, /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs-4", "lg-3"] }, translate2(label)), /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["min"], className: "text-bold" }, /* @__PURE__ */ React__default.createElement("span", { className: "text-error" }, /* @__PURE__ */ React__default.createElement(TooltipToggle, { id: "tooltip-toggle" }, valueOrDash(value))), /* @__PURE__ */ React__default.createElement(Tooltip, { fixedWidth: false }, translate2("dataconfirm.validationcheck.tooltip")))));
    }
    return /* @__PURE__ */ React__default.createElement("div", { className }, /* @__PURE__ */ React__default.createElement(Grid, { element: "span" }, /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs-4", "lg-3"] }, translate2(label)), /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs-8", "lg-9"], className: "text-bold" }, valueOrDash(value))));
  };
  const analyticsContext2 = {
    group: "Contact details unconfirmed",
    event: "AutoEvent",
    page: "Account - My data and authorisations",
    onPush: GaDataStore.push
  };
  return /* @__PURE__ */ React__default.createElement(AnalyticsProvider, { ...analyticsContext2 }, /* @__PURE__ */ React__default.createElement(
    Modal,
    {
      hasContentComponent: true,
      isOpen: isModalOpen,
      "aria-labelledby": "information-check-heading",
      initialFocusedElementId: "change-data",
      cover: brand === "TELIA" ? {
        backgroundColor: "#999999",
        minHeight: 500,
        image: {
          srcset: "https://res.cloudinary.com/telia/image/upload/q_5/w_400,h_800,c_fill/crm-components/Telia_Company_112_2.png",
          role: "presentation"
        },
        fillImage: true
      } : void 0,
      onClose: () => {
        setModalOpen(false);
        GaDataStore.push({
          event: "AutoEvent",
          page: "Account - My data and authorisations",
          group: "Contact details unconfirmed",
          id: "Button - contact-info-validation-modal-cancel"
        });
      }
    },
    /* @__PURE__ */ React__default.createElement(ModalContent, null, isLoading ? /* @__PURE__ */ React__default.createElement(Spinner, null) : /* @__PURE__ */ React__default.createElement(Text, null, /* @__PURE__ */ React__default.createElement(Heading$1, { className: "h2", id: "information-check-heading" }, translate("dataconfirm.validationcheck.heading")), /* @__PURE__ */ React__default.createElement("p", { className: "h4 text-bold" }, translate("dataconfirm.validationcheck.greeting", { name: person.firstName })), /* @__PURE__ */ React__default.createElement("p", null, translate("dataconfirm.validationcheck.message")), /* @__PURE__ */ React__default.createElement(
      LabelValue2,
      {
        label: "dataconfirm.validationcheck.phone",
        value: customerPhoneValue,
        className: "text__margin-double",
        validated: customerPhoneValidated
      }
    ), /* @__PURE__ */ React__default.createElement(LabelValue2, { label: "dataconfirm.validationcheck.email", value: customerEmailValue, validated: customerEmailValidated }), /* @__PURE__ */ React__default.createElement(LabelValue2, { label: "dataconfirm.validationcheck.postAddress", value: customerAddressFormatted, validated: customerAddressValidated }), /* @__PURE__ */ React__default.createElement(
      LabelValue2,
      {
        label: "dataconfirm.validationcheck.communicationLanguage",
        value: getTranslatedCommunicationLanguage(customerCommunicationLanguage, translate),
        validated: true
      }
    ))),
    /* @__PURE__ */ React__default.createElement(ModalFooter, null, /* @__PURE__ */ React__default.createElement(Grid, { align: ["middle-xs", "center-xs", "start-md"], reverse: ["xs"], className: "text-center" }, /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs-12", "md"] }, /* @__PURE__ */ React__default.createElement(AnalyticsTrigger, { trigger: { id: "Button - confirm-data", callback: "onClick" } }, /* @__PURE__ */ React__default.createElement(
      Button,
      {
        text: translate("dataconfirm.validationcheck.validateNow"),
        iconRight: "#arrow-right",
        onClick: handleChangeNowOnClick,
        id: "change-data"
      }
    )))))
  ));
});
const testObject = (defaultValues) => {
  if (typeof defaultValues === "string") {
    defaultValues = { value: defaultValues };
  }
  Object.entries(defaultValues).forEach(([key, value]) => {
    defaultValues["default__".concat(key)] = value;
  });
  defaultValues["reset"] = () => {
    Object.keys(defaultValues).forEach((key) => {
      if (key.startsWith("default__")) {
        defaultValues[key.split("default__")[1]] = defaultValues[key];
      }
    });
  };
  return defaultValues;
};
const testApiResponse = (defaultValues) => {
  return testObject({ data: defaultValues });
};
export {
  Address,
  ApplicationWrapper,
  B2cCustomerInfo,
  CommunicationLanguage,
  CommunicationLanguageSelector,
  ComponentContactAddressStore,
  ComponentContractStore,
  ComponentCreditInfoStore,
  ComponentCustomerContactInfoStore,
  ComponentInformationCheckStore,
  ComponentMandateStore,
  ComponentRegistrationStore,
  ComponentRootStore,
  ComponentRootStoreContext,
  ComponentRootStoreProvider,
  ComponentSignerStore,
  ComponentSsoStore,
  ComponentTranslateStore,
  ComponentURLDataStore,
  ContactAddress$1 as ContactAddress,
  ContactChannelsData,
  ContactChannelsRequiredValidation,
  ContactInfo,
  ContactInfoType,
  ContactInfoValidationCheck,
  ContactInfoValidationModal,
  ContractValidator,
  CountrySuggestionField,
  CountryUtil,
  Email,
  InformationCheckWrapper$1 as InformationCheckWrapper,
  InformationUpdateOld as InformationUpdate,
  InformationUpdate as InformationUpdateNew,
  Language,
  ORDERED_MODIFIABLE_MANDATE_TYPES,
  Phone,
  ReferenceNumbersModal,
  Registration$1 as Registration,
  Route,
  RouteErrorType,
  Routes,
  Signer,
  UpdateInformationCheck,
  getBirthYear,
  getCurrentLanguage,
  isContactInfoChanged,
  isUnderage,
  navigate,
  setLanguage,
  testApiResponse,
  testObject,
  useParams
};
